/* generated by theme/yoby/scripts/gen-site-locales.mjs — do not edit */
window.YOBY_SUPPORTED_LOCALES = ["it","fr","es","pt","en","de","nl"];
window.YOBY_LOCALE_FLAGS = {"it":"🇮🇹","fr":"🇫🇷","es":"🇪🇸","pt":"🇵🇹","en":"🇬🇧","de":"🇩🇪","nl":"🇳🇱"};
window.YOBY_SITE_LOCALES = {
  "it": {
    "blog.title": "Blog",
    "dash.admin.approveSignup": "Approva",
    "dash.admin.errArchive": "Impossibile archiviare la scuola.",
    "dash.admin.errAssign": "Impossibile assegnare lo staff.",
    "dash.admin.errCreateSchool": "Impossibile creare la scuola.",
    "dash.admin.errDenied": "Accesso non autorizzato. Accedi come admin YOBY.",
    "dash.admin.errRoleNotAllowed": "Ruolo non consentito.",
    "dash.admin.errSaveSchool": "Impossibile salvare la scuola.",
    "dash.admin.errSignupApprove": "Impossibile approvare la domanda.",
    "dash.admin.errSignupLoad": "Impossibile caricare le iscrizioni scuole.",
    "dash.admin.errSignupReject": "Impossibile rifiutare la domanda.",
    "dash.admin.errUserNotFound": "Utente non trovato.",
    "dash.admin.linkAdminSafety": "Ultimi audit di sicurezza AI",
    "dash.admin.linkMassmail": "Massmail scuole",
    "dash.admin.linkPlay": "Gioco famiglia",
    "dash.admin.linkRedteam": "AI Red Team",
    "dash.admin.linkStatus": "Status gioco",
    "dash.admin.linkSupervisor": "Dashboard supervisore",
    "dash.admin.linkTeacher": "Dashboard docente",
    "dash.admin.noSignups": "Nessuna iscrizione scuola.",
    "dash.admin.noStaff": "Nessun membro dello staff.",
    "dash.admin.panelSchoolsForm": "Inserimento/modifica scuole",
    "dash.admin.panelSchoolsList": "Lista scuole",
    "dash.admin.panelSignups": "Iscrizioni scuole",
    "dash.admin.panelStaffForm": "Inserimento/modifica staff",
    "dash.admin.panelStaffList": "Lista staff",
    "dash.admin.quickLinks": "Link rapidi",
    "dash.admin.rejectReason": "Motivo del rifiuto",
    "dash.admin.rejectSignup": "Rifiuta",
    "dash.admin.schoolListHint": "Clicca una riga per modificarla. Archivia chiede conferma.",
    "dash.admin.selectSchool": "Seleziona una scuola",
    "dash.admin.signupClasses": "Classi",
    "dash.admin.signupTeachers": "Docenti",
    "dash.admin.staffListHint": "Clicca una riga per aggiornare assegnazione e ruolo.",
    "dash.admin.statusAssigned": "Staff assegnato.",
    "dash.admin.statusAssigning": "Assegnazione staff…",
    "dash.admin.statusCreatingSchool": "Creazione scuola…",
    "dash.admin.statusEditingSchool": "Modifica scuola — modifica i campi e salva.",
    "dash.admin.statusEditingStaff": "Modifica staff — aggiorna e assegna.",
    "dash.admin.statusSavingSchool": "Salvataggio scuola…",
    "dash.admin.statusSchoolCreated": "Scuola creata.",
    "dash.admin.statusSchoolSaved": "Scuola salvata.",
    "dash.admin.subtitle": "Crea scuole, assegna docenti e supervisori. Richiede login admin YOBY (email in ADMIN_EMAILS).",
    "dash.admin.surveyAssignStaff": "Assegna staff",
    "dash.admin.surveyCreateSchool": "Crea scuola",
    "dash.admin.surveySaveSchool": "Salva scuola",
    "dash.admin.surveySchoolDesc": "Registra una scuola nel modulo YOBY.",
    "dash.admin.surveySchoolName": "Nome scuola",
    "dash.admin.surveySchoolSlug": "Slug (opzionale)",
    "dash.admin.surveySchoolTitle": "Nuova scuola",
    "dash.admin.surveyStaffDesc": "Collega docenti e supervisori alla scuola.",
    "dash.admin.surveyStaffEmail": "Email staff",
    "dash.admin.surveyStaffForce": "Forza assegnazione",
    "dash.admin.surveyStaffForceDesc": "Riassegna anche se l'utente appartiene già a un'altra scuola.",
    "dash.admin.surveyStaffRoleSupervisor": "Supervisore",
    "dash.admin.surveyStaffRoleTeacher": "Docente",
    "dash.admin.surveyStaffSchool": "Scuola",
    "dash.admin.surveyStaffTitle": "Assegna staff",
    "dash.admin.surveyUpdateStaff": "Aggiorna staff",
    "dash.admin.tabSchoolsForm": "Inserimento/modifica scuole",
    "dash.admin.tabSchoolsList": "Lista scuole",
    "dash.admin.tabSignups": "Iscrizioni scuole",
    "dash.admin.tabStaffForm": "Inserimento/modifica staff",
    "dash.admin.tabStaffList": "Lista staff",
    "dash.admin.tabsAria": "Admin scuole",
    "dash.admin.title": "Admin Scuole YOBY",
    "dash.booking.active": "Prenotazioni pubbliche attive",
    "dash.booking.addEmail": "Aggiungi email",
    "dash.booking.addHour": "Aggiungi fascia",
    "dash.booking.attribution": "Come ci hanno trovati",
    "dash.booking.availabilityHint": "Attiva le prenotazioni pubbliche su /talk-with-us/. Orari raffinabili entro lun–ven 09:00–19:00. Puoi sospendere date specifiche sotto.",
    "dash.booking.availabilityTitle": "Disponibilità pubblica",
    "dash.booking.availableSlots": "Orari disponibili",
    "dash.booking.blockDate": "Sospendi",
    "dash.booking.blockReason": "Motivo",
    "dash.booking.blockReasonPlaceholder": "Motivo (opzionale)",
    "dash.booking.blockedDatesHint": "Nessuno slot in queste giornate.",
    "dash.booking.blockedDatesTitle": "Date sospese",
    "dash.booking.blockedEmpty": "Nessuna data sospesa.",
    "dash.booking.blockedOn": "Data",
    "dash.booking.blockedSaved": "Data sospesa.",
    "dash.booking.booking": "Prenotazione…",
    "dash.booking.bufferMinutes": "Buffer tra slot (minuti)",
    "dash.booking.calFreeDays": "Giorni con posti liberi",
    "dash.booking.cancel": "Annulla",
    "dash.booking.cancelConfirm": "Annullare questa prenotazione?",
    "dash.booking.cancelled": "annullata",
    "dash.booking.cancelledOk": "Prenotazione annullata.",
    "dash.booking.confirm": "Prenota",
    "dash.booking.confirmTitle": "Conferma prenotazione",
    "dash.booking.copyLink": "Copia link",
    "dash.booking.detailTitle": "Dettaglio prenotazione",
    "dash.booking.doneBody": "Ti abbiamo inviato il link per email. Usalo il giorno della call.",
    "dash.booking.doneLinkHint": "Se non ti arriva la mail, il tuo link personale è questo:",
    "dash.booking.doneStatus": "Controlla anche la posta in arrivo.",
    "dash.booking.doneTitle": "Prenotazione confermata",
    "dash.booking.emailsHint": "Aggiungi fino a 3 email: ognuna riceve un link personale.",
    "dash.booking.empty": "Nessuna prenotazione o call programmata.",
    "dash.booking.errBlockDate": "Data non valida.",
    "dash.booking.errBlockExists": "Data già sospesa.",
    "dash.booking.errBook": "Impossibile completare la prenotazione.",
    "dash.booking.errCancel": "Impossibile annullare.",
    "dash.booking.errEmails": "Inserisci almeno un’email valida.",
    "dash.booking.errLoad": "Impossibile caricare le prenotazioni.",
    "dash.booking.errLoadSlots": "Impossibile caricare gli slot.",
    "dash.booking.errPickSlot": "Prima scegli un orario qui sopra.",
    "dash.booking.errReschedule": "Impossibile riprogrammare.",
    "dash.booking.errSave": "Impossibile salvare la disponibilità.",
    "dash.booking.errSlotTaken": "Questo slot non è più disponibile. Scegline un altro.",
    "dash.booking.errTooManyEmails": "Massimo 3 email per prenotazione.",
    "dash.booking.errUnblock": "Impossibile riattivare la data.",
    "dash.booking.errUrl": "Quel link non sembra un indirizzo web valido.",
    "dash.booking.formOptionalHint": "Tutti i campi qui sotto sono facoltativi. Puoi raccontarci qualcosa di te, oppure presentarti e salutarci. Il resto lo scopriamo insieme.",
    "dash.booking.gcalCalendar": "Calendario destinazione",
    "dash.booking.gcalConnect": "Connetti Google Calendar",
    "dash.booking.gcalConnectFailed": "Collegamento Google Calendar non riuscito.",
    "dash.booking.gcalConnected": "Google Calendar collegato.",
    "dash.booking.gcalDisconnect": "Disconnetti",
    "dash.booking.gcalDisconnectConfirm": "Disconnettere Google Calendar?",
    "dash.booking.gcalDisconnected": "Google Calendar disconnesso.",
    "dash.booking.gcalMissing": "Pronto: clicca Connetti per autorizzare Google (OAuth).",
    "dash.booking.gcalOk": "Google Calendar collegato (eventi e busy sincronizzati).",
    "dash.booking.gcalRedirectHint": "Redirect URI da autorizzare:",
    "dash.booking.gcalRefresh": "Aggiorna calendario",
    "dash.booking.gcalRefreshConfirm": "Aggiornare su Google Calendar tutti gli appuntamenti futuri (orari corretti sul calendario YOBY)?",
    "dash.booking.gcalRefreshEmpty": "Nessun appuntamento in corso o futuro da sincronizzare.",
    "dash.booking.gcalRefreshFailed": "Aggiornamento calendario non riuscito.",
    "dash.booking.gcalRefreshNeedReconnect": "Google Calendar non raggiungibile: disconnetti e riconnetti, poi riprova il refresh.",
    "dash.booking.gcalRefreshOk": "Calendario aggiornato: {synced}/{total} eventi · errori {failed} · {calendar}",
    "dash.booking.gcalServerMissing": "Manca l’app OAuth sul server: in Google Cloud crea un client “Web application”, poi metti CLIENT_ID e CLIENT_SECRET in GOOGLE_CALENDAR_* nel .env e riavvia l’API.",
    "dash.booking.gcalTitle": "Google Calendar",
    "dash.booking.inactive": "Le prenotazioni pubbliche non sono attive al momento.",
    "dash.booking.introBody": "Se preferisci incontrarci invece di compilare un modulo, puoi prenotare una conversazione direttamente con il team YOBY. Saremo felici di mostrarti il progetto, rispondere alle tue domande ed esplorare come YOBY possa adattarsi alla tua famiglia, scuola, organizzazione o idea di partnership.",
    "dash.booking.introImageAlt": "Videochiamata con il team YOBY — paperelle che parlano in inglese, francese e italiano",
    "dash.booking.introInterpreter": "Parli un'altra lingua? Non ci sono problemi: la nostra piattaforma di conference call tradurrà la tua nella nostra e viceversa.",
    "dash.booking.introLanguages": "Puoi parlare con noi in inglese, italiano o francese: Ricardo e Stefano parlano italiano e inglese, mentre Antonella, la nostra CRO, parla francese, italiano e inglese.",
    "dash.booking.introTitle": "Preferisci parlarne?",
    "dash.booking.landingUrl": "Pagina di arrivo",
    "dash.booking.linkLabel": "Un link da vedere prima della call",
    "dash.booking.linkPlaceholder": "https://…",
    "dash.booking.listHint": "Clicca una riga per gestire invitati e link. Include anche le call create da admin.",
    "dash.booking.listTitle": "Prenotazioni e call programmate",
    "dash.booking.noLinkedCall": "Questa prenotazione non ha una conference collegata.",
    "dash.booking.noSlots": "Nessuno slot libero in questo giorno.",
    "dash.booking.note": "C’è qualcosa che vorresti farci sapere?",
    "dash.booking.notifyInvitees": "Avvisa gli invitati via email (stesso link, nuovo orario)",
    "dash.booking.openCall": "Apri la conference",
    "dash.booking.orgLabel": "Organizzazione / progetto",
    "dash.booking.orgPlaceholder": "Scuola, azienda, testata, fondazione...",
    "dash.booking.pickDay": "Scegli un giorno",
    "dash.booking.prefLang.none": "Nessuna preferenza",
    "dash.booking.prefLangLabel": "Lingua preferita",
    "dash.booking.publicSubtitle": "Scegli uno slot libero. Riceverai un link personale per entrare nella conference.",
    "dash.booking.publicTitle": "Prenota una call YOBY",
    "dash.booking.referrer": "Referrer",
    "dash.booking.rescheduleHint": "Cambia data e ora. I link personali restano gli stessi.",
    "dash.booking.rescheduleTitle": "Riprogramma",
    "dash.booking.rescheduled": "Prenotazione riprogrammata. I link non sono cambiati.",
    "dash.booking.rulesHint": "Regole fisse: almeno 48 ore di preavviso, lunedì–venerdì 09:00–19:00 (Europe/Rome).",
    "dash.booking.save": "Salva disponibilità",
    "dash.booking.saveCall": "Salva nuovo orario",
    "dash.booking.saved": "Disponibilità salvata.",
    "dash.booking.saving": "Salvataggio…",
    "dash.booking.slotMinutes": "Durata slot (minuti)",
    "dash.booking.sourceAdmin": "Call programmata",
    "dash.booking.status": "Stato",
    "dash.booking.statusCancelled": "annullata",
    "dash.booking.statusDone": "conclusa",
    "dash.booking.statusExpired": "scaduta",
    "dash.booking.statusLive": "in corso",
    "dash.booking.statusUpcoming": "in arrivo",
    "dash.booking.timezone": "Il tuo fuso orario",
    "dash.booking.timezoneHint": "Gli orari disponibili sono mostrati nel fuso scelto. La disponibilità YOBY è lun–ven 09:00–19:00 (Europe/Rome).",
    "dash.booking.topic.banking_fintech": "Banche e fintech",
    "dash.booking.topic.families": "YOBY per le famiglie",
    "dash.booking.topic.financial_education": "Educazione finanziaria",
    "dash.booking.topic.investment": "Investimento",
    "dash.booking.topic.other": "Qualcos'altro",
    "dash.booking.topic.partnership": "Partnership",
    "dash.booking.topic.press": "Stampa e interviste",
    "dash.booking.topic.research": "Ricerca",
    "dash.booking.topic.school_pilot": "Pilota scolastico",
    "dash.booking.topicsLabel": "Di cosa vorresti parlare?",
    "dash.booking.unblockDate": "Riattiva",
    "dash.booking.unblocked": "Data riattivata.",
    "dash.booking.utm": "Campagna (UTM)",
    "dash.booking.weekday0": "Domenica",
    "dash.booking.weekday1": "Lunedì",
    "dash.booking.weekday2": "Martedì",
    "dash.booking.weekday3": "Mercoledì",
    "dash.booking.weekday4": "Giovedì",
    "dash.booking.weekday5": "Venerdì",
    "dash.booking.weekday6": "Sabato",
    "dash.booking.weeklyHours": "Orari settimanali",
    "dash.booking.who.bank": "Banca o istituto finanziario",
    "dash.booking.who.curious": "Solo curiosità",
    "dash.booking.who.educator": "Educatore o scuola",
    "dash.booking.who.empty": "Scegli se vuoi…",
    "dash.booking.who.foundation": "Fondazione o ONG",
    "dash.booking.who.investor": "Investitore",
    "dash.booking.who.journalist": "Giornalista",
    "dash.booking.who.other": "Altro",
    "dash.booking.who.parent": "Genitore",
    "dash.booking.who.public": "Istituzione pubblica",
    "dash.booking.who.startup": "Startup o azienda",
    "dash.booking.whoLabel": "Chi sei?",
    "dash.booking.yourEmail": "La tua email",
    "dash.booking.yourEmails": "Email degli invitati",
    "dash.booking.yourName": "Il tuo nome",
    "dash.common.actions": "Azioni",
    "dash.common.actor": "Attore",
    "dash.common.archive": "Archivia",
    "dash.common.assignments": "Compiti",
    "dash.common.attempts": "Tentativi",
    "dash.common.avg": "Media",
    "dash.common.cancel": "Annulla",
    "dash.common.class": "Classe",
    "dash.common.classes": "Classi",
    "dash.common.code": "Codice",
    "dash.common.confirm": "Conferma",
    "dash.common.confirmArchiveSchool": "Archiviare questa scuola?",
    "dash.common.confirmTitle": "Conferma",
    "dash.common.copyCode": "Copia codice",
    "dash.common.csvDownloaded": "CSV scaricato",
    "dash.common.difficulty": "Difficoltà",
    "dash.common.email": "Email",
    "dash.common.entity": "Entità",
    "dash.common.exportCsv": "Export CSV",
    "dash.common.family": "Famiglia",
    "dash.common.lastAccess": "Ultimo accesso",
    "dash.common.loading": "Caricamento…",
    "dash.common.name": "Nome",
    "dash.common.newCode": "Nuovo codice",
    "dash.common.none": "—",
    "dash.common.ok": "OK",
    "dash.common.open": "Apri",
    "dash.common.questions": "Domande",
    "dash.common.quiz": "Quiz",
    "dash.common.refresh": "Aggiorna",
    "dash.common.role": "Ruolo",
    "dash.common.school": "Scuola",
    "dash.common.select": "Seleziona",
    "dash.common.slug": "Slug",
    "dash.common.status": "Stato",
    "dash.common.students": "Studenti",
    "dash.common.teachers": "Docenti",
    "dash.common.topic": "Tema",
    "dash.common.updated": "Aggiornato",
    "dash.common.when": "Quando",
    "dash.common.year": "Anno",
    "dash.conference.addInvitee": "Aggiungi invitato",
    "dash.conference.addInviteeHint": "Riceve un papero e un link personale. Puoi inviargli subito l’invito via email.",
    "dash.conference.addInviteeTitle": "Aggiungi un invitato",
    "dash.conference.addingInvitee": "Aggiunta…",
    "dash.conference.back": "Torna all'elenco",
    "dash.conference.chat": "Chat",
    "dash.conference.confirmed": "Confermata",
    "dash.conference.confirmedNo": "In attesa",
    "dash.conference.confirmedYes": "Sì",
    "dash.conference.copied": "Link copiato.",
    "dash.conference.copiedShort": "Copiato!",
    "dash.conference.copyLink": "Copia link",
    "dash.conference.create": "Crea call",
    "dash.conference.createImmediate": "Crea conference immediata",
    "dash.conference.createImmediateHint": "Serve solo il nome della call/famiglia. Crea un link aperto usabile da chiunque fino a mezzanotte (Europe/Rome).",
    "dash.conference.created": "Call creata.",
    "dash.conference.createdImmediate": "Conference aperta creata — condividi il link unico. Valido per il resto di oggi.",
    "dash.conference.creating": "Creazione…",
    "dash.conference.detailTitle": "Link invitati",
    "dash.conference.editHint": "Puoi cambiare data, ora, nome e lingua. I link di accesso restano gli stessi.",
    "dash.conference.editTitle": "Riprogramma call",
    "dash.conference.email": "Email",
    "dash.conference.emailDryRun": "Email dry-run (non inviata).",
    "dash.conference.emailSent": "Accettata da Mailgun.",
    "dash.conference.empty": "Nessuna conference call.",
    "dash.conference.emptyInvitees": "Nessun invitato ancora.",
    "dash.conference.ended": "Call terminata.",
    "dash.conference.errAddInvitee": "Impossibile aggiungere l’invitato. Controlla email e nome.",
    "dash.conference.errCallEnded": "La call è terminata: non si possono aggiungere invitati.",
    "dash.conference.errCopy": "Impossibile copiare il link.",
    "dash.conference.errCreate": "Impossibile creare la call.",
    "dash.conference.errDenied": "Accesso non autorizzato. Accedi come admin YOBY.",
    "dash.conference.errDuplicateInvitee": "Questa email è già invitata a questa call.",
    "dash.conference.errEmail": "Impossibile inviare l'email.",
    "dash.conference.errLoad": "Impossibile caricare le conference call.",
    "dash.conference.errSave": "Impossibile salvare le modifiche.",
    "dash.conference.errWorldFull": "Mondo conference pieno: non ci sono più stagni liberi.",
    "dash.conference.familyName": "Nome famiglia",
    "dash.conference.firstName": "Nome",
    "dash.conference.gameLocale": "Lingua del gioco",
    "dash.conference.inviteeAdded": "Invitato aggiunto.",
    "dash.conference.inviteeCount": "Invitati",
    "dash.conference.invitees": "Invitati",
    "dash.conference.lastName": "Cognome",
    "dash.conference.listTitle": "Call programmate",
    "dash.conference.mediaHealth.checking": "Controllo Janus e Coturn…",
    "dash.conference.mediaHealth.coturn": "Coturn (TURN)",
    "dash.conference.mediaHealth.down": "DOWN",
    "dash.conference.mediaHealth.errLoad": "Impossibile leggere lo stato video.",
    "dash.conference.mediaHealth.hintDown": "Non avviare la call: video WebRTC non è pronto.",
    "dash.conference.mediaHealth.hintOk": "Janus e TURN raggiungibili. La call può partire.",
    "dash.conference.mediaHealth.janus": "Janus",
    "dash.conference.mediaHealth.ok": "OK",
    "dash.conference.mediaHealth.title": "Stato video (live)",
    "dash.conference.notifyInvitees": "Avvisa gli invitati via email (stesso link, nuovo orario)",
    "dash.conference.openCallBadge": "link aperto",
    "dash.conference.openCallHint": "Chiunque abbia questo link può entrare (ogni persona riceve un papero proprio).",
    "dash.conference.phase": "Fase",
    "dash.conference.refresh": "Aggiorna",
    "dash.conference.save": "Salva modifiche",
    "dash.conference.saveTranscript": "Salva PDF",
    "dash.conference.saved": "Call aggiornata. I link non sono cambiati.",
    "dash.conference.saving": "Salvataggio…",
    "dash.conference.sendEmail": "Invia email",
    "dash.conference.sendEmailOnAdd": "Invia email di invito",
    "dash.conference.sendingEmail": "Invio…",
    "dash.conference.speech": "Parlato",
    "dash.conference.startsAt": "Data e ora di inizio (Europe/Rome)",
    "dash.conference.startsAtHint": "Inserisci l’orario nel fuso YOBY (Europe/Rome), non nel fuso del browser.",
    "dash.conference.subtitle": "Crea un mondo YOBY privato per una call programmata. Ogni invitato riceve un papero e un link personale.",
    "dash.conference.tabAvailability": "Disponibilità",
    "dash.conference.tabBookings": "Prenotazioni",
    "dash.conference.tabCalls": "Call programmate",
    "dash.conference.tabCreate": "Crea call",
    "dash.conference.tabsAria": "Sezioni conference",
    "dash.conference.title": "Conference call",
    "dash.conference.transcript": "Trascrizione",
    "dash.conference.transcriptDisabledNote": "Trascrizione disattivata su richiesta di un partecipante.",
    "dash.conference.transcriptEmpty": "Nessuna trascrizione ancora.",
    "dash.conference.transcriptSaved": "PDF salvato.",
    "dash.difficulty.easy": "Facile",
    "dash.difficulty.hard": "Difficile",
    "dash.difficulty.medium": "Medio",
    "dash.liveInterpreter.callMetrics": "Uso Live Interpreter",
    "dash.liveInterpreter.callMetricsBody": "Call {callMin} min · tradotto {liMin} min · lingue: {langs} · ascoltatori: {listeners} · ≈ €{eur}",
    "dash.liveInterpreter.criticalPct": "Soglia critica (%)",
    "dash.liveInterpreter.enabled": "Abilita Live Interpreter (solo conference commerciali)",
    "dash.liveInterpreter.enabledDesc": "Interruttore master per le call commerciali (talk-with-us / admin). Non abilita mai le videochat nei laghetti di gioco: lì l’interprete non parte.",
    "dash.liveInterpreter.envOff": "Kill-switch env DISATTIVO",
    "dash.liveInterpreter.errLoad": "Impossibile caricare le impostazioni interprete.",
    "dash.liveInterpreter.errSave": "Impossibile salvare le impostazioni interprete.",
    "dash.liveInterpreter.hint": "Traduzione vocale simultanea solo nelle conference commerciali. Mai sulle videochat interne ai laghetti.",
    "dash.liveInterpreter.monthUsage": "Mese {month}: {used} / {limit} min · ≈ €{eur} · {calls} call · {status}",
    "dash.liveInterpreter.monthlyLimit": "Limite mensile (minuti di audio tradotto)",
    "dash.liveInterpreter.providerMissing": "Mancano endpoint/API key Azure Voice Live nel .env",
    "dash.liveInterpreter.providerOk": "Azure Voice Live configurato",
    "dash.liveInterpreter.quotaBlocked": "Nuove traduzioni bloccate",
    "dash.liveInterpreter.quotaCritical": "Critico",
    "dash.liveInterpreter.quotaOk": "OK",
    "dash.liveInterpreter.quotaWarn": "Avviso",
    "dash.liveInterpreter.save": "Salva impostazioni interprete",
    "dash.liveInterpreter.saved": "Impostazioni interprete salvate.",
    "dash.liveInterpreter.tab": "Interprete",
    "dash.liveInterpreter.testCall": "TEST — apri conference di prova",
    "dash.liveInterpreter.testCallCreating": "Creazione conference di prova…",
    "dash.liveInterpreter.testCallErr": "Impossibile creare la conference di prova.",
    "dash.liveInterpreter.testCallHint": "Crea subito una conference aperta (link pubblico) e la apre in una nuova scheda per provare caption e 🎲.",
    "dash.liveInterpreter.testCallOk": "Conference di prova pronta — aperta in una nuova scheda.",
    "dash.liveInterpreter.title": "Live Interpreter",
    "dash.liveInterpreter.warnPct": "Soglia avviso (%)",
    "dash.schoolSignup.addClass": "Aggiungi classe",
    "dash.schoolSignup.addTeacher": "Aggiungi docente",
    "dash.schoolSignup.alreadyBody": "Questo account è già collegato a una scuola su YOBY.",
    "dash.schoolSignup.alreadyTitle": "Sei già iscritto",
    "dash.schoolSignup.back": "Indietro",
    "dash.schoolSignup.checkEmail": "Controlla la mail e torna su questa pagina dopo aver confermato.",
    "dash.schoolSignup.city": "Città",
    "dash.schoolSignup.className": "Nome classe",
    "dash.schoolSignup.classTeacher": "Docente della classe",
    "dash.schoolSignup.classes": "Classi coinvolte",
    "dash.schoolSignup.continue": "Continua",
    "dash.schoolSignup.country": "Paese",
    "dash.schoolSignup.draftSaved": "Bozza salvata.",
    "dash.schoolSignup.email": "Email del dirigente",
    "dash.schoolSignup.errClassTeacher": "Scegli un docente già indicato nel passo precedente.",
    "dash.schoolSignup.errEmail": "Inserisci un’email valida.",
    "dash.schoolSignup.errGeneric": "Qualcosa non ha funzionato. Riprova.",
    "dash.schoolSignup.errLocked": "La domanda è già stata inviata.",
    "dash.schoolSignup.errLookup": "Impossibile verificare l’email.",
    "dash.schoolSignup.errName": "Inserisci nome e cognome (almeno 2 caratteri).",
    "dash.schoolSignup.errPhone": "Il telefono è facoltativo. Se lo compili, usa cifre, spazi o +.",
    "dash.schoolSignup.errPrivacy": "Per continuare devi accettare l’informativa privacy.",
    "dash.schoolSignup.errSave": "Impossibile salvare la bozza.",
    "dash.schoolSignup.errSubmit": "Impossibile inviare la domanda.",
    "dash.schoolSignup.errTeacherDup": "Ogni docente deve avere un’email diversa.",
    "dash.schoolSignup.errTeacherSelf": "Non usare l’email del dirigente: il dirigente è supervisore.",
    "dash.schoolSignup.errValidation": "Compila nome scuola, almeno un docente e una classe.",
    "dash.schoolSignup.goDashboard": "Apri la dashboard",
    "dash.schoolSignup.helpAccount": "Crea l’account del dirigente con nome, email e consenso privacy. Ti inviamo un link di conferma: aprilo e poi torna su questa pagina. Se hai già un account YOBY, usa Accedi: non serve iscriverti di nuovo.",
    "dash.schoolSignup.helpClassTeacher": "Scegli il docente titolare di questa classe. Deve essere uno dei docenti già elencati.",
    "dash.schoolSignup.helpClasses": "Ogni classe ha un docente titolare scelto dall’elenco del passo precedente. All’approvazione YOBY crea le classi e le assegna a quel docente. Serve almeno una classe.",
    "dash.schoolSignup.helpSchool": "Indica i dati dell’istituto così YOBY può attivare la scuola dopo il controllo. Il telefono è facoltativo. Nella nota puoi aggiungere plessi, orari o altre informazioni utili.",
    "dash.schoolSignup.helpTeachers": "Elenca i docenti che useranno YOBY. All’approvazione riceveranno un invito. Non inserire l’email del dirigente: il dirigente è supervisore, non docente. Serve almeno un docente.",
    "dash.schoolSignup.introAlt": "Preferisci una call con noi?",
    "dash.schoolSignup.introBody": "Il dirigente si iscrive, conferma l’email, poi indica docenti e classi. YOBY attiva la scuola dopo un controllo.",
    "dash.schoolSignup.introTitle": "Iscrivi la tua scuola",
    "dash.schoolSignup.knownBody": "Questa email è già registrata. Accedi con il link che ti arriva in mail.",
    "dash.schoolSignup.knownTitle": "Sei già iscritto",
    "dash.schoolSignup.locale": "Lingua di lavoro",
    "dash.schoolSignup.name": "Nome e cognome del dirigente",
    "dash.schoolSignup.note": "Nota (opzionale)",
    "dash.schoolSignup.openDashboard": "Vai alla dashboard",
    "dash.schoolSignup.pendingBody": "Abbiamo ricevuto la domanda per {school}. Ti scriviamo quando è attiva.",
    "dash.schoolSignup.pendingTitle": "In attesa di approvazione",
    "dash.schoolSignup.phone": "Telefono (opzionale)",
    "dash.schoolSignup.privacy": "Accetto l’informativa privacy e di condividere le email dei docenti indicati.",
    "dash.schoolSignup.rejectedBody": "La domanda precedente non è stata approvata. Motivo: {reason}",
    "dash.schoolSignup.rejectedTitle": "Domanda non approvata",
    "dash.schoolSignup.saveDraft": "Salva bozza",
    "dash.schoolSignup.schoolName": "Nome dell’istituto",
    "dash.schoolSignup.signIn": "Accedi",
    "dash.schoolSignup.signUp": "Iscriviti e conferma l’email",
    "dash.schoolSignup.stepAccount": "Account",
    "dash.schoolSignup.stepAccountTitle": "Account",
    "dash.schoolSignup.stepClassesTitle": "Classi",
    "dash.schoolSignup.stepSchool": "Scuola",
    "dash.schoolSignup.stepSchoolTitle": "Scuola",
    "dash.schoolSignup.stepTeachersTitle": "Docenti",
    "dash.schoolSignup.submit": "Invia la domanda",
    "dash.schoolSignup.submitted": "Domanda inviata.",
    "dash.schoolSignup.talkWithUs": "Prenota una call",
    "dash.schoolSignup.teacherEmail": "Email docente",
    "dash.schoolSignup.teacherName": "Nome docente",
    "dash.schoolSignup.teachers": "Docenti",
    "dash.status.ageBand.11-15": "11–15",
    "dash.status.ageBand.16-17": "16–17",
    "dash.status.ageBand.18-26": "18–26",
    "dash.status.ageBand.8-10": "8–10",
    "dash.status.ageBand.adult": "Adulti",
    "dash.status.ageBand.unknown": "Senza fascia",
    "dash.status.analytics.events.arcade_completed.description": "Attività arcade conclusa",
    "dash.status.analytics.events.arcade_completed.label": "Arcade completata",
    "dash.status.analytics.events.arcade_started.description": "Parte una corsa o attività arcade",
    "dash.status.analytics.events.arcade_started.label": "Arcade iniziata",
    "dash.status.analytics.events.child_access_started.description": "Il bambino entra (login genitore o link)",
    "dash.status.analytics.events.child_access_started.label": "Accesso bambino",
    "dash.status.analytics.events.child_first_claim_email_sent.description": "Email transazionale di claim inviata al genitore",
    "dash.status.analytics.events.child_first_claim_email_sent.label": "Email di sblocco inviata",
    "dash.status.analytics.events.child_first_claim_opened.description": "Il genitore apre l’anteprima del link /claim",
    "dash.status.analytics.events.child_first_claim_opened.label": "Link sblocco aperto",
    "dash.status.analytics.events.child_first_claimed.description": "Il genitore sblocca il papero pending nella famiglia",
    "dash.status.analytics.events.child_first_claimed.label": "Papero sbloccato",
    "dash.status.analytics.events.child_first_family_activated.description": "Famiglia pronta a giocare dopo il claim child-first",
    "dash.status.analytics.events.child_first_family_activated.label": "Famiglia child-first attivata",
    "dash.status.analytics.events.child_first_parent_email_submitted.description": "Il bambino inserisce l’email del genitore/tutore",
    "dash.status.analytics.events.child_first_parent_email_submitted.label": "Email genitore inviata",
    "dash.status.analytics.events.child_first_started.description": "Il bambino avvia Crea il mio papero",
    "dash.status.analytics.events.child_first_started.label": "Child-first iniziato",
    "dash.status.analytics.events.child_profile_created.description": "Viene creato il profilo del bambino",
    "dash.status.analytics.events.child_profile_created.label": "Profilo bambino creato",
    "dash.status.analytics.events.collectible_obtained.description": "Viene raccolto un oggetto",
    "dash.status.analytics.events.collectible_obtained.label": "Collezionabile ottenuto",
    "dash.status.analytics.events.family_activation_completed.description": "Esistono almeno adulto, bambino e primo accesso",
    "dash.status.analytics.events.family_activation_completed.label": "Famiglia attivata",
    "dash.status.analytics.events.family_created.description": "Un genitore crea il laghetto",
    "dash.status.analytics.events.family_created.label": "Famiglia creata",
    "dash.status.analytics.events.market_transaction.description": "Acquisto, vendita o negoziazione",
    "dash.status.analytics.events.market_transaction.label": "Transazione mercato",
    "dash.status.analytics.events.market_visited.description": "Accesso al mercato",
    "dash.status.analytics.events.market_visited.label": "Mercato visitato",
    "dash.status.analytics.events.mission_completed.description": "Missione conclusa",
    "dash.status.analytics.events.mission_completed.label": "Missione completata",
    "dash.status.analytics.events.mission_started.description": "Inizia una missione di gioco",
    "dash.status.analytics.events.mission_started.label": "Missione iniziata",
    "dash.status.analytics.events.parent_demo_converted.description": "Un genitore completa la demo e crea l’account",
    "dash.status.analytics.events.parent_demo_converted.label": "Demo famiglie convertita",
    "dash.status.analytics.events.parent_demo_keep_prompt.description": "Mostrata la proposta di tenere il papero",
    "dash.status.analytics.events.parent_demo_keep_prompt.label": "Demo famiglie: tieni il papero",
    "dash.status.analytics.events.parent_demo_parent_ui_complete.description": "Completata la panoramica UI famiglia",
    "dash.status.analytics.events.parent_demo_parent_ui_complete.label": "Demo famiglie: UI completata",
    "dash.status.analytics.events.parent_demo_started.description": "Avvio dal link pubblico Prova YOBY per famiglie",
    "dash.status.analytics.events.parent_demo_started.label": "Demo famiglie",
    "dash.status.analytics.events.parent_demo_tour_complete.description": "Completato il tour nel mondo",
    "dash.status.analytics.events.parent_demo_tour_complete.label": "Demo famiglie: tour finito",
    "dash.status.analytics.events.quiz_assigned.description": "Il docente assegna un quiz",
    "dash.status.analytics.events.quiz_assigned.label": "Quiz assegnato",
    "dash.status.analytics.events.quiz_completed.description": "Il quiz viene concluso",
    "dash.status.analytics.events.quiz_completed.label": "Quiz completato",
    "dash.status.analytics.events.quiz_started.description": "Il bambino apre il quiz",
    "dash.status.analytics.events.quiz_started.label": "Quiz iniziato",
    "dash.status.analytics.events.real_task_assigned.description": "Il genitore assegna un compito reale",
    "dash.status.analytics.events.real_task_assigned.label": "Compito reale assegnato",
    "dash.status.analytics.events.real_task_completed.description": "Il bambino dichiara il completamento",
    "dash.status.analytics.events.real_task_completed.label": "Compito reale fatto",
    "dash.status.analytics.events.real_task_validated.description": "Il genitore convalida il compito",
    "dash.status.analytics.events.real_task_validated.label": "Compito reale validato",
    "dash.status.analytics.events.reward_claimed.description": "Il bambino usa o riscuote il premio",
    "dash.status.analytics.events.reward_claimed.label": "Premio riscosso",
    "dash.status.analytics.events.reward_distributed.description": "Il genitore assegna il premio al figlio",
    "dash.status.analytics.events.reward_distributed.label": "Premio distribuito",
    "dash.status.analytics.events.reward_earned.description": "Una ricompensa viene ottenuta",
    "dash.status.analytics.events.reward_earned.label": "Premio ottenuto",
    "dash.status.analytics.events.session_ended.description": "Esce o diventa inattivo",
    "dash.status.analytics.events.session_ended.label": "Sessione terminata",
    "dash.status.analytics.events.session_started.description": "Qualcuno entra nel gioco",
    "dash.status.analytics.events.session_started.label": "Sessione iniziata",
    "dash.status.analytics.events.shared_family_session.description": "Adulto e bambino sono presenti insieme",
    "dash.status.analytics.events.shared_family_session.label": "Sessione famiglia insieme",
    "dash.status.analytics.events.subscription_cancelled.description": "Disdetta abbonamento",
    "dash.status.analytics.events.subscription_cancelled.label": "Abbonamento disdetto",
    "dash.status.analytics.events.subscription_started.description": "Attivazione Family o Patron",
    "dash.status.analytics.events.subscription_started.label": "Abbonamento attivato",
    "dash.status.analytics.events.teacher_demo_converted.description": "Un docente completa la demo e crea l’account",
    "dash.status.analytics.events.teacher_demo_converted.label": "Demo docenti convertita",
    "dash.status.analytics.events.teacher_demo_keep_prompt.description": "Mostrata la proposta di tenere il papero",
    "dash.status.analytics.events.teacher_demo_keep_prompt.label": "Demo docenti: tieni il papero",
    "dash.status.analytics.events.teacher_demo_started.description": "Avvio dal link pubblico Prova YOBY per docenti",
    "dash.status.analytics.events.teacher_demo_started.label": "Demo docenti",
    "dash.status.analytics.events.teacher_demo_teacher_ui_complete.description": "Completata la panoramica UI insegnante",
    "dash.status.analytics.events.teacher_demo_teacher_ui_complete.label": "Demo docenti: UI completata",
    "dash.status.analytics.events.teacher_demo_tour_complete.description": "Completato il tour nel mondo",
    "dash.status.analytics.events.teacher_demo_tour_complete.label": "Demo docenti: tour finito",
    "dash.status.analytics.events.temporary_link_generated.description": "Viene creato un link temporaneo",
    "dash.status.analytics.events.temporary_link_generated.label": "Link temporaneo creato",
    "dash.status.analytics.events.temporary_link_used.description": "Il link viene realmente usato",
    "dash.status.analytics.events.temporary_link_used.label": "Link temporaneo usato",
    "dash.status.charts.acq_age_doughnut.title": "Profili bambino per fascia d’età",
    "dash.status.charts.acq_child_first_funnel.title": "Funnel papero child-first",
    "dash.status.charts.acq_child_first_trend.title": "Trend child-first",
    "dash.status.charts.acq_demo_bar.title": "Demo da link pubblici",
    "dash.status.charts.acq_demo_trend.title": "Trend demo da link",
    "dash.status.charts.acq_funnel.title": "Funnel acquisizione",
    "dash.status.charts.acq_plan_doughnut.title": "Piani abbonamento",
    "dash.status.charts.acq_trend_line.title": "Trend acquisizione",
    "dash.status.charts.eco_age_doughnut.title": "Ricompensa per fascia d’età",
    "dash.status.charts.eco_arcade_line.title": "Attività arcade",
    "dash.status.charts.eco_chores_funnel.title": "Funnel compiti reali",
    "dash.status.charts.eco_collectibles_line.title": "Collezionabili",
    "dash.status.charts.eco_market_bar.title": "Attività mercato",
    "dash.status.charts.eco_reward_origin.title": "Origine premi",
    "dash.status.charts.eco_reward_volume.title": "Volume premi",
    "dash.status.charts.eng_access_doughnut.title": "Canali accesso bambino",
    "dash.status.charts.eng_age_doughnut.title": "Sessioni per fascia d’età",
    "dash.status.charts.eng_device_bar.title": "Sessioni per dispositivo",
    "dash.status.charts.eng_links_bar.title": "Link temporanei",
    "dash.status.charts.eng_sessions_line.title": "Sessioni per ruolo",
    "dash.status.charts.eng_shared_line.title": "Sessioni famiglia insieme",
    "dash.status.charts.learn_age_doughnut.title": "Quiz completati per fascia d’età",
    "dash.status.charts.learn_duration_bar.title": "Durata media",
    "dash.status.charts.learn_mission_host.title": "Missioni per personaggio",
    "dash.status.charts.learn_mission_trend.title": "Trend missioni",
    "dash.status.charts.learn_quiz_funnel.title": "Funnel quiz",
    "dash.status.charts.learn_quiz_trend.title": "Trend quiz",
    "dash.status.charts.live_age_bar.title": "Online per fascia d’età",
    "dash.status.charts.live_realm_pie.title": "Online per realm",
    "dash.status.charts.live_role_bar.title": "Online per ruolo",
    "dash.status.daysLabel": "Giorni",
    "dash.status.errLoad": "Impossibile caricare lo status.",
    "dash.status.lastAccessTitle": "Ultimo accesso",
    "dash.status.loading": "Caricamento…",
    "dash.status.logAll": "Tutti",
    "dash.status.logFilter": "Evento",
    "dash.status.refresh": "Aggiorna",
    "dash.status.report.anonymized": "Report anonimizzato: nessuna email o nome persona.",
    "dash.status.report.failed": "Generazione report non riuscita. Riprova.",
    "dash.status.report.generate": "Genera report",
    "dash.status.report.generating": "Elaborazione in corso",
    "dash.status.report.impossible": "Impossibile generare il report: non ci sono ancora dati analytics nel periodo selezionato.",
    "dash.status.report.overviewTitle": "Commento generale",
    "dash.status.report.pdfAnalysisTitle": "Analisi",
    "dash.status.report.pdfChartsTitle": "Grafici",
    "dash.status.report.pdfKpisTitle": "Indicatori chiave",
    "dash.status.report.pdfPage": "Pagina {n} di {total}",
    "dash.status.report.pdfPeriod": "Periodo: ultimi {days} giorni",
    "dash.status.report.pdfTitle": "Report analytics Yoby",
    "dash.status.report.pdfUnavailable": "Libreria PDF non disponibile.",
    "dash.status.report.previewFailed": "Impossibile mostrare l’anteprima PDF.",
    "dash.status.report.previewPreparing": "Preparazione anteprima PDF…",
    "dash.status.report.readyAt": "Generato",
    "dash.status.report.savePdf": "Salva PDF",
    "dash.status.report.waiting": "Report in elaborazione… attendere.",
    "dash.status.sectionOnline": "Online adesso",
    "dash.status.sectionOnlineAge": "Online per fascia d’età",
    "dash.status.sectionTotals": "Totali (esclusi mondi conference attivi)",
    "dash.status.sectionTotalsAge": "Personaggi per fascia d’età",
    "dash.status.subtitle": "Presenza in gioco e analytics di prodotto.",
    "dash.status.summaryChildren": "Bambini online",
    "dash.status.summaryFamilies": "Famiglie in gioco",
    "dash.status.summaryInGame": "In gioco (totale)",
    "dash.status.summaryParents": "Genitori online",
    "dash.status.summaryPlayers": "Giocatori in gioco",
    "dash.status.summaryQueueDepth": "Coda analytics",
    "dash.status.summaryRows": "Righe ultimo accesso",
    "dash.status.summarySurface": "In superficie",
    "dash.status.summaryUnderground": "Nel sottosuolo",
    "dash.status.summaryWorldsActive": "Mondi con giocatori online",
    "dash.status.summaryWorldsOpened": "Mondi aperti",
    "dash.status.tabs.acquisition": "Acquisizione",
    "dash.status.tabs.economy": "Economy",
    "dash.status.tabs.engagement": "Engagement",
    "dash.status.tabs.learning": "Learning",
    "dash.status.tabs.live": "Live",
    "dash.status.tabs.logs": "Log",
    "dash.status.tabs.report": "Report",
    "dash.status.thAgeBand": "Fascia",
    "dash.status.thEmailName": "Email / Nome",
    "dash.status.thEvent": "Evento",
    "dash.status.thFamily": "Famiglia",
    "dash.status.thLastAccess": "Ultimo accesso",
    "dash.status.thRole": "Ruolo",
    "dash.status.thSummary": "Riepilogo",
    "dash.status.thTime": "Ora",
    "dash.status.thWorld": "Mondo",
    "dash.status.thWorldFamilies": "Famiglie",
    "dash.status.thWorldPlayers": "Giocatori",
    "dash.status.thWorldSurface": "Superficie",
    "dash.status.thWorldUnderground": "Sottosuolo",
    "dash.status.title": "Status",
    "dash.status.totalChildren": "Bambini (totale)",
    "dash.status.totalFamilies": "Famiglie (totale)",
    "dash.status.totalParents": "Genitori (totale)",
    "dash.status.totalPlayers": "Personaggi (totale)",
    "dash.status.updated": "Aggiornato",
    "dash.status.worldsTitle": "Dettaglio per mondo",
    "dash.supervisor.csvDownloaded": "CSV scaricato",
    "dash.supervisor.errAudit": "Impossibile caricare il registro audit.",
    "dash.supervisor.errDenied": "Accesso non autorizzato. Accedi come supervisore o admin YOBY.",
    "dash.supervisor.errExport": "Impossibile esportare il CSV.",
    "dash.supervisor.exportCsvSchool": "Export CSV scuola",
    "dash.supervisor.hintAudit": "Ultime azioni registrate per la scuola.",
    "dash.supervisor.hintQuizzes": "Utilizzo quiz per slug (tentativi completati nella scuola).",
    "dash.supervisor.metaSlug": "Slug",
    "dash.supervisor.metaStatus": "Stato",
    "dash.supervisor.metricSchoolAvg": "Media scuola",
    "dash.supervisor.noAudit": "Nessuna voce di audit.",
    "dash.supervisor.noClasses": "Nessuna classe.",
    "dash.supervisor.noQuizzes": "Nessun dato quiz.",
    "dash.supervisor.noSchools": "Nessuna scuola assegnata.",
    "dash.supervisor.noTeachers": "Nessun docente.",
    "dash.supervisor.refresh": "Aggiorna",
    "dash.supervisor.selectSchoolHint": "Seleziona una scuola per vedere classi, docenti e statistiche quiz.",
    "dash.supervisor.subtitle": "Panoramica scuole, classi, docenti, quiz e audit.",
    "dash.supervisor.tabAudit": "Audit",
    "dash.supervisor.tabClasses": "Classi",
    "dash.supervisor.tabQuizzes": "Quiz",
    "dash.supervisor.tabTeachers": "Docenti",
    "dash.supervisor.thAssignments": "Compiti",
    "dash.supervisor.thSchool": "Scuola",
    "dash.supervisor.thTeacher": "Docente",
    "dash.supervisor.title": "Dashboard Supervisore",
    "dash.supervisor.yourSchools": "Le tue scuole",
    "dash.teacher.catalogTitle": "Catalogo quiz",
    "dash.teacher.confirmArchiveClass": "Archiviare questa classe? Il codice non sarà più utilizzabile.",
    "dash.teacher.copied": "Copiato!",
    "dash.teacher.copyCode": "Copia codice",
    "dash.teacher.createClass": "Crea una classe",
    "dash.teacher.demoLink": "Link demo",
    "dash.teacher.demoLinkCopied": "Link copiato negli appunti.",
    "dash.teacher.demoLinkReady": "Link permanente creato",
    "dash.teacher.errArchive": "Impossibile archiviare la classe.",
    "dash.teacher.errAssign": "Impossibile assegnare il quiz.",
    "dash.teacher.errCreateClass": "Impossibile creare la classe.",
    "dash.teacher.errDemoDenied": "Solo gli admin possono creare link demo.",
    "dash.teacher.errDemoLink": "Impossibile creare il link demo.",
    "dash.teacher.errDemoNoQuiz": "Nessun quiz libero da assegnare a questa classe.",
    "dash.teacher.errDenied": "Accesso non autorizzato. Accedi come docente.",
    "dash.teacher.errExport": "Impossibile esportare il CSV.",
    "dash.teacher.errExportCatalog": "Impossibile esportare il catalogo quiz.",
    "dash.teacher.errLoadClasses": "Impossibile caricare le classi.",
    "dash.teacher.errNoTeacher": "Profilo docente non trovato.",
    "dash.teacher.errRegen": "Impossibile rigenerare il codice.",
    "dash.teacher.errSelectSchool": "Seleziona prima una scuola.",
    "dash.teacher.exportCatalogCsv": "Scarica catalogo CSV (tutte le lingue)",
    "dash.teacher.exportCsv": "Export CSV",
    "dash.teacher.hintAssign": "Scegli categoria, quiz e impostazioni del compito.",
    "dash.teacher.hintWrong": "Domande con più errori negli ultimi compiti assegnati.",
    "dash.teacher.metaAge": "Età",
    "dash.teacher.metaCode": "Codice",
    "dash.teacher.metaLang": "Lingua",
    "dash.teacher.metaYear": "Anno",
    "dash.teacher.metricAssignments": "Compiti",
    "dash.teacher.metricAttempts": "Tentativi",
    "dash.teacher.metricClassAvg": "Media classe",
    "dash.teacher.metricEnrolled": "Iscritti",
    "dash.teacher.newCode": "Nuovo codice",
    "dash.teacher.noAssignments": "Nessun compito.",
    "dash.teacher.noCatalog": "Nessun quiz nel catalogo.",
    "dash.teacher.noClasses": "Nessuna classe.",
    "dash.teacher.noStudents": "Nessuno studente iscritto.",
    "dash.teacher.noWrong": "Nessuna domanda difficile.",
    "dash.teacher.open": "Apri",
    "dash.teacher.playLink": "Link di gioco",
    "dash.teacher.playLinkCopied": "Link copiato negli appunti.",
    "dash.teacher.playLinkFailed": "Impossibile creare il link di gioco",
    "dash.teacher.playLinkHint": "Gli alunni aprono il link e toccano il proprio nome. Supervisionare la scelta.",
    "dash.teacher.playLinkHours": "Ore",
    "dash.teacher.playLinkReady": "Link di gioco creato",
    "dash.teacher.quizColChoices": "Risposte",
    "dash.teacher.quizColOrder": "#",
    "dash.teacher.quizColQuestion": "Domanda",
    "dash.teacher.quizLoadError": "Impossibile caricare il quiz.",
    "dash.teacher.quizLoading": "Caricamento quiz…",
    "dash.teacher.quizPreviewTitle": "Anteprima quiz",
    "dash.teacher.selectClassHint": "Seleziona una classe per vedere i dettagli.",
    "dash.teacher.statusAssigned": "Quiz assegnato.",
    "dash.teacher.statusAssigning": "Assegnazione quiz…",
    "dash.teacher.statusClassCreated": "Classe creata.",
    "dash.teacher.statusCreating": "Creazione classe…",
    "dash.teacher.subtitle": "Classi, codici iscrizione, compiti quiz, risultati e export.",
    "dash.teacher.surveyFeedbackFinal": "A fine quiz",
    "dash.teacher.surveyFeedbackImmediate": "Immediato dopo ogni domanda",
    "dash.teacher.tabAssign": "Assegna quiz",
    "dash.teacher.tabAssignments": "Compiti",
    "dash.teacher.tabStudents": "Studenti",
    "dash.teacher.tabWrong": "Domande difficili",
    "dash.teacher.thAge": "Età",
    "dash.teacher.thAvg": "Media",
    "dash.teacher.thClass": "Classe",
    "dash.teacher.thCode": "Codice",
    "dash.teacher.thCompleted": "Completati",
    "dash.teacher.thDifficulty": "Difficoltà",
    "dash.teacher.thDone": "Compiti fatti",
    "dash.teacher.thDue": "Scadenza",
    "dash.teacher.thErrorPct": "% errori",
    "dash.teacher.thErrors": "Errori",
    "dash.teacher.thFirstName": "Nome",
    "dash.teacher.thJoined": "Iscritto",
    "dash.teacher.thLastName": "Cognome",
    "dash.teacher.thLastSeen": "Ultimo accesso",
    "dash.teacher.thMaxAttempts": "Tentativi max",
    "dash.teacher.thNickname": "Nickname",
    "dash.teacher.thPublish": "Pubblicazione",
    "dash.teacher.thQuestion": "Domanda",
    "dash.teacher.thTheme": "Tema",
    "dash.teacher.thTitle": "Titolo",
    "dash.teacher.thTotalAnswers": "Risposte totali",
    "dash.teacher.thYear": "Anno",
    "dash.teacher.title": "Dashboard Docente",
    "dash.teacher.yourClasses": "Le tue classi",
    "dash.teacher.yourClassesHint": "Seleziona una classe per vedere studenti, compiti e statistiche.",
    "dash.topic.bisogni_desideri": "Bisogni e desideri",
    "dash.topic.budget": "Budget",
    "dash.topic.consumo": "Consumo consapevole",
    "dash.topic.imprenditorialita": "Imprenditorialità",
    "dash.topic.lavoro": "Mondo del lavoro",
    "dash.topic.risparmio": "Risparmio",
    "footer.aria.site": "Piè di pagina",
    "footer.aria.social": "Link social",
    "footer.brand.tagline": "Il laghetto familiare dove bambini e grandi imparano i soldi insieme.",
    "footer.col.about": "About YOBY",
    "footer.col.aiAudits": "Ultimi audit di sicurezza AI",
    "footer.col.banksAndPartners": "Banche e partner",
    "footer.col.contact": "Contatti",
    "footer.col.cookiePolicy": "Cookie Policy",
    "footer.col.dataAndGdpr": "Dati e GDPR",
    "footer.col.investors": "Investitori",
    "footer.col.parentalControls": "Controllo genitori",
    "footer.col.partners.title": "Partner",
    "footer.col.press": "Press",
    "footer.col.privacyPolicy": "Privacy Policy",
    "footer.col.product.title": "Prodotto",
    "footer.col.roadmap": "Roadmap",
    "footer.col.safety": "Sicurezza",
    "footer.col.schools": "Scuole",
    "footer.col.termsOfService": "Termini di servizio",
    "footer.col.trust.title": "Sicurezza",
    "footer.col.yoby.title": "YOBY",
    "footer.copyright.line1": "© 2026 YOBY. Tutti i diritti riservati.",
    "footer.copyright.line2": "Creato in Europa per famiglie, papere e abitudini finanziarie migliori.",
    "home.about.feature1.body": "Uno spazio privato dove tutta la famiglia esplora, completa missioni e cresce insieme. Ogni membro ha la propria papera.",
    "home.about.feature1.title": "🦆 Un gioco di famiglia per imparare a gestire i soldi",
    "home.about.feature2.body": "La Rana, la Gazza, la Talpa e altri ti guidano con brevi missioni e domande a scelta. Impari facendo, non studiando.",
    "home.about.feature2.title": "🐸 Mentori che insegnano competenze finanziarie giocando",
    "home.about.feature3.body": "Tre valute simboliche per obiettivi, risparmio e buone abitudini. Un'economia di gioco che insegna senza sembrare una lezione.",
    "home.about.feature3.title": "🐚 Risparmio, obiettivi e abitudini in un'economia di gioco",
    "home.about.feature4.body": "Nessun bambino può ricevere contenuti inappropriati. Nessuna videochat senza un genitore presente. Progettato per i minori — non solo adattato.",
    "home.about.feature4.title": "🔒 Sicuro per progettazione",
    "home.about.title": "Cosa troverai nel mondo YOBY",
    "home.cta.choosePlan": "Scegli un piano",
    "home.cta.joinDescription": "Crea il tuo account familiare e inizia a esplorare.",
    "home.cta.joinTitle": "Tuffati. È gratis.",
    "home.cta.playNow": "Gioca ora",
    "home.cta.premiumActive": "Hai un piano premium — goditi l'esperienza completa!",
    "home.cta.premiumHint": "I piani premium offrono condizioni di gioco migliori: più conchiglie, aree esclusive e funzioni prioritarie.",
    "home.cta.ready": "Pronto a tuffarti di nuovo nello stagno?",
    "home.cta.signIn": "Accedi",
    "home.cta.signUpFree": "Inizia gratis",
    "home.cta.tryAsParent": "Sei un genitore? Prova YOBY",
    "home.cta.tryAsStudent": "Sei un insegnante? Prova YOBY",
    "home.cta.welcomeBack": "Bentornato",
    "home.cta.welcomeBackName": "Bentornato, {name}",
    "home.hero.childBody": "Crealo subito. Un genitore sbloccherà il laghetto quando sarete pronti.",
    "home.hero.childCta": "Crea il mio papero",
    "home.hero.childTitle": "Cerchi il tuo papero? 🦆",
    "home.hero.ctaPrimary": "Inizia gratis",
    "home.hero.ctaSecondary": "Scopri come funziona",
    "home.hero.description": "YOBY è un gioco di educazione finanziaria in cui bambini e genitori imparano insieme risparmio, scelte sul denaro e obiettivi.",
    "home.hero.tagline": "I soldi parlano, finalmente divertendosi.",
    "home.hero.title": "Educazione finanziaria per bambini e famiglie, resa divertente.",
    "home.hero.visualAlt": "Il mondo di YOBY con paperi che esplorano il laghetto di famiglia",
    "home.learn.choices.body": "Affronta scelte quotidiane — spendere ora, risparmiare o condividere — in missioni sicure e narrative.",
    "home.learn.choices.title": "Scelte",
    "home.learn.goals.body": "Dai un nome a ciò che conta, pianifica e festeggia i progressi lungo il percorso.",
    "home.learn.goals.title": "Obiettivi",
    "home.learn.saving.body": "Metti da parte le conchiglie per dopo e guarda piccoli passi diventare obiettivi più grandi.",
    "home.learn.saving.title": "Risparmio",
    "home.learn.title": "Cosa imparano i bambini",
    "home.learn.value.body": "Collega impegno, tempo e risorse così i bambini capiscono cosa rappresenta il denaro.",
    "home.learn.value.title": "Valore del denaro",
    "home.links.families": "Educazione finanziaria per famiglie",
    "home.links.kids": "YOBY per bambini",
    "home.links.schools": "Educazione finanziaria per le scuole",
    "home.links.title": "Esplora YOBY",
    "home.seo.description": "YOBY è un mondo giocoso di educazione finanziaria dove bambini e genitori imparano risparmio, scelte sul denaro e sane abitudini insieme.",
    "home.seo.title": "Educazione finanziaria per bambini e famiglie | YOBY",
    "home.seoSection.body": "YOBY trasforma l'educazione finanziaria per bambini in un'avventura condivisa. In un mondo di stagni giocosi, bambini e genitori praticano il risparmio, fissano obiettivi insieme e discutono le scelte quotidiane sul denaro. Personaggi mentore e brevi missioni guidano l'apprendimento del denaro attraverso il gioco — non schede o lezioni. Se cerchi educazione finanziaria per famiglie a casa, YOBY incontra i bambini dove sono: curiosi, creativi e pronti a esplorare. Ogni membro della famiglia ha la propria papera in uno stagno condiviso solo con persone di fiducia. Conchiglie, semi e stelle rappresentano abitudini reali — pazienza, pianificazione e comprensione del valore di ciò che si guadagna. Lungo il percorso, i bambini imparano che le piccole scelte contano, che aspettare può valerne la pena e che il denaro è uno strumento per gli obiettivi — non solo per spendere. I genitori restano coinvolti con visibilità e controlli chiari in uno spazio progettato per i minori fin dall'inizio.",
    "home.seoSection.title": "Educazione finanziaria per bambini, attraverso il gioco",
    "home.showcase.aria": "Screenshot del gioco",
    "home.showcase.card1.alt": "Gioco YOBY di educazione finanziaria familiare con genitori e bambini che esplorano uno stagno virtuale",
    "home.showcase.card1.title": "Stagno di famiglia — esplorate insieme",
    "home.showcase.card2.alt": "Personaggi mentore YOBY che insegnano ai bambini il denaro con missioni giocose",
    "home.showcase.card2.title": "Incontra i mentori — impara giocando",
    "home.showcase.card3.alt": "Quiz di educazione finanziaria YOBY e negozi del villaggio con dialoghi localizzati",
    "home.showcase.card3.title": "Quiz, negozi e vita nel villaggio",
    "home.showcase.card4.alt": "Mentori sotterranei YOBY che insegnano il denaro con missioni cinematiche",
    "home.showcase.card4.title": "Mentori sotterranei e missioni",
    "home.showcase.card5.alt": "Mercato del Tasso YOBY dove i bambini praticano scelte sul denaro",
    "home.showcase.card5.title": "Mercati e scelte sul denaro",
    "home.showcase.card6.alt": "Mini-gioco Corsa pazza di YOBY: i bambini corrono sul prato raccogliendo oggetti di stagione a tempo",
    "home.showcase.card6.title": "Corsa pazza — una gara a tempo sul prato",
    "home.showcase.hint": "Tocca per ingrandire",
    "home.showcase.title": "Scopri il mondo",
    "lang.switch": "Lingua",
    "nav.account": "Account",
    "nav.actions.signIn": "Accedi",
    "nav.actions.startFree": "Inizia gratis",
    "nav.actions.talkWithUs": "Parla con noi",
    "nav.aria.main": "Navigazione principale",
    "nav.aria.staff": "Area scuola e amministrazione",
    "nav.footer.schoolSignup": "Iscrivi la tua scuola",
    "nav.main.blog": "Blog",
    "nav.main.forFamilies": "Per famiglie",
    "nav.main.forKids": "Per bambini",
    "nav.main.home": "Home",
    "nav.main.howItWorks": "Come funziona",
    "nav.main.pricing": "Prezzi",
    "nav.main.talkWithUs": "Parla con noi",
    "nav.menu": "Menu",
    "nav.searchPosts": "Cerca post, tag e autori",
    "nav.signIn": "Accedi",
    "nav.staff.admin": "Admin scuole",
    "nav.staff.adminSafety": "Ultimi audit di sicurezza AI",
    "nav.staff.conference": "Conference call",
    "nav.staff.massmail": "Massmail scuole",
    "nav.staff.redteam": "AI Red Team",
    "nav.staff.schoolSignups": "Iscrizioni scuole",
    "nav.staff.status": "Status gioco",
    "nav.staff.supervisor": "Dashboard supervisore",
    "nav.staff.teacher": "Dashboard docente",
    "nav.subscribe": "Iscriviti",
    "safetyLab.areasTitle": "Temi che controlliamo",
    "safetyLab.audience": "Per famiglie e scuole",
    "safetyLab.cat.abuse": "Abuso",
    "safetyLab.cat.dangerous_behavior": "Comportamenti pericolosi",
    "safetyLab.cat.distress_support": "Supporto emotivo (consentito)",
    "safetyLab.cat.drugs": "Droghe",
    "safetyLab.cat.hate": "Odio",
    "safetyLab.cat.inappropriate_instructions": "Istruzioni inappropriate",
    "safetyLab.cat.jailbreak": "Prompt injection",
    "safetyLab.cat.off_topic": "Fuori tema",
    "safetyLab.cat.other": "Altri controlli di sicurezza",
    "safetyLab.cat.personal_data": "Dati personali",
    "safetyLab.cat.self_harm": "Autolesionismo",
    "safetyLab.cat.sexual": "Contenuti sessuali inappropriati",
    "safetyLab.cat.violence": "Violenza",
    "safetyLab.chartEmpty": "Quando ci saranno più audit, qui vedrai il trend.",
    "safetyLab.chartOutcomes": "Come è andato l’ultimo audit",
    "safetyLab.chartTrend": "Andamento degli ultimi audit",
    "safetyLab.historyEmpty": "Nessun audit completato.",
    "safetyLab.historyTitle": "Storico recente",
    "safetyLab.languages": "Lingue del test",
    "safetyLab.lastTested": "Ultimo audit",
    "safetyLab.legendCritical": "Critico: rischio alto; ha priorità massima.",
    "safetyLab.legendFail": "Fallito: qualcosa non ha reagito come doveva — lo correggiamo.",
    "safetyLab.legendPass": "Superato: il filtro ha reagito come previsto.",
    "safetyLab.legendTitle": "Cosa significano i risultati",
    "safetyLab.legendWarning": "Avviso: spesso un falso positivo (troppo severo su un messaggio innocuo), non un rischio per i bambini.",
    "safetyLab.loadFailed": "Impossibile caricare gli audit di sicurezza.",
    "safetyLab.loading": "Caricamento degli ultimi audit…",
    "safetyLab.method1": "Il cuore del controllo è il Safety Gate: lo stesso filtro che intercetta i messaggi in gioco (ingresso e, in alcuni casi, uscita). Ogni scenario di test manda un messaggio (o una sequenza) e verifica se il filtro consente, reindirizza o blocca come previsto.",
    "safetyLab.method2": "Nella suite completa sottoponiamo al controllo tutti i personaggi AI con cui un bambino può parlare: laghetto di superficie (granchio, rana, gazza, papera, talpa, loris, castoro), sottosuolo (assolotto, pipistrello, riccio, gambero, tasso, talpa) e tutor (pellicano, dotto). Esistono anche run «quick» più veloci, con un solo personaggio e una sola fascia d’età per scenario: i personaggi elencati sopra riflettono sempre solo ciò che quella run ha davvero eseguito.",
    "safetyLab.method3": "Gli scenari coprono temi sensibili e tentativi di elusione: contenuti sessuali inappropriati, violenza, autolesionismo, abuso, droghe, odio, dati personali, istruzioni pericolose, manipolazione dei prompt (jailbreak), messaggi fuori tema e anche casi benigni o di supporto emotivo che devono restare consentiti. Molti scenari girano in più lingue (fino a it, en, fr, es, pt, de, nl) e su fasce d’età diverse.",
    "safetyLab.method4": "Ogni caso riceve un esito: superato, avviso, fallito o critico. Un avviso spesso indica un falso positivo (filtro troppo severo su un messaggio innocuo), non un rischio per i bambini. Un fallimento o un critico significa che qualcosa non ha reagito come doveva e va corretto. Mostriamo sempre l’ultima run completata, anche se non è verde: non sostituiamo un risultato cattivo con uno buono più vecchio.",
    "safetyLab.method5": "Per non aiutare chi vuole aggirare le protezioni, non pubblichiamo i testi degli attacchi, le ricette di jailbreak né le trascrizioni complete. In pubblico vedi aggregati, categorie e date; i dettagli tecnici restano interni.",
    "safetyLab.method6": "La libreria di scenari cresce nel tempo: quando troviamo una debolezza, aggiungiamo un caso di regressione e lo teniamo. Se non c’è ancora nessun audit completato, lo diciamo chiaramente («non ancora testato»).",
    "safetyLab.methodIntro": "YOBY esegue audit automatici di sicurezza sull’AI rivolta ai bambini. Non inventiamo i numeri: ogni cifra su questa pagina proviene da un’esecuzione reale salvata nel nostro sistema. Qui sotto spieghiamo cosa facciamo, cosa misuriamo e cosa non mostriamo di proposito.",
    "safetyLab.methodTitle": "Come vengono effettuati i test",
    "safetyLab.metricCritical": "Critici",
    "safetyLab.metricExecuted": "Casi controllati",
    "safetyLab.metricFail": "Falliti",
    "safetyLab.metricPass": "Superati",
    "safetyLab.metricPassRate": "Tasso di successo",
    "safetyLab.metricWarning": "Avvisi",
    "safetyLab.never": "Non ancora eseguito",
    "safetyLab.noteParents": "Questa pagina è pensata per genitori e insegnanti. Puoi consultarla in qualsiasi momento: è un resoconto pubblico degli ultimi audit, non una pagina di marketing con numeri inventati.",
    "safetyLab.npcs": "Personaggi AI coperti",
    "safetyLab.plainLead": "YOBY prova continuamente a “mettere alla prova” i personaggi AI, come farebbe un audit di sicurezza. Qui vedi l’esito più recente — senza i dettagli tecnici degli attacchi.",
    "safetyLab.statusCritical": "Problemi gravi rilevati",
    "safetyLab.statusError": "Ultimo audit non completato",
    "safetyLab.statusIssues": "Ci sono punti da migliorare",
    "safetyLab.statusNever": "Nessun audit ancora disponibile",
    "safetyLab.statusPass": "Tutto in ordine",
    "safetyLab.subtitle": "Risultati reali dei controlli automatici sull’AI che parla con i bambini. Pensati per genitori e insegnanti.",
    "safetyLab.thCases": "Casi",
    "safetyLab.thDate": "Data",
    "safetyLab.thStatus": "Esito",
    "safetyLab.title": "Ultimi audit di sicurezza AI",
    "footer.col.genderEquality": "Parità di genere",
    "dash.booking.gcalRefreshHint": "Dopo una prenotazione, usa «Aggiorna calendario» se l’evento non compare su Google.",
    "dash.conference.delivery.title": "Consegna email",
    "dash.conference.delivery.untracked": "Esito non disponibile",
    "dash.conference.delivery.invite": "Invito",
    "dash.conference.delivery.reschedule": "Cambio appuntamento",
    "dash.conference.delivery.reminder": "Promemoria",
    "dash.conference.delivery.pending": "Preparazione",
    "dash.conference.delivery.accepted": "Accettata da Mailgun",
    "dash.conference.delivery.delivered": "Consegnata al server destinatario",
    "dash.conference.delivery.deferred": "Ritardo temporaneo",
    "dash.conference.delivery.failed": "Invio o consegna falliti",
    "dash.conference.delivery.dry_run": "Simulata, non inviata",
    "dash.conference.delivery.confirmation": "La tua presenza è confermata",
    "footer.col.accessibility": "Accessibilità",
    "accessibility.title": "Accessibilità su YOBY",
    "accessibility.intro": "Vogliamo rendere le informazioni di YOBY più facili da leggere e utilizzare. Qui spieghiamo gli strumenti disponibili sul sito e i limiti attuali del gioco.",
    "accessibility.site.title": "Il sito informativo",
    "accessibility.site.body": "Le pagine del sito offrono contenuti testuali, collegamenti di navigazione e un pannello per personalizzare la visualizzazione. Puoi adattare la lettura alle tue esigenze e raggiungere il contenuto principale tramite un collegamento da tastiera.",
    "accessibility.site.status": "Queste funzioni sono un supporto, non una garanzia di accessibilità completa. Non dichiariamo una conformità complessiva a standard di accessibilità sulla base del solo widget; non abbiamo completato una verifica completa di tutte le pagine, dei moduli e dei servizi integrati.",
    "accessibility.preferences.title": "Personalizza la visualizzazione",
    "accessibility.preferences.body": "Apri il pannello dall’icona Accessibilità nella barra di navigazione oppure con Alt+Shift+A su Windows/Linux e ⌥ Option+Shift+A su Mac. Le modifiche si applicano subito alle pagine del sito.",
    "accessibility.preferences.contrast": "Contrasto elevato: aumenta il contrasto visivo della pagina.",
    "accessibility.preferences.invert": "Inverti colori: inverte i colori di sfondi e contenuti, comprese le immagini.",
    "accessibility.preferences.size": "Testo più grande: passa tra dimensione normale, grande ed extra grande.",
    "accessibility.preferences.spacing": "Spaziatura testo: aumenta la spaziatura di lettura nei contenuti supportati.",
    "accessibility.preferences.focus": "Evidenzia focus: rende più visibile il controllo selezionato con la tastiera.",
    "accessibility.preferences.links": "Sottolinea link: aggiunge una sottolineatura ai collegamenti.",
    "accessibility.preferences.motion": "Riduci animazioni: riduce animazioni e transizioni della pagina.",
    "accessibility.preferences.font": "Font leggibile: usa un carattere sans-serif di sistema.",
    "accessibility.preferences.storage": "Le preferenze vengono salvate nella memoria locale di questo browser e non sono inviate a YOBY dal widget. Puoi annullarle con «Ripristina predefiniti». Non vengono sincronizzate tra dispositivi; se il browser blocca la memoria locale, il salvataggio potrebbe non essere disponibile.",
    "accessibility.keyboard.title": "Usare la tastiera",
    "accessibility.keyboard.body": "Il primo Tab mostra il collegamento «Vai al contenuto». Usa Tab e Shift+Tab per spostarti tra i controlli, Invio o Spazio per attivare i pulsanti. Nel pannello il focus resta tra i suoi controlli; Esc lo chiude e riporta il focus al punto da cui lo hai aperto.",
    "accessibility.game.title": "Il gioco: limiti attuali",
    "accessibility.game.body": "Il gioco è un’esperienza visiva e interattiva distinta dal sito informativo. Al momento non lo presentiamo come un’esperienza pienamente accessibile e non possiamo garantirne l’uso completo con lettori di schermo o con la sola tastiera.",
    "accessibility.game.limits": "Le preferenze del sito non rendono accessibile il mondo di gioco e non si applicano automaticamente alla scena 3D, alle interazioni o a tutti i suoi controlli. Anche i servizi incorporati, come i pannelli di accesso e registrazione, possono avere comportamenti e limiti propri. Se incontri una barriera, contattaci: possiamo raccogliere il problema e valutare come aiutarti, senza promettere che ogni attività sia già disponibile in una forma equivalente.",
    "accessibility.feedback.title": "Segnala una difficoltà",
    "accessibility.feedback.body": "Per aiutarci a capire il problema, indica la pagina o la funzione interessata, cosa stavi cercando di fare, il dispositivo e il browser e, se pertinente, la tecnologia assistiva utilizzata. Non serve condividere diagnosi o altri dati sanitari.",
    "accessibility.feedback.contact": "Contattaci per l’accessibilità",
    "auth.a11y.email": "Indirizzo email",
    "auth.a11y.subscribe": "Iscriviti",
    "auth.a11y.sent": "Email inviata. Controlla la posta per continuare.",
    "auth.a11y.termsRequired": "Accetta i termini per continuare.",
    "auth.a11y.close": "Chiudi finestra",
    "auth.a11y.account": "Account YOBY",
    "auth.a11y.sending": "Invio in corso…"
  },
  "fr": {
    "blog.title": "Blog",
    "dash.admin.approveSignup": "Approve",
    "dash.admin.errArchive": "Impossible d'archiver l'école.",
    "dash.admin.errAssign": "Impossible d'assigner le personnel.",
    "dash.admin.errCreateSchool": "Impossible de créer l'école.",
    "dash.admin.errDenied": "Accès refusé. Connectez-vous en tant qu'admin YOBY.",
    "dash.admin.errRoleNotAllowed": "Rôle non autorisé.",
    "dash.admin.errSaveSchool": "Impossible d’enregistrer l’école.",
    "dash.admin.errSignupApprove": "Could not approve the application.",
    "dash.admin.errSignupLoad": "Could not load school applications.",
    "dash.admin.errSignupReject": "Could not reject the application.",
    "dash.admin.errUserNotFound": "Utilisateur introuvable.",
    "dash.admin.linkAdminSafety": "Derniers audits de sécurité de l’IA",
    "dash.admin.linkMassmail": "Massmail écoles",
    "dash.admin.linkPlay": "Jeu familial",
    "dash.admin.linkRedteam": "AI Red Team",
    "dash.admin.linkStatus": "Statut du jeu",
    "dash.admin.linkSupervisor": "Tableau superviseur",
    "dash.admin.linkTeacher": "Tableau enseignant",
    "dash.admin.noSignups": "No school applications.",
    "dash.admin.noStaff": "Aucun membre du personnel.",
    "dash.admin.panelSchoolsForm": "Ajouter / modifier écoles",
    "dash.admin.panelSchoolsList": "Liste des écoles",
    "dash.admin.panelSignups": "Inscriptions écoles",
    "dash.admin.panelStaffForm": "Ajouter / modifier personnel",
    "dash.admin.panelStaffList": "Liste du personnel",
    "dash.admin.quickLinks": "Liens rapides",
    "dash.admin.rejectReason": "Rejection reason",
    "dash.admin.rejectSignup": "Reject",
    "dash.admin.schoolListHint": "Cliquez une ligne pour la modifier. Archiver demande confirmation.",
    "dash.admin.selectSchool": "Sélectionnez une école",
    "dash.admin.signupClasses": "Classes",
    "dash.admin.signupTeachers": "Teachers",
    "dash.admin.staffListHint": "Cliquez une ligne pour mettre à jour l’affectation et le rôle.",
    "dash.admin.statusAssigned": "Personnel assigné.",
    "dash.admin.statusAssigning": "Assignation du personnel…",
    "dash.admin.statusCreatingSchool": "Création de l'école…",
    "dash.admin.statusEditingSchool": "Modification de l’école — changez les champs et enregistrez.",
    "dash.admin.statusEditingStaff": "Modification du staff — mettez à jour et assignez.",
    "dash.admin.statusSavingSchool": "Enregistrement de l’école…",
    "dash.admin.statusSchoolCreated": "École créée.",
    "dash.admin.statusSchoolSaved": "École enregistrée.",
    "dash.admin.subtitle": "Créez des écoles et assignez enseignants et superviseurs. Connexion admin YOBY requise (e-mail dans ADMIN_EMAILS).",
    "dash.admin.surveyAssignStaff": "Assigner le personnel",
    "dash.admin.surveyCreateSchool": "Créer l'école",
    "dash.admin.surveySaveSchool": "Enregistrer l’école",
    "dash.admin.surveySchoolDesc": "Enregistrez une école dans le module YOBY.",
    "dash.admin.surveySchoolName": "Nom de l'école",
    "dash.admin.surveySchoolSlug": "Slug (optionnel)",
    "dash.admin.surveySchoolTitle": "Nouvelle école",
    "dash.admin.surveyStaffDesc": "Associez enseignants et superviseurs à une école.",
    "dash.admin.surveyStaffEmail": "E-mail du personnel",
    "dash.admin.surveyStaffForce": "Forcer l'assignation",
    "dash.admin.surveyStaffForceDesc": "Réassigner même si l'utilisateur appartient déjà à une autre école.",
    "dash.admin.surveyStaffRoleSupervisor": "Superviseur",
    "dash.admin.surveyStaffRoleTeacher": "Enseignant",
    "dash.admin.surveyStaffSchool": "École",
    "dash.admin.surveyStaffTitle": "Assigner le personnel",
    "dash.admin.surveyUpdateStaff": "Mettre à jour le staff",
    "dash.admin.tabSchoolsForm": "Ajouter / modifier écoles",
    "dash.admin.tabSchoolsList": "Liste des écoles",
    "dash.admin.tabSignups": "Inscriptions écoles",
    "dash.admin.tabStaffForm": "Ajouter / modifier personnel",
    "dash.admin.tabStaffList": "Liste du personnel",
    "dash.admin.tabsAria": "Administration scolaire",
    "dash.admin.title": "Administration scolaire YOBY",
    "dash.booking.active": "Réservations publiques actives",
    "dash.booking.addEmail": "Ajouter un email",
    "dash.booking.addHour": "Ajouter une plage",
    "dash.booking.attribution": "Comment ils nous ont trouvés",
    "dash.booking.availabilityHint": "Activez les réservations publiques sur /talk-with-us/. Horaires affinables lun–ven 09:00–19:00. Suspendez des dates ci-dessous.",
    "dash.booking.availabilityTitle": "Disponibilité publique",
    "dash.booking.availableSlots": "Créneaux disponibles",
    "dash.booking.blockDate": "Suspendre",
    "dash.booking.blockReason": "Motif",
    "dash.booking.blockReasonPlaceholder": "Motif (optionnel)",
    "dash.booking.blockedDatesHint": "Aucun créneau ces jours-là.",
    "dash.booking.blockedDatesTitle": "Dates suspendues",
    "dash.booking.blockedEmpty": "Aucune date suspendue.",
    "dash.booking.blockedOn": "Date",
    "dash.booking.blockedSaved": "Date suspendue.",
    "dash.booking.booking": "Réservation…",
    "dash.booking.bufferMinutes": "Buffer entre créneaux (minutes)",
    "dash.booking.calFreeDays": "Jours avec créneaux libres",
    "dash.booking.cancel": "Annuler",
    "dash.booking.cancelConfirm": "Annuler cette réservation ?",
    "dash.booking.cancelled": "annulée",
    "dash.booking.cancelledOk": "Réservation annulée.",
    "dash.booking.confirm": "Réserver",
    "dash.booking.confirmTitle": "Confirmer la réservation",
    "dash.booking.copyLink": "Copier le lien",
    "dash.booking.detailTitle": "Détail de la réservation",
    "dash.booking.doneBody": "Nous vous avons envoyé le lien par e-mail. Utilisez-le le jour de l’appel.",
    "dash.booking.doneLinkHint": "Si l'e-mail n'arrive pas, voici votre lien personnel :",
    "dash.booking.doneStatus": "Vérifiez aussi votre boîte mail.",
    "dash.booking.doneTitle": "Réservation confirmée",
    "dash.booking.emailsHint": "Ajoutez jusqu’à 3 emails — chacun reçoit un lien personnel.",
    "dash.booking.empty": "Aucune réservation ni appel programmé.",
    "dash.booking.errBlockDate": "Date invalide.",
    "dash.booking.errBlockExists": "Date déjà suspendue.",
    "dash.booking.errBook": "Impossible de finaliser la réservation.",
    "dash.booking.errCancel": "Impossible d’annuler.",
    "dash.booking.errEmails": "Saisissez au moins un email valide.",
    "dash.booking.errLoad": "Impossible de charger les réservations.",
    "dash.booking.errLoadSlots": "Impossible de charger les créneaux.",
    "dash.booking.errPickSlot": "Choisissez d’abord un créneau ci-dessus.",
    "dash.booking.errReschedule": "Impossible de reporter.",
    "dash.booking.errSave": "Impossible d’enregistrer.",
    "dash.booking.errSlotTaken": "Ce créneau n’est plus disponible.",
    "dash.booking.errTooManyEmails": "Maximum 3 emails par réservation.",
    "dash.booking.errUnblock": "Impossible de réactiver.",
    "dash.booking.errUrl": "Ce lien ne ressemble pas à une adresse web valide.",
    "dash.booking.formOptionalHint": "Tous les champs ci-dessous sont facultatifs. Vous pouvez nous en dire un peu sur vous, ou simplement venir dire bonjour. On verra ensemble.",
    "dash.booking.gcalCalendar": "Calendrier cible",
    "dash.booking.gcalConnect": "Connecter Google Calendar",
    "dash.booking.gcalConnectFailed": "Échec de la connexion Google Calendar.",
    "dash.booking.gcalConnected": "Google Calendar connecté.",
    "dash.booking.gcalDisconnect": "Déconnecter",
    "dash.booking.gcalDisconnectConfirm": "Déconnecter Google Calendar ?",
    "dash.booking.gcalDisconnected": "Google Calendar déconnecté.",
    "dash.booking.gcalMissing": "Prêt — cliquez Connecter pour autoriser Google (OAuth).",
    "dash.booking.gcalOk": "Google Calendar connecté.",
    "dash.booking.gcalRedirectHint": "URI de redirection à autoriser :",
    "dash.booking.gcalRefresh": "Actualiser le calendrier",
    "dash.booking.gcalRefreshConfirm": "Resynchroniser tous les rendez-vous futurs sur Google Calendar (horaires corrects sur le calendrier YOBY) ?",
    "dash.booking.gcalRefreshEmpty": "Aucun rendez-vous en cours ou à venir à synchroniser.",
    "dash.booking.gcalRefreshFailed": "Échec de l’actualisation du calendrier.",
    "dash.booking.gcalRefreshNeedReconnect": "Google Calendar inaccessible : déconnectez puis reconnectez, puis réessayez.",
    "dash.booking.gcalRefreshOk": "Calendrier actualisé : {synced}/{total} événements · {failed} échecs · {calendar}",
    "dash.booking.gcalServerMissing": "App OAuth manquante sur le serveur : créez un client Google Cloud « Web application », mettez CLIENT_ID/SECRET dans GOOGLE_CALENDAR_* du .env, redémarrez l’API.",
    "dash.booking.gcalTitle": "Google Calendar",
    "dash.booking.inactive": "Les réservations publiques ne sont pas actives.",
    "dash.booking.introBody": "Si vous préférez nous rencontrer plutôt que remplir un formulaire, vous pouvez réserver directement un échange avec l’équipe YOBY. Nous serons ravis de vous présenter le projet, de répondre à vos questions et d’explorer comment YOBY pourrait s’intégrer à votre famille, école, organisation ou idée de partenariat.",
    "dash.booking.introImageAlt": "Appel vidéo avec l’équipe YOBY — canards qui discutent en anglais, français et italien",
    "dash.booking.introInterpreter": "Vous parlez une autre langue ? Pas de problème : notre plateforme de visioconférence traduira la vôtre dans la nôtre et inversement.",
    "dash.booking.introLanguages": "Vous pouvez nous parler en anglais, en italien ou en français : Ricardo et Stefano parlent italien et anglais, tandis qu’Antonella, notre CRO, parle français, italien et anglais.",
    "dash.booking.introTitle": "Vous préférez en parler ?",
    "dash.booking.landingUrl": "Page d’arrivée",
    "dash.booking.linkLabel": "Un lien à consulter avant l’appel",
    "dash.booking.linkPlaceholder": "https://…",
    "dash.booking.listHint": "Cliquez une ligne pour gérer les invités et les liens. Les appels créés par l’admin apparaissent aussi.",
    "dash.booking.listTitle": "Réservations et appels programmés",
    "dash.booking.noLinkedCall": "Cette réservation n’a pas de conference liée.",
    "dash.booking.noSlots": "Aucun créneau libre ce jour-là.",
    "dash.booking.note": "Quelque chose que vous aimeriez nous dire ?",
    "dash.booking.notifyInvitees": "Prévenir les invités par e-mail (même lien, nouvel horaire)",
    "dash.booking.openCall": "Ouvrir la conférence",
    "dash.booking.orgLabel": "Organisation / projet",
    "dash.booking.orgPlaceholder": "École, entreprise, publication, fondation...",
    "dash.booking.pickDay": "Choisissez un jour",
    "dash.booking.prefLang.none": "Pas de préférence",
    "dash.booking.prefLangLabel": "Langue préférée",
    "dash.booking.publicSubtitle": "Choisissez un créneau. Vous recevrez un lien personnel pour la conférence.",
    "dash.booking.publicTitle": "Réserver un appel YOBY",
    "dash.booking.referrer": "Referrer",
    "dash.booking.rescheduleHint": "Changez la date et l’heure. Les liens personnels restent les mêmes.",
    "dash.booking.rescheduleTitle": "Reporter",
    "dash.booking.rescheduled": "Réservation reportée. Les liens n’ont pas changé.",
    "dash.booking.rulesHint": "Règles fixes : préavis d’au moins 48 h, lundi–vendredi 09:00–19:00 (Europe/Rome).",
    "dash.booking.save": "Enregistrer",
    "dash.booking.saveCall": "Enregistrer le nouvel horaire",
    "dash.booking.saved": "Disponibilité enregistrée.",
    "dash.booking.saving": "Enregistrement…",
    "dash.booking.slotMinutes": "Durée du créneau (minutes)",
    "dash.booking.sourceAdmin": "Appel programmé",
    "dash.booking.status": "Statut",
    "dash.booking.statusCancelled": "annulée",
    "dash.booking.statusDone": "terminée",
    "dash.booking.statusExpired": "expirée",
    "dash.booking.statusLive": "en cours",
    "dash.booking.statusUpcoming": "à venir",
    "dash.booking.timezone": "Votre fuseau horaire",
    "dash.booking.timezoneHint": "Les créneaux sont affichés dans le fuseau choisi. La disponibilité YOBY est lun–ven 09:00–19:00 (Europe/Rome).",
    "dash.booking.topic.banking_fintech": "Banque et fintech",
    "dash.booking.topic.families": "YOBY pour les familles",
    "dash.booking.topic.financial_education": "Éducation financière",
    "dash.booking.topic.investment": "Investissement",
    "dash.booking.topic.other": "Autre chose",
    "dash.booking.topic.partnership": "Partenariat",
    "dash.booking.topic.press": "Presse et interviews",
    "dash.booking.topic.research": "Recherche",
    "dash.booking.topic.school_pilot": "Pilote scolaire",
    "dash.booking.topicsLabel": "De quoi aimeriez-vous parler ?",
    "dash.booking.unblockDate": "Réactiver",
    "dash.booking.unblocked": "Date réactivée.",
    "dash.booking.utm": "Campagne (UTM)",
    "dash.booking.weekday0": "Dimanche",
    "dash.booking.weekday1": "Lundi",
    "dash.booking.weekday2": "Mardi",
    "dash.booking.weekday3": "Mercredi",
    "dash.booking.weekday4": "Jeudi",
    "dash.booking.weekday5": "Vendredi",
    "dash.booking.weekday6": "Samedi",
    "dash.booking.weeklyHours": "Horaires hebdomadaires",
    "dash.booking.who.bank": "Banque ou institution financière",
    "dash.booking.who.curious": "Simple curiosité",
    "dash.booking.who.educator": "Éducateur ou école",
    "dash.booking.who.empty": "Choisissez si vous voulez…",
    "dash.booking.who.foundation": "Fondation ou ONG",
    "dash.booking.who.investor": "Investisseur",
    "dash.booking.who.journalist": "Journaliste",
    "dash.booking.who.other": "Autre",
    "dash.booking.who.parent": "Parent",
    "dash.booking.who.public": "Institution publique",
    "dash.booking.who.startup": "Startup ou entreprise",
    "dash.booking.whoLabel": "Qui êtes-vous ?",
    "dash.booking.yourEmail": "Votre email",
    "dash.booking.yourEmails": "Emails des invités",
    "dash.booking.yourName": "Votre nom",
    "dash.common.actions": "Actions",
    "dash.common.actor": "Acteur",
    "dash.common.archive": "Archiver",
    "dash.common.assignments": "Devoirs",
    "dash.common.attempts": "Tentatives",
    "dash.common.avg": "Moyenne",
    "dash.common.cancel": "Annuler",
    "dash.common.class": "Classe",
    "dash.common.classes": "Classes",
    "dash.common.code": "Code",
    "dash.common.confirm": "Confirmer",
    "dash.common.confirmArchiveSchool": "Archiver cette école ?",
    "dash.common.confirmTitle": "Confirmation",
    "dash.common.copyCode": "Copier le code",
    "dash.common.csvDownloaded": "CSV téléchargé",
    "dash.common.difficulty": "Difficulté",
    "dash.common.email": "E-mail",
    "dash.common.entity": "Entité",
    "dash.common.exportCsv": "Exporter CSV",
    "dash.common.family": "Famille",
    "dash.common.lastAccess": "Dernier accès",
    "dash.common.loading": "Chargement…",
    "dash.common.name": "Nom",
    "dash.common.newCode": "Nouveau code",
    "dash.common.none": "—",
    "dash.common.ok": "OK",
    "dash.common.open": "Ouvrir",
    "dash.common.questions": "Questions",
    "dash.common.quiz": "Quiz",
    "dash.common.refresh": "Actualiser",
    "dash.common.role": "Rôle",
    "dash.common.school": "École",
    "dash.common.select": "Sélectionner",
    "dash.common.slug": "Slug",
    "dash.common.status": "Statut",
    "dash.common.students": "Élèves",
    "dash.common.teachers": "Enseignants",
    "dash.common.topic": "Thème",
    "dash.common.updated": "Mis à jour",
    "dash.common.when": "Quand",
    "dash.common.year": "Année",
    "dash.conference.addInvitee": "Ajouter un invité",
    "dash.conference.addInviteeHint": "Il reçoit un canard et un lien personnel. Vous pouvez envoyer l’invitation par e-mail tout de suite.",
    "dash.conference.addInviteeTitle": "Ajouter un invité",
    "dash.conference.addingInvitee": "Ajout…",
    "dash.conference.back": "Retour à la liste",
    "dash.conference.chat": "Chat",
    "dash.conference.confirmed": "Confirmée",
    "dash.conference.confirmedNo": "En attente",
    "dash.conference.confirmedYes": "Oui",
    "dash.conference.copied": "Lien copié.",
    "dash.conference.copiedShort": "Copié !",
    "dash.conference.copyLink": "Copier le lien",
    "dash.conference.create": "Créer l'appel",
    "dash.conference.createImmediate": "Créer une conférence immédiate",
    "dash.conference.createImmediateHint": "Seul le nom de l'appel/famille est requis. Crée un lien ouvert jusqu'à minuit (Europe/Rome).",
    "dash.conference.created": "Appel créé.",
    "dash.conference.createdImmediate": "Conférence ouverte créée — partagez le lien unique. Valable pour le reste de la journée.",
    "dash.conference.creating": "Création…",
    "dash.conference.detailTitle": "Liens d'invitation",
    "dash.conference.editHint": "Vous pouvez changer la date, l’heure, le nom et la langue. Les liens d’accès restent les mêmes.",
    "dash.conference.editTitle": "Reporter l’appel",
    "dash.conference.email": "Email",
    "dash.conference.emailDryRun": "Email dry-run (non envoyé).",
    "dash.conference.emailSent": "Accepté par Mailgun.",
    "dash.conference.empty": "Aucune conference call.",
    "dash.conference.emptyInvitees": "Aucun invité pour l’instant.",
    "dash.conference.ended": "Appel terminé.",
    "dash.conference.errAddInvitee": "Impossible d’ajouter l’invité. Vérifiez l’e-mail et le nom.",
    "dash.conference.errCallEnded": "L’appel est terminé : impossible d’ajouter des invités.",
    "dash.conference.errCopy": "Impossible de copier le lien.",
    "dash.conference.errCreate": "Impossible de créer l'appel.",
    "dash.conference.errDenied": "Accès refusé. Connectez-vous en tant qu'admin YOBY.",
    "dash.conference.errDuplicateInvitee": "Cet e-mail est déjà invité à cet appel.",
    "dash.conference.errEmail": "Impossible d'envoyer l'email.",
    "dash.conference.errLoad": "Impossible de charger les conference calls.",
    "dash.conference.errSave": "Impossible d’enregistrer les modifications.",
    "dash.conference.errWorldFull": "Monde conference plein : plus d’étangs libres.",
    "dash.conference.familyName": "Nom de famille",
    "dash.conference.firstName": "Prénom",
    "dash.conference.gameLocale": "Langue du jeu",
    "dash.conference.inviteeAdded": "Invité ajouté.",
    "dash.conference.inviteeCount": "Invités",
    "dash.conference.invitees": "Invités",
    "dash.conference.lastName": "Nom",
    "dash.conference.listTitle": "Appels planifiés",
    "dash.conference.mediaHealth.checking": "Vérification de Janus et Coturn…",
    "dash.conference.mediaHealth.coturn": "Coturn (TURN)",
    "dash.conference.mediaHealth.down": "DOWN",
    "dash.conference.mediaHealth.errLoad": "Impossible de lire l’état vidéo.",
    "dash.conference.mediaHealth.hintDown": "N’ouvrez pas l’appel : la vidéo WebRTC n’est pas prête.",
    "dash.conference.mediaHealth.hintOk": "Janus et TURN sont joignables. L’appel peut commencer.",
    "dash.conference.mediaHealth.janus": "Janus",
    "dash.conference.mediaHealth.ok": "OK",
    "dash.conference.mediaHealth.title": "État vidéo (live)",
    "dash.conference.notifyInvitees": "Prévenir les invités par e-mail (même lien, nouvel horaire)",
    "dash.conference.openCallBadge": "lien ouvert",
    "dash.conference.openCallHint": "Quiconque a ce lien peut rejoindre (chaque personne reçoit son canard).",
    "dash.conference.phase": "Phase",
    "dash.conference.refresh": "Actualiser",
    "dash.conference.save": "Enregistrer",
    "dash.conference.saveTranscript": "Enregistrer PDF",
    "dash.conference.saved": "Appel mis à jour. Les liens n’ont pas changé.",
    "dash.conference.saving": "Enregistrement…",
    "dash.conference.sendEmail": "Envoyer l'email",
    "dash.conference.sendEmailOnAdd": "Envoyer l’e-mail d’invitation",
    "dash.conference.sendingEmail": "Envoi…",
    "dash.conference.speech": "Parole",
    "dash.conference.startsAt": "Date et heure de début (Europe/Rome)",
    "dash.conference.startsAtHint": "Saisissez l’heure dans le fuseau YOBY (Europe/Rome), pas celui du navigateur.",
    "dash.conference.subtitle": "Créez un monde YOBY privé pour un appel planifié. Chaque invité reçoit un canard et un lien personnel.",
    "dash.conference.tabAvailability": "Disponibilité",
    "dash.conference.tabBookings": "Réservations",
    "dash.conference.tabCalls": "Appels planifiés",
    "dash.conference.tabCreate": "Créer un appel",
    "dash.conference.tabsAria": "Sections conférence",
    "dash.conference.title": "Conference call",
    "dash.conference.transcript": "Transcription",
    "dash.conference.transcriptDisabledNote": "Transcription désactivée à la demande d'un participant.",
    "dash.conference.transcriptEmpty": "Pas encore de transcription.",
    "dash.conference.transcriptSaved": "PDF enregistré.",
    "dash.difficulty.easy": "Facile",
    "dash.difficulty.hard": "Difficile",
    "dash.difficulty.medium": "Moyen",
    "dash.liveInterpreter.callMetrics": "Live Interpreter usage",
    "dash.liveInterpreter.callMetricsBody": "Call {callMin} min · translated {liMin} min · languages: {langs} · listeners: {listeners} · ≈ €{eur}",
    "dash.liveInterpreter.criticalPct": "Critical threshold (%)",
    "dash.liveInterpreter.enabled": "Activer Live Interpreter (conférences commerciales uniquement)",
    "dash.liveInterpreter.enabledDesc": "Interrupteur master pour les appels commerciaux. N’active jamais le vidéo des étangs in-game.",
    "dash.liveInterpreter.envOff": "Env kill-switch is OFF",
    "dash.liveInterpreter.errLoad": "Impossible de charger.",
    "dash.liveInterpreter.errSave": "Impossible d’enregistrer.",
    "dash.liveInterpreter.hint": "Traduction vocale uniquement pour les conférences commerciales. Jamais sur la vidéo des étangs.",
    "dash.liveInterpreter.monthUsage": "Month {month}: {used} / {limit} min · ≈ €{eur} · {calls} calls · {status}",
    "dash.liveInterpreter.monthlyLimit": "Limite mensuelle (minutes audio traduit)",
    "dash.liveInterpreter.providerMissing": "Endpoint/clé API Azure Voice Live manquants dans .env",
    "dash.liveInterpreter.providerOk": "Azure Voice Live configuré",
    "dash.liveInterpreter.quotaBlocked": "Nouvelles traductions bloquées",
    "dash.liveInterpreter.quotaCritical": "Critical",
    "dash.liveInterpreter.quotaOk": "OK",
    "dash.liveInterpreter.quotaWarn": "Warning",
    "dash.liveInterpreter.save": "Enregistrer",
    "dash.liveInterpreter.saved": "Paramètres enregistrés.",
    "dash.liveInterpreter.tab": "Interprète",
    "dash.liveInterpreter.testCall": "TEST — ouvrir une conférence d’essai",
    "dash.liveInterpreter.testCallCreating": "Création de la conférence d’essai…",
    "dash.liveInterpreter.testCallErr": "Impossible de créer la conférence d’essai.",
    "dash.liveInterpreter.testCallHint": "Crée une conférence immédiate (lien public) et l’ouvre dans un nouvel onglet.",
    "dash.liveInterpreter.testCallOk": "Conférence d’essai prête — ouverte dans un nouvel onglet.",
    "dash.liveInterpreter.title": "Live Interpreter",
    "dash.liveInterpreter.warnPct": "Warning threshold (%)",
    "dash.schoolSignup.addClass": "Add class",
    "dash.schoolSignup.addTeacher": "Add teacher",
    "dash.schoolSignup.alreadyBody": "This account is already linked to a school on YOBY.",
    "dash.schoolSignup.alreadyTitle": "Vous êtes déjà inscrit",
    "dash.schoolSignup.back": "Retour",
    "dash.schoolSignup.checkEmail": "Check your email and come back to this page after confirming.",
    "dash.schoolSignup.city": "City",
    "dash.schoolSignup.className": "Class name",
    "dash.schoolSignup.classTeacher": "Enseignant de la classe",
    "dash.schoolSignup.classes": "Classes involved",
    "dash.schoolSignup.continue": "Continue",
    "dash.schoolSignup.country": "Country",
    "dash.schoolSignup.draftSaved": "Draft saved.",
    "dash.schoolSignup.email": "Principal’s email",
    "dash.schoolSignup.errClassTeacher": "Choisissez un enseignant déjà indiqué à l’étape précédente.",
    "dash.schoolSignup.errEmail": "Saisissez une adresse e-mail valide.",
    "dash.schoolSignup.errGeneric": "Something went wrong. Try again.",
    "dash.schoolSignup.errLocked": "The application has already been submitted.",
    "dash.schoolSignup.errLookup": "Could not check this email.",
    "dash.schoolSignup.errName": "Saisissez le prénom et le nom (au moins 2 caractères).",
    "dash.schoolSignup.errPhone": "Le téléphone est facultatif. S’il est renseigné, utilisez des chiffres, des espaces ou +.",
    "dash.schoolSignup.errPrivacy": "Vous devez accepter la notice de confidentialité pour continuer.",
    "dash.schoolSignup.errSave": "Could not save the draft.",
    "dash.schoolSignup.errSubmit": "Could not submit the application.",
    "dash.schoolSignup.errTeacherDup": "Chaque enseignant doit avoir une adresse e-mail différente.",
    "dash.schoolSignup.errTeacherSelf": "N’utilisez pas l’e-mail du chef d’établissement : il est superviseur, pas enseignant.",
    "dash.schoolSignup.errValidation": "Enter the school name, at least one teacher and one class.",
    "dash.schoolSignup.goDashboard": "Open dashboard",
    "dash.schoolSignup.helpAccount": "Créez le compte du chef d’établissement avec nom, e-mail et consentement. Nous envoyons un lien de confirmation : ouvrez-le, puis revenez sur cette page. Si vous avez déjà un compte YOBY, connectez-vous sans vous réinscrire.",
    "dash.schoolSignup.helpClassTeacher": "Choisissez l’enseignant titulaire de cette classe. Il doit déjà figurer dans la liste des enseignants.",
    "dash.schoolSignup.helpClasses": "Chaque classe a un enseignant titulaire choisi à l’étape précédente. Après validation, YOBY crée les classes et les lui attribue. Une classe au minimum est requise.",
    "dash.schoolSignup.helpSchool": "Indiquez les informations de l’établissement pour que YOBY puisse l’activer après contrôle. Le téléphone est facultatif. Dans la note, vous pouvez préciser sites, horaires ou autres précisions.",
    "dash.schoolSignup.helpTeachers": "Listez les enseignants qui utiliseront YOBY. Ils recevront une invitation après validation. N’ajoutez pas l’e-mail du chef d’établissement : il est superviseur, pas enseignant. Un enseignant au minimum est requis.",
    "dash.schoolSignup.introAlt": "Prefer a call with us?",
    "dash.schoolSignup.introBody": "The principal signs up, confirms the email, then lists teachers and classes. YOBY activates the school after a review.",
    "dash.schoolSignup.introTitle": "Inscrivez votre école",
    "dash.schoolSignup.knownBody": "This email is already registered. Sign in with the link we send you.",
    "dash.schoolSignup.knownTitle": "Vous êtes déjà inscrit",
    "dash.schoolSignup.locale": "Working language",
    "dash.schoolSignup.name": "Principal’s name",
    "dash.schoolSignup.note": "Note (optional)",
    "dash.schoolSignup.openDashboard": "Go to dashboard",
    "dash.schoolSignup.pendingBody": "We received the application for {school}. We’ll email you when it’s active.",
    "dash.schoolSignup.pendingTitle": "Waiting for approval",
    "dash.schoolSignup.phone": "Phone (optional)",
    "dash.schoolSignup.privacy": "I accept the privacy notice and to share the listed teachers’ emails.",
    "dash.schoolSignup.rejectedBody": "The previous application was not approved. Reason: {reason}",
    "dash.schoolSignup.rejectedTitle": "Application not approved",
    "dash.schoolSignup.saveDraft": "Save draft",
    "dash.schoolSignup.schoolName": "School name",
    "dash.schoolSignup.signIn": "Connexion",
    "dash.schoolSignup.signUp": "S’inscrire et confirmer l’e-mail",
    "dash.schoolSignup.stepAccount": "Compte",
    "dash.schoolSignup.stepAccountTitle": "Compte",
    "dash.schoolSignup.stepClassesTitle": "Classes",
    "dash.schoolSignup.stepSchool": "École",
    "dash.schoolSignup.stepSchoolTitle": "École",
    "dash.schoolSignup.stepTeachersTitle": "Enseignants",
    "dash.schoolSignup.submit": "Envoyer la demande",
    "dash.schoolSignup.submitted": "Application sent.",
    "dash.schoolSignup.talkWithUs": "Book a call",
    "dash.schoolSignup.teacherEmail": "Teacher email",
    "dash.schoolSignup.teacherName": "Teacher name",
    "dash.schoolSignup.teachers": "Teachers",
    "dash.status.ageBand.11-15": "11–15",
    "dash.status.ageBand.16-17": "16–17",
    "dash.status.ageBand.18-26": "18–26",
    "dash.status.ageBand.8-10": "8–10",
    "dash.status.ageBand.adult": "Adultes",
    "dash.status.ageBand.unknown": "Sans tranche",
    "dash.status.analytics.events.arcade_completed.description": "Arcade activity ends",
    "dash.status.analytics.events.arcade_completed.label": "Arcade completed",
    "dash.status.analytics.events.arcade_started.description": "Crazy Run or arcade activity starts",
    "dash.status.analytics.events.arcade_started.label": "Arcade started",
    "dash.status.analytics.events.child_access_started.description": "Child enters via link or parent",
    "dash.status.analytics.events.child_access_started.label": "Child access started",
    "dash.status.analytics.events.child_first_claim_email_sent.description": "E-mail transactionnel de claim envoyé au parent",
    "dash.status.analytics.events.child_first_claim_email_sent.label": "E-mail de déblocage envoyé",
    "dash.status.analytics.events.child_first_claim_opened.description": "Le parent ouvre l’aperçu du lien /claim",
    "dash.status.analytics.events.child_first_claim_opened.label": "Lien de déblocage ouvert",
    "dash.status.analytics.events.child_first_claimed.description": "Le parent débloque le canard pending dans la famille",
    "dash.status.analytics.events.child_first_claimed.label": "Canard débloqué",
    "dash.status.analytics.events.child_first_family_activated.description": "Famille prête à jouer après le claim child-first",
    "dash.status.analytics.events.child_first_family_activated.label": "Famille child-first activée",
    "dash.status.analytics.events.child_first_parent_email_submitted.description": "L’enfant saisit l’e-mail du parent/tuteur",
    "dash.status.analytics.events.child_first_parent_email_submitted.label": "E-mail parent envoyé",
    "dash.status.analytics.events.child_first_started.description": "L’enfant commence Créer mon canard",
    "dash.status.analytics.events.child_first_started.label": "Child-first démarré",
    "dash.status.analytics.events.child_profile_created.description": "A child character profile is created",
    "dash.status.analytics.events.child_profile_created.label": "Child profile created",
    "dash.status.analytics.events.collectible_obtained.description": "An item is collected",
    "dash.status.analytics.events.collectible_obtained.label": "Collectible obtained",
    "dash.status.analytics.events.family_activation_completed.description": "Adult, child and first access exist",
    "dash.status.analytics.events.family_activation_completed.label": "Family activated",
    "dash.status.analytics.events.family_created.description": "A parent creates the family pond",
    "dash.status.analytics.events.family_created.label": "Family created",
    "dash.status.analytics.events.market_transaction.description": "Buy, sell or negotiate",
    "dash.status.analytics.events.market_transaction.label": "Market transaction",
    "dash.status.analytics.events.market_visited.description": "Access to the market",
    "dash.status.analytics.events.market_visited.label": "Market visited",
    "dash.status.analytics.events.mission_completed.description": "Mission finished",
    "dash.status.analytics.events.mission_completed.label": "Mission completed",
    "dash.status.analytics.events.mission_started.description": "A game mission begins",
    "dash.status.analytics.events.mission_started.label": "Mission started",
    "dash.status.analytics.events.parent_demo_converted.description": "Un parent termine la démo et crée un compte",
    "dash.status.analytics.events.parent_demo_converted.label": "Démo familles convertie",
    "dash.status.analytics.events.parent_demo_keep_prompt.description": "Proposition de garder le canard affichée",
    "dash.status.analytics.events.parent_demo_keep_prompt.label": "Démo familles : garder le canard",
    "dash.status.analytics.events.parent_demo_parent_ui_complete.description": "Aperçu de l’interface famille terminé",
    "dash.status.analytics.events.parent_demo_parent_ui_complete.label": "Démo familles : UI terminée",
    "dash.status.analytics.events.parent_demo_started.description": "Démarrage depuis le lien public Essayer YOBY pour les familles",
    "dash.status.analytics.events.parent_demo_started.label": "Démos familles",
    "dash.status.analytics.events.parent_demo_tour_complete.description": "Visite du monde terminée",
    "dash.status.analytics.events.parent_demo_tour_complete.label": "Démo familles : visite terminée",
    "dash.status.analytics.events.quiz_assigned.description": "Teacher assigns a quiz",
    "dash.status.analytics.events.quiz_assigned.label": "Quiz assigned",
    "dash.status.analytics.events.quiz_completed.description": "Quiz finished",
    "dash.status.analytics.events.quiz_completed.label": "Quiz completed",
    "dash.status.analytics.events.quiz_started.description": "Child opens a quiz",
    "dash.status.analytics.events.quiz_started.label": "Quiz started",
    "dash.status.analytics.events.real_task_assigned.description": "Parent assigns a real-life chore",
    "dash.status.analytics.events.real_task_assigned.label": "Real task assigned",
    "dash.status.analytics.events.real_task_completed.description": "Child marks chore done",
    "dash.status.analytics.events.real_task_completed.label": "Real task done",
    "dash.status.analytics.events.real_task_validated.description": "Parent accepts or rejects",
    "dash.status.analytics.events.real_task_validated.label": "Real task validated",
    "dash.status.analytics.events.reward_claimed.description": "Child claims a reward",
    "dash.status.analytics.events.reward_claimed.label": "Reward claimed",
    "dash.status.analytics.events.reward_distributed.description": "Parent allocates a reward",
    "dash.status.analytics.events.reward_distributed.label": "Reward distributed",
    "dash.status.analytics.events.reward_earned.description": "A reward is granted",
    "dash.status.analytics.events.reward_earned.label": "Reward earned",
    "dash.status.analytics.events.session_ended.description": "Exit or inactivity",
    "dash.status.analytics.events.session_ended.label": "Session ended",
    "dash.status.analytics.events.session_started.description": "Someone enters the game",
    "dash.status.analytics.events.session_started.label": "Session started",
    "dash.status.analytics.events.shared_family_session.description": "Parent and child online together",
    "dash.status.analytics.events.shared_family_session.label": "Shared family session",
    "dash.status.analytics.events.subscription_cancelled.description": "Subscription cancelled",
    "dash.status.analytics.events.subscription_cancelled.label": "Subscription cancelled",
    "dash.status.analytics.events.subscription_started.description": "Family or Patron activated",
    "dash.status.analytics.events.subscription_started.label": "Subscription started",
    "dash.status.analytics.events.teacher_demo_converted.description": "Un enseignant termine la démo et crée un compte",
    "dash.status.analytics.events.teacher_demo_converted.label": "Démo enseignants convertie",
    "dash.status.analytics.events.teacher_demo_keep_prompt.description": "Proposition de garder le canard affichée",
    "dash.status.analytics.events.teacher_demo_keep_prompt.label": "Démo enseignants : garder le canard",
    "dash.status.analytics.events.teacher_demo_started.description": "Démarrage depuis le lien public Essayer YOBY pour les enseignants",
    "dash.status.analytics.events.teacher_demo_started.label": "Démos enseignants",
    "dash.status.analytics.events.teacher_demo_teacher_ui_complete.description": "Aperçu de l’interface enseignant terminé",
    "dash.status.analytics.events.teacher_demo_teacher_ui_complete.label": "Démo enseignants : UI terminée",
    "dash.status.analytics.events.teacher_demo_tour_complete.description": "Visite du monde terminée",
    "dash.status.analytics.events.teacher_demo_tour_complete.label": "Démo enseignants : visite terminée",
    "dash.status.analytics.events.temporary_link_generated.description": "A temporary play link is created",
    "dash.status.analytics.events.temporary_link_generated.label": "Temp link created",
    "dash.status.analytics.events.temporary_link_used.description": "A temporary link is redeemed",
    "dash.status.analytics.events.temporary_link_used.label": "Temp link used",
    "dash.status.charts.acq_age_doughnut.title": "Profils enfant par tranche d’âge",
    "dash.status.charts.acq_child_first_funnel.title": "Entonnoir canard child-first",
    "dash.status.charts.acq_child_first_trend.title": "Tendance child-first",
    "dash.status.charts.acq_demo_bar.title": "Démos depuis les liens publics",
    "dash.status.charts.acq_demo_trend.title": "Tendance des démos",
    "dash.status.charts.acq_funnel.title": "Acquisition funnel",
    "dash.status.charts.acq_plan_doughnut.title": "Subscription plans",
    "dash.status.charts.acq_trend_line.title": "Acquisition trend",
    "dash.status.charts.eco_age_doughnut.title": "Récompenses par tranche d’âge",
    "dash.status.charts.eco_arcade_line.title": "Arcade activity",
    "dash.status.charts.eco_chores_funnel.title": "Real tasks funnel",
    "dash.status.charts.eco_collectibles_line.title": "Collectibles",
    "dash.status.charts.eco_market_bar.title": "Market activity",
    "dash.status.charts.eco_reward_origin.title": "Reward origins",
    "dash.status.charts.eco_reward_volume.title": "Reward volume",
    "dash.status.charts.eng_access_doughnut.title": "Child access channels",
    "dash.status.charts.eng_age_doughnut.title": "Sessions par tranche d’âge",
    "dash.status.charts.eng_device_bar.title": "Sessions by device",
    "dash.status.charts.eng_links_bar.title": "Temporary links",
    "dash.status.charts.eng_sessions_line.title": "Sessions by role",
    "dash.status.charts.eng_shared_line.title": "Shared family sessions",
    "dash.status.charts.learn_age_doughnut.title": "Quiz terminés par tranche d’âge",
    "dash.status.charts.learn_duration_bar.title": "Average duration",
    "dash.status.charts.learn_mission_host.title": "Missions by host",
    "dash.status.charts.learn_mission_trend.title": "Mission trend",
    "dash.status.charts.learn_quiz_funnel.title": "Quiz funnel",
    "dash.status.charts.learn_quiz_trend.title": "Quiz trend",
    "dash.status.charts.live_age_bar.title": "En ligne par tranche d’âge",
    "dash.status.charts.live_realm_pie.title": "Online by realm",
    "dash.status.charts.live_role_bar.title": "Online by role",
    "dash.status.daysLabel": "Jours",
    "dash.status.errLoad": "Impossible de charger le statut.",
    "dash.status.lastAccessTitle": "Dernier accès",
    "dash.status.loading": "Chargement…",
    "dash.status.logAll": "Tous",
    "dash.status.logFilter": "Événement",
    "dash.status.refresh": "Actualiser",
    "dash.status.report.anonymized": "Rapport anonymisé : pas d’e-mails ni de noms.",
    "dash.status.report.failed": "Échec de la génération. Réessayez.",
    "dash.status.report.generate": "Générer le rapport",
    "dash.status.report.generating": "Génération",
    "dash.status.report.impossible": "Impossible de générer le rapport : aucune donnée analytics sur la période.",
    "dash.status.report.overviewTitle": "Commentaire général",
    "dash.status.report.pdfAnalysisTitle": "Analyse",
    "dash.status.report.pdfChartsTitle": "Graphiques",
    "dash.status.report.pdfKpisTitle": "Indicateurs clés",
    "dash.status.report.pdfPage": "Page {n} sur {total}",
    "dash.status.report.pdfPeriod": "Période : {days} derniers jours",
    "dash.status.report.pdfTitle": "Rapport analytics Yoby",
    "dash.status.report.pdfUnavailable": "Bibliothèque PDF indisponible.",
    "dash.status.report.previewFailed": "Impossible d’afficher l’aperçu PDF.",
    "dash.status.report.previewPreparing": "Préparation de l’aperçu PDF…",
    "dash.status.report.readyAt": "Généré",
    "dash.status.report.savePdf": "Enregistrer PDF",
    "dash.status.report.waiting": "Rapport en cours de préparation…",
    "dash.status.sectionOnline": "En ligne maintenant",
    "dash.status.sectionOnlineAge": "En ligne par tranche d’âge",
    "dash.status.sectionTotals": "Totaux (hors mondes conference actifs)",
    "dash.status.sectionTotalsAge": "Personnages par tranche d’âge",
    "dash.status.subtitle": "Présence en jeu et analytique produit.",
    "dash.status.summaryChildren": "Enfants en ligne",
    "dash.status.summaryFamilies": "Familles en jeu",
    "dash.status.summaryInGame": "En jeu (total)",
    "dash.status.summaryParents": "Parents en ligne",
    "dash.status.summaryPlayers": "Joueurs en jeu",
    "dash.status.summaryQueueDepth": "File analytics",
    "dash.status.summaryRows": "Lignes dernier accès",
    "dash.status.summarySurface": "En surface",
    "dash.status.summaryUnderground": "Souterrain",
    "dash.status.summaryWorldsActive": "Mondes avec joueurs en ligne",
    "dash.status.summaryWorldsOpened": "Mondes ouverts",
    "dash.status.tabs.acquisition": "Acquisition",
    "dash.status.tabs.economy": "Économie",
    "dash.status.tabs.engagement": "Engagement",
    "dash.status.tabs.learning": "Apprentissage",
    "dash.status.tabs.live": "Live",
    "dash.status.tabs.logs": "Logs",
    "dash.status.tabs.report": "Rapport",
    "dash.status.thAgeBand": "Tranche",
    "dash.status.thEmailName": "E-mail / Nom",
    "dash.status.thEvent": "Événement",
    "dash.status.thFamily": "Famille",
    "dash.status.thLastAccess": "Dernier accès",
    "dash.status.thRole": "Rôle",
    "dash.status.thSummary": "Résumé",
    "dash.status.thTime": "Heure",
    "dash.status.thWorld": "Monde",
    "dash.status.thWorldFamilies": "Familles",
    "dash.status.thWorldPlayers": "Joueurs",
    "dash.status.thWorldSurface": "Surface",
    "dash.status.thWorldUnderground": "Souterrain",
    "dash.status.title": "Statut",
    "dash.status.totalChildren": "Enfants (total)",
    "dash.status.totalFamilies": "Familles (total)",
    "dash.status.totalParents": "Parents (total)",
    "dash.status.totalPlayers": "Personnages (total)",
    "dash.status.updated": "Mis à jour",
    "dash.status.worldsTitle": "Détail par monde",
    "dash.supervisor.csvDownloaded": "CSV téléchargé",
    "dash.supervisor.errAudit": "Impossible de charger le journal d'audit.",
    "dash.supervisor.errDenied": "Accès refusé. Connectez-vous en tant que superviseur ou admin YOBY.",
    "dash.supervisor.errExport": "Impossible d'exporter le CSV.",
    "dash.supervisor.exportCsvSchool": "Exporter CSV école",
    "dash.supervisor.hintAudit": "Dernières actions enregistrées pour l'école.",
    "dash.supervisor.hintQuizzes": "Utilisation des quiz par slug (tentatives complétées dans l'école).",
    "dash.supervisor.metaSlug": "Slug",
    "dash.supervisor.metaStatus": "Statut",
    "dash.supervisor.metricSchoolAvg": "Moyenne de l'école",
    "dash.supervisor.noAudit": "Aucune entrée d'audit.",
    "dash.supervisor.noClasses": "Aucune classe.",
    "dash.supervisor.noQuizzes": "Aucune donnée quiz.",
    "dash.supervisor.noSchools": "Aucune école assignée.",
    "dash.supervisor.noTeachers": "Aucun enseignant.",
    "dash.supervisor.refresh": "Actualiser",
    "dash.supervisor.selectSchoolHint": "Sélectionnez une école pour voir classes, enseignants et statistiques quiz.",
    "dash.supervisor.subtitle": "Vue d'ensemble des écoles, classes, enseignants, quiz et audit.",
    "dash.supervisor.tabAudit": "Audit",
    "dash.supervisor.tabClasses": "Classes",
    "dash.supervisor.tabQuizzes": "Quiz",
    "dash.supervisor.tabTeachers": "Enseignants",
    "dash.supervisor.thAssignments": "Devoirs",
    "dash.supervisor.thSchool": "École",
    "dash.supervisor.thTeacher": "Enseignant",
    "dash.supervisor.title": "Tableau superviseur",
    "dash.supervisor.yourSchools": "Vos écoles",
    "dash.teacher.catalogTitle": "Catalogue de quiz",
    "dash.teacher.confirmArchiveClass": "Archiver cette classe ? Le code ne sera plus utilisable.",
    "dash.teacher.copied": "Copié !",
    "dash.teacher.copyCode": "Copier le code",
    "dash.teacher.createClass": "Créer une classe",
    "dash.teacher.demoLink": "Lien démo",
    "dash.teacher.demoLinkCopied": "Lien copié dans le presse-papiers.",
    "dash.teacher.demoLinkReady": "Lien permanent créé",
    "dash.teacher.errArchive": "Impossible d'archiver la classe.",
    "dash.teacher.errAssign": "Impossible d'assigner le quiz.",
    "dash.teacher.errCreateClass": "Impossible de créer la classe.",
    "dash.teacher.errDemoDenied": "Seuls les admins peuvent créer des liens démo.",
    "dash.teacher.errDemoLink": "Impossible de créer le lien démo.",
    "dash.teacher.errDemoNoQuiz": "Aucun quiz libre à assigner à cette classe.",
    "dash.teacher.errDenied": "Accès refusé. Connectez-vous en tant qu'enseignant.",
    "dash.teacher.errExport": "Impossible d'exporter le CSV.",
    "dash.teacher.errExportCatalog": "Impossible d’exporter le catalogue de quiz.",
    "dash.teacher.errLoadClasses": "Impossible de charger les classes.",
    "dash.teacher.errNoTeacher": "Profil enseignant introuvable.",
    "dash.teacher.errRegen": "Impossible de régénérer le code.",
    "dash.teacher.errSelectSchool": "Sélectionnez d'abord une école.",
    "dash.teacher.exportCatalogCsv": "Télécharger le catalogue CSV (toutes les langues)",
    "dash.teacher.exportCsv": "Exporter CSV",
    "dash.teacher.hintAssign": "Choisissez la catégorie, le quiz et les paramètres du devoir.",
    "dash.teacher.hintWrong": "Questions avec le plus d'erreurs dans les devoirs récents.",
    "dash.teacher.metaAge": "Âge",
    "dash.teacher.metaCode": "Code",
    "dash.teacher.metaLang": "Langue",
    "dash.teacher.metaYear": "Année",
    "dash.teacher.metricAssignments": "Devoirs",
    "dash.teacher.metricAttempts": "Tentatives",
    "dash.teacher.metricClassAvg": "Moyenne de classe",
    "dash.teacher.metricEnrolled": "Inscrits",
    "dash.teacher.newCode": "Nouveau code",
    "dash.teacher.noAssignments": "Aucun devoir.",
    "dash.teacher.noCatalog": "Aucun quiz dans le catalogue.",
    "dash.teacher.noClasses": "Aucune classe.",
    "dash.teacher.noStudents": "Aucun élève inscrit.",
    "dash.teacher.noWrong": "Aucune question difficile.",
    "dash.teacher.open": "Ouvrir",
    "dash.teacher.playLink": "Lien de jeu",
    "dash.teacher.playLinkCopied": "Lien copié dans le presse-papiers.",
    "dash.teacher.playLinkFailed": "Impossible de créer le lien de jeu",
    "dash.teacher.playLinkHint": "Les élèves ouvrent le lien et touchent leur nom. Surveillez le choix.",
    "dash.teacher.playLinkHours": "Heures",
    "dash.teacher.playLinkReady": "Lien de jeu créé",
    "dash.teacher.quizColChoices": "Réponses",
    "dash.teacher.quizColOrder": "#",
    "dash.teacher.quizColQuestion": "Question",
    "dash.teacher.quizLoadError": "Impossible de charger le quiz.",
    "dash.teacher.quizLoading": "Chargement du quiz…",
    "dash.teacher.quizPreviewTitle": "Aperçu du quiz",
    "dash.teacher.selectClassHint": "Sélectionnez une classe pour voir les détails.",
    "dash.teacher.statusAssigned": "Quiz assigné.",
    "dash.teacher.statusAssigning": "Assignation du quiz…",
    "dash.teacher.statusClassCreated": "Classe créée.",
    "dash.teacher.statusCreating": "Création de la classe…",
    "dash.teacher.subtitle": "Classes, codes d'inscription, devoirs quiz, résultats et exports.",
    "dash.teacher.surveyFeedbackFinal": "À la fin du quiz",
    "dash.teacher.surveyFeedbackImmediate": "Immédiatement après chaque question",
    "dash.teacher.tabAssign": "Assigner un quiz",
    "dash.teacher.tabAssignments": "Devoirs",
    "dash.teacher.tabStudents": "Élèves",
    "dash.teacher.tabWrong": "Questions difficiles",
    "dash.teacher.thAge": "Âge",
    "dash.teacher.thAvg": "Moyenne",
    "dash.teacher.thClass": "Classe",
    "dash.teacher.thCode": "Code",
    "dash.teacher.thCompleted": "Complétés",
    "dash.teacher.thDifficulty": "Difficulté",
    "dash.teacher.thDone": "Terminés",
    "dash.teacher.thDue": "Échéance",
    "dash.teacher.thErrorPct": "% d'erreurs",
    "dash.teacher.thErrors": "Erreurs",
    "dash.teacher.thFirstName": "Prénom",
    "dash.teacher.thJoined": "Inscrit",
    "dash.teacher.thLastName": "Nom",
    "dash.teacher.thLastSeen": "Dernière visite",
    "dash.teacher.thMaxAttempts": "Tentatives max",
    "dash.teacher.thNickname": "Surnom",
    "dash.teacher.thPublish": "Publication",
    "dash.teacher.thQuestion": "Question",
    "dash.teacher.thTheme": "Thème",
    "dash.teacher.thTitle": "Titre",
    "dash.teacher.thTotalAnswers": "Réponses totales",
    "dash.teacher.thYear": "Année",
    "dash.teacher.title": "Tableau enseignant",
    "dash.teacher.yourClasses": "Vos classes",
    "dash.teacher.yourClassesHint": "Sélectionnez une classe pour voir élèves, devoirs et statistiques.",
    "dash.topic.bisogni_desideri": "Besoins et envies",
    "dash.topic.budget": "Budget",
    "dash.topic.consumo": "Consommation responsable",
    "dash.topic.imprenditorialita": "Entrepreneuriat",
    "dash.topic.lavoro": "Monde du travail",
    "dash.topic.risparmio": "Épargne",
    "footer.aria.site": "Pied de page",
    "footer.aria.social": "Réseaux sociaux",
    "footer.brand.tagline": "L'étang familial où enfants et adultes apprennent l'argent ensemble.",
    "footer.col.about": "À propos de YOBY",
    "footer.col.aiAudits": "Derniers audits de sécurité de l’IA",
    "footer.col.banksAndPartners": "Banques et partenaires",
    "footer.col.contact": "Contact",
    "footer.col.cookiePolicy": "Politique cookies",
    "footer.col.dataAndGdpr": "Données et RGPD",
    "footer.col.investors": "Investisseurs",
    "footer.col.parentalControls": "Contrôle parental",
    "footer.col.partners.title": "Partenaires",
    "footer.col.press": "Presse",
    "footer.col.privacyPolicy": "Politique de confidentialité",
    "footer.col.product.title": "Produit",
    "footer.col.roadmap": "Roadmap",
    "footer.col.safety": "Sécurité",
    "footer.col.schools": "Écoles",
    "footer.col.termsOfService": "Conditions d'utilisation",
    "footer.col.trust.title": "Confiance et sécurité",
    "footer.col.yoby.title": "YOBY",
    "footer.copyright.line1": "© 2026 YOBY. Tous droits réservés.",
    "footer.copyright.line2": "Créé en Europe pour les familles, les canards et de meilleures habitudes financières.",
    "home.about.feature1.body": "Un espace privé où toute la famille explore, accomplit des quêtes et grandit ensemble. Chaque membre a son propre canard.",
    "home.about.feature1.title": "🦆 Un jeu en famille pour apprendre l'argent",
    "home.about.feature2.body": "La Grenouille, la Pie, la Taupe et d'autres vous guident avec de courtes quêtes et des questions à choix. Apprendre en faisant, pas en étudiant.",
    "home.about.feature2.title": "🐸 Des mentors qui enseignent l'argent en jouant",
    "home.about.feature3.body": "Trois monnaies symboliques pour les objectifs, l'épargne et les bonnes habitudes. Une économie de jeu qui enseigne sans ressembler à un cours.",
    "home.about.feature3.title": "🐚 Épargne, objectifs et habitudes dans une économie ludique",
    "home.about.feature4.body": "Aucun enfant ne peut recevoir de contenu inapproprié. Pas de chat vidéo sans un parent présent. Conçu pour les mineurs — pas seulement adapté.",
    "home.about.feature4.title": "🔒 Sûr par conception",
    "home.about.title": "Ce que vous trouverez dans le monde YOBY",
    "home.cta.choosePlan": "Choisir une formule",
    "home.cta.joinDescription": "Créez votre compte familial et commencez à explorer.",
    "home.cta.joinTitle": "Plongez. C'est gratuit.",
    "home.cta.playNow": "Jouer maintenant",
    "home.cta.premiumActive": "Vous avez une formule premium — profitez de l'expérience complète !",
    "home.cta.premiumHint": "Les formules premium offrent de meilleures conditions de jeu : plus de coquillages, zones exclusives et fonctionnalités prioritaires.",
    "home.cta.ready": "Prêt à replonger dans l'étang ?",
    "home.cta.signIn": "Se connecter",
    "home.cta.signUpFree": "Essai gratuit",
    "home.cta.tryAsParent": "Vous êtes parent ? Essayez YOBY",
    "home.cta.tryAsStudent": "Vous êtes enseignant ? Essayez YOBY",
    "home.cta.welcomeBack": "Bon retour",
    "home.cta.welcomeBackName": "Bon retour, {name}",
    "home.hero.childBody": "Crée-le maintenant. Un parent débloquera l'étang quand vous serez prêts.",
    "home.hero.childCta": "Créer mon canard",
    "home.hero.childTitle": "Tu cherches ton canard ? 🦆",
    "home.hero.ctaPrimary": "Essai gratuit",
    "home.hero.ctaSecondary": "Voir comment ça marche",
    "home.hero.description": "YOBY est un jeu d'éducation financière où enfants et parents apprennent ensemble l'épargne, les choix d'argent et les objectifs.",
    "home.hero.tagline": "L'argent parle, enfin de façon amusante.",
    "home.hero.title": "Éducation financière pour les enfants et les familles, rendue amusante.",
    "home.hero.visualAlt": "Le monde YOBY avec des canards qui explorent l'étang familial",
    "home.learn.choices.body": "Affrontez des arbitrages du quotidien — dépenser, épargner ou partager — dans des quêtes sûres et narratives.",
    "home.learn.choices.title": "Choix",
    "home.learn.goals.body": "Nommez ce qui compte, planifiez et célébrez les progrès au fil du chemin.",
    "home.learn.goals.title": "Objectifs",
    "home.learn.saving.body": "Mettez des coquillages de côté et voyez de petits pas devenir de grands objectifs.",
    "home.learn.saving.title": "Épargne",
    "home.learn.title": "Ce que les enfants apprennent",
    "home.learn.value.body": "Reliez effort, temps et ressources pour que les enfants comprennent ce que représente l'argent.",
    "home.learn.value.title": "Valeur de l'argent",
    "home.links.families": "Éducation financière pour les familles",
    "home.links.kids": "YOBY pour les enfants",
    "home.links.schools": "Éducation financière pour les écoles",
    "home.links.title": "Explorer YOBY",
    "home.seo.description": "YOBY est un monde ludique d'éducation financière où enfants et parents apprennent l'épargne, les choix d'argent et de saines habitudes ensemble.",
    "home.seo.title": "Éducation financière pour enfants et familles | YOBY",
    "home.seoSection.body": "YOBY transforme l'éducation financière pour les enfants en aventure partagée. Dans un monde d'étangs ludiques, enfants et parents pratiquent l'épargne, fixent des objectifs ensemble et discutent des choix d'argent du quotidien. Des mentors et de courtes quêtes guident l'apprentissage de l'argent par le jeu — pas par des fiches ou des cours. Si vous cherchez une éducation financière pour les familles à la maison, YOBY rejoint les enfants là où ils sont : curieux, créatifs et prêts à explorer. Chaque membre de la famille a son propre canard dans un étang partagé uniquement avec des personnes de confiance. Coquillages, graines et étoiles représentent de vraies habitudes — patience, planification et compréhension de la valeur de ce que l'on gagne. En chemin, les enfants apprennent que les petits choix comptent, que l'attente peut valoir le coup et que l'argent est un outil pour les objectifs — pas seulement pour dépenser. Les parents restent impliqués avec une visibilité et des contrôles clairs dans un espace conçu pour les mineurs dès le départ.",
    "home.seoSection.title": "Éducation financière pour les enfants, par le jeu",
    "home.showcase.aria": "Captures d'écran du jeu",
    "home.showcase.card1.alt": "Jeu YOBY d'éducation financière familiale avec parents et enfants explorant un étang virtuel",
    "home.showcase.card1.title": "Étang familial — explorez ensemble",
    "home.showcase.card2.alt": "Mentors YOBY enseignant l'argent aux enfants par des quêtes ludiques",
    "home.showcase.card2.title": "Rencontrez les mentors — apprenez en jouant",
    "home.showcase.card3.alt": "Quiz d'éducation financière YOBY et boutiques du village avec dialogues localisés",
    "home.showcase.card3.title": "Quiz, boutiques et vie du village",
    "home.showcase.card4.alt": "Mentors souterrains YOBY enseignant l'argent par des quêtes cinématiques",
    "home.showcase.card4.title": "Mentors souterrains et quêtes",
    "home.showcase.card5.alt": "Marché du Tasso YOBY où les enfants pratiquent des choix d'argent",
    "home.showcase.card5.title": "Marchés et choix d'argent",
    "home.showcase.card6.alt": "Mini-jeu Course folle YOBY : les enfants courent dans l’herbe en ramassant des objets de saison contre la montre",
    "home.showcase.card6.title": "Course folle — une course chronométrée sur l’herbe",
    "home.showcase.hint": "Appuyez pour agrandir",
    "home.showcase.title": "Découvrez le monde",
    "lang.switch": "Langue",
    "nav.account": "Compte",
    "nav.actions.signIn": "Connexion",
    "nav.actions.startFree": "Essai gratuit",
    "nav.actions.talkWithUs": "Parlez avec nous",
    "nav.aria.main": "Navigation principale",
    "nav.aria.staff": "Espace école et administration",
    "nav.footer.schoolSignup": "Inscrire votre école",
    "nav.main.blog": "Blog",
    "nav.main.forFamilies": "Pour les familles",
    "nav.main.forKids": "Pour les enfants",
    "nav.main.home": "Accueil",
    "nav.main.howItWorks": "Comment ça marche",
    "nav.main.pricing": "Tarifs",
    "nav.main.talkWithUs": "Parlez avec nous",
    "nav.menu": "Menu",
    "nav.searchPosts": "Rechercher des articles, tags et auteurs",
    "nav.signIn": "Se connecter",
    "nav.staff.admin": "Admin écoles",
    "nav.staff.adminSafety": "Derniers audits de sécurité de l’IA",
    "nav.staff.conference": "Conference call",
    "nav.staff.massmail": "Massmail écoles",
    "nav.staff.redteam": "AI Red Team",
    "nav.staff.schoolSignups": "Inscriptions écoles",
    "nav.staff.status": "Statut du jeu",
    "nav.staff.supervisor": "Tableau superviseur",
    "nav.staff.teacher": "Tableau docent",
    "nav.subscribe": "S'abonner",
    "safetyLab.areasTitle": "Sujets que nous contrôlons",
    "safetyLab.audience": "Pour les familles et les écoles",
    "safetyLab.cat.abuse": "Abuse",
    "safetyLab.cat.dangerous_behavior": "Dangerous behaviour",
    "safetyLab.cat.distress_support": "Emotional support (allowed)",
    "safetyLab.cat.drugs": "Drugs",
    "safetyLab.cat.hate": "Hate",
    "safetyLab.cat.inappropriate_instructions": "Inappropriate instructions",
    "safetyLab.cat.jailbreak": "Prompt injection",
    "safetyLab.cat.off_topic": "Off-topic",
    "safetyLab.cat.other": "Other safety checks",
    "safetyLab.cat.personal_data": "Personal information",
    "safetyLab.cat.self_harm": "Self-harm",
    "safetyLab.cat.sexual": "Inappropriate sexual content",
    "safetyLab.cat.violence": "Violence",
    "safetyLab.chartEmpty": "Quand il y aura plus d’audits, la tendance apparaîtra ici.",
    "safetyLab.chartOutcomes": "Résultat du dernier audit",
    "safetyLab.chartTrend": "Tendance des audits récents",
    "safetyLab.historyEmpty": "Aucun audit terminé.",
    "safetyLab.historyTitle": "Historique récent",
    "safetyLab.languages": "Langues du test",
    "safetyLab.lastTested": "Dernier audit",
    "safetyLab.legendCritical": "Critique : risque élevé ; priorité maximale.",
    "safetyLab.legendFail": "Échoué : quelque chose n’a pas réagi correctement — nous corrigeons.",
    "safetyLab.legendPass": "Réussi : le filtre a réagi comme prévu.",
    "safetyLab.legendTitle": "Ce que signifient les résultats",
    "safetyLab.legendWarning": "Avertissement : souvent un faux positif (trop strict sur un message anodin), pas un risque pour les enfants.",
    "safetyLab.loadFailed": "Impossible de charger les audits de sécurité.",
    "safetyLab.loading": "Chargement des derniers audits…",
    "safetyLab.method1": "Le cœur du contrôle est le Safety Gate : le même filtre qui intercepte les messages en jeu (entrée et, parfois, sortie). Chaque scénario envoie un message (ou une courte séquence) et vérifie si le filtre autorise, redirige ou bloque comme prévu.",
    "safetyLab.method2": "Dans la suite complète, nous testons tous les personnages IA auxquels un enfant peut parler : étang de surface, sous-sol et tuteurs. Il existe aussi des runs « quick » plus rapides, avec un seul personnage et une seule tranche d’âge par scénario : les hôtes listés reflètent toujours uniquement ce que cette run a réellement exécuté.",
    "safetyLab.method3": "Les scénarios couvrent des sujets sensibles et des tentatives de contournement : contenu sexuel inapproprié, violence, automutilation, abus, drogues, haine, données personnelles, consignes dangereuses, manipulation de prompts (jailbreak), hors sujet, ainsi que des cas bénins ou de soutien émotionnel qui doivent rester autorisés. Beaucoup de scénarios tournent en plusieurs langues et tranches d’âge.",
    "safetyLab.method4": "Chaque cas reçoit un résultat : réussi, avertissement, échoué ou critique. Un avertissement signifie souvent un faux positif (filtre trop strict sur un message anodin), pas un risque pour les enfants. Un échec ou un critique signifie qu’un comportement attendu a manqué et doit être corrigé. Nous montrons toujours la dernière run terminée, même si elle n’est pas verte : nous ne remplaçons jamais un mauvais résultat par un ancien bon résultat.",
    "safetyLab.method5": "Pour ne pas aider à contourner les protections, nous ne publions ni textes d’attaque, ni recettes de jailbreak, ni transcriptions complètes. En public, vous voyez des agrégats, des catégories et des dates ; le détail technique reste interne.",
    "safetyLab.method6": "La bibliothèque de scénarios grandit : quand nous trouvons une faiblesse, nous ajoutons un cas de régression et le conservons. S’il n’y a encore aucun audit terminé, nous le disons clairement.",
    "safetyLab.methodIntro": "YOBY lance des audits de sécurité automatiques sur l’IA qui parle aux enfants. Nous n’inventons pas les chiffres : chaque nombre sur cette page vient d’une exécution réelle enregistrée dans notre système. Ci-dessous, nous expliquons ce que nous faisons, ce que nous mesurons, et ce que nous ne montrons pas volontairement.",
    "safetyLab.methodTitle": "Comment les tests sont réalisés",
    "safetyLab.metricCritical": "Critiques",
    "safetyLab.metricExecuted": "Cas vérifiés",
    "safetyLab.metricFail": "Échoués",
    "safetyLab.metricPass": "Réussis",
    "safetyLab.metricPassRate": "Taux de réussite",
    "safetyLab.metricWarning": "Avertissements",
    "safetyLab.never": "Pas encore exécuté",
    "safetyLab.noteParents": "Cette page est destinée aux parents et enseignants. Vous pouvez la consulter à tout moment : c’est un compte rendu public des derniers audits, pas une page marketing avec des chiffres inventés.",
    "safetyLab.npcs": "Personnages IA couverts",
    "safetyLab.plainLead": "YOBY met en permanence ses personnages IA à l’épreuve, comme un audit de sécurité. Voici le dernier résultat — sans détails techniques des attaques.",
    "safetyLab.statusCritical": "Problèmes graves détectés",
    "safetyLab.statusError": "Le dernier audit n’est pas terminé",
    "safetyLab.statusIssues": "Des points à améliorer",
    "safetyLab.statusNever": "Aucun audit disponible pour l’instant",
    "safetyLab.statusPass": "Tout est en ordre",
    "safetyLab.subtitle": "Résultats réels des contrôles automatiques sur l’IA qui parle aux enfants — pour parents et enseignants.",
    "safetyLab.thCases": "Cas",
    "safetyLab.thDate": "Date",
    "safetyLab.thStatus": "Résultat",
    "safetyLab.title": "Derniers audits de sécurité de l’IA",
    "footer.col.genderEquality": "Égalité des genres",
    "dash.booking.gcalRefreshHint": "Après une réservation, utilisez « Actualiser le calendrier » si l’événement n’apparaît pas sur Google.",
    "dash.conference.delivery.title": "Livraison des emails",
    "dash.conference.delivery.untracked": "Résultat indisponible",
    "dash.conference.delivery.invite": "Invitation",
    "dash.conference.delivery.reschedule": "Changement de rendez-vous",
    "dash.conference.delivery.reminder": "Rappel",
    "dash.conference.delivery.pending": "Préparation",
    "dash.conference.delivery.accepted": "Accepté par Mailgun",
    "dash.conference.delivery.delivered": "Remis au serveur du destinataire",
    "dash.conference.delivery.deferred": "Retard temporaire",
    "dash.conference.delivery.failed": "Échec de l’envoi ou de la livraison",
    "dash.conference.delivery.dry_run": "Simulé, non envoyé",
    "dash.conference.delivery.confirmation": "Votre présence est confirmée",
    "footer.col.accessibility": "Accessibilité",
    "accessibility.title": "Accessibilité sur YOBY",
    "accessibility.intro": "Nous souhaitons rendre les informations de YOBY plus faciles à lire et à utiliser. Cette page présente les outils du site et les limites actuelles du jeu.",
    "accessibility.site.title": "Le site d’information",
    "accessibility.site.body": "Les pages du site proposent des textes, des liens de navigation et un panneau pour personnaliser l’affichage. Vous pouvez adapter la lecture à vos besoins et atteindre le contenu principal grâce à un lien accessible au clavier.",
    "accessibility.site.status": "Ces fonctions sont une aide et ne garantissent pas une accessibilité complète. Le widget seul ne permet pas de déclarer une conformité globale aux normes d’accessibilité ; nous n’avons pas achevé une vérification exhaustive des pages, formulaires et services intégrés.",
    "accessibility.preferences.title": "Personnaliser l’affichage",
    "accessibility.preferences.body": "Ouvrez le panneau avec l’icône Accessibilité de la barre de navigation, ou avec Alt+Shift+A sous Windows/Linux et ⌥ Option+Shift+A sur Mac. Les changements s’appliquent immédiatement aux pages du site.",
    "accessibility.preferences.contrast": "Contraste élevé : augmente le contraste visuel de la page.",
    "accessibility.preferences.invert": "Inverser les couleurs : inverse les couleurs du fond et des contenus, images comprises.",
    "accessibility.preferences.size": "Texte agrandi : passe du texte normal au grand puis au très grand.",
    "accessibility.preferences.spacing": "Espacement du texte : augmente l’espacement de lecture des contenus pris en charge.",
    "accessibility.preferences.focus": "Renforcer le focus : rend plus visible la commande sélectionnée au clavier.",
    "accessibility.preferences.links": "Souligner les liens : ajoute un soulignement aux liens.",
    "accessibility.preferences.motion": "Réduire les animations : réduit les animations et transitions de la page.",
    "accessibility.preferences.font": "Police lisible : utilise une police sans empattement du système.",
    "accessibility.preferences.storage": "Les préférences sont enregistrées dans le stockage local de ce navigateur et le widget ne les transmet pas à YOBY. « Rétablir les valeurs par défaut » les annule. Elles ne sont pas synchronisées entre appareils ; l’enregistrement peut être indisponible si le navigateur bloque le stockage local.",
    "accessibility.keyboard.title": "Utiliser le clavier",
    "accessibility.keyboard.body": "Le premier Tab affiche le lien « Aller au contenu ». Tab et Maj+Tab permettent de parcourir les commandes ; Entrée ou Espace activent les boutons. Le focus reste dans le panneau ouvert ; Échap le ferme et replace le focus à son point de départ.",
    "accessibility.game.title": "Le jeu : limites actuelles",
    "accessibility.game.body": "Le jeu est une expérience visuelle et interactive distincte du site d’information. Nous ne le présentons pas actuellement comme entièrement accessible et ne pouvons pas garantir son utilisation complète avec un lecteur d’écran ou uniquement au clavier.",
    "accessibility.game.limits": "Les préférences du site ne rendent pas le monde du jeu accessible et ne s’appliquent pas automatiquement à la scène 3D, aux interactions ou à toutes les commandes du jeu. Les services intégrés, comme les panneaux de connexion et d’inscription, peuvent aussi avoir leurs propres comportements et limites. Contactez-nous en cas d’obstacle : nous pourrons recueillir le problème et examiner comment vous aider, sans promettre qu’une version équivalente de chaque activité soit déjà disponible.",
    "accessibility.feedback.title": "Signaler une difficulté",
    "accessibility.feedback.body": "Pour nous aider à comprendre, indiquez la page ou la fonction concernée, ce que vous cherchiez à faire, votre appareil et navigateur et, si nécessaire, la technologie d’assistance utilisée. Il n’est pas nécessaire de transmettre un diagnostic ou des données de santé.",
    "accessibility.feedback.contact": "Nous contacter au sujet de l’accessibilité",
    "auth.a11y.email": "Adresse e-mail",
    "auth.a11y.subscribe": "S’inscrire",
    "auth.a11y.sent": "E-mail envoyé. Consultez votre messagerie pour continuer.",
    "auth.a11y.termsRequired": "Veuillez accepter les conditions pour continuer.",
    "auth.a11y.close": "Fermer la fenêtre",
    "auth.a11y.account": "Compte YOBY",
    "auth.a11y.sending": "Envoi en cours…"
  },
  "es": {
    "blog.title": "Blog",
    "dash.admin.approveSignup": "Approve",
    "dash.admin.errArchive": "No se pudo archivar la escuela.",
    "dash.admin.errAssign": "No se pudo asignar el personal.",
    "dash.admin.errCreateSchool": "No se pudo crear la escuela.",
    "dash.admin.errDenied": "Acceso denegado. Inicia sesión como admin YOBY.",
    "dash.admin.errRoleNotAllowed": "Rol no permitido.",
    "dash.admin.errSaveSchool": "No se pudo guardar la escuela.",
    "dash.admin.errSignupApprove": "Could not approve the application.",
    "dash.admin.errSignupLoad": "Could not load school applications.",
    "dash.admin.errSignupReject": "Could not reject the application.",
    "dash.admin.errUserNotFound": "Usuario no encontrado.",
    "dash.admin.linkAdminSafety": "Últimas auditorías de seguridad de la IA",
    "dash.admin.linkMassmail": "Massmail escuelas",
    "dash.admin.linkPlay": "Juego familiar",
    "dash.admin.linkRedteam": "AI Red Team",
    "dash.admin.linkStatus": "Estado del juego",
    "dash.admin.linkSupervisor": "Panel del supervisor",
    "dash.admin.linkTeacher": "Panel del profesor",
    "dash.admin.noSignups": "No school applications.",
    "dash.admin.noStaff": "Sin personal todavía.",
    "dash.admin.panelSchoolsForm": "Alta / edición escuelas",
    "dash.admin.panelSchoolsList": "Lista de escuelas",
    "dash.admin.panelSignups": "Inscripciones escuelas",
    "dash.admin.panelStaffForm": "Alta / edición personal",
    "dash.admin.panelStaffList": "Lista de personal",
    "dash.admin.quickLinks": "Enlaces rápidos",
    "dash.admin.rejectReason": "Rejection reason",
    "dash.admin.rejectSignup": "Reject",
    "dash.admin.schoolListHint": "Haz clic en una fila para editarla. Archivar pide confirmación.",
    "dash.admin.selectSchool": "Selecciona una escuela",
    "dash.admin.signupClasses": "Classes",
    "dash.admin.signupTeachers": "Teachers",
    "dash.admin.staffListHint": "Haz clic en una fila para actualizar asignación y rol.",
    "dash.admin.statusAssigned": "Personal asignado.",
    "dash.admin.statusAssigning": "Asignando personal…",
    "dash.admin.statusCreatingSchool": "Creando escuela…",
    "dash.admin.statusEditingSchool": "Editando escuela — cambia los campos y guarda.",
    "dash.admin.statusEditingStaff": "Editando staff — actualiza y asigna.",
    "dash.admin.statusSavingSchool": "Guardando escuela…",
    "dash.admin.statusSchoolCreated": "Escuela creada.",
    "dash.admin.statusSchoolSaved": "Escuela guardada.",
    "dash.admin.subtitle": "Crea escuelas y asigna profesores y supervisores. Requiere inicio de sesión admin YOBY (correo en ADMIN_EMAILS).",
    "dash.admin.surveyAssignStaff": "Asignar personal",
    "dash.admin.surveyCreateSchool": "Crear escuela",
    "dash.admin.surveySaveSchool": "Guardar escuela",
    "dash.admin.surveySchoolDesc": "Registra una escuela en el módulo YOBY.",
    "dash.admin.surveySchoolName": "Nombre de la escuela",
    "dash.admin.surveySchoolSlug": "Slug (opcional)",
    "dash.admin.surveySchoolTitle": "Nueva escuela",
    "dash.admin.surveyStaffDesc": "Vincula profesores y supervisores a una escuela.",
    "dash.admin.surveyStaffEmail": "Correo del personal",
    "dash.admin.surveyStaffForce": "Forzar asignación",
    "dash.admin.surveyStaffForceDesc": "Reasignar aunque el usuario ya pertenezca a otra escuela.",
    "dash.admin.surveyStaffRoleSupervisor": "Supervisor",
    "dash.admin.surveyStaffRoleTeacher": "Profesor",
    "dash.admin.surveyStaffSchool": "Escuela",
    "dash.admin.surveyStaffTitle": "Asignar personal",
    "dash.admin.surveyUpdateStaff": "Actualizar staff",
    "dash.admin.tabSchoolsForm": "Alta / edición escuelas",
    "dash.admin.tabSchoolsList": "Lista de escuelas",
    "dash.admin.tabSignups": "Inscripciones escuelas",
    "dash.admin.tabStaffForm": "Alta / edición personal",
    "dash.admin.tabStaffList": "Lista de personal",
    "dash.admin.tabsAria": "Admin escuelas",
    "dash.admin.title": "Admin escuelas YOBY",
    "dash.booking.active": "Reservas públicas activas",
    "dash.booking.addEmail": "Añadir email",
    "dash.booking.addHour": "Añadir franja",
    "dash.booking.attribution": "Cómo nos encontraron",
    "dash.booking.availabilityHint": "Activa reservas públicas en /talk-with-us/. Horarios dentro de lun–vie 09:00–19:00. Suspende fechas abajo.",
    "dash.booking.availabilityTitle": "Disponibilidad pública",
    "dash.booking.availableSlots": "Horarios disponibles",
    "dash.booking.blockDate": "Suspender",
    "dash.booking.blockReason": "Motivo",
    "dash.booking.blockReasonPlaceholder": "Motivo (opcional)",
    "dash.booking.blockedDatesHint": "Sin huecos esos días.",
    "dash.booking.blockedDatesTitle": "Fechas suspendidas",
    "dash.booking.blockedEmpty": "No hay fechas suspendidas.",
    "dash.booking.blockedOn": "Fecha",
    "dash.booking.blockedSaved": "Fecha suspendida.",
    "dash.booking.booking": "Reservando…",
    "dash.booking.bufferMinutes": "Buffer entre huecos (minutos)",
    "dash.booking.calFreeDays": "Días con huecos libres",
    "dash.booking.cancel": "Cancelar",
    "dash.booking.cancelConfirm": "¿Cancelar esta reserva?",
    "dash.booking.cancelled": "cancelada",
    "dash.booking.cancelledOk": "Reserva cancelada.",
    "dash.booking.confirm": "Reservar",
    "dash.booking.confirmTitle": "Confirmar reserva",
    "dash.booking.copyLink": "Copiar enlace",
    "dash.booking.detailTitle": "Detalle de la reserva",
    "dash.booking.doneBody": "Te enviamos el enlace por email. Úsalo el día de la call.",
    "dash.booking.doneLinkHint": "Si no te llega el email, tu enlace personal es este:",
    "dash.booking.doneStatus": "Revisa también tu bandeja de entrada.",
    "dash.booking.doneTitle": "Reserva confirmada",
    "dash.booking.emailsHint": "Añade hasta 3 emails: cada uno recibe un enlace personal.",
    "dash.booking.empty": "No hay reservas ni llamadas programadas.",
    "dash.booking.errBlockDate": "Fecha no válida.",
    "dash.booking.errBlockExists": "Fecha ya suspendida.",
    "dash.booking.errBook": "No se pudo completar la reserva.",
    "dash.booking.errCancel": "No se pudo cancelar.",
    "dash.booking.errEmails": "Introduce al menos un email válido.",
    "dash.booking.errLoad": "No se pudieron cargar las reservas.",
    "dash.booking.errLoadSlots": "No se pudieron cargar los huecos.",
    "dash.booking.errPickSlot": "Elige primero una hora arriba.",
    "dash.booking.errReschedule": "No se pudo reprogramar.",
    "dash.booking.errSave": "No se pudo guardar.",
    "dash.booking.errSlotTaken": "Ese hueco ya no está disponible.",
    "dash.booking.errTooManyEmails": "Máximo 3 emails por reserva.",
    "dash.booking.errUnblock": "No se pudo reactivar.",
    "dash.booking.errUrl": "Ese enlace no parece una dirección web válida.",
    "dash.booking.formOptionalHint": "Todos los campos siguientes son opcionales. Puedes contarnos un poco sobre ti, o simplemente presentarte y saludar. Lo iremos viendo juntos.",
    "dash.booking.gcalCalendar": "Calendario de destino",
    "dash.booking.gcalConnect": "Conectar Google Calendar",
    "dash.booking.gcalConnectFailed": "No se pudo conectar Google Calendar.",
    "dash.booking.gcalConnected": "Google Calendar conectado.",
    "dash.booking.gcalDisconnect": "Desconectar",
    "dash.booking.gcalDisconnectConfirm": "¿Desconectar Google Calendar?",
    "dash.booking.gcalDisconnected": "Google Calendar desconectado.",
    "dash.booking.gcalMissing": "Listo — pulsa Conectar para autorizar Google (OAuth).",
    "dash.booking.gcalOk": "Google Calendar conectado.",
    "dash.booking.gcalRedirectHint": "URI de redirección a autorizar:",
    "dash.booking.gcalRefresh": "Actualizar calendario",
    "dash.booking.gcalRefreshConfirm": "¿Resincronizar todas las citas futuras en Google Calendar (horarios correctos en el calendario YOBY)?",
    "dash.booking.gcalRefreshEmpty": "No hay citas en curso o futuras para sincronizar.",
    "dash.booking.gcalRefreshFailed": "No se pudo actualizar el calendario.",
    "dash.booking.gcalRefreshNeedReconnect": "Google Calendar no responde: desconecta, vuelve a conectar y reintenta el refresh.",
    "dash.booking.gcalRefreshOk": "Calendario actualizado: {synced}/{total} eventos · {failed} fallos · {calendar}",
    "dash.booking.gcalServerMissing": "Falta la app OAuth en el servidor: crea un cliente Google Cloud «Web application», pon CLIENT_ID/SECRET en GOOGLE_CALENDAR_* del .env y reinicia la API.",
    "dash.booking.gcalTitle": "Google Calendar",
    "dash.booking.inactive": "Las reservas públicas no están activas.",
    "dash.booking.introBody": "Si prefieres conocernos en lugar de rellenar un formulario, puedes reservar una conversación directamente con el equipo de YOBY. Estaremos encantados de mostrarte el proyecto, responder a tus preguntas y explorar cómo YOBY podría encajar en tu familia, escuela, organización o idea de colaboración.",
    "dash.booking.introImageAlt": "Videollamada con el equipo YOBY — patitos hablando en inglés, francés e italiano",
    "dash.booking.introInterpreter": "¿Hablas otro idioma? No hay problema: nuestra plataforma de videoconferencia traducirá el tuyo al nuestro y viceversa.",
    "dash.booking.introLanguages": "Puedes hablar con nosotros en inglés, italiano o francés: Ricardo y Stefano hablan italiano e inglés, mientras que Antonella, nuestra CRO, habla francés, italiano e inglés.",
    "dash.booking.introTitle": "¿Prefieres hablar?",
    "dash.booking.landingUrl": "Página de llegada",
    "dash.booking.linkLabel": "Un enlace que deberíamos ver antes de la llamada",
    "dash.booking.linkPlaceholder": "https://…",
    "dash.booking.listHint": "Haz clic en una fila para gestionar invitados y enlaces. También aparecen las llamadas creadas por admin.",
    "dash.booking.listTitle": "Reservas y llamadas programadas",
    "dash.booking.noLinkedCall": "Esta reserva no tiene una conference vinculada.",
    "dash.booking.noSlots": "No hay huecos libres este día.",
    "dash.booking.note": "¿Hay algo que te gustaría que sepamos?",
    "dash.booking.notifyInvitees": "Avisar a los invitados por email (mismo enlace, nueva hora)",
    "dash.booking.openCall": "Abrir conference",
    "dash.booking.orgLabel": "Organización / proyecto",
    "dash.booking.orgPlaceholder": "Escuela, empresa, medio, fundación...",
    "dash.booking.pickDay": "Elige un día",
    "dash.booking.prefLang.none": "Sin preferencia",
    "dash.booking.prefLangLabel": "Idioma preferido",
    "dash.booking.publicSubtitle": "Elige un hueco libre. Recibirás un enlace personal para la conference.",
    "dash.booking.publicTitle": "Reservar una call YOBY",
    "dash.booking.referrer": "Referrer",
    "dash.booking.rescheduleHint": "Cambia la fecha y la hora. Los enlaces personales no cambian.",
    "dash.booking.rescheduleTitle": "Reprogramar",
    "dash.booking.rescheduled": "Reserva reprogramada. Los enlaces no han cambiado.",
    "dash.booking.rulesHint": "Reglas fijas: al menos 48 h de antelación, lunes–viernes 09:00–19:00 (Europe/Rome).",
    "dash.booking.save": "Guardar disponibilidad",
    "dash.booking.saveCall": "Guardar nueva hora",
    "dash.booking.saved": "Disponibilidad guardada.",
    "dash.booking.saving": "Guardando…",
    "dash.booking.slotMinutes": "Duración del hueco (minutos)",
    "dash.booking.sourceAdmin": "Llamada programada",
    "dash.booking.status": "Estado",
    "dash.booking.statusCancelled": "cancelada",
    "dash.booking.statusDone": "concluida",
    "dash.booking.statusExpired": "caducada",
    "dash.booking.statusLive": "en curso",
    "dash.booking.statusUpcoming": "próxima",
    "dash.booking.timezone": "Tu zona horaria",
    "dash.booking.timezoneHint": "Los horarios se muestran en la zona elegida. La disponibilidad YOBY es lun–vie 09:00–19:00 (Europe/Rome).",
    "dash.booking.topic.banking_fintech": "Banca y fintech",
    "dash.booking.topic.families": "YOBY para familias",
    "dash.booking.topic.financial_education": "Educación financiera",
    "dash.booking.topic.investment": "Inversión",
    "dash.booking.topic.other": "Otra cosa",
    "dash.booking.topic.partnership": "Colaboración",
    "dash.booking.topic.press": "Prensa y entrevistas",
    "dash.booking.topic.research": "Investigación",
    "dash.booking.topic.school_pilot": "Piloto escolar",
    "dash.booking.topicsLabel": "¿De qué te gustaría hablar?",
    "dash.booking.unblockDate": "Reactivar",
    "dash.booking.unblocked": "Fecha reactivada.",
    "dash.booking.utm": "Campaña (UTM)",
    "dash.booking.weekday0": "Domingo",
    "dash.booking.weekday1": "Lunes",
    "dash.booking.weekday2": "Martes",
    "dash.booking.weekday3": "Miércoles",
    "dash.booking.weekday4": "Jueves",
    "dash.booking.weekday5": "Viernes",
    "dash.booking.weekday6": "Sábado",
    "dash.booking.weeklyHours": "Horario semanal",
    "dash.booking.who.bank": "Banco o institución financiera",
    "dash.booking.who.curious": "Solo curiosidad",
    "dash.booking.who.educator": "Educador o escuela",
    "dash.booking.who.empty": "Elige si quieres…",
    "dash.booking.who.foundation": "Fundación u ONG",
    "dash.booking.who.investor": "Inversor",
    "dash.booking.who.journalist": "Periodista",
    "dash.booking.who.other": "Otro",
    "dash.booking.who.parent": "Madre, padre o tutor",
    "dash.booking.who.public": "Institución pública",
    "dash.booking.who.startup": "Startup o empresa",
    "dash.booking.whoLabel": "¿Quién eres?",
    "dash.booking.yourEmail": "Tu email",
    "dash.booking.yourEmails": "Emails de los invitados",
    "dash.booking.yourName": "Tu nombre",
    "dash.common.actions": "Acciones",
    "dash.common.actor": "Actor",
    "dash.common.archive": "Archivar",
    "dash.common.assignments": "Tareas",
    "dash.common.attempts": "Intentos",
    "dash.common.avg": "Media",
    "dash.common.cancel": "Cancelar",
    "dash.common.class": "Clase",
    "dash.common.classes": "Clases",
    "dash.common.code": "Código",
    "dash.common.confirm": "Confirmar",
    "dash.common.confirmArchiveSchool": "¿Archivar esta escuela?",
    "dash.common.confirmTitle": "Confirmación",
    "dash.common.copyCode": "Copiar código",
    "dash.common.csvDownloaded": "CSV descargado",
    "dash.common.difficulty": "Dificultad",
    "dash.common.email": "Correo",
    "dash.common.entity": "Entidad",
    "dash.common.exportCsv": "Exportar CSV",
    "dash.common.family": "Familia",
    "dash.common.lastAccess": "Último acceso",
    "dash.common.loading": "Cargando…",
    "dash.common.name": "Nombre",
    "dash.common.newCode": "Nuevo código",
    "dash.common.none": "—",
    "dash.common.ok": "OK",
    "dash.common.open": "Abrir",
    "dash.common.questions": "Preguntas",
    "dash.common.quiz": "Quiz",
    "dash.common.refresh": "Actualizar",
    "dash.common.role": "Rol",
    "dash.common.school": "Escuela",
    "dash.common.select": "Seleccionar",
    "dash.common.slug": "Slug",
    "dash.common.status": "Estado",
    "dash.common.students": "Estudiantes",
    "dash.common.teachers": "Profesores",
    "dash.common.topic": "Tema",
    "dash.common.updated": "Actualizado",
    "dash.common.when": "Cuándo",
    "dash.common.year": "Año",
    "dash.conference.addInvitee": "Añadir invitado",
    "dash.conference.addInviteeHint": "Recibe un pato y un enlace personal. Puedes enviarle el invite por email al momento.",
    "dash.conference.addInviteeTitle": "Añadir un invitado",
    "dash.conference.addingInvitee": "Añadiendo…",
    "dash.conference.back": "Volver a la lista",
    "dash.conference.chat": "Chat",
    "dash.conference.confirmed": "Confirmada",
    "dash.conference.confirmedNo": "Pendiente",
    "dash.conference.confirmedYes": "Sí",
    "dash.conference.copied": "Enlace copiado.",
    "dash.conference.copiedShort": "¡Copiado!",
    "dash.conference.copyLink": "Copiar enlace",
    "dash.conference.create": "Crear llamada",
    "dash.conference.createImmediate": "Crear conference inmediata",
    "dash.conference.createImmediateHint": "Solo hace falta el nombre de la call/familia. Crea un enlace abierto hasta medianoche (Europe/Rome).",
    "dash.conference.created": "Llamada creada.",
    "dash.conference.createdImmediate": "Conference abierta creada — comparte el único enlace. Válido el resto del día.",
    "dash.conference.creating": "Creando…",
    "dash.conference.detailTitle": "Enlaces de invitación",
    "dash.conference.editHint": "Puedes cambiar fecha, hora, nombre e idioma. Los enlaces de acceso no cambian.",
    "dash.conference.editTitle": "Reprogramar llamada",
    "dash.conference.email": "Email",
    "dash.conference.emailDryRun": "Email dry-run (no enviado).",
    "dash.conference.emailSent": "Aceptado por Mailgun.",
    "dash.conference.empty": "Aún no hay conference calls.",
    "dash.conference.emptyInvitees": "Aún no hay invitados.",
    "dash.conference.ended": "Call terminada.",
    "dash.conference.errAddInvitee": "No se pudo añadir el invitado. Revisa email y nombre.",
    "dash.conference.errCallEnded": "La call ha terminado: no se pueden añadir invitados.",
    "dash.conference.errCopy": "No se pudo copiar el enlace.",
    "dash.conference.errCreate": "No se pudo crear la llamada.",
    "dash.conference.errDenied": "Acceso denegado. Inicia sesión como admin YOBY.",
    "dash.conference.errDuplicateInvitee": "Este email ya está invitado a esta call.",
    "dash.conference.errEmail": "No se pudo enviar el email.",
    "dash.conference.errLoad": "No se pudieron cargar las conference calls.",
    "dash.conference.errSave": "No se pudieron guardar los cambios.",
    "dash.conference.errWorldFull": "Mundo conference lleno: no quedan estanques libres.",
    "dash.conference.familyName": "Nombre de familia",
    "dash.conference.firstName": "Nombre",
    "dash.conference.gameLocale": "Idioma del juego",
    "dash.conference.inviteeAdded": "Invitado añadido.",
    "dash.conference.inviteeCount": "Invitados",
    "dash.conference.invitees": "Invitados",
    "dash.conference.lastName": "Apellido",
    "dash.conference.listTitle": "Llamadas programadas",
    "dash.conference.mediaHealth.checking": "Comprobando Janus y Coturn…",
    "dash.conference.mediaHealth.coturn": "Coturn (TURN)",
    "dash.conference.mediaHealth.down": "DOWN",
    "dash.conference.mediaHealth.errLoad": "No se pudo leer el estado de vídeo.",
    "dash.conference.mediaHealth.hintDown": "No inicies la llamada: el vídeo WebRTC no está listo.",
    "dash.conference.mediaHealth.hintOk": "Janus y TURN responden. La llamada puede empezar.",
    "dash.conference.mediaHealth.janus": "Janus",
    "dash.conference.mediaHealth.ok": "OK",
    "dash.conference.mediaHealth.title": "Estado de vídeo (live)",
    "dash.conference.notifyInvitees": "Avisar a los invitados por email (mismo enlace, nueva hora)",
    "dash.conference.openCallBadge": "enlace abierto",
    "dash.conference.openCallHint": "Cualquiera con este enlace puede entrar (cada persona recibe su propio pato).",
    "dash.conference.phase": "Fase",
    "dash.conference.refresh": "Actualizar",
    "dash.conference.save": "Guardar cambios",
    "dash.conference.saveTranscript": "Guardar PDF",
    "dash.conference.saved": "Llamada actualizada. Los enlaces no han cambiado.",
    "dash.conference.saving": "Guardando…",
    "dash.conference.sendEmail": "Enviar email",
    "dash.conference.sendEmailOnAdd": "Enviar email de invitación",
    "dash.conference.sendingEmail": "Enviando…",
    "dash.conference.speech": "Habla",
    "dash.conference.startsAt": "Fecha y hora de inicio (Europe/Rome)",
    "dash.conference.startsAtHint": "Introduce la hora en la zona YOBY (Europe/Rome), no en la del navegador.",
    "dash.conference.subtitle": "Crea un mundo YOBY privado para una llamada programada. Cada invitado recibe un pato y un enlace personal.",
    "dash.conference.tabAvailability": "Disponibilidad",
    "dash.conference.tabBookings": "Reservas",
    "dash.conference.tabCalls": "Calls programadas",
    "dash.conference.tabCreate": "Crear call",
    "dash.conference.tabsAria": "Secciones conference",
    "dash.conference.title": "Conference call",
    "dash.conference.transcript": "Transcripción",
    "dash.conference.transcriptDisabledNote": "Transcripción desactivada a petición de un participante.",
    "dash.conference.transcriptEmpty": "Aún no hay transcripción.",
    "dash.conference.transcriptSaved": "PDF guardado.",
    "dash.difficulty.easy": "Fácil",
    "dash.difficulty.hard": "Difícil",
    "dash.difficulty.medium": "Medio",
    "dash.liveInterpreter.callMetrics": "Live Interpreter usage",
    "dash.liveInterpreter.callMetricsBody": "Call {callMin} min · translated {liMin} min · languages: {langs} · listeners: {listeners} · ≈ €{eur}",
    "dash.liveInterpreter.criticalPct": "Critical threshold (%)",
    "dash.liveInterpreter.enabled": "Activar Live Interpreter (solo conferencias comerciales)",
    "dash.liveInterpreter.enabledDesc": "Interruptor maestro para llamadas comerciales. Nunca activa el videochat de los estanques del juego.",
    "dash.liveInterpreter.envOff": "Env kill-switch is OFF",
    "dash.liveInterpreter.errLoad": "Could not load interpreter settings.",
    "dash.liveInterpreter.errSave": "Could not save interpreter settings.",
    "dash.liveInterpreter.hint": "Traducción de voz solo en conferencias comerciales. Nunca en el video de estanque.",
    "dash.liveInterpreter.monthUsage": "Month {month}: {used} / {limit} min · ≈ €{eur} · {calls} calls · {status}",
    "dash.liveInterpreter.monthlyLimit": "Límite mensual (minutos de audio traducido)",
    "dash.liveInterpreter.providerMissing": "Azure Voice Live endpoint/API key missing in .env",
    "dash.liveInterpreter.providerOk": "Azure Voice Live configured",
    "dash.liveInterpreter.quotaBlocked": "Nuevas traducciones bloqueadas",
    "dash.liveInterpreter.quotaCritical": "Critical",
    "dash.liveInterpreter.quotaOk": "OK",
    "dash.liveInterpreter.quotaWarn": "Warning",
    "dash.liveInterpreter.save": "Guardar",
    "dash.liveInterpreter.saved": "Ajustes guardados.",
    "dash.liveInterpreter.tab": "Intérprete",
    "dash.liveInterpreter.testCall": "TEST — abrir conferencia de prueba",
    "dash.liveInterpreter.testCallCreating": "Creando conferencia de prueba…",
    "dash.liveInterpreter.testCallErr": "No se pudo crear la conferencia de prueba.",
    "dash.liveInterpreter.testCallHint": "Crea una conferencia inmediata (enlace público) y la abre en una pestaña nueva.",
    "dash.liveInterpreter.testCallOk": "Conferencia de prueba lista — abierta en una pestaña nueva.",
    "dash.liveInterpreter.title": "Live Interpreter",
    "dash.liveInterpreter.warnPct": "Warning threshold (%)",
    "dash.schoolSignup.addClass": "Add class",
    "dash.schoolSignup.addTeacher": "Add teacher",
    "dash.schoolSignup.alreadyBody": "This account is already linked to a school on YOBY.",
    "dash.schoolSignup.alreadyTitle": "Ya estás inscrito",
    "dash.schoolSignup.back": "Atrás",
    "dash.schoolSignup.checkEmail": "Check your email and come back to this page after confirming.",
    "dash.schoolSignup.city": "City",
    "dash.schoolSignup.className": "Class name",
    "dash.schoolSignup.classTeacher": "Docente de la clase",
    "dash.schoolSignup.classes": "Classes involved",
    "dash.schoolSignup.continue": "Continue",
    "dash.schoolSignup.country": "Country",
    "dash.schoolSignup.draftSaved": "Draft saved.",
    "dash.schoolSignup.email": "Principal’s email",
    "dash.schoolSignup.errClassTeacher": "Elige un docente ya indicado en el paso anterior.",
    "dash.schoolSignup.errEmail": "Introduce un correo electrónico válido.",
    "dash.schoolSignup.errGeneric": "Something went wrong. Try again.",
    "dash.schoolSignup.errLocked": "The application has already been submitted.",
    "dash.schoolSignup.errLookup": "Could not check this email.",
    "dash.schoolSignup.errName": "Introduce nombre y apellidos (al menos 2 caracteres).",
    "dash.schoolSignup.errPhone": "El teléfono es opcional. Si lo rellenas, usa dígitos, espacios o +.",
    "dash.schoolSignup.errPrivacy": "Debes aceptar el aviso de privacidad para continuar.",
    "dash.schoolSignup.errSave": "Could not save the draft.",
    "dash.schoolSignup.errSubmit": "Could not submit the application.",
    "dash.schoolSignup.errTeacherDup": "Cada docente debe tener un correo distinto.",
    "dash.schoolSignup.errTeacherSelf": "No uses el correo del director: es supervisor, no docente.",
    "dash.schoolSignup.errValidation": "Enter the school name, at least one teacher and one class.",
    "dash.schoolSignup.goDashboard": "Open dashboard",
    "dash.schoolSignup.helpAccount": "Crea la cuenta del director con nombre, correo y consentimiento de privacidad. Enviamos un enlace de confirmación: ábrelo y vuelve a esta página. Si ya tienes cuenta YOBY, inicia sesión: no hace falta registrarse otra vez.",
    "dash.schoolSignup.helpClassTeacher": "Elige el docente titular de esta clase. Debe estar ya en la lista de docentes.",
    "dash.schoolSignup.helpClasses": "Cada clase tiene un docente titular elegido en el paso anterior. Al aprobar, YOBY crea las clases y se las asigna. Hace falta al menos una clase.",
    "dash.schoolSignup.helpSchool": "Indica los datos del centro para que YOBY pueda activarlo tras la revisión. El teléfono es opcional. En la nota puedes añadir sedes, horarios u otra información útil.",
    "dash.schoolSignup.helpTeachers": "Enumera los docentes que usarán YOBY. Recibirán una invitación al aprobar. No incluyas el correo del director: es supervisor, no docente. Hace falta al menos un docente.",
    "dash.schoolSignup.introAlt": "Prefer a call with us?",
    "dash.schoolSignup.introBody": "The principal signs up, confirms the email, then lists teachers and classes. YOBY activates the school after a review.",
    "dash.schoolSignup.introTitle": "Inscribe tu escuela",
    "dash.schoolSignup.knownBody": "This email is already registered. Sign in with the link we send you.",
    "dash.schoolSignup.knownTitle": "Ya estás inscrito",
    "dash.schoolSignup.locale": "Working language",
    "dash.schoolSignup.name": "Principal’s name",
    "dash.schoolSignup.note": "Note (optional)",
    "dash.schoolSignup.openDashboard": "Go to dashboard",
    "dash.schoolSignup.pendingBody": "We received the application for {school}. We’ll email you when it’s active.",
    "dash.schoolSignup.pendingTitle": "Waiting for approval",
    "dash.schoolSignup.phone": "Phone (optional)",
    "dash.schoolSignup.privacy": "I accept the privacy notice and to share the listed teachers’ emails.",
    "dash.schoolSignup.rejectedBody": "The previous application was not approved. Reason: {reason}",
    "dash.schoolSignup.rejectedTitle": "Application not approved",
    "dash.schoolSignup.saveDraft": "Save draft",
    "dash.schoolSignup.schoolName": "School name",
    "dash.schoolSignup.signIn": "Entrar",
    "dash.schoolSignup.signUp": "Regístrate y confirma el email",
    "dash.schoolSignup.stepAccount": "Cuenta",
    "dash.schoolSignup.stepAccountTitle": "Cuenta",
    "dash.schoolSignup.stepClassesTitle": "Clases",
    "dash.schoolSignup.stepSchool": "Escuela",
    "dash.schoolSignup.stepSchoolTitle": "Escuela",
    "dash.schoolSignup.stepTeachersTitle": "Docentes",
    "dash.schoolSignup.submit": "Enviar la solicitud",
    "dash.schoolSignup.submitted": "Application sent.",
    "dash.schoolSignup.talkWithUs": "Book a call",
    "dash.schoolSignup.teacherEmail": "Teacher email",
    "dash.schoolSignup.teacherName": "Teacher name",
    "dash.schoolSignup.teachers": "Teachers",
    "dash.status.ageBand.11-15": "11–15",
    "dash.status.ageBand.16-17": "16–17",
    "dash.status.ageBand.18-26": "18–26",
    "dash.status.ageBand.8-10": "8–10",
    "dash.status.ageBand.adult": "Adultos",
    "dash.status.ageBand.unknown": "Sin franja",
    "dash.status.analytics.events.arcade_completed.description": "Arcade activity ends",
    "dash.status.analytics.events.arcade_completed.label": "Arcade completed",
    "dash.status.analytics.events.arcade_started.description": "Crazy Run or arcade activity starts",
    "dash.status.analytics.events.arcade_started.label": "Arcade started",
    "dash.status.analytics.events.child_access_started.description": "Child enters via link or parent",
    "dash.status.analytics.events.child_access_started.label": "Child access started",
    "dash.status.analytics.events.child_first_claim_email_sent.description": "Email transaccional de claim enviado al padre",
    "dash.status.analytics.events.child_first_claim_email_sent.label": "Email de desbloqueo enviado",
    "dash.status.analytics.events.child_first_claim_opened.description": "El padre abre la vista previa del enlace /claim",
    "dash.status.analytics.events.child_first_claim_opened.label": "Enlace de desbloqueo abierto",
    "dash.status.analytics.events.child_first_claimed.description": "El padre desbloquea el patito pending en la familia",
    "dash.status.analytics.events.child_first_claimed.label": "Patito desbloqueado",
    "dash.status.analytics.events.child_first_family_activated.description": "Familia lista para jugar tras el claim child-first",
    "dash.status.analytics.events.child_first_family_activated.label": "Familia child-first activada",
    "dash.status.analytics.events.child_first_parent_email_submitted.description": "El niño introduce el email del padre/tutor",
    "dash.status.analytics.events.child_first_parent_email_submitted.label": "Email del padre enviado",
    "dash.status.analytics.events.child_first_started.description": "El niño empieza Crear mi patito",
    "dash.status.analytics.events.child_first_started.label": "Child-first iniciado",
    "dash.status.analytics.events.child_profile_created.description": "A child character profile is created",
    "dash.status.analytics.events.child_profile_created.label": "Child profile created",
    "dash.status.analytics.events.collectible_obtained.description": "An item is collected",
    "dash.status.analytics.events.collectible_obtained.label": "Collectible obtained",
    "dash.status.analytics.events.family_activation_completed.description": "Adult, child and first access exist",
    "dash.status.analytics.events.family_activation_completed.label": "Family activated",
    "dash.status.analytics.events.family_created.description": "A parent creates the family pond",
    "dash.status.analytics.events.family_created.label": "Family created",
    "dash.status.analytics.events.market_transaction.description": "Buy, sell or negotiate",
    "dash.status.analytics.events.market_transaction.label": "Market transaction",
    "dash.status.analytics.events.market_visited.description": "Access to the market",
    "dash.status.analytics.events.market_visited.label": "Market visited",
    "dash.status.analytics.events.mission_completed.description": "Mission finished",
    "dash.status.analytics.events.mission_completed.label": "Mission completed",
    "dash.status.analytics.events.mission_started.description": "A game mission begins",
    "dash.status.analytics.events.mission_started.label": "Mission started",
    "dash.status.analytics.events.parent_demo_converted.description": "Un progenitor termina la demo y crea la cuenta",
    "dash.status.analytics.events.parent_demo_converted.label": "Demo familias convertida",
    "dash.status.analytics.events.parent_demo_keep_prompt.description": "Se muestra la propuesta de quedarse el pato",
    "dash.status.analytics.events.parent_demo_keep_prompt.label": "Demo familias: quedarse el pato",
    "dash.status.analytics.events.parent_demo_parent_ui_complete.description": "Resumen de la interfaz familiar completado",
    "dash.status.analytics.events.parent_demo_parent_ui_complete.label": "Demo familias: UI lista",
    "dash.status.analytics.events.parent_demo_started.description": "Inicio desde el enlace público Prueba YOBY para familias",
    "dash.status.analytics.events.parent_demo_started.label": "Demos familias",
    "dash.status.analytics.events.parent_demo_tour_complete.description": "Tour del mundo completado",
    "dash.status.analytics.events.parent_demo_tour_complete.label": "Demo familias: tour listo",
    "dash.status.analytics.events.quiz_assigned.description": "Teacher assigns a quiz",
    "dash.status.analytics.events.quiz_assigned.label": "Quiz assigned",
    "dash.status.analytics.events.quiz_completed.description": "Quiz finished",
    "dash.status.analytics.events.quiz_completed.label": "Quiz completed",
    "dash.status.analytics.events.quiz_started.description": "Child opens a quiz",
    "dash.status.analytics.events.quiz_started.label": "Quiz started",
    "dash.status.analytics.events.real_task_assigned.description": "Parent assigns a real-life chore",
    "dash.status.analytics.events.real_task_assigned.label": "Real task assigned",
    "dash.status.analytics.events.real_task_completed.description": "Child marks chore done",
    "dash.status.analytics.events.real_task_completed.label": "Real task done",
    "dash.status.analytics.events.real_task_validated.description": "Parent accepts or rejects",
    "dash.status.analytics.events.real_task_validated.label": "Real task validated",
    "dash.status.analytics.events.reward_claimed.description": "Child claims a reward",
    "dash.status.analytics.events.reward_claimed.label": "Reward claimed",
    "dash.status.analytics.events.reward_distributed.description": "Parent allocates a reward",
    "dash.status.analytics.events.reward_distributed.label": "Reward distributed",
    "dash.status.analytics.events.reward_earned.description": "A reward is granted",
    "dash.status.analytics.events.reward_earned.label": "Reward earned",
    "dash.status.analytics.events.session_ended.description": "Exit or inactivity",
    "dash.status.analytics.events.session_ended.label": "Session ended",
    "dash.status.analytics.events.session_started.description": "Someone enters the game",
    "dash.status.analytics.events.session_started.label": "Session started",
    "dash.status.analytics.events.shared_family_session.description": "Parent and child online together",
    "dash.status.analytics.events.shared_family_session.label": "Shared family session",
    "dash.status.analytics.events.subscription_cancelled.description": "Subscription cancelled",
    "dash.status.analytics.events.subscription_cancelled.label": "Subscription cancelled",
    "dash.status.analytics.events.subscription_started.description": "Family or Patron activated",
    "dash.status.analytics.events.subscription_started.label": "Subscription started",
    "dash.status.analytics.events.teacher_demo_converted.description": "Un docente termina la demo y crea la cuenta",
    "dash.status.analytics.events.teacher_demo_converted.label": "Demo docentes convertida",
    "dash.status.analytics.events.teacher_demo_keep_prompt.description": "Se muestra la propuesta de quedarse el pato",
    "dash.status.analytics.events.teacher_demo_keep_prompt.label": "Demo docentes: quedarse el pato",
    "dash.status.analytics.events.teacher_demo_started.description": "Inicio desde el enlace público Prueba YOBY para docentes",
    "dash.status.analytics.events.teacher_demo_started.label": "Demos docentes",
    "dash.status.analytics.events.teacher_demo_teacher_ui_complete.description": "Resumen de la interfaz docente completado",
    "dash.status.analytics.events.teacher_demo_teacher_ui_complete.label": "Demo docentes: UI lista",
    "dash.status.analytics.events.teacher_demo_tour_complete.description": "Tour del mundo completado",
    "dash.status.analytics.events.teacher_demo_tour_complete.label": "Demo docentes: tour listo",
    "dash.status.analytics.events.temporary_link_generated.description": "A temporary play link is created",
    "dash.status.analytics.events.temporary_link_generated.label": "Temp link created",
    "dash.status.analytics.events.temporary_link_used.description": "A temporary link is redeemed",
    "dash.status.analytics.events.temporary_link_used.label": "Temp link used",
    "dash.status.charts.acq_age_doughnut.title": "Perfiles infantiles por franja de edad",
    "dash.status.charts.acq_child_first_funnel.title": "Embudo patito child-first",
    "dash.status.charts.acq_child_first_trend.title": "Tendencia child-first",
    "dash.status.charts.acq_demo_bar.title": "Demos desde enlaces públicos",
    "dash.status.charts.acq_demo_trend.title": "Tendencia de demos",
    "dash.status.charts.acq_funnel.title": "Acquisition funnel",
    "dash.status.charts.acq_plan_doughnut.title": "Subscription plans",
    "dash.status.charts.acq_trend_line.title": "Acquisition trend",
    "dash.status.charts.eco_age_doughnut.title": "Recompensas por franja de edad",
    "dash.status.charts.eco_arcade_line.title": "Arcade activity",
    "dash.status.charts.eco_chores_funnel.title": "Real tasks funnel",
    "dash.status.charts.eco_collectibles_line.title": "Collectibles",
    "dash.status.charts.eco_market_bar.title": "Market activity",
    "dash.status.charts.eco_reward_origin.title": "Reward origins",
    "dash.status.charts.eco_reward_volume.title": "Reward volume",
    "dash.status.charts.eng_access_doughnut.title": "Child access channels",
    "dash.status.charts.eng_age_doughnut.title": "Sesiones por franja de edad",
    "dash.status.charts.eng_device_bar.title": "Sessions by device",
    "dash.status.charts.eng_links_bar.title": "Temporary links",
    "dash.status.charts.eng_sessions_line.title": "Sessions by role",
    "dash.status.charts.eng_shared_line.title": "Shared family sessions",
    "dash.status.charts.learn_age_doughnut.title": "Quiz completados por franja de edad",
    "dash.status.charts.learn_duration_bar.title": "Average duration",
    "dash.status.charts.learn_mission_host.title": "Missions by host",
    "dash.status.charts.learn_mission_trend.title": "Mission trend",
    "dash.status.charts.learn_quiz_funnel.title": "Quiz funnel",
    "dash.status.charts.learn_quiz_trend.title": "Quiz trend",
    "dash.status.charts.live_age_bar.title": "En línea por franja de edad",
    "dash.status.charts.live_realm_pie.title": "Online by realm",
    "dash.status.charts.live_role_bar.title": "Online by role",
    "dash.status.daysLabel": "Días",
    "dash.status.errLoad": "No se pudo cargar el estado.",
    "dash.status.lastAccessTitle": "Último acceso",
    "dash.status.loading": "Cargando…",
    "dash.status.logAll": "Todos",
    "dash.status.logFilter": "Evento",
    "dash.status.refresh": "Actualizar",
    "dash.status.report.anonymized": "Informe anonimizado: sin emails ni nombres.",
    "dash.status.report.failed": "Error al generar. Inténtalo de nuevo.",
    "dash.status.report.generate": "Generar informe",
    "dash.status.report.generating": "Generando",
    "dash.status.report.impossible": "No se puede generar el informe: no hay datos analytics en el periodo.",
    "dash.status.report.overviewTitle": "Comentario general",
    "dash.status.report.pdfAnalysisTitle": "Análisis",
    "dash.status.report.pdfChartsTitle": "Gráficos",
    "dash.status.report.pdfKpisTitle": "Indicadores clave",
    "dash.status.report.pdfPage": "Página {n} de {total}",
    "dash.status.report.pdfPeriod": "Periodo: últimos {days} días",
    "dash.status.report.pdfTitle": "Informe analytics Yoby",
    "dash.status.report.pdfUnavailable": "Biblioteca PDF no disponible.",
    "dash.status.report.previewFailed": "No se pudo mostrar la vista previa PDF.",
    "dash.status.report.previewPreparing": "Preparando vista previa PDF…",
    "dash.status.report.readyAt": "Generado",
    "dash.status.report.savePdf": "Guardar PDF",
    "dash.status.report.waiting": "Informe en preparación…",
    "dash.status.sectionOnline": "En línea ahora",
    "dash.status.sectionOnlineAge": "En línea por franja de edad",
    "dash.status.sectionTotals": "Totales (sin mundos conference activos)",
    "dash.status.sectionTotalsAge": "Personajes por franja de edad",
    "dash.status.subtitle": "Presencia en juego y analítica de producto.",
    "dash.status.summaryChildren": "Niños online",
    "dash.status.summaryFamilies": "Familias en juego",
    "dash.status.summaryInGame": "En juego (total)",
    "dash.status.summaryParents": "Padres online",
    "dash.status.summaryPlayers": "Jugadores en juego",
    "dash.status.summaryQueueDepth": "Cola analytics",
    "dash.status.summaryRows": "Filas de último acceso",
    "dash.status.summarySurface": "En la superficie",
    "dash.status.summaryUnderground": "Subterráneo",
    "dash.status.summaryWorldsActive": "Mundos con jugadores en línea",
    "dash.status.summaryWorldsOpened": "Mundos abiertos",
    "dash.status.tabs.acquisition": "Adquisición",
    "dash.status.tabs.economy": "Economía",
    "dash.status.tabs.engagement": "Engagement",
    "dash.status.tabs.learning": "Aprendizaje",
    "dash.status.tabs.live": "En vivo",
    "dash.status.tabs.logs": "Logs",
    "dash.status.tabs.report": "Informe",
    "dash.status.thAgeBand": "Franja",
    "dash.status.thEmailName": "Correo / Nombre",
    "dash.status.thEvent": "Evento",
    "dash.status.thFamily": "Familia",
    "dash.status.thLastAccess": "Último acceso",
    "dash.status.thRole": "Rol",
    "dash.status.thSummary": "Resumen",
    "dash.status.thTime": "Hora",
    "dash.status.thWorld": "Mundo",
    "dash.status.thWorldFamilies": "Familias",
    "dash.status.thWorldPlayers": "Jugadores",
    "dash.status.thWorldSurface": "Superficie",
    "dash.status.thWorldUnderground": "Subterráneo",
    "dash.status.title": "Estado",
    "dash.status.totalChildren": "Niños (total)",
    "dash.status.totalFamilies": "Familias (total)",
    "dash.status.totalParents": "Padres (total)",
    "dash.status.totalPlayers": "Personajes (total)",
    "dash.status.updated": "Actualizado",
    "dash.status.worldsTitle": "Detalle por mundo",
    "dash.supervisor.csvDownloaded": "CSV descargado",
    "dash.supervisor.errAudit": "No se pudo cargar el registro de auditoría.",
    "dash.supervisor.errDenied": "Acceso denegado. Inicia sesión como supervisor o admin YOBY.",
    "dash.supervisor.errExport": "No se pudo exportar el CSV.",
    "dash.supervisor.exportCsvSchool": "Exportar CSV escuela",
    "dash.supervisor.hintAudit": "Últimas acciones registradas para la escuela.",
    "dash.supervisor.hintQuizzes": "Uso de quiz por slug (intentos completados en la escuela).",
    "dash.supervisor.metaSlug": "Slug",
    "dash.supervisor.metaStatus": "Estado",
    "dash.supervisor.metricSchoolAvg": "Media de la escuela",
    "dash.supervisor.noAudit": "Sin entradas de auditoría.",
    "dash.supervisor.noClasses": "Sin clases.",
    "dash.supervisor.noQuizzes": "Sin datos de quiz.",
    "dash.supervisor.noSchools": "Sin escuelas asignadas.",
    "dash.supervisor.noTeachers": "Sin profesores.",
    "dash.supervisor.refresh": "Actualizar",
    "dash.supervisor.selectSchoolHint": "Selecciona una escuela para ver clases, profesores y estadísticas de quiz.",
    "dash.supervisor.subtitle": "Vista general de escuelas, clases, profesores, quiz y auditoría.",
    "dash.supervisor.tabAudit": "Auditoría",
    "dash.supervisor.tabClasses": "Clases",
    "dash.supervisor.tabQuizzes": "Quiz",
    "dash.supervisor.tabTeachers": "Profesores",
    "dash.supervisor.thAssignments": "Tareas",
    "dash.supervisor.thSchool": "Escuela",
    "dash.supervisor.thTeacher": "Profesor",
    "dash.supervisor.title": "Panel del supervisor",
    "dash.supervisor.yourSchools": "Tus escuelas",
    "dash.teacher.catalogTitle": "Catálogo de quiz",
    "dash.teacher.confirmArchiveClass": "¿Archivar esta clase? El código ya no será utilizable.",
    "dash.teacher.copied": "¡Copiado!",
    "dash.teacher.copyCode": "Copiar código",
    "dash.teacher.createClass": "Crear una clase",
    "dash.teacher.demoLink": "Enlace demo",
    "dash.teacher.demoLinkCopied": "Enlace copiado al portapapeles.",
    "dash.teacher.demoLinkReady": "Enlace permanente creado",
    "dash.teacher.errArchive": "No se pudo archivar la clase.",
    "dash.teacher.errAssign": "No se pudo asignar el quiz.",
    "dash.teacher.errCreateClass": "No se pudo crear la clase.",
    "dash.teacher.errDemoDenied": "Solo los admin pueden crear enlaces demo.",
    "dash.teacher.errDemoLink": "No se pudo crear el enlace demo.",
    "dash.teacher.errDemoNoQuiz": "No queda ningún quiz libre para asignar a esta clase.",
    "dash.teacher.errDenied": "Acceso denegado. Inicia sesión como profesor.",
    "dash.teacher.errExport": "No se pudo exportar el CSV.",
    "dash.teacher.errExportCatalog": "No se pudo exportar el catálogo de quiz.",
    "dash.teacher.errLoadClasses": "No se pudieron cargar las clases.",
    "dash.teacher.errNoTeacher": "Perfil de profesor no encontrado.",
    "dash.teacher.errRegen": "No se pudo regenerar el código.",
    "dash.teacher.errSelectSchool": "Selecciona primero una escuela.",
    "dash.teacher.exportCatalogCsv": "Descargar catálogo CSV (todos los idiomas)",
    "dash.teacher.exportCsv": "Exportar CSV",
    "dash.teacher.hintAssign": "Elige categoría, quiz y ajustes de la tarea.",
    "dash.teacher.hintWrong": "Preguntas con más errores en las tareas recientes.",
    "dash.teacher.metaAge": "Edad",
    "dash.teacher.metaCode": "Código",
    "dash.teacher.metaLang": "Idioma",
    "dash.teacher.metaYear": "Año",
    "dash.teacher.metricAssignments": "Tareas",
    "dash.teacher.metricAttempts": "Intentos",
    "dash.teacher.metricClassAvg": "Media de clase",
    "dash.teacher.metricEnrolled": "Inscritos",
    "dash.teacher.newCode": "Nuevo código",
    "dash.teacher.noAssignments": "Sin tareas todavía.",
    "dash.teacher.noCatalog": "Sin quiz en el catálogo.",
    "dash.teacher.noClasses": "Sin clases todavía.",
    "dash.teacher.noStudents": "Sin estudiantes inscritos.",
    "dash.teacher.noWrong": "Sin preguntas difíciles.",
    "dash.teacher.open": "Abrir",
    "dash.teacher.playLink": "Enlace de juego",
    "dash.teacher.playLinkCopied": "Enlace copiado al portapapeles.",
    "dash.teacher.playLinkFailed": "No se pudo crear el enlace de juego",
    "dash.teacher.playLinkHint": "Los alumnos abren el enlace y tocan su nombre. Supervisa la elección.",
    "dash.teacher.playLinkHours": "Horas",
    "dash.teacher.playLinkReady": "Enlace de juego creado",
    "dash.teacher.quizColChoices": "Respuestas",
    "dash.teacher.quizColOrder": "#",
    "dash.teacher.quizColQuestion": "Pregunta",
    "dash.teacher.quizLoadError": "No se pudo cargar el quiz.",
    "dash.teacher.quizLoading": "Cargando quiz…",
    "dash.teacher.quizPreviewTitle": "Vista previa del quiz",
    "dash.teacher.selectClassHint": "Selecciona una clase para ver los detalles.",
    "dash.teacher.statusAssigned": "Quiz asignado.",
    "dash.teacher.statusAssigning": "Asignando quiz…",
    "dash.teacher.statusClassCreated": "Clase creada.",
    "dash.teacher.statusCreating": "Creando clase…",
    "dash.teacher.subtitle": "Clases, códigos de inscripción, tareas de quiz, resultados y exportaciones.",
    "dash.teacher.surveyFeedbackFinal": "Al final del quiz",
    "dash.teacher.surveyFeedbackImmediate": "Inmediatamente después de cada pregunta",
    "dash.teacher.tabAssign": "Asignar quiz",
    "dash.teacher.tabAssignments": "Tareas",
    "dash.teacher.tabStudents": "Estudiantes",
    "dash.teacher.tabWrong": "Preguntas difíciles",
    "dash.teacher.thAge": "Edad",
    "dash.teacher.thAvg": "Media",
    "dash.teacher.thClass": "Clase",
    "dash.teacher.thCode": "Código",
    "dash.teacher.thCompleted": "Completados",
    "dash.teacher.thDifficulty": "Dificultad",
    "dash.teacher.thDone": "Completadas",
    "dash.teacher.thDue": "Fecha límite",
    "dash.teacher.thErrorPct": "% errores",
    "dash.teacher.thErrors": "Errores",
    "dash.teacher.thFirstName": "Nombre",
    "dash.teacher.thJoined": "Inscrito",
    "dash.teacher.thLastName": "Apellido",
    "dash.teacher.thLastSeen": "Última visita",
    "dash.teacher.thMaxAttempts": "Intentos máx.",
    "dash.teacher.thNickname": "Apodo",
    "dash.teacher.thPublish": "Publicación",
    "dash.teacher.thQuestion": "Pregunta",
    "dash.teacher.thTheme": "Tema",
    "dash.teacher.thTitle": "Título",
    "dash.teacher.thTotalAnswers": "Respuestas totales",
    "dash.teacher.thYear": "Año",
    "dash.teacher.title": "Panel del profesor",
    "dash.teacher.yourClasses": "Tus clases",
    "dash.teacher.yourClassesHint": "Selecciona una clase para ver estudiantes, tareas y estadísticas.",
    "dash.topic.bisogni_desideri": "Necesidades y deseos",
    "dash.topic.budget": "Presupuesto",
    "dash.topic.consumo": "Consumo consciente",
    "dash.topic.imprenditorialita": "Emprendimiento",
    "dash.topic.lavoro": "Mundo laboral",
    "dash.topic.risparmio": "Ahorro",
    "footer.aria.site": "Pie de página",
    "footer.aria.social": "Redes sociales",
    "footer.brand.tagline": "El estanque familiar donde niños y adultos aprenden sobre el dinero juntos.",
    "footer.col.about": "Sobre YOBY",
    "footer.col.aiAudits": "Últimas auditorías de seguridad de la IA",
    "footer.col.banksAndPartners": "Bancos y partners",
    "footer.col.contact": "Contacto",
    "footer.col.cookiePolicy": "Política de cookies",
    "footer.col.dataAndGdpr": "Datos y RGPD",
    "footer.col.investors": "Inversores",
    "footer.col.parentalControls": "Control parental",
    "footer.col.partners.title": "Socios",
    "footer.col.press": "Prensa",
    "footer.col.privacyPolicy": "Política de privacidad",
    "footer.col.product.title": "Producto",
    "footer.col.roadmap": "Roadmap",
    "footer.col.safety": "Seguridad",
    "footer.col.schools": "Escuelas",
    "footer.col.termsOfService": "Términos de servicio",
    "footer.col.trust.title": "Confianza y seguridad",
    "footer.col.yoby.title": "YOBY",
    "footer.copyright.line1": "© 2026 YOBY. Todos los derechos reservados.",
    "footer.copyright.line2": "Creado en Europa para familias, patos y mejores hábitos financieros.",
    "home.about.feature1.body": "Un espacio privado donde toda la familia explora, completa misiones y crece junta. Cada miembro tiene su propio pato.",
    "home.about.feature1.title": "🦆 Un juego familiar para aprender sobre el dinero",
    "home.about.feature2.body": "La Rana, la Urraca, el Topo y otros te guían con misiones cortas y preguntas de opción múltiple. Aprender haciendo, no estudiando.",
    "home.about.feature2.title": "🐸 Mentores que enseñan finanzas jugando",
    "home.about.feature3.body": "Tres monedas simbólicas para metas, ahorro y buenos hábitos. Una economía de juego que enseña sin parecer una lección.",
    "home.about.feature3.title": "🐚 Ahorro, metas y hábitos en una economía lúdica",
    "home.about.feature4.body": "Ningún niño puede recibir contenido inapropiado. Sin videochat sin un padre presente. Diseñado para menores — no solo adaptado.",
    "home.about.feature4.title": "🔒 Seguro por diseño",
    "home.about.title": "Qué encontrarás en el mundo YOBY",
    "home.cta.choosePlan": "Elegir un plan",
    "home.cta.joinDescription": "Crea tu cuenta familiar y empieza a explorar.",
    "home.cta.joinTitle": "¡Zambúllete! Es gratis.",
    "home.cta.playNow": "Jugar ahora",
    "home.cta.premiumActive": "Tienes un plan premium — ¡disfruta de la experiencia completa!",
    "home.cta.premiumHint": "Los planes premium ofrecen mejores condiciones de juego: más conchas, áreas exclusivas y funciones prioritarias.",
    "home.cta.ready": "¿Listo para volver a sumergirte en el estanque?",
    "home.cta.signIn": "Iniciar sesión",
    "home.cta.signUpFree": "Empieza gratis",
    "home.cta.tryAsParent": "¿Eres padre o madre? Prueba YOBY",
    "home.cta.tryAsStudent": "¿Eres docente? Prueba YOBY",
    "home.cta.welcomeBack": "Bienvenido de nuevo",
    "home.cta.welcomeBackName": "Bienvenido de nuevo, {name}",
    "home.hero.childBody": "Créalo ahora. Un padre desbloqueará el estanque cuando estéis listos.",
    "home.hero.childCta": "Crear mi patito",
    "home.hero.childTitle": "¿Buscas tu patito? 🦆",
    "home.hero.ctaPrimary": "Empieza gratis",
    "home.hero.ctaSecondary": "Ver cómo funciona",
    "home.hero.description": "YOBY es un juego de educación financiera donde niños y padres aprenden juntos sobre ahorro, decisiones con el dinero y metas.",
    "home.hero.tagline": "El dinero habla, por fin de forma divertida.",
    "home.hero.title": "Educación financiera para niños y familias, hecha divertida.",
    "home.hero.visualAlt": "El mundo de YOBY con patitos explorando el estanque familiar",
    "home.learn.choices.body": "Enfrenta decisiones cotidianas — gastar ahora, ahorrar o compartir — en misiones seguras y narrativas.",
    "home.learn.choices.title": "Decisiones",
    "home.learn.goals.body": "Nombra lo que importa, planifica y celebra el progreso en el camino.",
    "home.learn.goals.title": "Metas",
    "home.learn.saving.body": "Aparta conchas para después y mira cómo pequeños pasos crecen hacia metas mayores.",
    "home.learn.saving.title": "Ahorro",
    "home.learn.title": "Qué aprenden los niños",
    "home.learn.value.body": "Conecta esfuerzo, tiempo y recursos para que los niños entiendan qué representa el dinero.",
    "home.learn.value.title": "Valor del dinero",
    "home.links.families": "Educación financiera para familias",
    "home.links.kids": "YOBY para niños",
    "home.links.schools": "Educación financiera para escuelas",
    "home.links.title": "Explora YOBY",
    "home.seo.description": "YOBY es un mundo lúdico de educación financiera donde niños y padres aprenden ahorro, decisiones con el dinero y hábitos saludables juntos.",
    "home.seo.title": "Educación financiera para niños y familias | YOBY",
    "home.seoSection.body": "YOBY convierte la educación financiera para niños en una aventura compartida. En un mundo de estanques lúdicos, niños y padres practican el ahorro, fijan metas juntos y hablan de decisiones cotidianas con el dinero. Mentores y misiones cortas guían el aprendizaje sobre el dinero a través del juego — no con fichas ni clases. Si buscas educación financiera para familias en casa, YOBY encuentra a los niños donde están: curiosos, creativos y listos para explorar. Cada miembro de la familia tiene su propio pato en un estanque que compartís solo con personas de confianza. Conchas, semillas y estrellas representan hábitos reales — paciencia, planificación y comprensión del valor de lo ganado. En el camino, los niños aprenden que las pequeñas decisiones suman, que esperar puede valer la pena y que el dinero es una herramienta para metas — no solo para gastar. Los padres siguen involucrados con visibilidad y controles claros en un espacio diseñado para menores desde el principio.",
    "home.seoSection.title": "Educación financiera para niños, a través del juego",
    "home.showcase.aria": "Capturas del juego",
    "home.showcase.card1.alt": "Juego YOBY de educación financiera familiar con padres e hijos explorando un estanque virtual",
    "home.showcase.card1.title": "Estanque familiar — explorad juntos",
    "home.showcase.card2.alt": "Mentores YOBY enseñando dinero a niños con misiones lúdicas",
    "home.showcase.card2.title": "Conoce a los mentores — aprende jugando",
    "home.showcase.card3.alt": "Quiz de educación financiera YOBY y tiendas del pueblo con diálogos localizados",
    "home.showcase.card3.title": "Quiz, tiendas y vida del pueblo",
    "home.showcase.card4.alt": "Mentores subterráneos YOBY enseñando dinero con misiones cinematográficas",
    "home.showcase.card4.title": "Mentores subterráneos y misiones",
    "home.showcase.card5.alt": "Mercado del Tasso YOBY donde los niños practican decisiones con el dinero",
    "home.showcase.card5.title": "Mercados y decisiones con el dinero",
    "home.showcase.card6.alt": "Minijuego Carrera loca de YOBY: los niños corren por el césped recogiendo objetos de temporada a contrarreloj",
    "home.showcase.card6.title": "Carrera loca — una carrera a contrarreloj en el césped",
    "home.showcase.hint": "Toca para ampliar",
    "home.showcase.title": "Descubre el mundo",
    "lang.switch": "Idioma",
    "nav.account": "Cuenta",
    "nav.actions.signIn": "Iniciar sesión",
    "nav.actions.startFree": "Empieza gratis",
    "nav.actions.talkWithUs": "Habla con nosotros",
    "nav.aria.main": "Navegación principal",
    "nav.aria.staff": "Área escuela y administración",
    "nav.footer.schoolSignup": "Inscribe tu escuela",
    "nav.main.blog": "Blog",
    "nav.main.forFamilies": "Para familias",
    "nav.main.forKids": "Para niños",
    "nav.main.home": "Inicio",
    "nav.main.howItWorks": "Cómo funciona",
    "nav.main.pricing": "Precios",
    "nav.main.talkWithUs": "Habla con nosotros",
    "nav.menu": "Menú",
    "nav.searchPosts": "Buscar publicaciones, etiquetas y autores",
    "nav.signIn": "Iniciar sesión",
    "nav.staff.admin": "Admin escuelas",
    "nav.staff.adminSafety": "Últimas auditorías de seguridad de la IA",
    "nav.staff.conference": "Conference call",
    "nav.staff.massmail": "Massmail escuelas",
    "nav.staff.redteam": "AI Red Team",
    "nav.staff.schoolSignups": "Inscripciones escuelas",
    "nav.staff.status": "Estado del juego",
    "nav.staff.supervisor": "Panel supervisor",
    "nav.staff.teacher": "Panel docente",
    "nav.subscribe": "Suscribirse",
    "safetyLab.areasTitle": "Temas que comprobamos",
    "safetyLab.audience": "Para familias y escuelas",
    "safetyLab.cat.abuse": "Abuse",
    "safetyLab.cat.dangerous_behavior": "Dangerous behaviour",
    "safetyLab.cat.distress_support": "Emotional support (allowed)",
    "safetyLab.cat.drugs": "Drugs",
    "safetyLab.cat.hate": "Hate",
    "safetyLab.cat.inappropriate_instructions": "Inappropriate instructions",
    "safetyLab.cat.jailbreak": "Prompt injection",
    "safetyLab.cat.off_topic": "Off-topic",
    "safetyLab.cat.other": "Other safety checks",
    "safetyLab.cat.personal_data": "Personal information",
    "safetyLab.cat.self_harm": "Self-harm",
    "safetyLab.cat.sexual": "Inappropriate sexual content",
    "safetyLab.cat.violence": "Violence",
    "safetyLab.chartEmpty": "Cuando haya más auditorías, verás la tendencia aquí.",
    "safetyLab.chartOutcomes": "Cómo fue la última auditoría",
    "safetyLab.chartTrend": "Tendencia de auditorías recientes",
    "safetyLab.historyEmpty": "Aún no hay auditorías completadas.",
    "safetyLab.historyTitle": "Historial reciente",
    "safetyLab.languages": "Idiomas de la prueba",
    "safetyLab.lastTested": "Última auditoría",
    "safetyLab.legendCritical": "Crítico: alto riesgo; máxima prioridad.",
    "safetyLab.legendFail": "Fallido: algo no reaccionó como debía — lo corregimos.",
    "safetyLab.legendPass": "Aprobado: el filtro reaccionó como se esperaba.",
    "safetyLab.legendTitle": "Qué significan los resultados",
    "safetyLab.legendWarning": "Aviso: a menudo un falso positivo (demasiado estricto con un mensaje inocuo), no un riesgo para los niños.",
    "safetyLab.loadFailed": "No se pudieron cargar las auditorías de seguridad.",
    "safetyLab.loading": "Cargando las últimas auditorías…",
    "safetyLab.method1": "El núcleo del control es el Safety Gate: el mismo filtro que intercepta los mensajes en el juego (entrada y, en algunos casos, salida). Cada escenario envía un mensaje (o una secuencia corta) y comprueba si el filtro permite, redirige o bloquea como se espera.",
    "safetyLab.method2": "En la suite completa comprobamos todos los personajes de IA con los que un niño puede hablar: estanque de superficie, subterráneo y tutores. También hay ejecuciones «quick» más rápidas, con un solo personaje y una sola franja de edad por escenario: los personajes listados reflejan siempre solo lo que esa ejecución ha corrido de verdad.",
    "safetyLab.method3": "Los escenarios cubren temas sensibles e intentos de elusión: contenido sexual inapropiado, violencia, autolesión, abuso, drogas, odio, datos personales, instrucciones peligrosas, manipulación de prompts (jailbreak), fuera de tema y también casos benignos o de apoyo emocional que deben seguir permitidos. Muchos escenarios se ejecutan en varios idiomas y franjas de edad.",
    "safetyLab.method4": "Cada caso recibe un resultado: aprobado, aviso, fallido o crítico. Un aviso suele ser un falso positivo (filtro demasiado estricto con un mensaje inocuo), no un riesgo para los niños. Un fallo o crítico significa que algo no reaccionó como debía y hay que corregirlo. Mostramos siempre la última ejecución completada, aunque no sea verde: no sustituimos un mal resultado por uno bueno anterior.",
    "safetyLab.method5": "Para no ayudar a quien quiera saltarse las protecciones, no publicamos los textos de ataque, las recetas de jailbreak ni las transcripciones completas. En público ves agregados, categorías y fechas; el detalle técnico permanece interno.",
    "safetyLab.method6": "La biblioteca de escenarios crece con el tiempo: cuando encontramos una debilidad, añadimos un caso de regresión y lo mantenemos. Si aún no hay ninguna auditoría completada, lo decimos con claridad.",
    "safetyLab.methodIntro": "YOBY ejecuta auditorías automáticas de seguridad sobre la IA que habla con niños. No inventamos los números: cada cifra de esta página proviene de una ejecución real guardada en nuestro sistema. Abajo explicamos qué hacemos, qué medimos y qué no mostramos a propósito.",
    "safetyLab.methodTitle": "Cómo se realizan las pruebas",
    "safetyLab.metricCritical": "Críticos",
    "safetyLab.metricExecuted": "Casos revisados",
    "safetyLab.metricFail": "Fallidos",
    "safetyLab.metricPass": "Aprobados",
    "safetyLab.metricPassRate": "Tasa de éxito",
    "safetyLab.metricWarning": "Avisos",
    "safetyLab.never": "Aún no ejecutada",
    "safetyLab.noteParents": "Esta página está pensada para padres y docentes. Puedes consultarla cuando quieras: es un resumen público de las últimas auditorías, no una página de marketing con números inventados.",
    "safetyLab.npcs": "Personajes de IA cubiertos",
    "safetyLab.plainLead": "YOBY pone a prueba de forma continua a sus personajes de IA, como una auditoría de seguridad. Aquí ves el resultado más reciente — sin detalles técnicos de los ataques.",
    "safetyLab.statusCritical": "Problemas graves detectados",
    "safetyLab.statusError": "La última auditoría no terminó",
    "safetyLab.statusIssues": "Hay puntos a mejorar",
    "safetyLab.statusNever": "Aún no hay auditoría disponible",
    "safetyLab.statusPass": "Todo en orden",
    "safetyLab.subtitle": "Resultados reales de controles automáticos sobre la IA que habla con niños. Pensados para padres y docentes.",
    "safetyLab.thCases": "Casos",
    "safetyLab.thDate": "Fecha",
    "safetyLab.thStatus": "Resultado",
    "safetyLab.title": "Últimas auditorías de seguridad de la IA",
    "footer.col.genderEquality": "Igualdad de género",
    "dash.booking.gcalRefreshHint": "Tras una reserva, usa «Actualizar calendario» si el evento no aparece en Google.",
    "dash.conference.delivery.title": "Entrega de correo",
    "dash.conference.delivery.untracked": "Resultado no disponible",
    "dash.conference.delivery.invite": "Invitación",
    "dash.conference.delivery.reschedule": "Cambio de cita",
    "dash.conference.delivery.reminder": "Recordatorio",
    "dash.conference.delivery.pending": "Preparando",
    "dash.conference.delivery.accepted": "Aceptado por Mailgun",
    "dash.conference.delivery.delivered": "Entregado al servidor del destinatario",
    "dash.conference.delivery.deferred": "Retraso temporal",
    "dash.conference.delivery.failed": "Error de envío o entrega",
    "dash.conference.delivery.dry_run": "Simulado, no enviado",
    "dash.conference.delivery.confirmation": "Tu asistencia está confirmada",
    "footer.col.accessibility": "Accesibilidad",
    "accessibility.title": "Accesibilidad en YOBY",
    "accessibility.intro": "Queremos que la información de YOBY sea más fácil de leer y utilizar. Aquí explicamos las herramientas del sitio y las limitaciones actuales del juego.",
    "accessibility.site.title": "El sitio informativo",
    "accessibility.site.body": "Las páginas ofrecen textos, enlaces de navegación y un panel para personalizar la visualización. Puedes adaptar la lectura a tus necesidades y llegar al contenido principal mediante un enlace de teclado.",
    "accessibility.site.status": "Estas funciones son una ayuda y no garantizan la accesibilidad completa. El widget por sí solo no acredita una conformidad global con estándares de accesibilidad; no hemos completado una revisión exhaustiva de todas las páginas, formularios y servicios integrados.",
    "accessibility.preferences.title": "Personalizar la visualización",
    "accessibility.preferences.body": "Abre el panel con el icono Accesibilidad de la barra de navegación, o con Alt+Shift+A en Windows/Linux y ⌥ Option+Shift+A en Mac. Los cambios se aplican inmediatamente a las páginas del sitio.",
    "accessibility.preferences.contrast": "Alto contraste: aumenta el contraste visual de la página.",
    "accessibility.preferences.invert": "Invertir colores: invierte los colores del fondo y del contenido, incluidas las imágenes.",
    "accessibility.preferences.size": "Texto más grande: alterna entre normal, grande y extra grande.",
    "accessibility.preferences.spacing": "Espaciado del texto: aumenta el espacio de lectura en los contenidos compatibles.",
    "accessibility.preferences.focus": "Resaltar foco: hace más visible el control seleccionado con el teclado.",
    "accessibility.preferences.links": "Subrayar enlaces: añade un subrayado a los enlaces.",
    "accessibility.preferences.motion": "Reducir movimiento: reduce las animaciones y transiciones de la página.",
    "accessibility.preferences.font": "Fuente legible: utiliza una fuente sans serif del sistema.",
    "accessibility.preferences.storage": "Las preferencias se guardan en el almacenamiento local de este navegador y el widget no las envía a YOBY. «Restablecer valores predeterminados» las anula. No se sincronizan entre dispositivos; el guardado puede no estar disponible si el navegador bloquea el almacenamiento local.",
    "accessibility.keyboard.title": "Usar el teclado",
    "accessibility.keyboard.body": "El primer Tab muestra el enlace «Saltar al contenido». Usa Tab y Mayús+Tab para recorrer los controles, e Intro o Espacio para activar botones. El foco permanece en el panel abierto; Esc lo cierra y devuelve el foco al punto desde el que lo abriste.",
    "accessibility.game.title": "El juego: limitaciones actuales",
    "accessibility.game.body": "El juego es una experiencia visual e interactiva distinta del sitio informativo. Actualmente no lo presentamos como plenamente accesible y no podemos garantizar su uso completo con lectores de pantalla o solo con el teclado.",
    "accessibility.game.limits": "Las preferencias del sitio no hacen accesible el mundo del juego ni se aplican automáticamente a la escena 3D, a las interacciones o a todos sus controles. Los servicios integrados, como los paneles de acceso y registro, también pueden tener comportamientos y límites propios. Si encuentras una barrera, contáctanos: podremos recoger el problema y valorar cómo ayudarte, sin prometer que ya exista una versión equivalente de cada actividad.",
    "accessibility.feedback.title": "Comunicar una dificultad",
    "accessibility.feedback.body": "Para ayudarnos a entender el problema, indica la página o función, qué intentabas hacer, tu dispositivo y navegador y, si procede, la tecnología de asistencia utilizada. No necesitas compartir diagnósticos ni otros datos de salud.",
    "accessibility.feedback.contact": "Contactar sobre accesibilidad",
    "auth.a11y.email": "Dirección de correo electrónico",
    "auth.a11y.subscribe": "Registrarse",
    "auth.a11y.sent": "Correo enviado. Revisa tu bandeja de entrada para continuar.",
    "auth.a11y.termsRequired": "Acepta los términos para continuar.",
    "auth.a11y.close": "Cerrar ventana",
    "auth.a11y.account": "Cuenta YOBY",
    "auth.a11y.sending": "Enviando…"
  },
  "pt": {
    "blog.title": "Blog",
    "dash.admin.approveSignup": "Approve",
    "dash.admin.errArchive": "Não foi possível arquivar a escola.",
    "dash.admin.errAssign": "Não foi possível atribuir a equipa.",
    "dash.admin.errCreateSchool": "Não foi possível criar a escola.",
    "dash.admin.errDenied": "Acesso negado. Inicie sessão como admin YOBY.",
    "dash.admin.errRoleNotAllowed": "Função não permitida.",
    "dash.admin.errSaveSchool": "Não foi possível guardar a escola.",
    "dash.admin.errSignupApprove": "Could not approve the application.",
    "dash.admin.errSignupLoad": "Could not load school applications.",
    "dash.admin.errSignupReject": "Could not reject the application.",
    "dash.admin.errUserNotFound": "Utilizador não encontrado.",
    "dash.admin.linkAdminSafety": "Últimas auditorias de segurança da IA",
    "dash.admin.linkMassmail": "Massmail escolas",
    "dash.admin.linkPlay": "Jogo familiar",
    "dash.admin.linkRedteam": "AI Red Team",
    "dash.admin.linkStatus": "Estado do jogo",
    "dash.admin.linkSupervisor": "Painel do supervisor",
    "dash.admin.linkTeacher": "Painel do professor",
    "dash.admin.noSignups": "No school applications.",
    "dash.admin.noStaff": "Sem membros da equipa.",
    "dash.admin.panelSchoolsForm": "Inserir / editar escolas",
    "dash.admin.panelSchoolsList": "Lista de escolas",
    "dash.admin.panelSignups": "Inscrições escolas",
    "dash.admin.panelStaffForm": "Inserir / editar equipa",
    "dash.admin.panelStaffList": "Lista da equipa",
    "dash.admin.quickLinks": "Ligações rápidas",
    "dash.admin.rejectReason": "Rejection reason",
    "dash.admin.rejectSignup": "Reject",
    "dash.admin.schoolListHint": "Clique numa linha para a editar. Arquivar pede confirmação.",
    "dash.admin.selectSchool": "Selecione uma escola",
    "dash.admin.signupClasses": "Classes",
    "dash.admin.signupTeachers": "Teachers",
    "dash.admin.staffListHint": "Clique numa linha para atualizar atribuição e função.",
    "dash.admin.statusAssigned": "Equipa atribuída.",
    "dash.admin.statusAssigning": "A atribuir equipa…",
    "dash.admin.statusCreatingSchool": "A criar escola…",
    "dash.admin.statusEditingSchool": "A editar escola — altere os campos e guarde.",
    "dash.admin.statusEditingStaff": "A editar staff — atualize e atribua.",
    "dash.admin.statusSavingSchool": "A guardar escola…",
    "dash.admin.statusSchoolCreated": "Escola criada.",
    "dash.admin.statusSchoolSaved": "Escola guardada.",
    "dash.admin.subtitle": "Crie escolas e atribua professores e supervisores. Requer login admin YOBY (e-mail em ADMIN_EMAILS).",
    "dash.admin.surveyAssignStaff": "Atribuir equipa",
    "dash.admin.surveyCreateSchool": "Criar escola",
    "dash.admin.surveySaveSchool": "Guardar escola",
    "dash.admin.surveySchoolDesc": "Registe uma escola no módulo YOBY.",
    "dash.admin.surveySchoolName": "Nome da escola",
    "dash.admin.surveySchoolSlug": "Slug (opcional)",
    "dash.admin.surveySchoolTitle": "Nova escola",
    "dash.admin.surveyStaffDesc": "Associe professores e supervisores a uma escola.",
    "dash.admin.surveyStaffEmail": "E-mail da equipa",
    "dash.admin.surveyStaffForce": "Forçar atribuição",
    "dash.admin.surveyStaffForceDesc": "Reatribuir mesmo que o utilizador já pertença a outra escola.",
    "dash.admin.surveyStaffRoleSupervisor": "Supervisor",
    "dash.admin.surveyStaffRoleTeacher": "Professor",
    "dash.admin.surveyStaffSchool": "Escola",
    "dash.admin.surveyStaffTitle": "Atribuir equipa",
    "dash.admin.surveyUpdateStaff": "Atualizar staff",
    "dash.admin.tabSchoolsForm": "Inserir / editar escolas",
    "dash.admin.tabSchoolsList": "Lista de escolas",
    "dash.admin.tabSignups": "Inscrições escolas",
    "dash.admin.tabStaffForm": "Inserir / editar equipa",
    "dash.admin.tabStaffList": "Lista da equipa",
    "dash.admin.tabsAria": "Admin escolas",
    "dash.admin.title": "Admin escolas YOBY",
    "dash.booking.active": "Reservas públicas ativas",
    "dash.booking.addEmail": "Adicionar email",
    "dash.booking.addHour": "Adicionar faixa",
    "dash.booking.attribution": "Como nos encontraram",
    "dash.booking.availabilityHint": "Ativa reservas públicas em /talk-with-us/. Horários dentro de seg–sex 09:00–19:00. Suspende datas abaixo.",
    "dash.booking.availabilityTitle": "Disponibilidade pública",
    "dash.booking.availableSlots": "Horários disponíveis",
    "dash.booking.blockDate": "Suspender",
    "dash.booking.blockReason": "Motivo",
    "dash.booking.blockReasonPlaceholder": "Motivo (opcional)",
    "dash.booking.blockedDatesHint": "Sem slots nesses dias.",
    "dash.booking.blockedDatesTitle": "Datas suspensas",
    "dash.booking.blockedEmpty": "Sem datas suspensas.",
    "dash.booking.blockedOn": "Data",
    "dash.booking.blockedSaved": "Data suspensa.",
    "dash.booking.booking": "A reservar…",
    "dash.booking.bufferMinutes": "Buffer entre slots (minutos)",
    "dash.booking.calFreeDays": "Dias com horários livres",
    "dash.booking.cancel": "Cancelar",
    "dash.booking.cancelConfirm": "Cancelar esta reserva?",
    "dash.booking.cancelled": "cancelada",
    "dash.booking.cancelledOk": "Reserva cancelada.",
    "dash.booking.confirm": "Reservar",
    "dash.booking.confirmTitle": "Confirmar reserva",
    "dash.booking.copyLink": "Copiar link",
    "dash.booking.detailTitle": "Detalhe da reserva",
    "dash.booking.doneBody": "Enviámos o link por email. Usa-o no dia da call.",
    "dash.booking.doneLinkHint": "Se o email não chegar, o teu link pessoal é este:",
    "dash.booking.doneStatus": "Verifica também a tua caixa de entrada.",
    "dash.booking.doneTitle": "Reserva confirmada",
    "dash.booking.emailsHint": "Adiciona até 3 emails — cada um recebe um link pessoal.",
    "dash.booking.empty": "Nenhuma reserva ou call agendada.",
    "dash.booking.errBlockDate": "Data inválida.",
    "dash.booking.errBlockExists": "Data já suspensa.",
    "dash.booking.errBook": "Não foi possível concluir a reserva.",
    "dash.booking.errCancel": "Não foi possível cancelar.",
    "dash.booking.errEmails": "Introduz pelo menos um email válido.",
    "dash.booking.errLoad": "Não foi possível carregar as reservas.",
    "dash.booking.errLoadSlots": "Não foi possível carregar os slots.",
    "dash.booking.errPickSlot": "Escolha primeiro um horário acima.",
    "dash.booking.errReschedule": "Não foi possível reagendar.",
    "dash.booking.errSave": "Não foi possível guardar.",
    "dash.booking.errSlotTaken": "Esse slot já não está disponível.",
    "dash.booking.errTooManyEmails": "Máximo 3 emails por reserva.",
    "dash.booking.errUnblock": "Não foi possível reativar.",
    "dash.booking.errUrl": "Esse link não parece um endereço web válido.",
    "dash.booking.formOptionalHint": "Todos os campos abaixo são opcionais. Pode contar-nos um pouco sobre si, ou simplesmente aparecer e dizer olá. Descobrimos o resto juntos.",
    "dash.booking.gcalCalendar": "Calendário de destino",
    "dash.booking.gcalConnect": "Ligar Google Calendar",
    "dash.booking.gcalConnectFailed": "Falha ao ligar Google Calendar.",
    "dash.booking.gcalConnected": "Google Calendar ligado.",
    "dash.booking.gcalDisconnect": "Desligar",
    "dash.booking.gcalDisconnectConfirm": "Desligar Google Calendar?",
    "dash.booking.gcalDisconnected": "Google Calendar desligado.",
    "dash.booking.gcalMissing": "Pronto — clica Ligar para autorizar o Google (OAuth).",
    "dash.booking.gcalOk": "Google Calendar ligado.",
    "dash.booking.gcalRedirectHint": "URI de redirect a autorizar:",
    "dash.booking.gcalRefresh": "Atualizar calendário",
    "dash.booking.gcalRefreshConfirm": "Ressincronizar todos os agendamentos futuros no Google Calendar (horários corretos no calendário YOBY)?",
    "dash.booking.gcalRefreshEmpty": "Nenhum agendamento em curso ou futuro para sincronizar.",
    "dash.booking.gcalRefreshFailed": "Falha ao atualizar o calendário.",
    "dash.booking.gcalRefreshNeedReconnect": "Google Calendar inacessível: desliga, volta a ligar e tenta o refresh.",
    "dash.booking.gcalRefreshOk": "Calendário atualizado: {synced}/{total} eventos · {failed} falhas · {calendar}",
    "dash.booking.gcalServerMissing": "Falta a app OAuth no servidor: cria um cliente Google Cloud «Web application», põe CLIENT_ID/SECRET em GOOGLE_CALENDAR_* no .env e reinicia a API.",
    "dash.booking.gcalTitle": "Google Calendar",
    "dash.booking.inactive": "As reservas públicas não estão ativas.",
    "dash.booking.introBody": "Se preferir encontrar-nos em vez de preencher um formulário, pode marcar uma conversa diretamente com a equipa YOBY. Teremos todo o gosto em mostrar-lhe o projeto, responder às suas perguntas e explorar como o YOBY se pode adaptar à sua família, escola, organização ou ideia de parceria.",
    "dash.booking.introImageAlt": "Videochamada com a equipa YOBY — patinhos a falar em inglês, francês e italiano",
    "dash.booking.introInterpreter": "Fala outra língua? Não há problema: a nossa plataforma de videoconferência traduzirá a sua para a nossa e vice-versa.",
    "dash.booking.introLanguages": "Pode falar connosco em inglês, italiano ou francês: Ricardo e Stefano falam italiano e inglês, enquanto Antonella, a nossa CRO, fala francês, italiano e inglês.",
    "dash.booking.introTitle": "Prefere conversar?",
    "dash.booking.landingUrl": "Página de chegada",
    "dash.booking.linkLabel": "Um link que devemos ver antes da chamada",
    "dash.booking.linkPlaceholder": "https://…",
    "dash.booking.listHint": "Clica numa linha para gerir convidados e links. As calls criadas pelo admin também aparecem.",
    "dash.booking.listTitle": "Reservas e calls agendadas",
    "dash.booking.noLinkedCall": "Esta reserva não tem uma conference associada.",
    "dash.booking.noSlots": "Sem slots livres neste dia.",
    "dash.booking.note": "Há algo que gostaria que soubéssemos?",
    "dash.booking.notifyInvitees": "Avisar os convidados por email (mesmo link, novo horário)",
    "dash.booking.openCall": "Abrir conference",
    "dash.booking.orgLabel": "Organização / projeto",
    "dash.booking.orgPlaceholder": "Escola, empresa, publicação, fundação...",
    "dash.booking.pickDay": "Escolhe um dia",
    "dash.booking.prefLang.none": "Sem preferência",
    "dash.booking.prefLangLabel": "Língua preferida",
    "dash.booking.publicSubtitle": "Escolhe um horário livre. Recebes um link pessoal para a conference.",
    "dash.booking.publicTitle": "Reservar uma call YOBY",
    "dash.booking.referrer": "Referrer",
    "dash.booking.rescheduleHint": "Altera a data e a hora. Os links pessoais mantêm-se iguais.",
    "dash.booking.rescheduleTitle": "Reagendar",
    "dash.booking.rescheduled": "Marcação reagendada. Os links não mudaram.",
    "dash.booking.rulesHint": "Regras fixas: pelo menos 48 h de antecedência, segunda–sexta 09:00–19:00 (Europe/Rome).",
    "dash.booking.save": "Guardar disponibilidade",
    "dash.booking.saveCall": "Guardar novo horário",
    "dash.booking.saved": "Disponibilidade guardada.",
    "dash.booking.saving": "A guardar…",
    "dash.booking.slotMinutes": "Duração do slot (minutos)",
    "dash.booking.sourceAdmin": "Call agendada",
    "dash.booking.status": "Estado",
    "dash.booking.statusCancelled": "cancelada",
    "dash.booking.statusDone": "concluída",
    "dash.booking.statusExpired": "expirada",
    "dash.booking.statusLive": "em curso",
    "dash.booking.statusUpcoming": "próxima",
    "dash.booking.timezone": "O teu fuso horário",
    "dash.booking.timezoneHint": "Os horários são mostrados no fuso escolhido. A disponibilidade YOBY é seg–sex 09:00–19:00 (Europe/Rome).",
    "dash.booking.topic.banking_fintech": "Banca e fintech",
    "dash.booking.topic.families": "YOBY para famílias",
    "dash.booking.topic.financial_education": "Educação financeira",
    "dash.booking.topic.investment": "Investimento",
    "dash.booking.topic.other": "Outra coisa",
    "dash.booking.topic.partnership": "Parceria",
    "dash.booking.topic.press": "Imprensa e entrevistas",
    "dash.booking.topic.research": "Investigação",
    "dash.booking.topic.school_pilot": "Piloto escolar",
    "dash.booking.topicsLabel": "Sobre o que gostaria de falar?",
    "dash.booking.unblockDate": "Reativar",
    "dash.booking.unblocked": "Data reativada.",
    "dash.booking.utm": "Campanha (UTM)",
    "dash.booking.weekday0": "Domingo",
    "dash.booking.weekday1": "Segunda",
    "dash.booking.weekday2": "Terça",
    "dash.booking.weekday3": "Quarta",
    "dash.booking.weekday4": "Quinta",
    "dash.booking.weekday5": "Sexta",
    "dash.booking.weekday6": "Sábado",
    "dash.booking.weeklyHours": "Horário semanal",
    "dash.booking.who.bank": "Banco ou instituição financeira",
    "dash.booking.who.curious": "Apenas curiosidade",
    "dash.booking.who.educator": "Educador ou escola",
    "dash.booking.who.empty": "Escolha se quiser…",
    "dash.booking.who.foundation": "Fundação ou ONG",
    "dash.booking.who.investor": "Investidor",
    "dash.booking.who.journalist": "Jornalista",
    "dash.booking.who.other": "Outro",
    "dash.booking.who.parent": "Pai ou mãe",
    "dash.booking.who.public": "Instituição pública",
    "dash.booking.who.startup": "Startup ou empresa",
    "dash.booking.whoLabel": "Quem é?",
    "dash.booking.yourEmail": "O teu email",
    "dash.booking.yourEmails": "Emails dos convidados",
    "dash.booking.yourName": "O teu nome",
    "dash.common.actions": "Ações",
    "dash.common.actor": "Ator",
    "dash.common.archive": "Arquivar",
    "dash.common.assignments": "Tarefas",
    "dash.common.attempts": "Tentativas",
    "dash.common.avg": "Média",
    "dash.common.cancel": "Cancelar",
    "dash.common.class": "Turma",
    "dash.common.classes": "Turmas",
    "dash.common.code": "Código",
    "dash.common.confirm": "Confirmar",
    "dash.common.confirmArchiveSchool": "Arquivar esta escola?",
    "dash.common.confirmTitle": "Confirmação",
    "dash.common.copyCode": "Copiar código",
    "dash.common.csvDownloaded": "CSV descarregado",
    "dash.common.difficulty": "Dificuldade",
    "dash.common.email": "E-mail",
    "dash.common.entity": "Entidade",
    "dash.common.exportCsv": "Exportar CSV",
    "dash.common.family": "Família",
    "dash.common.lastAccess": "Último acesso",
    "dash.common.loading": "A carregar…",
    "dash.common.name": "Nome",
    "dash.common.newCode": "Novo código",
    "dash.common.none": "—",
    "dash.common.ok": "OK",
    "dash.common.open": "Abrir",
    "dash.common.questions": "Perguntas",
    "dash.common.quiz": "Quiz",
    "dash.common.refresh": "Atualizar",
    "dash.common.role": "Função",
    "dash.common.school": "Escola",
    "dash.common.select": "Selecionar",
    "dash.common.slug": "Slug",
    "dash.common.status": "Estado",
    "dash.common.students": "Alunos",
    "dash.common.teachers": "Professores",
    "dash.common.topic": "Tema",
    "dash.common.updated": "Atualizado",
    "dash.common.when": "Quando",
    "dash.common.year": "Ano",
    "dash.conference.addInvitee": "Adicionar convidado",
    "dash.conference.addInviteeHint": "Recebe um pato e um link pessoal. Podes enviar o convite por email de imediato.",
    "dash.conference.addInviteeTitle": "Adicionar um convidado",
    "dash.conference.addingInvitee": "A adicionar…",
    "dash.conference.back": "Voltar à lista",
    "dash.conference.chat": "Chat",
    "dash.conference.confirmed": "Confirmada",
    "dash.conference.confirmedNo": "Pendente",
    "dash.conference.confirmedYes": "Sim",
    "dash.conference.copied": "Link copiado.",
    "dash.conference.copiedShort": "Copiado!",
    "dash.conference.copyLink": "Copiar link",
    "dash.conference.create": "Criar call",
    "dash.conference.createImmediate": "Criar conference imediata",
    "dash.conference.createImmediateHint": "Só é preciso o nome da call/família. Cria um link aberto até à meia-noite (Europe/Rome).",
    "dash.conference.created": "Call criada.",
    "dash.conference.createdImmediate": "Conference aberta criada — partilha o link único. Válido para o resto do dia.",
    "dash.conference.creating": "A criar…",
    "dash.conference.detailTitle": "Links de convite",
    "dash.conference.editHint": "Podes alterar data, hora, nome e idioma. Os links de acesso mantêm-se iguais.",
    "dash.conference.editTitle": "Reagendar chamada",
    "dash.conference.email": "Email",
    "dash.conference.emailDryRun": "Email dry-run (não enviado).",
    "dash.conference.emailSent": "Aceite pelo Mailgun.",
    "dash.conference.empty": "Ainda não há conference calls.",
    "dash.conference.emptyInvitees": "Ainda sem convidados.",
    "dash.conference.ended": "Call terminada.",
    "dash.conference.errAddInvitee": "Não foi possível adicionar o convidado. Verifica email e nome.",
    "dash.conference.errCallEnded": "A call terminou: não é possível adicionar convidados.",
    "dash.conference.errCopy": "Não foi possível copiar o link.",
    "dash.conference.errCreate": "Não foi possível criar a call.",
    "dash.conference.errDenied": "Acesso negado. Entra como admin YOBY.",
    "dash.conference.errDuplicateInvitee": "Este email já está convidado para esta call.",
    "dash.conference.errEmail": "Não foi possível enviar o email.",
    "dash.conference.errLoad": "Não foi possível carregar as conference calls.",
    "dash.conference.errSave": "Não foi possível guardar as alterações.",
    "dash.conference.errWorldFull": "Mundo conference cheio: não há mais lagoas livres.",
    "dash.conference.familyName": "Nome da família",
    "dash.conference.firstName": "Nome",
    "dash.conference.gameLocale": "Idioma do jogo",
    "dash.conference.inviteeAdded": "Convidado adicionado.",
    "dash.conference.inviteeCount": "Convidados",
    "dash.conference.invitees": "Convidados",
    "dash.conference.lastName": "Apelido",
    "dash.conference.listTitle": "Calls agendadas",
    "dash.conference.mediaHealth.checking": "A verificar Janus e Coturn…",
    "dash.conference.mediaHealth.coturn": "Coturn (TURN)",
    "dash.conference.mediaHealth.down": "DOWN",
    "dash.conference.mediaHealth.errLoad": "Não foi possível ler o estado de vídeo.",
    "dash.conference.mediaHealth.hintDown": "Não inicies a call: o vídeo WebRTC não está pronto.",
    "dash.conference.mediaHealth.hintOk": "Janus e TURN estão acessíveis. A call pode começar.",
    "dash.conference.mediaHealth.janus": "Janus",
    "dash.conference.mediaHealth.ok": "OK",
    "dash.conference.mediaHealth.title": "Estado de vídeo (live)",
    "dash.conference.notifyInvitees": "Avisar os convidados por email (mesmo link, novo horário)",
    "dash.conference.openCallBadge": "link aberto",
    "dash.conference.openCallHint": "Quem tiver este link pode entrar (cada pessoa recebe o seu pato).",
    "dash.conference.phase": "Fase",
    "dash.conference.refresh": "Atualizar",
    "dash.conference.save": "Guardar alterações",
    "dash.conference.saveTranscript": "Guardar PDF",
    "dash.conference.saved": "Chamada atualizada. Os links não mudaram.",
    "dash.conference.saving": "A guardar…",
    "dash.conference.sendEmail": "Enviar email",
    "dash.conference.sendEmailOnAdd": "Enviar email de convite",
    "dash.conference.sendingEmail": "A enviar…",
    "dash.conference.speech": "Fala",
    "dash.conference.startsAt": "Data e hora de início (Europe/Rome)",
    "dash.conference.startsAtHint": "Introduz a hora no fuso YOBY (Europe/Rome), não no do browser.",
    "dash.conference.subtitle": "Cria um mundo YOBY privado para uma chamada agendada. Cada convidado recebe um pato e um link pessoal.",
    "dash.conference.tabAvailability": "Disponibilidade",
    "dash.conference.tabBookings": "Reservas",
    "dash.conference.tabCalls": "Calls agendadas",
    "dash.conference.tabCreate": "Criar call",
    "dash.conference.tabsAria": "Secções conference",
    "dash.conference.title": "Conference call",
    "dash.conference.transcript": "Transcrição",
    "dash.conference.transcriptDisabledNote": "Transcrição desativada a pedido de um participante.",
    "dash.conference.transcriptEmpty": "Ainda não há transcrição.",
    "dash.conference.transcriptSaved": "PDF guardado.",
    "dash.difficulty.easy": "Fácil",
    "dash.difficulty.hard": "Difícil",
    "dash.difficulty.medium": "Médio",
    "dash.liveInterpreter.callMetrics": "Live Interpreter usage",
    "dash.liveInterpreter.callMetricsBody": "Call {callMin} min · translated {liMin} min · languages: {langs} · listeners: {listeners} · ≈ €{eur}",
    "dash.liveInterpreter.criticalPct": "Critical threshold (%)",
    "dash.liveInterpreter.enabled": "Ativar Live Interpreter (só conferências comerciais)",
    "dash.liveInterpreter.enabledDesc": "Interruptor master para chamadas comerciais. Nunca ativa o vídeo dos lagos in-game.",
    "dash.liveInterpreter.envOff": "Env kill-switch is OFF",
    "dash.liveInterpreter.errLoad": "Could not load interpreter settings.",
    "dash.liveInterpreter.errSave": "Could not save interpreter settings.",
    "dash.liveInterpreter.hint": "Tradução de voz só em conferências comerciais. Nunca no vídeo dos lagos.",
    "dash.liveInterpreter.monthUsage": "Month {month}: {used} / {limit} min · ≈ €{eur} · {calls} calls · {status}",
    "dash.liveInterpreter.monthlyLimit": "Limite mensal (minutos de áudio traduzido)",
    "dash.liveInterpreter.providerMissing": "Azure Voice Live endpoint/API key missing in .env",
    "dash.liveInterpreter.providerOk": "Azure Voice Live configured",
    "dash.liveInterpreter.quotaBlocked": "Novas traduções bloqueadas",
    "dash.liveInterpreter.quotaCritical": "Critical",
    "dash.liveInterpreter.quotaOk": "OK",
    "dash.liveInterpreter.quotaWarn": "Warning",
    "dash.liveInterpreter.save": "Guardar",
    "dash.liveInterpreter.saved": "Definições guardadas.",
    "dash.liveInterpreter.tab": "Intérprete",
    "dash.liveInterpreter.testCall": "TEST — abrir conferência de teste",
    "dash.liveInterpreter.testCallCreating": "A criar conferência de teste…",
    "dash.liveInterpreter.testCallErr": "Não foi possível criar a conferência de teste.",
    "dash.liveInterpreter.testCallHint": "Cria já uma conferência aberta (link público) e abre-a num novo separador.",
    "dash.liveInterpreter.testCallOk": "Conferência de teste pronta — aberta num novo separador.",
    "dash.liveInterpreter.title": "Live Interpreter",
    "dash.liveInterpreter.warnPct": "Warning threshold (%)",
    "dash.schoolSignup.addClass": "Add class",
    "dash.schoolSignup.addTeacher": "Add teacher",
    "dash.schoolSignup.alreadyBody": "This account is already linked to a school on YOBY.",
    "dash.schoolSignup.alreadyTitle": "Já estás inscrito",
    "dash.schoolSignup.back": "Voltar",
    "dash.schoolSignup.checkEmail": "Check your email and come back to this page after confirming.",
    "dash.schoolSignup.city": "City",
    "dash.schoolSignup.className": "Class name",
    "dash.schoolSignup.classTeacher": "Docente da turma",
    "dash.schoolSignup.classes": "Classes involved",
    "dash.schoolSignup.continue": "Continue",
    "dash.schoolSignup.country": "Country",
    "dash.schoolSignup.draftSaved": "Draft saved.",
    "dash.schoolSignup.email": "Principal’s email",
    "dash.schoolSignup.errClassTeacher": "Escolhe um docente já indicado no passo anterior.",
    "dash.schoolSignup.errEmail": "Introduz um email válido.",
    "dash.schoolSignup.errGeneric": "Something went wrong. Try again.",
    "dash.schoolSignup.errLocked": "The application has already been submitted.",
    "dash.schoolSignup.errLookup": "Could not check this email.",
    "dash.schoolSignup.errName": "Introduz o nome e o apelido (pelo menos 2 caracteres).",
    "dash.schoolSignup.errPhone": "O telefone é opcional. Se o preencheres, usa dígitos, espaços ou +.",
    "dash.schoolSignup.errPrivacy": "Tens de aceitar o aviso de privacidade para continuar.",
    "dash.schoolSignup.errSave": "Could not save the draft.",
    "dash.schoolSignup.errSubmit": "Could not submit the application.",
    "dash.schoolSignup.errTeacherDup": "Cada docente deve ter um email diferente.",
    "dash.schoolSignup.errTeacherSelf": "Não uses o email do diretor: é supervisor, não docente.",
    "dash.schoolSignup.errValidation": "Enter the school name, at least one teacher and one class.",
    "dash.schoolSignup.goDashboard": "Open dashboard",
    "dash.schoolSignup.helpAccount": "Cria a conta do diretor com nome, email e consentimento de privacidade. Enviamos um link de confirmação: abre-o e volta a esta página. Se já tens conta YOBY, inicia sessão — não é preciso registar-te outra vez.",
    "dash.schoolSignup.helpClassTeacher": "Escolhe o docente titular desta turma. Tem de estar já na lista de docentes.",
    "dash.schoolSignup.helpClasses": "Cada turma tem um docente titular escolhido no passo anterior. Após a aprovação, o YOBY cria as turmas e atribui-as a esse docente. É precisa pelo menos uma turma.",
    "dash.schoolSignup.helpSchool": "Indica os dados da escola para o YOBY a poder ativar após a revisão. O telefone é opcional. Na nota podes acrescentar polos, horários ou outras informações úteis.",
    "dash.schoolSignup.helpTeachers": "Lista os docentes que vão usar o YOBY. Receberão um convite na aprovação. Não incluas o email do diretor: é supervisor, não docente. É preciso pelo menos um docente.",
    "dash.schoolSignup.introAlt": "Prefer a call with us?",
    "dash.schoolSignup.introBody": "The principal signs up, confirms the email, then lists teachers and classes. YOBY activates the school after a review.",
    "dash.schoolSignup.introTitle": "Inscreve a tua escola",
    "dash.schoolSignup.knownBody": "This email is already registered. Sign in with the link we send you.",
    "dash.schoolSignup.knownTitle": "Já estás inscrito",
    "dash.schoolSignup.locale": "Working language",
    "dash.schoolSignup.name": "Principal’s name",
    "dash.schoolSignup.note": "Note (optional)",
    "dash.schoolSignup.openDashboard": "Go to dashboard",
    "dash.schoolSignup.pendingBody": "We received the application for {school}. We’ll email you when it’s active.",
    "dash.schoolSignup.pendingTitle": "Waiting for approval",
    "dash.schoolSignup.phone": "Phone (optional)",
    "dash.schoolSignup.privacy": "I accept the privacy notice and to share the listed teachers’ emails.",
    "dash.schoolSignup.rejectedBody": "The previous application was not approved. Reason: {reason}",
    "dash.schoolSignup.rejectedTitle": "Application not approved",
    "dash.schoolSignup.saveDraft": "Save draft",
    "dash.schoolSignup.schoolName": "School name",
    "dash.schoolSignup.signIn": "Entrar",
    "dash.schoolSignup.signUp": "Inscreve-te e confirma o email",
    "dash.schoolSignup.stepAccount": "Conta",
    "dash.schoolSignup.stepAccountTitle": "Conta",
    "dash.schoolSignup.stepClassesTitle": "Turmas",
    "dash.schoolSignup.stepSchool": "Escola",
    "dash.schoolSignup.stepSchoolTitle": "Escola",
    "dash.schoolSignup.stepTeachersTitle": "Docentes",
    "dash.schoolSignup.submit": "Enviar o pedido",
    "dash.schoolSignup.submitted": "Application sent.",
    "dash.schoolSignup.talkWithUs": "Book a call",
    "dash.schoolSignup.teacherEmail": "Teacher email",
    "dash.schoolSignup.teacherName": "Teacher name",
    "dash.schoolSignup.teachers": "Teachers",
    "dash.status.ageBand.11-15": "11–15",
    "dash.status.ageBand.16-17": "16–17",
    "dash.status.ageBand.18-26": "18–26",
    "dash.status.ageBand.8-10": "8–10",
    "dash.status.ageBand.adult": "Adultos",
    "dash.status.ageBand.unknown": "Sem faixa",
    "dash.status.analytics.events.arcade_completed.description": "Arcade activity ends",
    "dash.status.analytics.events.arcade_completed.label": "Arcade completed",
    "dash.status.analytics.events.arcade_started.description": "Crazy Run or arcade activity starts",
    "dash.status.analytics.events.arcade_started.label": "Arcade started",
    "dash.status.analytics.events.child_access_started.description": "Child enters via link or parent",
    "dash.status.analytics.events.child_access_started.label": "Child access started",
    "dash.status.analytics.events.child_first_claim_email_sent.description": "Email transacional de claim enviado ao pai",
    "dash.status.analytics.events.child_first_claim_email_sent.label": "Email de desbloqueio enviado",
    "dash.status.analytics.events.child_first_claim_opened.description": "O pai abre a pré-visualização do link /claim",
    "dash.status.analytics.events.child_first_claim_opened.label": "Link de desbloqueio aberto",
    "dash.status.analytics.events.child_first_claimed.description": "O pai desbloqueia o patinho pending na família",
    "dash.status.analytics.events.child_first_claimed.label": "Patinho desbloqueado",
    "dash.status.analytics.events.child_first_family_activated.description": "Família pronta a jogar após o claim child-first",
    "dash.status.analytics.events.child_first_family_activated.label": "Família child-first ativada",
    "dash.status.analytics.events.child_first_parent_email_submitted.description": "A criança indica o email do pai/tutor",
    "dash.status.analytics.events.child_first_parent_email_submitted.label": "Email do pai enviado",
    "dash.status.analytics.events.child_first_started.description": "A criança começa Criar o meu patinho",
    "dash.status.analytics.events.child_first_started.label": "Child-first iniciado",
    "dash.status.analytics.events.child_profile_created.description": "A child character profile is created",
    "dash.status.analytics.events.child_profile_created.label": "Child profile created",
    "dash.status.analytics.events.collectible_obtained.description": "An item is collected",
    "dash.status.analytics.events.collectible_obtained.label": "Collectible obtained",
    "dash.status.analytics.events.family_activation_completed.description": "Adult, child and first access exist",
    "dash.status.analytics.events.family_activation_completed.label": "Family activated",
    "dash.status.analytics.events.family_created.description": "A parent creates the family pond",
    "dash.status.analytics.events.family_created.label": "Family created",
    "dash.status.analytics.events.market_transaction.description": "Buy, sell or negotiate",
    "dash.status.analytics.events.market_transaction.label": "Market transaction",
    "dash.status.analytics.events.market_visited.description": "Access to the market",
    "dash.status.analytics.events.market_visited.label": "Market visited",
    "dash.status.analytics.events.mission_completed.description": "Mission finished",
    "dash.status.analytics.events.mission_completed.label": "Mission completed",
    "dash.status.analytics.events.mission_started.description": "A game mission begins",
    "dash.status.analytics.events.mission_started.label": "Mission started",
    "dash.status.analytics.events.parent_demo_converted.description": "Um encarregado termina a demo e cria a conta",
    "dash.status.analytics.events.parent_demo_converted.label": "Demo famílias convertida",
    "dash.status.analytics.events.parent_demo_keep_prompt.description": "Mostrada a proposta de ficar com o pato",
    "dash.status.analytics.events.parent_demo_keep_prompt.label": "Demo famílias: ficar com o pato",
    "dash.status.analytics.events.parent_demo_parent_ui_complete.description": "Visão da interface familiar concluída",
    "dash.status.analytics.events.parent_demo_parent_ui_complete.label": "Demo famílias: UI concluída",
    "dash.status.analytics.events.parent_demo_started.description": "Início a partir do link público Experimentar o YOBY para famílias",
    "dash.status.analytics.events.parent_demo_started.label": "Demos famílias",
    "dash.status.analytics.events.parent_demo_tour_complete.description": "Tour no mundo concluído",
    "dash.status.analytics.events.parent_demo_tour_complete.label": "Demo famílias: tour concluído",
    "dash.status.analytics.events.quiz_assigned.description": "Teacher assigns a quiz",
    "dash.status.analytics.events.quiz_assigned.label": "Quiz assigned",
    "dash.status.analytics.events.quiz_completed.description": "Quiz finished",
    "dash.status.analytics.events.quiz_completed.label": "Quiz completed",
    "dash.status.analytics.events.quiz_started.description": "Child opens a quiz",
    "dash.status.analytics.events.quiz_started.label": "Quiz started",
    "dash.status.analytics.events.real_task_assigned.description": "Parent assigns a real-life chore",
    "dash.status.analytics.events.real_task_assigned.label": "Real task assigned",
    "dash.status.analytics.events.real_task_completed.description": "Child marks chore done",
    "dash.status.analytics.events.real_task_completed.label": "Real task done",
    "dash.status.analytics.events.real_task_validated.description": "Parent accepts or rejects",
    "dash.status.analytics.events.real_task_validated.label": "Real task validated",
    "dash.status.analytics.events.reward_claimed.description": "Child claims a reward",
    "dash.status.analytics.events.reward_claimed.label": "Reward claimed",
    "dash.status.analytics.events.reward_distributed.description": "Parent allocates a reward",
    "dash.status.analytics.events.reward_distributed.label": "Reward distributed",
    "dash.status.analytics.events.reward_earned.description": "A reward is granted",
    "dash.status.analytics.events.reward_earned.label": "Reward earned",
    "dash.status.analytics.events.session_ended.description": "Exit or inactivity",
    "dash.status.analytics.events.session_ended.label": "Session ended",
    "dash.status.analytics.events.session_started.description": "Someone enters the game",
    "dash.status.analytics.events.session_started.label": "Session started",
    "dash.status.analytics.events.shared_family_session.description": "Parent and child online together",
    "dash.status.analytics.events.shared_family_session.label": "Shared family session",
    "dash.status.analytics.events.subscription_cancelled.description": "Subscription cancelled",
    "dash.status.analytics.events.subscription_cancelled.label": "Subscription cancelled",
    "dash.status.analytics.events.subscription_started.description": "Family or Patron activated",
    "dash.status.analytics.events.subscription_started.label": "Subscription started",
    "dash.status.analytics.events.teacher_demo_converted.description": "Um professor termina a demo e cria a conta",
    "dash.status.analytics.events.teacher_demo_converted.label": "Demo professores convertida",
    "dash.status.analytics.events.teacher_demo_keep_prompt.description": "Mostrada a proposta de ficar com o pato",
    "dash.status.analytics.events.teacher_demo_keep_prompt.label": "Demo professores: ficar com o pato",
    "dash.status.analytics.events.teacher_demo_started.description": "Início a partir do link público Experimentar o YOBY para professores",
    "dash.status.analytics.events.teacher_demo_started.label": "Demos professores",
    "dash.status.analytics.events.teacher_demo_teacher_ui_complete.description": "Visão da interface do professor concluída",
    "dash.status.analytics.events.teacher_demo_teacher_ui_complete.label": "Demo professores: UI concluída",
    "dash.status.analytics.events.teacher_demo_tour_complete.description": "Tour no mundo concluído",
    "dash.status.analytics.events.teacher_demo_tour_complete.label": "Demo professores: tour concluído",
    "dash.status.analytics.events.temporary_link_generated.description": "A temporary play link is created",
    "dash.status.analytics.events.temporary_link_generated.label": "Temp link created",
    "dash.status.analytics.events.temporary_link_used.description": "A temporary link is redeemed",
    "dash.status.analytics.events.temporary_link_used.label": "Temp link used",
    "dash.status.charts.acq_age_doughnut.title": "Perfis criança por faixa etária",
    "dash.status.charts.acq_child_first_funnel.title": "Funil patinho child-first",
    "dash.status.charts.acq_child_first_trend.title": "Tendência child-first",
    "dash.status.charts.acq_demo_bar.title": "Demos a partir de links públicos",
    "dash.status.charts.acq_demo_trend.title": "Tendência das demos",
    "dash.status.charts.acq_funnel.title": "Acquisition funnel",
    "dash.status.charts.acq_plan_doughnut.title": "Subscription plans",
    "dash.status.charts.acq_trend_line.title": "Acquisition trend",
    "dash.status.charts.eco_age_doughnut.title": "Recompensas por faixa etária",
    "dash.status.charts.eco_arcade_line.title": "Arcade activity",
    "dash.status.charts.eco_chores_funnel.title": "Real tasks funnel",
    "dash.status.charts.eco_collectibles_line.title": "Collectibles",
    "dash.status.charts.eco_market_bar.title": "Market activity",
    "dash.status.charts.eco_reward_origin.title": "Reward origins",
    "dash.status.charts.eco_reward_volume.title": "Reward volume",
    "dash.status.charts.eng_access_doughnut.title": "Child access channels",
    "dash.status.charts.eng_age_doughnut.title": "Sessões por faixa etária",
    "dash.status.charts.eng_device_bar.title": "Sessions by device",
    "dash.status.charts.eng_links_bar.title": "Temporary links",
    "dash.status.charts.eng_sessions_line.title": "Sessions by role",
    "dash.status.charts.eng_shared_line.title": "Shared family sessions",
    "dash.status.charts.learn_age_doughnut.title": "Quizzes concluídos por faixa etária",
    "dash.status.charts.learn_duration_bar.title": "Average duration",
    "dash.status.charts.learn_mission_host.title": "Missions by host",
    "dash.status.charts.learn_mission_trend.title": "Mission trend",
    "dash.status.charts.learn_quiz_funnel.title": "Quiz funnel",
    "dash.status.charts.learn_quiz_trend.title": "Quiz trend",
    "dash.status.charts.live_age_bar.title": "Online por faixa etária",
    "dash.status.charts.live_realm_pie.title": "Online by realm",
    "dash.status.charts.live_role_bar.title": "Online by role",
    "dash.status.daysLabel": "Dias",
    "dash.status.errLoad": "Não foi possível carregar o estado.",
    "dash.status.lastAccessTitle": "Último acesso",
    "dash.status.loading": "A carregar…",
    "dash.status.logAll": "Todos",
    "dash.status.logFilter": "Evento",
    "dash.status.refresh": "Atualizar",
    "dash.status.report.anonymized": "Relatório anonimizado: sem emails nem nomes.",
    "dash.status.report.failed": "Falha na geração. Tente novamente.",
    "dash.status.report.generate": "Gerar relatório",
    "dash.status.report.generating": "A gerar",
    "dash.status.report.impossible": "Impossível gerar o relatório: ainda não há dados analytics no período.",
    "dash.status.report.overviewTitle": "Comentário geral",
    "dash.status.report.pdfAnalysisTitle": "Análise",
    "dash.status.report.pdfChartsTitle": "Gráficos",
    "dash.status.report.pdfKpisTitle": "Indicadores-chave",
    "dash.status.report.pdfPage": "Página {n} de {total}",
    "dash.status.report.pdfPeriod": "Período: últimos {days} dias",
    "dash.status.report.pdfTitle": "Relatório analytics Yoby",
    "dash.status.report.pdfUnavailable": "Biblioteca PDF indisponível.",
    "dash.status.report.previewFailed": "Não foi possível mostrar a pré-visualização PDF.",
    "dash.status.report.previewPreparing": "A preparar pré-visualização PDF…",
    "dash.status.report.readyAt": "Gerado",
    "dash.status.report.savePdf": "Guardar PDF",
    "dash.status.report.waiting": "Relatório a ser preparado…",
    "dash.status.sectionOnline": "Online agora",
    "dash.status.sectionOnlineAge": "Online por faixa etária",
    "dash.status.sectionTotals": "Totais (sem mundos conference ativos)",
    "dash.status.sectionTotalsAge": "Personagens por faixa etária",
    "dash.status.subtitle": "Presença no jogo e analytics de produto.",
    "dash.status.summaryChildren": "Crianças online",
    "dash.status.summaryFamilies": "Famílias no jogo",
    "dash.status.summaryInGame": "No jogo (total)",
    "dash.status.summaryParents": "Pais online",
    "dash.status.summaryPlayers": "Jogadores no jogo",
    "dash.status.summaryQueueDepth": "Fila analytics",
    "dash.status.summaryRows": "Linhas de último acesso",
    "dash.status.summarySurface": "Na superfície",
    "dash.status.summaryUnderground": "Subterrâneo",
    "dash.status.summaryWorldsActive": "Mundos com jogadores online",
    "dash.status.summaryWorldsOpened": "Mundos abertos",
    "dash.status.tabs.acquisition": "Aquisição",
    "dash.status.tabs.economy": "Economia",
    "dash.status.tabs.engagement": "Engagement",
    "dash.status.tabs.learning": "Aprendizagem",
    "dash.status.tabs.live": "Live",
    "dash.status.tabs.logs": "Logs",
    "dash.status.tabs.report": "Relatório",
    "dash.status.thAgeBand": "Faixa",
    "dash.status.thEmailName": "E-mail / Nome",
    "dash.status.thEvent": "Evento",
    "dash.status.thFamily": "Família",
    "dash.status.thLastAccess": "Último acesso",
    "dash.status.thRole": "Função",
    "dash.status.thSummary": "Resumo",
    "dash.status.thTime": "Hora",
    "dash.status.thWorld": "Mundo",
    "dash.status.thWorldFamilies": "Famílias",
    "dash.status.thWorldPlayers": "Jogadores",
    "dash.status.thWorldSurface": "Superfície",
    "dash.status.thWorldUnderground": "Subterrâneo",
    "dash.status.title": "Estado",
    "dash.status.totalChildren": "Crianças (total)",
    "dash.status.totalFamilies": "Famílias (total)",
    "dash.status.totalParents": "Pais (total)",
    "dash.status.totalPlayers": "Personagens (total)",
    "dash.status.updated": "Atualizado",
    "dash.status.worldsTitle": "Detalhe por mundo",
    "dash.supervisor.csvDownloaded": "CSV descarregado",
    "dash.supervisor.errAudit": "Não foi possível carregar o registo de auditoria.",
    "dash.supervisor.errDenied": "Acesso negado. Inicie sessão como supervisor ou admin YOBY.",
    "dash.supervisor.errExport": "Não foi possível exportar o CSV.",
    "dash.supervisor.exportCsvSchool": "Exportar CSV da escola",
    "dash.supervisor.hintAudit": "Últimas ações registadas para a escola.",
    "dash.supervisor.hintQuizzes": "Utilização de quiz por slug (tentativas concluídas na escola).",
    "dash.supervisor.metaSlug": "Slug",
    "dash.supervisor.metaStatus": "Estado",
    "dash.supervisor.metricSchoolAvg": "Média da escola",
    "dash.supervisor.noAudit": "Sem entradas de auditoria.",
    "dash.supervisor.noClasses": "Sem turmas.",
    "dash.supervisor.noQuizzes": "Sem dados de quiz.",
    "dash.supervisor.noSchools": "Sem escolas atribuídas.",
    "dash.supervisor.noTeachers": "Sem professores.",
    "dash.supervisor.refresh": "Atualizar",
    "dash.supervisor.selectSchoolHint": "Selecione uma escola para ver turmas, professores e estatísticas de quiz.",
    "dash.supervisor.subtitle": "Visão geral de escolas, turmas, professores, quiz e auditoria.",
    "dash.supervisor.tabAudit": "Auditoria",
    "dash.supervisor.tabClasses": "Turmas",
    "dash.supervisor.tabQuizzes": "Quiz",
    "dash.supervisor.tabTeachers": "Professores",
    "dash.supervisor.thAssignments": "Tarefas",
    "dash.supervisor.thSchool": "Escola",
    "dash.supervisor.thTeacher": "Professor",
    "dash.supervisor.title": "Painel do supervisor",
    "dash.supervisor.yourSchools": "As suas escolas",
    "dash.teacher.catalogTitle": "Catálogo de quiz",
    "dash.teacher.confirmArchiveClass": "Arquivar esta turma? O código deixará de funcionar.",
    "dash.teacher.copied": "Copiado!",
    "dash.teacher.copyCode": "Copiar código",
    "dash.teacher.createClass": "Criar uma turma",
    "dash.teacher.demoLink": "Link demo",
    "dash.teacher.demoLinkCopied": "Link copiado para a área de transferência.",
    "dash.teacher.demoLinkReady": "Link permanente criado",
    "dash.teacher.errArchive": "Não foi possível arquivar a turma.",
    "dash.teacher.errAssign": "Não foi possível atribuir o quiz.",
    "dash.teacher.errCreateClass": "Não foi possível criar a turma.",
    "dash.teacher.errDemoDenied": "Apenas admins podem criar links demo.",
    "dash.teacher.errDemoLink": "Não foi possível criar o link demo.",
    "dash.teacher.errDemoNoQuiz": "Não há quiz livre para atribuir a esta turma.",
    "dash.teacher.errDenied": "Acesso negado. Inicie sessão como professor.",
    "dash.teacher.errExport": "Não foi possível exportar o CSV.",
    "dash.teacher.errExportCatalog": "Não foi possível exportar o catálogo de quiz.",
    "dash.teacher.errLoadClasses": "Não foi possível carregar as turmas.",
    "dash.teacher.errNoTeacher": "Perfil de professor não encontrado.",
    "dash.teacher.errRegen": "Não foi possível regenerar o código.",
    "dash.teacher.errSelectSchool": "Selecione primeiro uma escola.",
    "dash.teacher.exportCatalogCsv": "Descarregar catálogo CSV (todos os idiomas)",
    "dash.teacher.exportCsv": "Exportar CSV",
    "dash.teacher.hintAssign": "Escolha categoria, quiz e definições da tarefa.",
    "dash.teacher.hintWrong": "Perguntas com mais erros nas tarefas recentes.",
    "dash.teacher.metaAge": "Idade",
    "dash.teacher.metaCode": "Código",
    "dash.teacher.metaLang": "Idioma",
    "dash.teacher.metaYear": "Ano",
    "dash.teacher.metricAssignments": "Tarefas",
    "dash.teacher.metricAttempts": "Tentativas",
    "dash.teacher.metricClassAvg": "Média da turma",
    "dash.teacher.metricEnrolled": "Inscritos",
    "dash.teacher.newCode": "Novo código",
    "dash.teacher.noAssignments": "Sem tarefas.",
    "dash.teacher.noCatalog": "Sem quiz no catálogo.",
    "dash.teacher.noClasses": "Sem turmas.",
    "dash.teacher.noStudents": "Sem alunos inscritos.",
    "dash.teacher.noWrong": "Sem perguntas difíceis.",
    "dash.teacher.open": "Abrir",
    "dash.teacher.playLink": "Link de jogo",
    "dash.teacher.playLinkCopied": "Link copiado para a área de transferência.",
    "dash.teacher.playLinkFailed": "Não foi possível criar o link de jogo",
    "dash.teacher.playLinkHint": "Os alunos abrem o link e tocam no próprio nome. Supervisione a escolha.",
    "dash.teacher.playLinkHours": "Horas",
    "dash.teacher.playLinkReady": "Link de jogo criado",
    "dash.teacher.quizColChoices": "Respostas",
    "dash.teacher.quizColOrder": "#",
    "dash.teacher.quizColQuestion": "Pergunta",
    "dash.teacher.quizLoadError": "Não foi possível carregar o quiz.",
    "dash.teacher.quizLoading": "A carregar quiz…",
    "dash.teacher.quizPreviewTitle": "Pré-visualização do quiz",
    "dash.teacher.selectClassHint": "Selecione uma turma para ver os detalhes.",
    "dash.teacher.statusAssigned": "Quiz atribuído.",
    "dash.teacher.statusAssigning": "A atribuir quiz…",
    "dash.teacher.statusClassCreated": "Turma criada.",
    "dash.teacher.statusCreating": "A criar turma…",
    "dash.teacher.subtitle": "Turmas, códigos de inscrição, tarefas de quiz, resultados e exportações.",
    "dash.teacher.surveyFeedbackFinal": "No final do quiz",
    "dash.teacher.surveyFeedbackImmediate": "Imediatamente após cada pergunta",
    "dash.teacher.tabAssign": "Atribuir quiz",
    "dash.teacher.tabAssignments": "Tarefas",
    "dash.teacher.tabStudents": "Alunos",
    "dash.teacher.tabWrong": "Perguntas difíceis",
    "dash.teacher.thAge": "Idade",
    "dash.teacher.thAvg": "Média",
    "dash.teacher.thClass": "Turma",
    "dash.teacher.thCode": "Código",
    "dash.teacher.thCompleted": "Concluídos",
    "dash.teacher.thDifficulty": "Dificuldade",
    "dash.teacher.thDone": "Concluídas",
    "dash.teacher.thDue": "Prazo",
    "dash.teacher.thErrorPct": "% erros",
    "dash.teacher.thErrors": "Erros",
    "dash.teacher.thFirstName": "Nome",
    "dash.teacher.thJoined": "Inscrito",
    "dash.teacher.thLastName": "Apelido",
    "dash.teacher.thLastSeen": "Última visita",
    "dash.teacher.thMaxAttempts": "Tentativas máx.",
    "dash.teacher.thNickname": "Alcunha",
    "dash.teacher.thPublish": "Publicação",
    "dash.teacher.thQuestion": "Pergunta",
    "dash.teacher.thTheme": "Tema",
    "dash.teacher.thTitle": "Título",
    "dash.teacher.thTotalAnswers": "Respostas totais",
    "dash.teacher.thYear": "Ano",
    "dash.teacher.title": "Painel do professor",
    "dash.teacher.yourClasses": "As suas turmas",
    "dash.teacher.yourClassesHint": "Selecione uma turma para ver alunos, tarefas e estatísticas.",
    "dash.topic.bisogni_desideri": "Necessidades e desejos",
    "dash.topic.budget": "Orçamento",
    "dash.topic.consumo": "Consumo consciente",
    "dash.topic.imprenditorialita": "Empreendedorismo",
    "dash.topic.lavoro": "Mundo do trabalho",
    "dash.topic.risparmio": "Poupança",
    "footer.aria.site": "Rodapé",
    "footer.aria.social": "Redes sociais",
    "footer.brand.tagline": "O lago familiar onde crianças e adultos aprendem sobre dinheiro juntos.",
    "footer.col.about": "Sobre a YOBY",
    "footer.col.aiAudits": "Últimas auditorias de segurança da IA",
    "footer.col.banksAndPartners": "Bancos e parceiros",
    "footer.col.contact": "Contacto",
    "footer.col.cookiePolicy": "Política de cookies",
    "footer.col.dataAndGdpr": "Dados e RGPD",
    "footer.col.investors": "Investidores",
    "footer.col.parentalControls": "Controlo parental",
    "footer.col.partners.title": "Parceiros",
    "footer.col.press": "Imprensa",
    "footer.col.privacyPolicy": "Política de privacidade",
    "footer.col.product.title": "Produto",
    "footer.col.roadmap": "Roadmap",
    "footer.col.safety": "Segurança",
    "footer.col.schools": "Escolas",
    "footer.col.termsOfService": "Termos de serviço",
    "footer.col.trust.title": "Confiança e segurança",
    "footer.col.yoby.title": "YOBY",
    "footer.copyright.line1": "© 2026 YOBY. Todos os direitos reservados.",
    "footer.copyright.line2": "Criado na Europa para famílias, patos e melhores hábitos financeiros.",
    "home.about.feature1.body": "Um espaço privado onde toda a família explora, completa missões e cresce junta. Cada membro tem o seu próprio pato.",
    "home.about.feature1.title": "🦆 Um jogo de família para aprender sobre dinheiro",
    "home.about.feature2.body": "A Rã, a Pega, a Toupeira e outros guiam você com missões curtas e perguntas de escolha. Aprender fazendo, não estudando.",
    "home.about.feature2.title": "🐸 Mentores que ensinam finanças brincando",
    "home.about.feature3.body": "Três moedas simbólicas para metas, poupança e bons hábitos. Uma economia de jogo que ensina sem parecer uma lição.",
    "home.about.feature3.title": "🐚 Poupança, metas e hábitos numa economia lúdica",
    "home.about.feature4.body": "Nenhuma criança pode receber conteúdo inadequado. Sem videochamada sem um pai presente. Feito para menores — não apenas adaptado.",
    "home.about.feature4.title": "🔒 Seguro por design",
    "home.about.title": "O que você vai encontrar no mundo YOBY",
    "home.cta.choosePlan": "Escolher um plano",
    "home.cta.joinDescription": "Crie sua conta familiar e comece a explorar.",
    "home.cta.joinTitle": "Mergulhe. É grátis.",
    "home.cta.playNow": "Jogar agora",
    "home.cta.premiumActive": "Você tem um plano premium — aproveite a experiência completa!",
    "home.cta.premiumHint": "Os planos premium oferecem melhores condições de jogo: mais conchas, áreas exclusivas e funcionalidades prioritárias.",
    "home.cta.ready": "Pronto para mergulhar de novo no lago?",
    "home.cta.signIn": "Entrar",
    "home.cta.signUpFree": "Começar grátis",
    "home.cta.tryAsParent": "És pai ou mãe? Experimenta o YOBY",
    "home.cta.tryAsStudent": "És professor? Experimenta o YOBY",
    "home.cta.welcomeBack": "Bem-vindo de volta",
    "home.cta.welcomeBackName": "Bem-vindo de volta, {name}",
    "home.hero.childBody": "Cria-o já. Um pai desbloqueará o lago quando estiverem prontos.",
    "home.hero.childCta": "Criar o meu patinho",
    "home.hero.childTitle": "À procura do teu patinho? 🦆",
    "home.hero.ctaPrimary": "Começar grátis",
    "home.hero.ctaSecondary": "Ver como funciona",
    "home.hero.description": "YOBY é um jogo de educação financeira onde crianças e pais aprendem juntos poupança, escolhas com dinheiro e metas.",
    "home.hero.tagline": "O dinheiro fala — finalmente de forma divertida.",
    "home.hero.title": "Literacia financeira para crianças e famílias, feita divertida.",
    "home.hero.visualAlt": "O mundo YOBY com patinhos a explorar o lago da família",
    "home.learn.choices.body": "Enfrenta trade-offs do dia a dia — gastar agora, poupar ou partilhar — em missões seguras e narrativas.",
    "home.learn.choices.title": "Escolhas",
    "home.learn.goals.body": "Dá nome ao que importa, planifica e celebra o progresso ao longo do caminho.",
    "home.learn.goals.title": "Metas",
    "home.learn.saving.body": "Guarda conchas para mais tarde e vê pequenos passos crescerem em metas maiores.",
    "home.learn.saving.title": "Poupança",
    "home.learn.title": "O que as crianças aprendem",
    "home.learn.value.body": "Liga esforço, tempo e recursos para que as crianças entendam o que o dinheiro representa.",
    "home.learn.value.title": "Valor do dinheiro",
    "home.links.families": "Educação financeira para famílias",
    "home.links.kids": "YOBY para crianças",
    "home.links.schools": "Literacia financeira para escolas",
    "home.links.title": "Explora o YOBY",
    "home.seo.description": "YOBY é um mundo lúdico de literacia financeira onde crianças e pais aprendem poupança, escolhas com dinheiro e hábitos saudáveis juntos.",
    "home.seo.title": "Literacia financeira para crianças e famílias | YOBY",
    "home.seoSection.body": "YOBY transforma a literacia financeira para crianças numa aventura partilhada. Num mundo lúdico de charcos, crianças e pais praticam poupança, definem metas juntos e falam sobre escolhas quotidianas com dinheiro. Mentores e missões curtas guiam a aprendizagem sobre dinheiro através do jogo — não com fichas ou aulas. Se procuras educação financeira para famílias em casa, o YOBY encontra as crianças onde elas estão: curiosas, criativas e prontas para explorar. Cada membro da família tem o seu pato num charco partilhado apenas com pessoas de confiança. Conchas, sementes e estrelas representam hábitos reais — paciência, planeamento e compreensão do valor do que se ganha. Pelo caminho, as crianças aprendem que pequenas escolhas somam, que esperar pode valer a pena e que o dinheiro é uma ferramenta para metas — não só para gastar. Os pais mantêm-se envolvidos com visibilidade e controlos claros num espaço concebido para menores desde o início.",
    "home.seoSection.title": "Educação financeira para crianças, através do jogo",
    "home.showcase.aria": "Capturas de tela do jogo",
    "home.showcase.card1.alt": "Jogo YOBY de educação financeira familiar com pais e filhos a explorar um charco virtual",
    "home.showcase.card1.title": "Lago da família — explorem juntos",
    "home.showcase.card2.alt": "Mentores YOBY a ensinar dinheiro a crianças com missões lúdicas",
    "home.showcase.card2.title": "Conheça os mentores — aprenda jogando",
    "home.showcase.card3.alt": "Quiz de educação financeira YOBY e lojas da aldeia com diálogos localizados",
    "home.showcase.card3.title": "Quizzes, lojas e vida na aldeia",
    "home.showcase.card4.alt": "Mentores subterrâneos YOBY a ensinar dinheiro com missões cinematográficas",
    "home.showcase.card4.title": "Mentores subterrâneos e missões",
    "home.showcase.card5.alt": "Mercado do Tasso YOBY onde crianças praticam escolhas com dinheiro",
    "home.showcase.card5.title": "Mercados e escolhas com dinheiro",
    "home.showcase.card6.alt": "Mini-jogo Corrida louca do YOBY: as crianças correm na relva a apanhar objetos da estação contra o relógio",
    "home.showcase.card6.title": "Corrida louca — uma corrida a tempo na relva",
    "home.showcase.hint": "Toque para ampliar",
    "home.showcase.title": "Conheça o mundo",
    "lang.switch": "Idioma",
    "nav.account": "Conta",
    "nav.actions.signIn": "Entrar",
    "nav.actions.startFree": "Começar grátis",
    "nav.actions.talkWithUs": "Fala connosco",
    "nav.aria.main": "Navegação principal",
    "nav.aria.staff": "Área escola e administração",
    "nav.footer.schoolSignup": "Inscreve a tua escola",
    "nav.main.blog": "Blog",
    "nav.main.forFamilies": "Para famílias",
    "nav.main.forKids": "Para crianças",
    "nav.main.home": "Início",
    "nav.main.howItWorks": "Como funciona",
    "nav.main.pricing": "Preços",
    "nav.main.talkWithUs": "Fala connosco",
    "nav.menu": "Menu",
    "nav.searchPosts": "Pesquisar posts, tags e autores",
    "nav.signIn": "Entrar",
    "nav.staff.admin": "Admin escolas",
    "nav.staff.adminSafety": "Últimas auditorias de segurança da IA",
    "nav.staff.conference": "Conference call",
    "nav.staff.massmail": "Massmail escolas",
    "nav.staff.redteam": "AI Red Team",
    "nav.staff.schoolSignups": "Inscrições escolas",
    "nav.staff.status": "Estado do jogo",
    "nav.staff.supervisor": "Painel supervisor",
    "nav.staff.teacher": "Painel docente",
    "nav.subscribe": "Inscrever-se",
    "safetyLab.areasTitle": "Temas que controlamos",
    "safetyLab.audience": "Para famílias e escolas",
    "safetyLab.cat.abuse": "Abuse",
    "safetyLab.cat.dangerous_behavior": "Dangerous behaviour",
    "safetyLab.cat.distress_support": "Emotional support (allowed)",
    "safetyLab.cat.drugs": "Drugs",
    "safetyLab.cat.hate": "Hate",
    "safetyLab.cat.inappropriate_instructions": "Inappropriate instructions",
    "safetyLab.cat.jailbreak": "Prompt injection",
    "safetyLab.cat.off_topic": "Off-topic",
    "safetyLab.cat.other": "Other safety checks",
    "safetyLab.cat.personal_data": "Personal information",
    "safetyLab.cat.self_harm": "Self-harm",
    "safetyLab.cat.sexual": "Inappropriate sexual content",
    "safetyLab.cat.violence": "Violence",
    "safetyLab.chartEmpty": "Quando houver mais auditorias, verás a tendência aqui.",
    "safetyLab.chartOutcomes": "Como correu a última auditoria",
    "safetyLab.chartTrend": "Tendência das auditorias recentes",
    "safetyLab.historyEmpty": "Ainda sem auditorias concluídas.",
    "safetyLab.historyTitle": "Histórico recente",
    "safetyLab.languages": "Idiomas do teste",
    "safetyLab.lastTested": "Última auditoria",
    "safetyLab.legendCritical": "Crítico: risco elevado; prioridade máxima.",
    "safetyLab.legendFail": "Falhou: algo não reagiu como devia — corrigimos.",
    "safetyLab.legendPass": "Aprovado: o filtro reagiu como esperado.",
    "safetyLab.legendTitle": "O que significam os resultados",
    "safetyLab.legendWarning": "Aviso: muitas vezes um falso positivo (demasiado rigoroso num pedido inofensivo), não um risco para as crianças.",
    "safetyLab.loadFailed": "Não foi possível carregar as auditorias de segurança.",
    "safetyLab.loading": "A carregar as últimas auditorias…",
    "safetyLab.method1": "O núcleo do controlo é o Safety Gate: o mesmo filtro que intercepta as mensagens no jogo (entrada e, nalguns casos, saída). Cada cenário envia uma mensagem (ou uma sequência curta) e verifica se o filtro permite, redireciona ou bloqueia como esperado.",
    "safetyLab.method2": "Na suite completa testamos todas as personagens de IA com quem uma criança pode falar: lago de superfície, subsolo e tutores. Há também runs «quick» mais rápidas, com uma só personagem e uma só faixa etária por cenário: as hosts listadas refletem sempre apenas o que essa run executou de verdade.",
    "safetyLab.method3": "Os cenários cobrem temas sensíveis e tentativas de contornar regras: conteúdo sexual inadequado, violência, autolesão, abuso, drogas, ódio, dados pessoais, instruções perigosas, manipulação de prompts (jailbreak), fora de tema, e também casos benignos ou de apoio emocional que devem continuar permitidos. Muitos cenários correm em várias línguas e faixas etárias.",
    "safetyLab.method4": "Cada caso recebe um resultado: aprovado, aviso, falhou ou crítico. Um aviso é muitas vezes um falso positivo (filtro demasiado rigoroso num pedido inofensivo), não um risco para as crianças. Falha ou crítico significa que algo não reagiu como devia e precisa de correção. Mostramos sempre a última run concluída, mesmo que não seja verde: nunca substituímos um mau resultado por um bom mais antigo.",
    "safetyLab.method5": "Para não ajudar quem queira contornar as proteções, não publicamos textos de ataque, receitas de jailbreak nem transcrições completas. Em público vês agregados, categorias e datas; o detalhe técnico fica interno.",
    "safetyLab.method6": "A biblioteca de cenários cresce: quando encontramos uma fraqueza, adicionamos um caso de regressão e mantemo-lo. Se ainda não houver nenhuma auditoria concluída, dizemo-lo com clareza.",
    "safetyLab.methodIntro": "A YOBY corre auditorias automáticas de segurança sobre a IA que fala com crianças. Não inventamos os números: cada valor nesta página vem de uma execução real guardada no nosso sistema. Abaixo explicamos o que fazemos, o que medimos e o que não mostramos de propósito.",
    "safetyLab.methodTitle": "Como os testes são feitos",
    "safetyLab.metricCritical": "Críticos",
    "safetyLab.metricExecuted": "Casos verificados",
    "safetyLab.metricFail": "Falharam",
    "safetyLab.metricPass": "Aprovados",
    "safetyLab.metricPassRate": "Taxa de sucesso",
    "safetyLab.metricWarning": "Avisos",
    "safetyLab.never": "Ainda não executada",
    "safetyLab.noteParents": "Esta página é para pais e professores. Podes consultá-la a qualquer momento: é um relato público das últimas auditorias, não uma página de marketing com números inventados.",
    "safetyLab.npcs": "Personagens de IA cobertas",
    "safetyLab.plainLead": "A YOBY testa continuamente as suas personagens de IA, como uma auditoria de segurança. Aqui vês o resultado mais recente — sem detalhes técnicos dos ataques.",
    "safetyLab.statusCritical": "Problemas graves detetados",
    "safetyLab.statusError": "A última auditoria não terminou",
    "safetyLab.statusIssues": "Há pontos a melhorar",
    "safetyLab.statusNever": "Ainda sem auditoria disponível",
    "safetyLab.statusPass": "Tudo em ordem",
    "safetyLab.subtitle": "Resultados reais de controlos automáticos sobre a IA que fala com crianças — para pais e professores.",
    "safetyLab.thCases": "Casos",
    "safetyLab.thDate": "Data",
    "safetyLab.thStatus": "Resultado",
    "safetyLab.title": "Últimas auditorias de segurança da IA",
    "footer.col.genderEquality": "Igualdade de género",
    "dash.booking.gcalRefreshHint": "Após uma reserva, usa «Atualizar calendário» se o evento não aparecer no Google.",
    "dash.conference.delivery.title": "Entrega de email",
    "dash.conference.delivery.untracked": "Resultado indisponível",
    "dash.conference.delivery.invite": "Convite",
    "dash.conference.delivery.reschedule": "Alteração da marcação",
    "dash.conference.delivery.reminder": "Lembrete",
    "dash.conference.delivery.pending": "A preparar",
    "dash.conference.delivery.accepted": "Aceite pelo Mailgun",
    "dash.conference.delivery.delivered": "Entregue ao servidor do destinatário",
    "dash.conference.delivery.deferred": "Atraso temporário",
    "dash.conference.delivery.failed": "Falha no envio ou na entrega",
    "dash.conference.delivery.dry_run": "Simulado, não enviado",
    "dash.conference.delivery.confirmation": "A tua presença está confirmada",
    "footer.col.accessibility": "Acessibilidade",
    "accessibility.title": "Acessibilidade no YOBY",
    "accessibility.intro": "Queremos tornar a informação do YOBY mais fácil de ler e utilizar. Esta página explica as ferramentas do site e as limitações atuais do jogo.",
    "accessibility.site.title": "O site informativo",
    "accessibility.site.body": "As páginas oferecem textos, ligações de navegação e um painel para personalizar a visualização. Podes adaptar a leitura às tuas necessidades e chegar ao conteúdo principal através de uma ligação acessível pelo teclado.",
    "accessibility.site.status": "Estas funções são uma ajuda e não garantem acessibilidade completa. O widget, por si só, não comprova conformidade global com normas de acessibilidade; não concluímos uma revisão exaustiva de todas as páginas, formulários e serviços integrados.",
    "accessibility.preferences.title": "Personalizar a visualização",
    "accessibility.preferences.body": "Abre o painel pelo ícone Acessibilidade na barra de navegação, ou com Alt+Shift+A no Windows/Linux e ⌥ Option+Shift+A no Mac. As alterações aplicam-se imediatamente às páginas do site.",
    "accessibility.preferences.contrast": "Contraste elevado: aumenta o contraste visual da página.",
    "accessibility.preferences.invert": "Inverter cores: inverte as cores do fundo e dos conteúdos, incluindo imagens.",
    "accessibility.preferences.size": "Texto maior: alterna entre normal, grande e extra grande.",
    "accessibility.preferences.spacing": "Espaçamento do texto: aumenta o espaço de leitura nos conteúdos suportados.",
    "accessibility.preferences.focus": "Realçar foco: torna mais visível o controlo selecionado com o teclado.",
    "accessibility.preferences.links": "Sublinhar ligações: acrescenta um sublinhado às ligações.",
    "accessibility.preferences.motion": "Reduzir movimento: reduz animações e transições da página.",
    "accessibility.preferences.font": "Tipo de letra legível: utiliza um tipo de letra sem serifa do sistema.",
    "accessibility.preferences.storage": "As preferências ficam guardadas no armazenamento local deste navegador e o widget não as envia ao YOBY. «Repor predefinições» anula-as. Não são sincronizadas entre dispositivos; a gravação pode não estar disponível se o navegador bloquear o armazenamento local.",
    "accessibility.keyboard.title": "Usar o teclado",
    "accessibility.keyboard.body": "O primeiro Tab mostra a ligação «Saltar para o conteúdo». Usa Tab e Shift+Tab para percorrer os controlos, e Enter ou Espaço para ativar botões. O foco permanece no painel aberto; Esc fecha-o e devolve o foco ao ponto de abertura.",
    "accessibility.game.title": "O jogo: limitações atuais",
    "accessibility.game.body": "O jogo é uma experiência visual e interativa distinta do site informativo. Atualmente não o apresentamos como totalmente acessível e não podemos garantir a sua utilização completa com leitores de ecrã ou apenas com o teclado.",
    "accessibility.game.limits": "As preferências do site não tornam o mundo do jogo acessível nem se aplicam automaticamente à cena 3D, às interações ou a todos os seus controlos. Os serviços incorporados, como os painéis de acesso e registo, também podem ter comportamentos e limitações próprios. Se encontrares uma barreira, contacta-nos: podemos registar o problema e avaliar como ajudar, sem prometer que já exista uma versão equivalente de cada atividade.",
    "accessibility.feedback.title": "Comunicar uma dificuldade",
    "accessibility.feedback.body": "Para nos ajudar a compreender, indica a página ou função, o que tentavas fazer, o dispositivo e navegador e, quando relevante, a tecnologia de apoio utilizada. Não é necessário partilhar diagnósticos nem outros dados de saúde.",
    "accessibility.feedback.contact": "Contactar sobre acessibilidade",
    "auth.a11y.email": "Endereço de e-mail",
    "auth.a11y.subscribe": "Registar",
    "auth.a11y.sent": "E-mail enviado. Verifica a tua caixa de entrada para continuar.",
    "auth.a11y.termsRequired": "Aceita os termos para continuar.",
    "auth.a11y.close": "Fechar janela",
    "auth.a11y.account": "Conta YOBY",
    "auth.a11y.sending": "A enviar…"
  },
  "en": {
    "blog.title": "Blog",
    "dash.admin.approveSignup": "Approve",
    "dash.admin.errArchive": "Could not archive school.",
    "dash.admin.errAssign": "Could not assign staff.",
    "dash.admin.errCreateSchool": "Could not create school.",
    "dash.admin.errDenied": "Access denied. Sign in as a YOBY admin.",
    "dash.admin.errRoleNotAllowed": "Role not allowed.",
    "dash.admin.errSaveSchool": "Could not save school.",
    "dash.admin.errSignupApprove": "Could not approve the application.",
    "dash.admin.errSignupLoad": "Could not load school applications.",
    "dash.admin.errSignupReject": "Could not reject the application.",
    "dash.admin.errUserNotFound": "User not found.",
    "dash.admin.linkAdminSafety": "Latest AI safety audits",
    "dash.admin.linkMassmail": "School massmail",
    "dash.admin.linkPlay": "Family game",
    "dash.admin.linkRedteam": "AI Red Team",
    "dash.admin.linkStatus": "Game status",
    "dash.admin.linkSupervisor": "Supervisor dashboard",
    "dash.admin.linkTeacher": "Teacher dashboard",
    "dash.admin.noSignups": "No school applications.",
    "dash.admin.noStaff": "No staff members yet.",
    "dash.admin.panelSchoolsForm": "Add / edit schools",
    "dash.admin.panelSchoolsList": "School list",
    "dash.admin.panelSignups": "School applications",
    "dash.admin.panelStaffForm": "Add / edit staff",
    "dash.admin.panelStaffList": "Staff list",
    "dash.admin.quickLinks": "Quick links",
    "dash.admin.rejectReason": "Rejection reason",
    "dash.admin.rejectSignup": "Reject",
    "dash.admin.schoolListHint": "Click a row to edit it. Archive asks for confirmation.",
    "dash.admin.selectSchool": "Select a school",
    "dash.admin.signupClasses": "Classes",
    "dash.admin.signupTeachers": "Teachers",
    "dash.admin.staffListHint": "Click a row to update assignment and role.",
    "dash.admin.statusAssigned": "Staff assigned.",
    "dash.admin.statusAssigning": "Assigning staff…",
    "dash.admin.statusCreatingSchool": "Creating school…",
    "dash.admin.statusEditingSchool": "Editing school — change fields and save.",
    "dash.admin.statusEditingStaff": "Editing staff — update and assign.",
    "dash.admin.statusSavingSchool": "Saving school…",
    "dash.admin.statusSchoolCreated": "School created.",
    "dash.admin.statusSchoolSaved": "School saved.",
    "dash.admin.subtitle": "Create schools and assign teachers and supervisors. Requires YOBY admin login (email in ADMIN_EMAILS).",
    "dash.admin.surveyAssignStaff": "Assign staff",
    "dash.admin.surveyCreateSchool": "Create school",
    "dash.admin.surveySaveSchool": "Save school",
    "dash.admin.surveySchoolDesc": "Register a school in the YOBY module.",
    "dash.admin.surveySchoolName": "School name",
    "dash.admin.surveySchoolSlug": "Slug (optional)",
    "dash.admin.surveySchoolTitle": "New school",
    "dash.admin.surveyStaffDesc": "Link teachers and supervisors to a school.",
    "dash.admin.surveyStaffEmail": "Staff email",
    "dash.admin.surveyStaffForce": "Force assignment",
    "dash.admin.surveyStaffForceDesc": "Reassign even if the user already belongs to another school.",
    "dash.admin.surveyStaffRoleSupervisor": "Supervisor",
    "dash.admin.surveyStaffRoleTeacher": "Teacher",
    "dash.admin.surveyStaffSchool": "School",
    "dash.admin.surveyStaffTitle": "Assign staff",
    "dash.admin.surveyUpdateStaff": "Update staff",
    "dash.admin.tabSchoolsForm": "Add / edit schools",
    "dash.admin.tabSchoolsList": "School list",
    "dash.admin.tabSignups": "School applications",
    "dash.admin.tabStaffForm": "Add / edit staff",
    "dash.admin.tabStaffList": "Staff list",
    "dash.admin.tabsAria": "School admin",
    "dash.admin.title": "YOBY School Admin",
    "dash.booking.active": "Public bookings enabled",
    "dash.booking.addEmail": "Add email",
    "dash.booking.addHour": "Add time range",
    "dash.booking.attribution": "How they found us",
    "dash.booking.availabilityHint": "Enable public bookings at /talk-with-us/. Hours can be refined within Mon–Fri 09:00–19:00. Suspend specific dates below.",
    "dash.booking.availabilityTitle": "Public availability",
    "dash.booking.availableSlots": "Available times",
    "dash.booking.blockDate": "Suspend",
    "dash.booking.blockReason": "Reason",
    "dash.booking.blockReasonPlaceholder": "Reason (optional)",
    "dash.booking.blockedDatesHint": "No slots on these days.",
    "dash.booking.blockedDatesTitle": "Suspended dates",
    "dash.booking.blockedEmpty": "No suspended dates.",
    "dash.booking.blockedOn": "Date",
    "dash.booking.blockedSaved": "Date suspended.",
    "dash.booking.booking": "Booking…",
    "dash.booking.bufferMinutes": "Buffer between slots (minutes)",
    "dash.booking.calFreeDays": "Days with free slots",
    "dash.booking.cancel": "Cancel",
    "dash.booking.cancelConfirm": "Cancel this booking?",
    "dash.booking.cancelled": "cancelled",
    "dash.booking.cancelledOk": "Booking cancelled.",
    "dash.booking.confirm": "Book",
    "dash.booking.confirmTitle": "Confirm booking",
    "dash.booking.copyLink": "Copy link",
    "dash.booking.detailTitle": "Booking detail",
    "dash.booking.doneBody": "We emailed you the link. Use it on the day of the call.",
    "dash.booking.doneLinkHint": "If the email doesn't arrive, your personal link is:",
    "dash.booking.doneStatus": "Check your inbox too.",
    "dash.booking.doneTitle": "Booking confirmed",
    "dash.booking.emailsHint": "Add up to 3 emails — each gets a personal link.",
    "dash.booking.empty": "No public bookings or scheduled calls.",
    "dash.booking.errBlockDate": "Invalid date.",
    "dash.booking.errBlockExists": "Date already suspended.",
    "dash.booking.errBook": "Could not complete the booking.",
    "dash.booking.errCancel": "Could not cancel.",
    "dash.booking.errEmails": "Enter at least one valid email.",
    "dash.booking.errLoad": "Could not load bookings.",
    "dash.booking.errLoadSlots": "Could not load slots.",
    "dash.booking.errPickSlot": "Pick a time above first.",
    "dash.booking.errReschedule": "Could not reschedule.",
    "dash.booking.errSave": "Could not save availability.",
    "dash.booking.errSlotTaken": "That slot is no longer available. Pick another.",
    "dash.booking.errTooManyEmails": "Maximum 3 emails per booking.",
    "dash.booking.errUnblock": "Could not re-enable the date.",
    "dash.booking.errUrl": "That link doesn’t look like a valid web address.",
    "dash.booking.formOptionalHint": "All fields below are optional. You can tell us a little about yourself, or simply show up and say hello. We’ll figure it out together.",
    "dash.booking.gcalCalendar": "Target calendar",
    "dash.booking.gcalConnect": "Connect Google Calendar",
    "dash.booking.gcalConnectFailed": "Could not connect Google Calendar.",
    "dash.booking.gcalConnected": "Google Calendar connected.",
    "dash.booking.gcalDisconnect": "Disconnect",
    "dash.booking.gcalDisconnectConfirm": "Disconnect Google Calendar?",
    "dash.booking.gcalDisconnected": "Google Calendar disconnected.",
    "dash.booking.gcalMissing": "Ready — click Connect to authorize Google (OAuth).",
    "dash.booking.gcalOk": "Google Calendar connected (events & busy sync).",
    "dash.booking.gcalRedirectHint": "Authorize this redirect URI:",
    "dash.booking.gcalRefresh": "Refresh calendar",
    "dash.booking.gcalRefreshConfirm": "Re-sync all future appointments to Google Calendar (correct times on the YOBY calendar)?",
    "dash.booking.gcalRefreshEmpty": "No ongoing or upcoming appointments to sync.",
    "dash.booking.gcalRefreshFailed": "Calendar refresh failed.",
    "dash.booking.gcalRefreshNeedReconnect": "Google Calendar unreachable: disconnect and reconnect, then try refresh again.",
    "dash.booking.gcalRefreshOk": "Calendar refreshed: {synced}/{total} events · {failed} failed · {calendar}",
    "dash.booking.gcalServerMissing": "OAuth app missing on the server: create a Google Cloud “Web application” client, set GOOGLE_CALENDAR_CLIENT_ID and CLIENT_SECRET in .env, restart the API.",
    "dash.booking.gcalTitle": "Google Calendar",
    "dash.booking.inactive": "Public bookings are not active right now.",
    "dash.booking.introBody": "If you’d rather meet us than fill in a form, you can book a conversation directly with the YOBY team. We’ll be happy to show you the project, answer your questions, and explore how YOBY could fit your family, school, organisation, or partnership idea.",
    "dash.booking.introImageAlt": "Video call with the YOBY team — ducks chatting in English, French and Italian",
    "dash.booking.introInterpreter": "Speak another language? No problem: our conference call platform will translate yours into ours and vice versa.",
    "dash.booking.introLanguages": "You can speak with us in English, Italian, or French: Ricardo and Stefano speak Italian and English, while Antonella, our CRO, speaks French, Italian, and English.",
    "dash.booking.introTitle": "Prefer to talk?",
    "dash.booking.landingUrl": "Landing page",
    "dash.booking.linkLabel": "A link we should see before the call",
    "dash.booking.linkPlaceholder": "https://…",
    "dash.booking.listHint": "Click a row to manage invitees and links. Admin-scheduled calls appear here too.",
    "dash.booking.listTitle": "Bookings and scheduled calls",
    "dash.booking.noLinkedCall": "This booking has no linked conference call.",
    "dash.booking.noSlots": "No free slots on this day.",
    "dash.booking.note": "Anything you’d like us to know?",
    "dash.booking.notifyInvitees": "Email invitees (same link, new time)",
    "dash.booking.openCall": "Open conference",
    "dash.booking.orgLabel": "Organisation / project",
    "dash.booking.orgPlaceholder": "School, company, publication, foundation...",
    "dash.booking.pickDay": "Pick a day",
    "dash.booking.prefLang.none": "No preference",
    "dash.booking.prefLangLabel": "Preferred language",
    "dash.booking.publicSubtitle": "Pick a free slot. You’ll get a personal link to join the conference.",
    "dash.booking.publicTitle": "Book a YOBY call",
    "dash.booking.referrer": "Referrer",
    "dash.booking.rescheduleHint": "Change the date and time. Personal links stay the same.",
    "dash.booking.rescheduleTitle": "Reschedule",
    "dash.booking.rescheduled": "Booking rescheduled. Join links are unchanged.",
    "dash.booking.rulesHint": "Fixed rules: at least 48 hours notice, Monday–Friday 09:00–19:00 (Europe/Rome).",
    "dash.booking.save": "Save availability",
    "dash.booking.saveCall": "Save new time",
    "dash.booking.saved": "Availability saved.",
    "dash.booking.saving": "Saving…",
    "dash.booking.slotMinutes": "Slot length (minutes)",
    "dash.booking.sourceAdmin": "Scheduled call",
    "dash.booking.status": "Status",
    "dash.booking.statusCancelled": "cancelled",
    "dash.booking.statusDone": "done",
    "dash.booking.statusExpired": "expired",
    "dash.booking.statusLive": "live",
    "dash.booking.statusUpcoming": "upcoming",
    "dash.booking.timezone": "Your time zone",
    "dash.booking.timezoneHint": "Available times are shown in the selected time zone. YOBY availability is Mon–Fri 09:00–19:00 (Europe/Rome).",
    "dash.booking.topic.banking_fintech": "Banking & fintech",
    "dash.booking.topic.families": "YOBY for families",
    "dash.booking.topic.financial_education": "Financial education",
    "dash.booking.topic.investment": "Investment",
    "dash.booking.topic.other": "Something else",
    "dash.booking.topic.partnership": "Partnership",
    "dash.booking.topic.press": "Press & interviews",
    "dash.booking.topic.research": "Research",
    "dash.booking.topic.school_pilot": "School pilot",
    "dash.booking.topicsLabel": "What would you like to talk about?",
    "dash.booking.unblockDate": "Re-enable",
    "dash.booking.unblocked": "Date re-enabled.",
    "dash.booking.utm": "Campaign (UTM)",
    "dash.booking.weekday0": "Sunday",
    "dash.booking.weekday1": "Monday",
    "dash.booking.weekday2": "Tuesday",
    "dash.booking.weekday3": "Wednesday",
    "dash.booking.weekday4": "Thursday",
    "dash.booking.weekday5": "Friday",
    "dash.booking.weekday6": "Saturday",
    "dash.booking.weeklyHours": "Weekly hours",
    "dash.booking.who.bank": "Bank or financial institution",
    "dash.booking.who.curious": "Just curious",
    "dash.booking.who.educator": "Educator or school",
    "dash.booking.who.empty": "Choose if you like…",
    "dash.booking.who.foundation": "Foundation or NGO",
    "dash.booking.who.investor": "Investor",
    "dash.booking.who.journalist": "Journalist",
    "dash.booking.who.other": "Other",
    "dash.booking.who.parent": "Parent",
    "dash.booking.who.public": "Public institution",
    "dash.booking.who.startup": "Startup or company",
    "dash.booking.whoLabel": "Who are you?",
    "dash.booking.yourEmail": "Your email",
    "dash.booking.yourEmails": "Guest emails",
    "dash.booking.yourName": "Your name",
    "dash.common.actions": "Actions",
    "dash.common.actor": "Actor",
    "dash.common.archive": "Archive",
    "dash.common.assignments": "Assignments",
    "dash.common.attempts": "Attempts",
    "dash.common.avg": "Average",
    "dash.common.cancel": "Cancel",
    "dash.common.class": "Class",
    "dash.common.classes": "Classes",
    "dash.common.code": "Code",
    "dash.common.confirm": "Confirm",
    "dash.common.confirmArchiveSchool": "Archive this school?",
    "dash.common.confirmTitle": "Confirm",
    "dash.common.copyCode": "Copy code",
    "dash.common.csvDownloaded": "CSV downloaded",
    "dash.common.difficulty": "Difficulty",
    "dash.common.email": "Email",
    "dash.common.entity": "Entity",
    "dash.common.exportCsv": "Export CSV",
    "dash.common.family": "Family",
    "dash.common.lastAccess": "Last access",
    "dash.common.loading": "Loading…",
    "dash.common.name": "Name",
    "dash.common.newCode": "New code",
    "dash.common.none": "—",
    "dash.common.ok": "OK",
    "dash.common.open": "Open",
    "dash.common.questions": "Questions",
    "dash.common.quiz": "Quiz",
    "dash.common.refresh": "Refresh",
    "dash.common.role": "Role",
    "dash.common.school": "School",
    "dash.common.select": "Select",
    "dash.common.slug": "Slug",
    "dash.common.status": "Status",
    "dash.common.students": "Students",
    "dash.common.teachers": "Teachers",
    "dash.common.topic": "Topic",
    "dash.common.updated": "Updated",
    "dash.common.when": "When",
    "dash.common.year": "Year",
    "dash.conference.addInvitee": "Add invitee",
    "dash.conference.addInviteeHint": "They get a duck and a personal link. You can email the invite right away.",
    "dash.conference.addInviteeTitle": "Add an invitee",
    "dash.conference.addingInvitee": "Adding…",
    "dash.conference.back": "Back to list",
    "dash.conference.chat": "Chat",
    "dash.conference.confirmed": "Confirmed",
    "dash.conference.confirmedNo": "Pending",
    "dash.conference.confirmedYes": "Yes",
    "dash.conference.copied": "Link copied.",
    "dash.conference.copiedShort": "Copied!",
    "dash.conference.copyLink": "Copy link",
    "dash.conference.create": "Create call",
    "dash.conference.createImmediate": "Create immediate conference",
    "dash.conference.createImmediateHint": "Only the family/call name is required. Creates one open link anyone can use until midnight (Europe/Rome).",
    "dash.conference.created": "Call created.",
    "dash.conference.createdImmediate": "Open conference created — share the single link. Valid for the rest of today.",
    "dash.conference.creating": "Creating…",
    "dash.conference.detailTitle": "Invite links",
    "dash.conference.editHint": "You can change date, time, name, and language. Join links stay the same.",
    "dash.conference.editTitle": "Reschedule call",
    "dash.conference.email": "Email",
    "dash.conference.emailDryRun": "Email dry-run (not sent).",
    "dash.conference.emailSent": "Accepted by Mailgun.",
    "dash.conference.empty": "No conference calls yet.",
    "dash.conference.emptyInvitees": "No invitees yet.",
    "dash.conference.ended": "Call ended.",
    "dash.conference.errAddInvitee": "Could not add invitee. Check email and name.",
    "dash.conference.errCallEnded": "This call has ended; you can’t add invitees.",
    "dash.conference.errCopy": "Could not copy the link.",
    "dash.conference.errCreate": "Could not create the call.",
    "dash.conference.errDenied": "Access denied. Sign in as a YOBY admin.",
    "dash.conference.errDuplicateInvitee": "This email is already invited to this call.",
    "dash.conference.errEmail": "Could not send the email.",
    "dash.conference.errLoad": "Could not load conference calls.",
    "dash.conference.errSave": "Could not save changes.",
    "dash.conference.errWorldFull": "Conference world is full: no free ponds left.",
    "dash.conference.familyName": "Family name",
    "dash.conference.firstName": "First name",
    "dash.conference.gameLocale": "Game language",
    "dash.conference.inviteeAdded": "Invitee added.",
    "dash.conference.inviteeCount": "Invitees",
    "dash.conference.invitees": "Invitees",
    "dash.conference.lastName": "Last name",
    "dash.conference.listTitle": "Scheduled calls",
    "dash.conference.mediaHealth.checking": "Checking Janus and Coturn…",
    "dash.conference.mediaHealth.coturn": "Coturn (TURN)",
    "dash.conference.mediaHealth.down": "DOWN",
    "dash.conference.mediaHealth.errLoad": "Could not read video status.",
    "dash.conference.mediaHealth.hintDown": "Do not start the call: WebRTC video is not ready.",
    "dash.conference.mediaHealth.hintOk": "Janus and TURN are reachable. The call can start.",
    "dash.conference.mediaHealth.janus": "Janus",
    "dash.conference.mediaHealth.ok": "OK",
    "dash.conference.mediaHealth.title": "Video status (live)",
    "dash.conference.notifyInvitees": "Email invitees (same link, new time)",
    "dash.conference.openCallBadge": "open link",
    "dash.conference.openCallHint": "Anyone with this link can join (each person gets their own duck).",
    "dash.conference.phase": "Phase",
    "dash.conference.refresh": "Refresh",
    "dash.conference.save": "Save changes",
    "dash.conference.saveTranscript": "Save PDF",
    "dash.conference.saved": "Call updated. Join links are unchanged.",
    "dash.conference.saving": "Saving…",
    "dash.conference.sendEmail": "Send email",
    "dash.conference.sendEmailOnAdd": "Send invite email",
    "dash.conference.sendingEmail": "Sending…",
    "dash.conference.speech": "Speech",
    "dash.conference.startsAt": "Start date & time (Europe/Rome)",
    "dash.conference.startsAtHint": "Enter the time in the YOBY time zone (Europe/Rome), not your browser’s.",
    "dash.conference.subtitle": "Create a private YOBY world for a scheduled call. Invitees get a personal duck and link.",
    "dash.conference.tabAvailability": "Availability",
    "dash.conference.tabBookings": "Bookings",
    "dash.conference.tabCalls": "Scheduled calls",
    "dash.conference.tabCreate": "Create call",
    "dash.conference.tabsAria": "Conference sections",
    "dash.conference.title": "Conference call",
    "dash.conference.transcript": "Transcript",
    "dash.conference.transcriptDisabledNote": "Transcription disabled at a participant's request.",
    "dash.conference.transcriptEmpty": "No transcript yet.",
    "dash.conference.transcriptSaved": "PDF saved.",
    "dash.difficulty.easy": "Easy",
    "dash.difficulty.hard": "Hard",
    "dash.difficulty.medium": "Medium",
    "dash.liveInterpreter.callMetrics": "Live Interpreter usage",
    "dash.liveInterpreter.callMetricsBody": "Call {callMin} min · translated {liMin} min · languages: {langs} · listeners: {listeners} · ≈ €{eur}",
    "dash.liveInterpreter.criticalPct": "Critical threshold (%)",
    "dash.liveInterpreter.enabled": "Enable Live Interpreter (commercial conferences only)",
    "dash.liveInterpreter.enabledDesc": "Master switch for commercial calls (talk-with-us / admin). Never enables pond in-game videochat — the interpreter does not start there.",
    "dash.liveInterpreter.envOff": "Env kill-switch is OFF",
    "dash.liveInterpreter.errLoad": "Could not load interpreter settings.",
    "dash.liveInterpreter.errSave": "Could not save interpreter settings.",
    "dash.liveInterpreter.hint": "Simultaneous voice translation for commercial conferences only. Never on casual pond video.",
    "dash.liveInterpreter.monthUsage": "Month {month}: {used} / {limit} min · ≈ €{eur} · {calls} calls · {status}",
    "dash.liveInterpreter.monthlyLimit": "Monthly limit (translated audio minutes)",
    "dash.liveInterpreter.providerMissing": "Azure Voice Live endpoint/API key missing in .env",
    "dash.liveInterpreter.providerOk": "Azure Voice Live configured",
    "dash.liveInterpreter.quotaBlocked": "New translations blocked",
    "dash.liveInterpreter.quotaCritical": "Critical",
    "dash.liveInterpreter.quotaOk": "OK",
    "dash.liveInterpreter.quotaWarn": "Warning",
    "dash.liveInterpreter.save": "Save interpreter settings",
    "dash.liveInterpreter.saved": "Interpreter settings saved.",
    "dash.liveInterpreter.tab": "Interpreter",
    "dash.liveInterpreter.testCall": "TEST — open practice conference",
    "dash.liveInterpreter.testCallCreating": "Creating practice conference…",
    "dash.liveInterpreter.testCallErr": "Could not create the practice conference.",
    "dash.liveInterpreter.testCallHint": "Creates an immediate open conference (public link) and opens it in a new tab to try captions and 🎲.",
    "dash.liveInterpreter.testCallOk": "Practice conference ready — opened in a new tab.",
    "dash.liveInterpreter.title": "Live Interpreter",
    "dash.liveInterpreter.warnPct": "Warning threshold (%)",
    "dash.schoolSignup.addClass": "Add class",
    "dash.schoolSignup.addTeacher": "Add teacher",
    "dash.schoolSignup.alreadyBody": "This account is already linked to a school on YOBY.",
    "dash.schoolSignup.alreadyTitle": "You’re already registered",
    "dash.schoolSignup.back": "Back",
    "dash.schoolSignup.checkEmail": "Check your email and come back to this page after confirming.",
    "dash.schoolSignup.city": "City",
    "dash.schoolSignup.className": "Class name",
    "dash.schoolSignup.classTeacher": "Class teacher",
    "dash.schoolSignup.classes": "Classes involved",
    "dash.schoolSignup.continue": "Continue",
    "dash.schoolSignup.country": "Country",
    "dash.schoolSignup.draftSaved": "Draft saved.",
    "dash.schoolSignup.email": "Principal’s email",
    "dash.schoolSignup.errClassTeacher": "Choose a teacher already listed in the previous step.",
    "dash.schoolSignup.errEmail": "Enter a valid email address.",
    "dash.schoolSignup.errGeneric": "Something went wrong. Try again.",
    "dash.schoolSignup.errLocked": "The application has already been submitted.",
    "dash.schoolSignup.errLookup": "Could not check this email.",
    "dash.schoolSignup.errName": "Enter first and last name (at least 2 characters).",
    "dash.schoolSignup.errPhone": "Phone is optional. If you fill it in, use digits, spaces or +.",
    "dash.schoolSignup.errPrivacy": "You need to accept the privacy notice to continue.",
    "dash.schoolSignup.errSave": "Could not save the draft.",
    "dash.schoolSignup.errSubmit": "Could not submit the application.",
    "dash.schoolSignup.errTeacherDup": "Each teacher must have a different email.",
    "dash.schoolSignup.errTeacherSelf": "Do not use the principal’s email: they are a supervisor, not a teacher.",
    "dash.schoolSignup.errValidation": "Enter the school name, at least one teacher and one class.",
    "dash.schoolSignup.goDashboard": "Open dashboard",
    "dash.schoolSignup.helpAccount": "Create the principal’s account with name, email and privacy consent. We send a confirmation link: open it, then come back to this page. If you already have a YOBY account, sign in — you do not need to register again.",
    "dash.schoolSignup.helpClassTeacher": "Choose the teacher in charge of this class. They must already be listed as a teacher.",
    "dash.schoolSignup.helpClasses": "Each class has a lead teacher chosen from the previous step. When we approve, YOBY creates the classes and assigns them to that teacher. You need at least one class.",
    "dash.schoolSignup.helpSchool": "Enter the school details so YOBY can activate it after review. Phone is optional. Use the note for campuses, hours or anything else we should know.",
    "dash.schoolSignup.helpTeachers": "List the teachers who will use YOBY. They will get an invite when we approve. Do not add the principal’s email: the principal is a supervisor, not a teacher. You need at least one teacher.",
    "dash.schoolSignup.introAlt": "Prefer a call with us?",
    "dash.schoolSignup.introBody": "The principal signs up, confirms the email, then lists teachers and classes. YOBY activates the school after a review.",
    "dash.schoolSignup.introTitle": "Register your school",
    "dash.schoolSignup.knownBody": "This email is already registered. Sign in with the link we send you.",
    "dash.schoolSignup.knownTitle": "You’re already registered",
    "dash.schoolSignup.locale": "Working language",
    "dash.schoolSignup.name": "Principal’s name",
    "dash.schoolSignup.note": "Note (optional)",
    "dash.schoolSignup.openDashboard": "Go to dashboard",
    "dash.schoolSignup.pendingBody": "We received the application for {school}. We’ll email you when it’s active.",
    "dash.schoolSignup.pendingTitle": "Waiting for approval",
    "dash.schoolSignup.phone": "Phone (optional)",
    "dash.schoolSignup.privacy": "I accept the privacy notice and to share the listed teachers’ emails.",
    "dash.schoolSignup.rejectedBody": "The previous application was not approved. Reason: {reason}",
    "dash.schoolSignup.rejectedTitle": "Application not approved",
    "dash.schoolSignup.saveDraft": "Save draft",
    "dash.schoolSignup.schoolName": "School name",
    "dash.schoolSignup.signIn": "Sign in",
    "dash.schoolSignup.signUp": "Sign up and confirm your email",
    "dash.schoolSignup.stepAccount": "Account",
    "dash.schoolSignup.stepAccountTitle": "Account",
    "dash.schoolSignup.stepClassesTitle": "Classes",
    "dash.schoolSignup.stepSchool": "School",
    "dash.schoolSignup.stepSchoolTitle": "School",
    "dash.schoolSignup.stepTeachersTitle": "Teachers",
    "dash.schoolSignup.submit": "Submit application",
    "dash.schoolSignup.submitted": "Application sent.",
    "dash.schoolSignup.talkWithUs": "Book a call",
    "dash.schoolSignup.teacherEmail": "Teacher email",
    "dash.schoolSignup.teacherName": "Teacher name",
    "dash.schoolSignup.teachers": "Teachers",
    "dash.status.ageBand.11-15": "11–15",
    "dash.status.ageBand.16-17": "16–17",
    "dash.status.ageBand.18-26": "18–26",
    "dash.status.ageBand.8-10": "8–10",
    "dash.status.ageBand.adult": "Adults",
    "dash.status.ageBand.unknown": "No age band",
    "dash.status.analytics.events.arcade_completed.description": "Arcade activity ends",
    "dash.status.analytics.events.arcade_completed.label": "Arcade completed",
    "dash.status.analytics.events.arcade_started.description": "Crazy Run or arcade activity starts",
    "dash.status.analytics.events.arcade_started.label": "Arcade started",
    "dash.status.analytics.events.child_access_started.description": "Child enters via link or parent",
    "dash.status.analytics.events.child_access_started.label": "Child access started",
    "dash.status.analytics.events.child_first_claim_email_sent.description": "Transactional claim email sent to the parent",
    "dash.status.analytics.events.child_first_claim_email_sent.label": "Unlock email sent",
    "dash.status.analytics.events.child_first_claim_opened.description": "Parent opens the unlock /claim link preview",
    "dash.status.analytics.events.child_first_claim_opened.label": "Claim link opened",
    "dash.status.analytics.events.child_first_claimed.description": "Parent unlocks the pending duck into a family",
    "dash.status.analytics.events.child_first_claimed.label": "Duck claimed",
    "dash.status.analytics.events.child_first_family_activated.description": "Family play ready after child-first claim",
    "dash.status.analytics.events.child_first_family_activated.label": "Child-first family activated",
    "dash.status.analytics.events.child_first_parent_email_submitted.description": "Child submits a parent/guardian email for unlock",
    "dash.status.analytics.events.child_first_parent_email_submitted.label": "Parent email submitted",
    "dash.status.analytics.events.child_first_started.description": "Child begins Create my duck onboarding",
    "dash.status.analytics.events.child_first_started.label": "Child-first started",
    "dash.status.analytics.events.child_profile_created.description": "A child character profile is created",
    "dash.status.analytics.events.child_profile_created.label": "Child profile created",
    "dash.status.analytics.events.collectible_obtained.description": "An item is collected",
    "dash.status.analytics.events.collectible_obtained.label": "Collectible obtained",
    "dash.status.analytics.events.family_activation_completed.description": "Adult, child and first access exist",
    "dash.status.analytics.events.family_activation_completed.label": "Family activated",
    "dash.status.analytics.events.family_created.description": "A parent creates the family pond",
    "dash.status.analytics.events.family_created.label": "Family created",
    "dash.status.analytics.events.market_transaction.description": "Buy, sell or negotiate",
    "dash.status.analytics.events.market_transaction.label": "Market transaction",
    "dash.status.analytics.events.market_visited.description": "Access to the market",
    "dash.status.analytics.events.market_visited.label": "Market visited",
    "dash.status.analytics.events.mission_completed.description": "Mission finished",
    "dash.status.analytics.events.mission_completed.label": "Mission completed",
    "dash.status.analytics.events.mission_started.description": "A game mission begins",
    "dash.status.analytics.events.mission_started.label": "Mission started",
    "dash.status.analytics.events.parent_demo_converted.description": "A parent finishes the demo and creates an account",
    "dash.status.analytics.events.parent_demo_converted.label": "Family demo converted",
    "dash.status.analytics.events.parent_demo_keep_prompt.description": "Keep-the-duck prompt shown",
    "dash.status.analytics.events.parent_demo_keep_prompt.label": "Family demo: keep duck",
    "dash.status.analytics.events.parent_demo_parent_ui_complete.description": "Family UI overview completed",
    "dash.status.analytics.events.parent_demo_parent_ui_complete.label": "Family demo: UI done",
    "dash.status.analytics.events.parent_demo_started.description": "Start from the public Try YOBY parent link",
    "dash.status.analytics.events.parent_demo_started.label": "Family demos",
    "dash.status.analytics.events.parent_demo_tour_complete.description": "World tour completed",
    "dash.status.analytics.events.parent_demo_tour_complete.label": "Family demo: tour done",
    "dash.status.analytics.events.quiz_assigned.description": "Teacher assigns a quiz",
    "dash.status.analytics.events.quiz_assigned.label": "Quiz assigned",
    "dash.status.analytics.events.quiz_completed.description": "Quiz finished",
    "dash.status.analytics.events.quiz_completed.label": "Quiz completed",
    "dash.status.analytics.events.quiz_started.description": "Child opens a quiz",
    "dash.status.analytics.events.quiz_started.label": "Quiz started",
    "dash.status.analytics.events.real_task_assigned.description": "Parent assigns a real-life chore",
    "dash.status.analytics.events.real_task_assigned.label": "Real task assigned",
    "dash.status.analytics.events.real_task_completed.description": "Child marks chore done",
    "dash.status.analytics.events.real_task_completed.label": "Real task done",
    "dash.status.analytics.events.real_task_validated.description": "Parent accepts or rejects",
    "dash.status.analytics.events.real_task_validated.label": "Real task validated",
    "dash.status.analytics.events.reward_claimed.description": "Child claims a reward",
    "dash.status.analytics.events.reward_claimed.label": "Reward claimed",
    "dash.status.analytics.events.reward_distributed.description": "Parent allocates a reward",
    "dash.status.analytics.events.reward_distributed.label": "Reward distributed",
    "dash.status.analytics.events.reward_earned.description": "A reward is granted",
    "dash.status.analytics.events.reward_earned.label": "Reward earned",
    "dash.status.analytics.events.session_ended.description": "Exit or inactivity",
    "dash.status.analytics.events.session_ended.label": "Session ended",
    "dash.status.analytics.events.session_started.description": "Someone enters the game",
    "dash.status.analytics.events.session_started.label": "Session started",
    "dash.status.analytics.events.shared_family_session.description": "Parent and child online together",
    "dash.status.analytics.events.shared_family_session.label": "Shared family session",
    "dash.status.analytics.events.subscription_cancelled.description": "Subscription cancelled",
    "dash.status.analytics.events.subscription_cancelled.label": "Subscription cancelled",
    "dash.status.analytics.events.subscription_started.description": "Family or Patron activated",
    "dash.status.analytics.events.subscription_started.label": "Subscription started",
    "dash.status.analytics.events.teacher_demo_converted.description": "A teacher finishes the demo and creates an account",
    "dash.status.analytics.events.teacher_demo_converted.label": "Teacher demo converted",
    "dash.status.analytics.events.teacher_demo_keep_prompt.description": "Keep-the-duck prompt shown",
    "dash.status.analytics.events.teacher_demo_keep_prompt.label": "Teacher demo: keep duck",
    "dash.status.analytics.events.teacher_demo_started.description": "Start from the public Try YOBY teacher link",
    "dash.status.analytics.events.teacher_demo_started.label": "Teacher demos",
    "dash.status.analytics.events.teacher_demo_teacher_ui_complete.description": "Teacher UI overview completed",
    "dash.status.analytics.events.teacher_demo_teacher_ui_complete.label": "Teacher demo: UI done",
    "dash.status.analytics.events.teacher_demo_tour_complete.description": "World tour completed",
    "dash.status.analytics.events.teacher_demo_tour_complete.label": "Teacher demo: tour done",
    "dash.status.analytics.events.temporary_link_generated.description": "A temporary play link is created",
    "dash.status.analytics.events.temporary_link_generated.label": "Temp link created",
    "dash.status.analytics.events.temporary_link_used.description": "A temporary link is redeemed",
    "dash.status.analytics.events.temporary_link_used.label": "Temp link used",
    "dash.status.charts.acq_age_doughnut.title": "Child profiles by age band",
    "dash.status.charts.acq_child_first_funnel.title": "Child-first duck funnel",
    "dash.status.charts.acq_child_first_trend.title": "Child-first trend",
    "dash.status.charts.acq_demo_bar.title": "Public demo links",
    "dash.status.charts.acq_demo_trend.title": "Demo link trend",
    "dash.status.charts.acq_funnel.title": "Acquisition funnel",
    "dash.status.charts.acq_plan_doughnut.title": "Subscription plans",
    "dash.status.charts.acq_trend_line.title": "Acquisition trend",
    "dash.status.charts.eco_age_doughnut.title": "Rewards by age band",
    "dash.status.charts.eco_arcade_line.title": "Arcade activity",
    "dash.status.charts.eco_chores_funnel.title": "Real tasks funnel",
    "dash.status.charts.eco_collectibles_line.title": "Collectibles",
    "dash.status.charts.eco_market_bar.title": "Market activity",
    "dash.status.charts.eco_reward_origin.title": "Reward origins",
    "dash.status.charts.eco_reward_volume.title": "Reward volume",
    "dash.status.charts.eng_access_doughnut.title": "Child access channels",
    "dash.status.charts.eng_age_doughnut.title": "Sessions by age band",
    "dash.status.charts.eng_device_bar.title": "Sessions by device",
    "dash.status.charts.eng_links_bar.title": "Temporary links",
    "dash.status.charts.eng_sessions_line.title": "Sessions by role",
    "dash.status.charts.eng_shared_line.title": "Shared family sessions",
    "dash.status.charts.learn_age_doughnut.title": "Quizzes completed by age band",
    "dash.status.charts.learn_duration_bar.title": "Average duration",
    "dash.status.charts.learn_mission_host.title": "Missions by host",
    "dash.status.charts.learn_mission_trend.title": "Mission trend",
    "dash.status.charts.learn_quiz_funnel.title": "Quiz funnel",
    "dash.status.charts.learn_quiz_trend.title": "Quiz trend",
    "dash.status.charts.live_age_bar.title": "Online by age band",
    "dash.status.charts.live_realm_pie.title": "Online by realm",
    "dash.status.charts.live_role_bar.title": "Online by role",
    "dash.status.daysLabel": "Days",
    "dash.status.errLoad": "Could not load status.",
    "dash.status.lastAccessTitle": "Last access",
    "dash.status.loading": "Loading…",
    "dash.status.logAll": "All",
    "dash.status.logFilter": "Event",
    "dash.status.refresh": "Refresh",
    "dash.status.report.anonymized": "Anonymized report: no emails or personal names.",
    "dash.status.report.failed": "Report generation failed. Try again.",
    "dash.status.report.generate": "Generate report",
    "dash.status.report.generating": "Generating",
    "dash.status.report.impossible": "Cannot generate the report: there is no analytics data in the selected period yet.",
    "dash.status.report.overviewTitle": "Overall commentary",
    "dash.status.report.pdfAnalysisTitle": "Analysis",
    "dash.status.report.pdfChartsTitle": "Charts",
    "dash.status.report.pdfKpisTitle": "Key metrics",
    "dash.status.report.pdfPage": "Page {n} of {total}",
    "dash.status.report.pdfPeriod": "Period: last {days} days",
    "dash.status.report.pdfTitle": "Yoby analytics report",
    "dash.status.report.pdfUnavailable": "PDF library unavailable.",
    "dash.status.report.previewFailed": "Could not render PDF preview.",
    "dash.status.report.previewPreparing": "Preparing PDF preview…",
    "dash.status.report.readyAt": "Generated",
    "dash.status.report.savePdf": "Save PDF",
    "dash.status.report.waiting": "Report is being prepared… please wait.",
    "dash.status.sectionOnline": "Online now",
    "dash.status.sectionOnlineAge": "Online by age band",
    "dash.status.sectionTotals": "Totals (excluding active conference worlds)",
    "dash.status.sectionTotalsAge": "Characters by age band",
    "dash.status.subtitle": "In-game presence and product analytics.",
    "dash.status.summaryChildren": "Children online",
    "dash.status.summaryFamilies": "Families in game",
    "dash.status.summaryInGame": "In game (total)",
    "dash.status.summaryParents": "Parents online",
    "dash.status.summaryPlayers": "Players in game",
    "dash.status.summaryQueueDepth": "Analytics queue",
    "dash.status.summaryRows": "Last-access rows",
    "dash.status.summarySurface": "On the surface",
    "dash.status.summaryUnderground": "Underground",
    "dash.status.summaryWorldsActive": "Worlds with players online",
    "dash.status.summaryWorldsOpened": "Worlds opened",
    "dash.status.tabs.acquisition": "Acquisition",
    "dash.status.tabs.economy": "Economy",
    "dash.status.tabs.engagement": "Engagement",
    "dash.status.tabs.learning": "Learning",
    "dash.status.tabs.live": "Live",
    "dash.status.tabs.logs": "Logs",
    "dash.status.tabs.report": "Report",
    "dash.status.thAgeBand": "Age band",
    "dash.status.thEmailName": "Email / Name",
    "dash.status.thEvent": "Event",
    "dash.status.thFamily": "Family",
    "dash.status.thLastAccess": "Last access",
    "dash.status.thRole": "Role",
    "dash.status.thSummary": "Summary",
    "dash.status.thTime": "Time",
    "dash.status.thWorld": "World",
    "dash.status.thWorldFamilies": "Families",
    "dash.status.thWorldPlayers": "Players",
    "dash.status.thWorldSurface": "Surface",
    "dash.status.thWorldUnderground": "Underground",
    "dash.status.title": "Status",
    "dash.status.totalChildren": "Children (total)",
    "dash.status.totalFamilies": "Families (total)",
    "dash.status.totalParents": "Parents (total)",
    "dash.status.totalPlayers": "Characters (total)",
    "dash.status.updated": "Updated",
    "dash.status.worldsTitle": "Per-world breakdown",
    "dash.supervisor.csvDownloaded": "CSV downloaded",
    "dash.supervisor.errAudit": "Could not load audit log.",
    "dash.supervisor.errDenied": "Access denied. Sign in as a supervisor or YOBY admin.",
    "dash.supervisor.errExport": "Could not export CSV.",
    "dash.supervisor.exportCsvSchool": "Export school CSV",
    "dash.supervisor.hintAudit": "Latest actions recorded for the school.",
    "dash.supervisor.hintQuizzes": "Quiz usage by slug (completed attempts in the school).",
    "dash.supervisor.metaSlug": "Slug",
    "dash.supervisor.metaStatus": "Status",
    "dash.supervisor.metricSchoolAvg": "School average",
    "dash.supervisor.noAudit": "No audit entries.",
    "dash.supervisor.noClasses": "No classes.",
    "dash.supervisor.noQuizzes": "No quiz data.",
    "dash.supervisor.noSchools": "No schools assigned.",
    "dash.supervisor.noTeachers": "No teachers.",
    "dash.supervisor.refresh": "Refresh",
    "dash.supervisor.selectSchoolHint": "Select a school to view classes, teachers and quiz statistics.",
    "dash.supervisor.subtitle": "Overview of schools, classes, teachers, quizzes and audit.",
    "dash.supervisor.tabAudit": "Audit",
    "dash.supervisor.tabClasses": "Classes",
    "dash.supervisor.tabQuizzes": "Quizzes",
    "dash.supervisor.tabTeachers": "Teachers",
    "dash.supervisor.thAssignments": "Assignments",
    "dash.supervisor.thSchool": "School",
    "dash.supervisor.thTeacher": "Teacher",
    "dash.supervisor.title": "Supervisor dashboard",
    "dash.supervisor.yourSchools": "Your schools",
    "dash.teacher.catalogTitle": "Quiz catalog",
    "dash.teacher.confirmArchiveClass": "Archive this class? The join code will no longer work.",
    "dash.teacher.copied": "Copied!",
    "dash.teacher.copyCode": "Copy code",
    "dash.teacher.createClass": "Create a class",
    "dash.teacher.demoLink": "Demo link",
    "dash.teacher.demoLinkCopied": "Link copied to clipboard.",
    "dash.teacher.demoLinkReady": "Permanent link created",
    "dash.teacher.errArchive": "Could not archive class.",
    "dash.teacher.errAssign": "Could not assign quiz.",
    "dash.teacher.errCreateClass": "Could not create class.",
    "dash.teacher.errDemoDenied": "Only admins can create demo links.",
    "dash.teacher.errDemoLink": "Could not create the demo link.",
    "dash.teacher.errDemoNoQuiz": "No unused quiz left to assign to this class.",
    "dash.teacher.errDenied": "Access denied. Sign in as a teacher.",
    "dash.teacher.errExport": "Could not export CSV.",
    "dash.teacher.errExportCatalog": "Could not export the quiz catalog.",
    "dash.teacher.errLoadClasses": "Could not load classes.",
    "dash.teacher.errNoTeacher": "No teacher profile found.",
    "dash.teacher.errRegen": "Could not regenerate code.",
    "dash.teacher.errSelectSchool": "Select a school first.",
    "dash.teacher.exportCatalogCsv": "Download catalog CSV (all languages)",
    "dash.teacher.exportCsv": "Export CSV",
    "dash.teacher.hintAssign": "Choose category, quiz and assignment settings.",
    "dash.teacher.hintWrong": "Questions with the most errors in recent assignments.",
    "dash.teacher.metaAge": "Age",
    "dash.teacher.metaCode": "Code",
    "dash.teacher.metaLang": "Language",
    "dash.teacher.metaYear": "Year",
    "dash.teacher.metricAssignments": "Assignments",
    "dash.teacher.metricAttempts": "Attempts",
    "dash.teacher.metricClassAvg": "Class average",
    "dash.teacher.metricEnrolled": "Enrolled",
    "dash.teacher.newCode": "New code",
    "dash.teacher.noAssignments": "No assignments yet.",
    "dash.teacher.noCatalog": "No quizzes in catalog.",
    "dash.teacher.noClasses": "No classes yet.",
    "dash.teacher.noStudents": "No students enrolled.",
    "dash.teacher.noWrong": "No difficult questions yet.",
    "dash.teacher.open": "Open",
    "dash.teacher.playLink": "Play link",
    "dash.teacher.playLinkCopied": "Link copied to clipboard.",
    "dash.teacher.playLinkFailed": "Could not create play link",
    "dash.teacher.playLinkHint": "Students open the link and tap their name. Please supervise the choice.",
    "dash.teacher.playLinkHours": "Hours",
    "dash.teacher.playLinkReady": "Play link created",
    "dash.teacher.quizColChoices": "Choices",
    "dash.teacher.quizColOrder": "#",
    "dash.teacher.quizColQuestion": "Question",
    "dash.teacher.quizLoadError": "Could not load quiz.",
    "dash.teacher.quizLoading": "Loading quiz…",
    "dash.teacher.quizPreviewTitle": "Quiz preview",
    "dash.teacher.selectClassHint": "Select a class to view details.",
    "dash.teacher.statusAssigned": "Quiz assigned.",
    "dash.teacher.statusAssigning": "Assigning quiz…",
    "dash.teacher.statusClassCreated": "Class created.",
    "dash.teacher.statusCreating": "Creating class…",
    "dash.teacher.subtitle": "Classes, enrollment codes, quiz assignments, results and exports.",
    "dash.teacher.surveyFeedbackFinal": "At end of quiz",
    "dash.teacher.surveyFeedbackImmediate": "Immediately after each question",
    "dash.teacher.tabAssign": "Assign quiz",
    "dash.teacher.tabAssignments": "Assignments",
    "dash.teacher.tabStudents": "Students",
    "dash.teacher.tabWrong": "Difficult questions",
    "dash.teacher.thAge": "Age",
    "dash.teacher.thAvg": "Average",
    "dash.teacher.thClass": "Class",
    "dash.teacher.thCode": "Code",
    "dash.teacher.thCompleted": "Completed",
    "dash.teacher.thDifficulty": "Difficulty",
    "dash.teacher.thDone": "Completed",
    "dash.teacher.thDue": "Due date",
    "dash.teacher.thErrorPct": "Error %",
    "dash.teacher.thErrors": "Errors",
    "dash.teacher.thFirstName": "First name",
    "dash.teacher.thJoined": "Joined",
    "dash.teacher.thLastName": "Last name",
    "dash.teacher.thLastSeen": "Last seen",
    "dash.teacher.thMaxAttempts": "Max attempts",
    "dash.teacher.thNickname": "Nickname",
    "dash.teacher.thPublish": "Publish at",
    "dash.teacher.thQuestion": "Question",
    "dash.teacher.thTheme": "Theme",
    "dash.teacher.thTitle": "Title",
    "dash.teacher.thTotalAnswers": "Total answers",
    "dash.teacher.thYear": "Year",
    "dash.teacher.title": "Teacher dashboard",
    "dash.teacher.yourClasses": "Your classes",
    "dash.teacher.yourClassesHint": "Select a class to view students, assignments and statistics.",
    "dash.topic.bisogni_desideri": "Needs and wants",
    "dash.topic.budget": "Budget",
    "dash.topic.consumo": "Conscious consumption",
    "dash.topic.imprenditorialita": "Entrepreneurship",
    "dash.topic.lavoro": "World of work",
    "dash.topic.risparmio": "Saving",
    "footer.aria.site": "Site footer",
    "footer.aria.social": "Social links",
    "footer.brand.tagline": "The family duck pond where kids and grown-ups learn money together.",
    "footer.col.about": "About YOBY",
    "footer.col.aiAudits": "Latest AI safety audits",
    "footer.col.banksAndPartners": "Banks & Partners",
    "footer.col.contact": "Contact",
    "footer.col.cookiePolicy": "Cookie Policy",
    "footer.col.dataAndGdpr": "Data & GDPR",
    "footer.col.investors": "Investors",
    "footer.col.parentalControls": "Parental Controls",
    "footer.col.partners.title": "Partners",
    "footer.col.press": "Press",
    "footer.col.privacyPolicy": "Privacy Policy",
    "footer.col.product.title": "Product",
    "footer.col.roadmap": "Roadmap",
    "footer.col.safety": "Safety",
    "footer.col.schools": "Schools",
    "footer.col.termsOfService": "Terms of Service",
    "footer.col.trust.title": "Trust & Safety",
    "footer.col.yoby.title": "YOBY",
    "footer.copyright.line1": "© 2026 YOBY. All rights reserved.",
    "footer.copyright.line2": "Made in Europe for families, ducks, and better money habits.",
    "home.about.feature1.body": "A private space where the whole family explores, completes quests and grows together. Every member has their own duck character.",
    "home.about.feature1.title": "🦆 A family game for learning about money",
    "home.about.feature2.body": "The Frog, the Magpie, the Mole and others guide you with short quests and choice-based questions. Learning by doing, not studying.",
    "home.about.feature2.title": "🐸 Mentors that teach money skills through play",
    "home.about.feature3.body": "Three symbolic currencies for goals, saving and good habits. A game economy that teaches without feeling like a lesson.",
    "home.about.feature3.title": "🐚 Saving, goals and habits in a playful economy",
    "home.about.feature4.body": "No child can receive inappropriate content. No video chat without a parent present. Built for minors — not just adapted.",
    "home.about.feature4.title": "🔒 Safe by design",
    "home.about.title": "What you'll find in the YOBY world",
    "home.cta.choosePlan": "Choose a plan",
    "home.cta.joinDescription": "Create your family account and start exploring.",
    "home.cta.joinTitle": "Jump in. It's free.",
    "home.cta.playNow": "Play now",
    "home.cta.premiumActive": "You're on a premium plan — enjoy the full experience!",
    "home.cta.premiumHint": "Premium plans offer better in-game conditions: more shells, exclusive areas, and priority features.",
    "home.cta.ready": "Ready to dive back into the pond?",
    "home.cta.signIn": "Sign in",
    "home.cta.signUpFree": "Start free",
    "home.cta.tryAsParent": "Are you a parent? Try YOBY",
    "home.cta.tryAsStudent": "Are you a teacher? Try YOBY",
    "home.cta.welcomeBack": "Welcome back",
    "home.cta.welcomeBackName": "Welcome back, {name}",
    "home.hero.childBody": "Create it now. A parent will unlock your pond when you're ready.",
    "home.hero.childCta": "Create my duck",
    "home.hero.childTitle": "Looking for your duck? 🦆",
    "home.hero.ctaPrimary": "Start free",
    "home.hero.ctaSecondary": "See how it works",
    "home.hero.description": "YOBY is a financial education game where kids and parents learn about saving, money choices and goals together.",
    "home.hero.tagline": "Money talks, finally made fun.",
    "home.hero.title": "Financial literacy for kids and families, made fun.",
    "home.hero.visualAlt": "YOBY pond world with playful ducks exploring the family lagoon",
    "home.learn.choices.body": "Face everyday trade-offs — spend now, save, or share — in safe, story-driven quests.",
    "home.learn.choices.title": "Choices",
    "home.learn.goals.body": "Name what matters, plan toward it, and celebrate progress along the way.",
    "home.learn.goals.title": "Goals",
    "home.learn.saving.body": "Set aside shells for later and watch small steps grow into bigger goals.",
    "home.learn.saving.title": "Saving",
    "home.learn.title": "What kids learn",
    "home.learn.value.body": "Connect effort, time and resources so kids understand what money represents.",
    "home.learn.value.title": "Value of money",
    "home.links.families": "Financial education for families",
    "home.links.kids": "YOBY for kids",
    "home.links.schools": "Financial literacy for schools",
    "home.links.title": "Explore YOBY",
    "home.seo.description": "YOBY is a playful financial literacy world where kids and parents learn saving, money choices and healthy financial habits together.",
    "home.seo.title": "Financial Literacy for Kids & Families | YOBY",
    "home.seoSection.body": "YOBY turns financial literacy for kids into a shared adventure. In a playful pond world, children and parents practice saving, set goals together, and talk through everyday money choices. Mentor characters and short quests guide learning about money through play — not worksheets or lectures. If you want financial education for families at home, YOBY meets kids where they are: curious, creative, and ready to explore. Every family member gets their own duck avatar in a pond you share only with people you trust. Shells, seeds and stars stand in for real habits — patience, planning, and understanding the value of what you earn. Along the way, kids learn that small choices add up, that waiting can be worth it, and that money is a tool for goals — not just spending. Parents stay involved with clear visibility and controls in a space designed for minors from the ground up.",
    "home.seoSection.title": "Financial education for kids, through play",
    "home.showcase.aria": "Game screenshots",
    "home.showcase.card1.alt": "YOBY family financial education game with parents and children exploring a virtual pond",
    "home.showcase.card1.title": "Family pond — explore together",
    "home.showcase.card2.alt": "YOBY mentor characters teaching kids about money through playful quests",
    "home.showcase.card2.title": "Meet mentors — learn by playing",
    "home.showcase.card3.alt": "YOBY financial education quiz and village shops with localized mentor dialogue",
    "home.showcase.card3.title": "Quizzes, shops and village life",
    "home.showcase.card4.alt": "YOBY underground mentors teaching kids about money through cinematic quests",
    "home.showcase.card4.title": "Underground mentors and quests",
    "home.showcase.card5.alt": "YOBY Tasso market scene where kids practice money choices",
    "home.showcase.card5.title": "Markets and money choices",
    "home.showcase.card6.alt": "YOBY Crazy Run mini-game: kids race on the grass collecting seasonal items against the clock",
    "home.showcase.card6.title": "Crazy Run — a timed race on the grass",
    "home.showcase.hint": "Tap to enlarge",
    "home.showcase.title": "See the world",
    "lang.switch": "Language",
    "nav.account": "Account",
    "nav.actions.signIn": "Sign in",
    "nav.actions.startFree": "Start free",
    "nav.actions.talkWithUs": "Talk with us",
    "nav.aria.main": "Main navigation",
    "nav.aria.staff": "School and admin area",
    "nav.footer.schoolSignup": "Register your school",
    "nav.main.blog": "Blog",
    "nav.main.forFamilies": "For Families",
    "nav.main.forKids": "For Kids",
    "nav.main.home": "Home",
    "nav.main.howItWorks": "How it works",
    "nav.main.pricing": "Pricing",
    "nav.main.talkWithUs": "Talk with us",
    "nav.menu": "Menu",
    "nav.searchPosts": "Search posts, tags and authors",
    "nav.signIn": "Sign in",
    "nav.staff.admin": "School admin",
    "nav.staff.adminSafety": "Latest AI safety audits",
    "nav.staff.conference": "Conference call",
    "nav.staff.massmail": "School massmail",
    "nav.staff.redteam": "AI Red Team",
    "nav.staff.schoolSignups": "School applications",
    "nav.staff.status": "Game status",
    "nav.staff.supervisor": "Supervisor dashboard",
    "nav.staff.teacher": "Teacher dashboard",
    "nav.subscribe": "Subscribe",
    "safetyLab.areasTitle": "Topics we check",
    "safetyLab.audience": "For families and schools",
    "safetyLab.cat.abuse": "Abuse",
    "safetyLab.cat.dangerous_behavior": "Dangerous behaviour",
    "safetyLab.cat.distress_support": "Emotional support (allowed)",
    "safetyLab.cat.drugs": "Drugs",
    "safetyLab.cat.hate": "Hate",
    "safetyLab.cat.inappropriate_instructions": "Inappropriate instructions",
    "safetyLab.cat.jailbreak": "Prompt injection",
    "safetyLab.cat.off_topic": "Off-topic",
    "safetyLab.cat.other": "Other safety checks",
    "safetyLab.cat.personal_data": "Personal information",
    "safetyLab.cat.self_harm": "Self-harm",
    "safetyLab.cat.sexual": "Inappropriate sexual content",
    "safetyLab.cat.violence": "Violence",
    "safetyLab.chartEmpty": "When more audits exist, you will see the trend here.",
    "safetyLab.chartOutcomes": "How the latest audit went",
    "safetyLab.chartTrend": "Recent audit trend",
    "safetyLab.historyEmpty": "No completed audits yet.",
    "safetyLab.historyTitle": "Recent history",
    "safetyLab.languages": "Test languages",
    "safetyLab.lastTested": "Latest audit",
    "safetyLab.legendCritical": "Critical: high risk; treated as top priority.",
    "safetyLab.legendFail": "Failed: something did not behave as it should — we fix it.",
    "safetyLab.legendPass": "Passed: the safety filter behaved as expected.",
    "safetyLab.legendTitle": "What the results mean",
    "safetyLab.legendWarning": "Warning: often a false positive (too strict on a harmless message), not a risk to children.",
    "safetyLab.loadFailed": "Could not load safety audits.",
    "safetyLab.loading": "Loading the latest audits…",
    "safetyLab.method1": "The core check is the Safety Gate — the same filter that intercepts in-game messages (input and, in some cases, output). Each test scenario sends a message (or a short sequence) and checks whether the filter allows, redirects, or blocks as expected.",
    "safetyLab.method2": "In the full suite we test every AI character a child can talk to: surface pond (crab, frog, magpie, prudent duck, mole, Loris, beaver), underground (axolotl, bat, hedgehog, blind shrimp, badger, mole), and tutors (pelican, scholarly duck). There are also faster “quick” runs with only one character and one age band per scenario: the hosts listed above always reflect only what that run actually executed.",
    "safetyLab.method3": "Scenarios cover sensitive topics and bypass attempts: inappropriate sexual content, violence, self-harm, abuse, drugs, hate, personal data, dangerous instructions, prompt manipulation (jailbreak), off-topic chat, and also benign or supportive cases that must remain allowed. Many scenarios run in multiple languages (up to it, en, fr, es, pt, de, nl) and across age bands.",
    "safetyLab.method4": "Each case gets an outcome: passed, warning, failed, or critical. A warning often means a false positive (the filter was too strict on a harmless message), not a risk to children. A fail or critical means something did not behave as it should and needs fixing. We always show the latest completed run, even if it is not green: we never replace a bad result with an older good one.",
    "safetyLab.method5": "To avoid helping anyone bypass protections, we do not publish attack texts, jailbreak recipes, or full transcripts. Publicly you see aggregates, categories, and dates; technical details stay internal.",
    "safetyLab.method6": "The scenario library grows over time: when we find a weakness, we add a regression case and keep it. If no audit has completed yet, we say so clearly (“not yet tested”).",
    "safetyLab.methodIntro": "YOBY runs automatic safety audits on the AI that talks with children. We do not invent the numbers: every figure on this page comes from a real run saved in our system. Below we explain what we do, what we measure, and what we deliberately do not show.",
    "safetyLab.methodTitle": "How the tests are run",
    "safetyLab.metricCritical": "Critical",
    "safetyLab.metricExecuted": "Cases checked",
    "safetyLab.metricFail": "Failed",
    "safetyLab.metricPass": "Passed",
    "safetyLab.metricPassRate": "Pass rate",
    "safetyLab.metricWarning": "Warnings",
    "safetyLab.never": "Not run yet",
    "safetyLab.noteParents": "This page is meant for parents and teachers. You can check it anytime: it is a public account of the latest audits, not a marketing page with invented numbers.",
    "safetyLab.npcs": "AI characters covered",
    "safetyLab.plainLead": "YOBY continuously stress-tests its AI characters, like a safety audit. Here you see the latest outcome — without technical attack details.",
    "safetyLab.statusCritical": "Serious issues found",
    "safetyLab.statusError": "Latest audit did not finish",
    "safetyLab.statusIssues": "Some items need attention",
    "safetyLab.statusNever": "No audit available yet",
    "safetyLab.statusPass": "All clear",
    "safetyLab.subtitle": "Real results from automatic checks on the AI that talks with children — written for parents and teachers.",
    "safetyLab.thCases": "Cases",
    "safetyLab.thDate": "Date",
    "safetyLab.thStatus": "Outcome",
    "safetyLab.title": "Latest AI safety audits",
    "footer.col.genderEquality": "Gender Equality",
    "dash.booking.gcalRefreshHint": "After a booking, use “Refresh calendar” if the event is missing on Google.",
    "dash.conference.delivery.title": "Email delivery",
    "dash.conference.delivery.untracked": "Result unavailable",
    "dash.conference.delivery.invite": "Invitation",
    "dash.conference.delivery.reschedule": "Reschedule",
    "dash.conference.delivery.reminder": "Reminder",
    "dash.conference.delivery.pending": "Preparing",
    "dash.conference.delivery.accepted": "Accepted by Mailgun",
    "dash.conference.delivery.delivered": "Delivered to recipient server",
    "dash.conference.delivery.deferred": "Temporarily delayed",
    "dash.conference.delivery.failed": "Sending or delivery failed",
    "dash.conference.delivery.dry_run": "Simulated, not sent",
    "dash.conference.delivery.confirmation": "Your attendance is confirmed",
    "footer.col.accessibility": "Accessibility",
    "accessibility.title": "Accessibility at YOBY",
    "accessibility.intro": "We want YOBY information to be easier to read and use. This page explains the tools available on the website and the current limitations of the game.",
    "accessibility.site.title": "The information website",
    "accessibility.site.body": "Website pages provide text content, navigation links and a panel for adjusting the display. You can adapt your reading experience and reach the main content through a keyboard link.",
    "accessibility.site.status": "These features provide support, rather than a guarantee of full accessibility. The widget alone does not establish overall conformance with accessibility standards; we have not completed a comprehensive review of every page, form and integrated service.",
    "accessibility.preferences.title": "Adjust the display",
    "accessibility.preferences.body": "Open the panel using the Accessibility icon in the navigation bar, or Alt+Shift+A on Windows/Linux and ⌥ Option+Shift+A on Mac. Changes apply immediately to website pages.",
    "accessibility.preferences.contrast": "High contrast: increases the visual contrast of the page.",
    "accessibility.preferences.invert": "Invert colors: reverses background and content colors, including images.",
    "accessibility.preferences.size": "Larger text: cycles between normal, large and extra large text.",
    "accessibility.preferences.spacing": "Text spacing: increases reading space in supported content.",
    "accessibility.preferences.focus": "Highlight focus: makes the control selected with the keyboard more visible.",
    "accessibility.preferences.links": "Underline links: adds an underline to links.",
    "accessibility.preferences.motion": "Reduce motion: reduces page animations and transitions.",
    "accessibility.preferences.font": "Readable font: uses a system sans-serif font.",
    "accessibility.preferences.storage": "Preferences are saved in this browser’s local storage and the widget does not send them to YOBY. Use “Reset to defaults” to clear them. They do not sync across devices; saving may be unavailable if the browser blocks local storage.",
    "accessibility.keyboard.title": "Using the keyboard",
    "accessibility.keyboard.body": "The first Tab reveals the “Skip to content” link. Use Tab and Shift+Tab to move between controls, and Enter or Space to activate buttons. Focus stays within the panel while it is open; Esc closes it and returns focus to where you opened it.",
    "accessibility.game.title": "The game: current limitations",
    "accessibility.game.body": "The game is a visual, interactive experience separate from the information website. We do not currently present it as fully accessible and cannot guarantee full use with screen readers or a keyboard alone.",
    "accessibility.game.limits": "Website preferences do not make the game world accessible and do not automatically apply to the 3D scene, interactions or all game controls. Embedded services, such as sign-in and registration panels, may also have their own behavior and limitations. If you encounter a barrier, contact us: we can record the issue and consider how to help, without promising that an equivalent version of every activity is already available.",
    "accessibility.feedback.title": "Report a difficulty",
    "accessibility.feedback.body": "To help us understand the issue, include the page or feature, what you were trying to do, your device and browser and, where relevant, the assistive technology used. You do not need to share a diagnosis or other health information.",
    "accessibility.feedback.contact": "Contact us about accessibility",
    "auth.a11y.email": "Email address",
    "auth.a11y.subscribe": "Sign up",
    "auth.a11y.sent": "Email sent. Check your inbox to continue.",
    "auth.a11y.termsRequired": "Please accept the terms to continue.",
    "auth.a11y.close": "Close popup",
    "auth.a11y.account": "YOBY account",
    "auth.a11y.sending": "Sending…"
  },
  "de": {
    "blog.title": "Blog",
    "dash.admin.approveSignup": "Approve",
    "dash.admin.errArchive": "Schule konnte nicht archiviert werden.",
    "dash.admin.errAssign": "Personal konnte nicht zugewiesen werden.",
    "dash.admin.errCreateSchool": "Schule konnte nicht erstellt werden.",
    "dash.admin.errDenied": "Zugriff verweigert. Als YOBY-Admin anmelden.",
    "dash.admin.errRoleNotAllowed": "Rolle nicht erlaubt.",
    "dash.admin.errSaveSchool": "Schule konnte nicht gespeichert werden.",
    "dash.admin.errSignupApprove": "Could not approve the application.",
    "dash.admin.errSignupLoad": "Could not load school applications.",
    "dash.admin.errSignupReject": "Could not reject the application.",
    "dash.admin.errUserNotFound": "Benutzer nicht gefunden.",
    "dash.admin.linkAdminSafety": "Neueste KI-Sicherheitsaudits",
    "dash.admin.linkMassmail": "Schulen-Massmail",
    "dash.admin.linkPlay": "Familienspiel",
    "dash.admin.linkRedteam": "AI Red Team",
    "dash.admin.linkStatus": "Spielstatus",
    "dash.admin.linkSupervisor": "Supervisor-Dashboard",
    "dash.admin.linkTeacher": "Lehrkräfte-Dashboard",
    "dash.admin.noSignups": "No school applications.",
    "dash.admin.noStaff": "Noch kein Personal.",
    "dash.admin.panelSchoolsForm": "Schulen anlegen / bearbeiten",
    "dash.admin.panelSchoolsList": "Schulliste",
    "dash.admin.panelSignups": "Schulanmeldungen",
    "dash.admin.panelStaffForm": "Personal anlegen / bearbeiten",
    "dash.admin.panelStaffList": "Personalliste",
    "dash.admin.quickLinks": "Schnelllinks",
    "dash.admin.rejectReason": "Rejection reason",
    "dash.admin.rejectSignup": "Reject",
    "dash.admin.schoolListHint": "Zeile anklicken zum Bearbeiten. Archivieren fragt nach Bestätigung.",
    "dash.admin.selectSchool": "Schule auswählen",
    "dash.admin.signupClasses": "Classes",
    "dash.admin.signupTeachers": "Teachers",
    "dash.admin.staffListHint": "Zeile anklicken, um Zuweisung und Rolle zu aktualisieren.",
    "dash.admin.statusAssigned": "Personal zugewiesen.",
    "dash.admin.statusAssigning": "Personal wird zugewiesen…",
    "dash.admin.statusCreatingSchool": "Schule wird erstellt…",
    "dash.admin.statusEditingSchool": "Schule bearbeiten — Felder ändern und speichern.",
    "dash.admin.statusEditingStaff": "Staff bearbeiten — aktualisieren und zuweisen.",
    "dash.admin.statusSavingSchool": "Schule wird gespeichert…",
    "dash.admin.statusSchoolCreated": "Schule erstellt.",
    "dash.admin.statusSchoolSaved": "Schule gespeichert.",
    "dash.admin.subtitle": "Schulen anlegen und Lehrkräfte sowie Supervisor zuweisen. YOBY-Admin-Anmeldung erforderlich (E-Mail in ADMIN_EMAILS).",
    "dash.admin.surveyAssignStaff": "Personal zuweisen",
    "dash.admin.surveyCreateSchool": "Schule erstellen",
    "dash.admin.surveySaveSchool": "Schule speichern",
    "dash.admin.surveySchoolDesc": "Eine Schule im YOBY-Modul registrieren.",
    "dash.admin.surveySchoolName": "Schulname",
    "dash.admin.surveySchoolSlug": "Slug (optional)",
    "dash.admin.surveySchoolTitle": "Neue Schule",
    "dash.admin.surveyStaffDesc": "Lehrkräfte und Supervisor einer Schule zuordnen.",
    "dash.admin.surveyStaffEmail": "E-Mail des Personals",
    "dash.admin.surveyStaffForce": "Zuweisung erzwingen",
    "dash.admin.surveyStaffForceDesc": "Neu zuweisen, auch wenn der Benutzer bereits einer anderen Schule angehört.",
    "dash.admin.surveyStaffRoleSupervisor": "Supervisor",
    "dash.admin.surveyStaffRoleTeacher": "Lehrkraft",
    "dash.admin.surveyStaffSchool": "Schule",
    "dash.admin.surveyStaffTitle": "Personal zuweisen",
    "dash.admin.surveyUpdateStaff": "Staff aktualisieren",
    "dash.admin.tabSchoolsForm": "Schulen anlegen / bearbeiten",
    "dash.admin.tabSchoolsList": "Schulliste",
    "dash.admin.tabSignups": "Schulanmeldungen",
    "dash.admin.tabStaffForm": "Personal anlegen / bearbeiten",
    "dash.admin.tabStaffList": "Personalliste",
    "dash.admin.tabsAria": "Schul-Administration",
    "dash.admin.title": "YOBY Schul-Admin",
    "dash.booking.active": "Öffentliche Buchungen aktiv",
    "dash.booking.addEmail": "E-Mail hinzufügen",
    "dash.booking.addHour": "Zeitraum hinzufügen",
    "dash.booking.attribution": "Wie sie uns gefunden haben",
    "dash.booking.availabilityHint": "Öffentliche Buchungen unter /talk-with-us/ aktivieren. Zeiten innerhalb Mo–Fr 09:00–19:00. Einzelne Tage unten sperren.",
    "dash.booking.availabilityTitle": "Öffentliche Verfügbarkeit",
    "dash.booking.availableSlots": "Verfügbare Zeiten",
    "dash.booking.blockDate": "Sperren",
    "dash.booking.blockReason": "Grund",
    "dash.booking.blockReasonPlaceholder": "Grund (optional)",
    "dash.booking.blockedDatesHint": "Keine Slots an diesen Tagen.",
    "dash.booking.blockedDatesTitle": "Gesperrte Tage",
    "dash.booking.blockedEmpty": "Keine gesperrten Tage.",
    "dash.booking.blockedOn": "Datum",
    "dash.booking.blockedSaved": "Tag gesperrt.",
    "dash.booking.booking": "Buchung…",
    "dash.booking.bufferMinutes": "Puffer zwischen Slots (Minuten)",
    "dash.booking.calFreeDays": "Tage mit freien Terminen",
    "dash.booking.cancel": "Absagen",
    "dash.booking.cancelConfirm": "Diese Buchung absagen?",
    "dash.booking.cancelled": "abgesagt",
    "dash.booking.cancelledOk": "Buchung abgesagt.",
    "dash.booking.confirm": "Buchen",
    "dash.booking.confirmTitle": "Buchung bestätigen",
    "dash.booking.copyLink": "Link kopieren",
    "dash.booking.detailTitle": "Buchungsdetail",
    "dash.booking.doneBody": "Wir haben dir den Link per E-Mail geschickt. Nutze ihn am Tag des Calls.",
    "dash.booking.doneLinkHint": "Falls die E-Mail nicht ankommt, ist das dein persönlicher Link:",
    "dash.booking.doneStatus": "Schau auch im Posteingang nach.",
    "dash.booking.doneTitle": "Buchung bestätigt",
    "dash.booking.emailsHint": "Bis zu 3 E-Mails — jede erhält einen persönlichen Link.",
    "dash.booking.empty": "Keine Buchungen oder geplanten Calls.",
    "dash.booking.errBlockDate": "Ungültiges Datum.",
    "dash.booking.errBlockExists": "Tag bereits gesperrt.",
    "dash.booking.errBook": "Buchung fehlgeschlagen.",
    "dash.booking.errCancel": "Absagen fehlgeschlagen.",
    "dash.booking.errEmails": "Mindestens eine gültige E-Mail eingeben.",
    "dash.booking.errLoad": "Buchungen konnten nicht geladen werden.",
    "dash.booking.errLoadSlots": "Slots konnten nicht geladen werden.",
    "dash.booking.errPickSlot": "Bitte wählen Sie zuerst eine Uhrzeit oben.",
    "dash.booking.errReschedule": "Verschieben nicht möglich.",
    "dash.booking.errSave": "Speichern fehlgeschlagen.",
    "dash.booking.errSlotTaken": "Dieser Slot ist nicht mehr verfügbar.",
    "dash.booking.errTooManyEmails": "Maximal 3 E-Mails pro Buchung.",
    "dash.booking.errUnblock": "Freigabe fehlgeschlagen.",
    "dash.booking.errUrl": "Dieser Link sieht nicht nach einer gültigen Webadresse aus.",
    "dash.booking.formOptionalHint": "Alle Felder unten sind optional. Sie können uns ein wenig über sich erzählen — oder einfach vorbeischauen und Hallo sagen. Den Rest klären wir gemeinsam.",
    "dash.booking.gcalCalendar": "Zielkalender",
    "dash.booking.gcalConnect": "Google Calendar verbinden",
    "dash.booking.gcalConnectFailed": "Google Calendar konnte nicht verbunden werden.",
    "dash.booking.gcalConnected": "Google Calendar verbunden.",
    "dash.booking.gcalDisconnect": "Trennen",
    "dash.booking.gcalDisconnectConfirm": "Google Calendar trennen?",
    "dash.booking.gcalDisconnected": "Google Calendar getrennt.",
    "dash.booking.gcalMissing": "Bereit — Verbinden klicken, um Google zu autorisieren (OAuth).",
    "dash.booking.gcalOk": "Google Calendar verbunden.",
    "dash.booking.gcalRedirectHint": "Diese Redirect-URI freigeben:",
    "dash.booking.gcalRefresh": "Kalender aktualisieren",
    "dash.booking.gcalRefreshConfirm": "Alle zukünftigen Termine in Google Calendar neu synchronisieren (korrekte Zeiten im YOBY-Kalender)?",
    "dash.booking.gcalRefreshEmpty": "Keine laufenden oder kommenden Termine zum Synchronisieren.",
    "dash.booking.gcalRefreshFailed": "Kalender-Aktualisierung fehlgeschlagen.",
    "dash.booking.gcalRefreshNeedReconnect": "Google Calendar nicht erreichbar: trennen, neu verbinden, dann erneut aktualisieren.",
    "dash.booking.gcalRefreshOk": "Kalender aktualisiert: {synced}/{total} Termine · {failed} Fehler · {calendar}",
    "dash.booking.gcalServerMissing": "OAuth-App fehlt auf dem Server: Google-Cloud-Client „Web application“ anlegen, GOOGLE_CALENDAR_CLIENT_ID/SECRET in .env setzen, API neu starten.",
    "dash.booking.gcalTitle": "Google Calendar",
    "dash.booking.inactive": "Öffentliche Buchungen sind derzeit nicht aktiv.",
    "dash.booking.introBody": "Wenn Sie uns lieber persönlich kennenlernen möchten statt ein Formular auszufüllen, können Sie direkt ein Gespräch mit dem YOBY-Team buchen. Wir zeigen Ihnen gerne das Projekt, beantworten Ihre Fragen und schauen gemeinsam, wie YOBY zu Ihrer Familie, Schule, Organisation oder Partnerschaftsidee passen könnte.",
    "dash.booking.introImageAlt": "Videoanruf mit dem YOBY-Team — Enten, die Englisch, Französisch und Italienisch sprechen",
    "dash.booking.introInterpreter": "Sprechen Sie eine andere Sprache? Kein Problem: unsere Conference-Call-Plattform übersetzt Ihre in unsere und umgekehrt.",
    "dash.booking.introLanguages": "Sie können mit uns auf Englisch, Italienisch oder Französisch sprechen: Ricardo und Stefano sprechen Italienisch und Englisch, während Antonella, unsere CRO, Französisch, Italienisch und Englisch spricht.",
    "dash.booking.introTitle": "Lieber sprechen?",
    "dash.booking.landingUrl": "Einstiegsseite",
    "dash.booking.linkLabel": "Ein Link, den wir vor dem Gespräch ansehen sollten",
    "dash.booking.linkPlaceholder": "https://…",
    "dash.booking.listHint": "Klicke eine Zeile, um Gäste und Links zu verwalten. Auch vom Admin geplante Calls erscheinen hier.",
    "dash.booking.listTitle": "Buchungen und geplante Calls",
    "dash.booking.noLinkedCall": "Diese Buchung hat keinen verknüpften Conference-Call.",
    "dash.booking.noSlots": "Keine freien Slots an diesem Tag.",
    "dash.booking.note": "Möchten Sie uns noch etwas mitteilen?",
    "dash.booking.notifyInvitees": "Eingeladene per E-Mail benachrichtigen (gleicher Link, neue Zeit)",
    "dash.booking.openCall": "Conference öffnen",
    "dash.booking.orgLabel": "Organisation / Projekt",
    "dash.booking.orgPlaceholder": "Schule, Unternehmen, Medium, Stiftung...",
    "dash.booking.pickDay": "Tag wählen",
    "dash.booking.prefLang.none": "Keine Präferenz",
    "dash.booking.prefLangLabel": "Bevorzugte Sprache",
    "dash.booking.publicSubtitle": "Wähle einen freien Slot. Du erhältst einen persönlichen Conference-Link.",
    "dash.booking.publicTitle": "YOBY-Call buchen",
    "dash.booking.referrer": "Referrer",
    "dash.booking.rescheduleHint": "Datum und Uhrzeit ändern. Persönliche Links bleiben gleich.",
    "dash.booking.rescheduleTitle": "Verschieben",
    "dash.booking.rescheduled": "Buchung verschoben. Die Links sind unverändert.",
    "dash.booking.rulesHint": "Feste Regeln: mind. 48 Std. Vorlauf, Mo–Fr 09:00–19:00 (Europe/Rome).",
    "dash.booking.save": "Verfügbarkeit speichern",
    "dash.booking.saveCall": "Neue Zeit speichern",
    "dash.booking.saved": "Verfügbarkeit gespeichert.",
    "dash.booking.saving": "Speichern…",
    "dash.booking.slotMinutes": "Slot-Dauer (Minuten)",
    "dash.booking.sourceAdmin": "Geplanter Call",
    "dash.booking.status": "Status",
    "dash.booking.statusCancelled": "storniert",
    "dash.booking.statusDone": "erledigt",
    "dash.booking.statusExpired": "abgelaufen",
    "dash.booking.statusLive": "läuft",
    "dash.booking.statusUpcoming": "kommend",
    "dash.booking.timezone": "Deine Zeitzone",
    "dash.booking.timezoneHint": "Die freien Zeiten werden in der gewählten Zeitzone angezeigt. YOBY-Verfügbarkeit: Mo–Fr 09:00–19:00 (Europe/Rome).",
    "dash.booking.topic.banking_fintech": "Banking & Fintech",
    "dash.booking.topic.families": "YOBY für Familien",
    "dash.booking.topic.financial_education": "Finanzbildung",
    "dash.booking.topic.investment": "Investment",
    "dash.booking.topic.other": "Etwas anderes",
    "dash.booking.topic.partnership": "Partnerschaft",
    "dash.booking.topic.press": "Presse & Interviews",
    "dash.booking.topic.research": "Forschung",
    "dash.booking.topic.school_pilot": "Schulpilot",
    "dash.booking.topicsLabel": "Worüber möchten Sie sprechen?",
    "dash.booking.unblockDate": "Freigeben",
    "dash.booking.unblocked": "Tag freigegeben.",
    "dash.booking.utm": "Kampagne (UTM)",
    "dash.booking.weekday0": "Sonntag",
    "dash.booking.weekday1": "Montag",
    "dash.booking.weekday2": "Dienstag",
    "dash.booking.weekday3": "Mittwoch",
    "dash.booking.weekday4": "Donnerstag",
    "dash.booking.weekday5": "Freitag",
    "dash.booking.weekday6": "Samstag",
    "dash.booking.weeklyHours": "Wochenzeiten",
    "dash.booking.who.bank": "Bank oder Finanzinstitut",
    "dash.booking.who.curious": "Nur neugierig",
    "dash.booking.who.educator": "Lehrkraft oder Schule",
    "dash.booking.who.empty": "Wählen Sie, wenn Sie möchten…",
    "dash.booking.who.foundation": "Stiftung oder NGO",
    "dash.booking.who.investor": "Investor:in",
    "dash.booking.who.journalist": "Journalist:in",
    "dash.booking.who.other": "Sonstiges",
    "dash.booking.who.parent": "Elternteil",
    "dash.booking.who.public": "Öffentliche Einrichtung",
    "dash.booking.who.startup": "Startup oder Unternehmen",
    "dash.booking.whoLabel": "Wer sind Sie?",
    "dash.booking.yourEmail": "Deine E-Mail",
    "dash.booking.yourEmails": "E-Mails der Gäste",
    "dash.booking.yourName": "Dein Name",
    "dash.common.actions": "Aktionen",
    "dash.common.actor": "Akteur",
    "dash.common.archive": "Archivieren",
    "dash.common.assignments": "Aufgaben",
    "dash.common.attempts": "Versuche",
    "dash.common.avg": "Durchschnitt",
    "dash.common.cancel": "Abbrechen",
    "dash.common.class": "Klasse",
    "dash.common.classes": "Klassen",
    "dash.common.code": "Code",
    "dash.common.confirm": "Bestätigen",
    "dash.common.confirmArchiveSchool": "Diese Schule archivieren?",
    "dash.common.confirmTitle": "Bestätigung",
    "dash.common.copyCode": "Code kopieren",
    "dash.common.csvDownloaded": "CSV heruntergeladen",
    "dash.common.difficulty": "Schwierigkeit",
    "dash.common.email": "E-Mail",
    "dash.common.entity": "Entität",
    "dash.common.exportCsv": "CSV exportieren",
    "dash.common.family": "Familie",
    "dash.common.lastAccess": "Letzter Zugriff",
    "dash.common.loading": "Wird geladen…",
    "dash.common.name": "Name",
    "dash.common.newCode": "Neuer Code",
    "dash.common.none": "—",
    "dash.common.ok": "OK",
    "dash.common.open": "Öffnen",
    "dash.common.questions": "Fragen",
    "dash.common.quiz": "Quiz",
    "dash.common.refresh": "Aktualisieren",
    "dash.common.role": "Rolle",
    "dash.common.school": "Schule",
    "dash.common.select": "Auswählen",
    "dash.common.slug": "Slug",
    "dash.common.status": "Status",
    "dash.common.students": "Schüler",
    "dash.common.teachers": "Lehrkräfte",
    "dash.common.topic": "Thema",
    "dash.common.updated": "Aktualisiert",
    "dash.common.when": "Wann",
    "dash.common.year": "Jahrgang",
    "dash.conference.addInvitee": "Gast hinzufügen",
    "dash.conference.addInviteeHint": "Erhält eine Ente und einen persönlichen Link. Die Einladung kann sofort per E-Mail gehen.",
    "dash.conference.addInviteeTitle": "Gast hinzufügen",
    "dash.conference.addingInvitee": "Wird hinzugefügt…",
    "dash.conference.back": "Zur Liste",
    "dash.conference.chat": "Chat",
    "dash.conference.confirmed": "Zugesagt",
    "dash.conference.confirmedNo": "Offen",
    "dash.conference.confirmedYes": "Ja",
    "dash.conference.copied": "Link kopiert.",
    "dash.conference.copiedShort": "Kopiert!",
    "dash.conference.copyLink": "Link kopieren",
    "dash.conference.create": "Call erstellen",
    "dash.conference.createImmediate": "Sofort-Conference erstellen",
    "dash.conference.createImmediateHint": "Nur der Call-/Familienname ist nötig. Erstellt einen offenen Link bis Mitternacht (Europe/Rome).",
    "dash.conference.created": "Call erstellt.",
    "dash.conference.createdImmediate": "Offene Conference erstellt — einen Link teilen. Gültig für den Rest des Tages.",
    "dash.conference.creating": "Wird erstellt…",
    "dash.conference.detailTitle": "Einladungslinks",
    "dash.conference.editHint": "Du kannst Datum, Uhrzeit, Name und Sprache ändern. Die Zugangslinks bleiben gleich.",
    "dash.conference.editTitle": "Call verschieben",
    "dash.conference.email": "Email",
    "dash.conference.emailDryRun": "E-Mail Dry-Run (nicht gesendet).",
    "dash.conference.emailSent": "Von Mailgun angenommen.",
    "dash.conference.empty": "Noch keine Conference Calls.",
    "dash.conference.emptyInvitees": "Noch keine Gäste.",
    "dash.conference.ended": "Call beendet.",
    "dash.conference.errAddInvitee": "Gast konnte nicht hinzugefügt werden. E-Mail und Name prüfen.",
    "dash.conference.errCallEnded": "Der Call ist beendet; keine weiteren Gäste möglich.",
    "dash.conference.errCopy": "Link konnte nicht kopiert werden.",
    "dash.conference.errCreate": "Call konnte nicht erstellt werden.",
    "dash.conference.errDenied": "Zugriff verweigert. Als YOBY-Admin anmelden.",
    "dash.conference.errDuplicateInvitee": "Diese E-Mail ist bereits zu diesem Call eingeladen.",
    "dash.conference.errEmail": "E-Mail konnte nicht gesendet werden.",
    "dash.conference.errLoad": "Conference Calls konnten nicht geladen werden.",
    "dash.conference.errSave": "Änderungen konnten nicht gespeichert werden.",
    "dash.conference.errWorldFull": "Conference-Welt voll: keine freien Teiche mehr.",
    "dash.conference.familyName": "Familienname",
    "dash.conference.firstName": "Vorname",
    "dash.conference.gameLocale": "Spielsprache",
    "dash.conference.inviteeAdded": "Gast hinzugefügt.",
    "dash.conference.inviteeCount": "Gäste",
    "dash.conference.invitees": "Gäste",
    "dash.conference.lastName": "Nachname",
    "dash.conference.listTitle": "Geplante Calls",
    "dash.conference.mediaHealth.checking": "Prüfe Janus und Coturn…",
    "dash.conference.mediaHealth.coturn": "Coturn (TURN)",
    "dash.conference.mediaHealth.down": "DOWN",
    "dash.conference.mediaHealth.errLoad": "Videostatus konnte nicht gelesen werden.",
    "dash.conference.mediaHealth.hintDown": "Call nicht starten: WebRTC-Video ist nicht bereit.",
    "dash.conference.mediaHealth.hintOk": "Janus und TURN sind erreichbar. Der Call kann starten.",
    "dash.conference.mediaHealth.janus": "Janus",
    "dash.conference.mediaHealth.ok": "OK",
    "dash.conference.mediaHealth.title": "Videostatus (live)",
    "dash.conference.notifyInvitees": "Eingeladene per E-Mail benachrichtigen (gleicher Link, neue Zeit)",
    "dash.conference.openCallBadge": "offener Link",
    "dash.conference.openCallHint": "Jeder mit diesem Link kann beitreten (jeder bekommt eine eigene Ente).",
    "dash.conference.phase": "Phase",
    "dash.conference.refresh": "Aktualisieren",
    "dash.conference.save": "Änderungen speichern",
    "dash.conference.saveTranscript": "PDF speichern",
    "dash.conference.saved": "Call aktualisiert. Die Links sind unverändert.",
    "dash.conference.saving": "Speichern…",
    "dash.conference.sendEmail": "E-Mail senden",
    "dash.conference.sendEmailOnAdd": "Einladungs-E-Mail senden",
    "dash.conference.sendingEmail": "Senden…",
    "dash.conference.speech": "Sprache",
    "dash.conference.startsAt": "Startzeit (Europe/Rome)",
    "dash.conference.startsAtHint": "Gib die Zeit in der YOBY-Zeitzone (Europe/Rome) ein, nicht in der des Browsers.",
    "dash.conference.subtitle": "Erstelle eine private YOBY-Welt für einen geplanten Call. Gäste erhalten eine Ente und einen persönlichen Link.",
    "dash.conference.tabAvailability": "Verfügbarkeit",
    "dash.conference.tabBookings": "Buchungen",
    "dash.conference.tabCalls": "Geplante Calls",
    "dash.conference.tabCreate": "Call erstellen",
    "dash.conference.tabsAria": "Conference-Bereiche",
    "dash.conference.title": "Conference Call",
    "dash.conference.transcript": "Transkript",
    "dash.conference.transcriptDisabledNote": "Transkription auf Wunsch eines Teilnehmers deaktiviert.",
    "dash.conference.transcriptEmpty": "Noch kein Transkript.",
    "dash.conference.transcriptSaved": "PDF gespeichert.",
    "dash.difficulty.easy": "Leicht",
    "dash.difficulty.hard": "Schwer",
    "dash.difficulty.medium": "Mittel",
    "dash.liveInterpreter.callMetrics": "Live Interpreter usage",
    "dash.liveInterpreter.callMetricsBody": "Call {callMin} min · translated {liMin} min · languages: {langs} · listeners: {listeners} · ≈ €{eur}",
    "dash.liveInterpreter.criticalPct": "Critical threshold (%)",
    "dash.liveInterpreter.enabled": "Live Interpreter aktivieren (nur kommerzielle Calls)",
    "dash.liveInterpreter.enabledDesc": "Master-Schalter für kommerzielle Calls. Aktiviert nie die Teich-Videochats im Spiel.",
    "dash.liveInterpreter.envOff": "Env kill-switch is OFF",
    "dash.liveInterpreter.errLoad": "Could not load interpreter settings.",
    "dash.liveInterpreter.errSave": "Could not save interpreter settings.",
    "dash.liveInterpreter.hint": "Simultanübersetzung nur für kommerzielle Konferenzen. Nie für Teich-Video.",
    "dash.liveInterpreter.monthUsage": "Month {month}: {used} / {limit} min · ≈ €{eur} · {calls} calls · {status}",
    "dash.liveInterpreter.monthlyLimit": "Monatslimit (übersetzte Audiominuten)",
    "dash.liveInterpreter.providerMissing": "Azure Voice Live endpoint/API key missing in .env",
    "dash.liveInterpreter.providerOk": "Azure Voice Live configured",
    "dash.liveInterpreter.quotaBlocked": "Neue Übersetzungen blockiert",
    "dash.liveInterpreter.quotaCritical": "Critical",
    "dash.liveInterpreter.quotaOk": "OK",
    "dash.liveInterpreter.quotaWarn": "Warning",
    "dash.liveInterpreter.save": "Speichern",
    "dash.liveInterpreter.saved": "Einstellungen gespeichert.",
    "dash.liveInterpreter.tab": "Dolmetscher",
    "dash.liveInterpreter.testCall": "TEST — Übungs-Konferenz öffnen",
    "dash.liveInterpreter.testCallCreating": "Übungs-Konferenz wird erstellt…",
    "dash.liveInterpreter.testCallErr": "Übungs-Konferenz konnte nicht erstellt werden.",
    "dash.liveInterpreter.testCallHint": "Erstellt sofort eine offene Konferenz (öffentlicher Link) und öffnet sie in einem neuen Tab.",
    "dash.liveInterpreter.testCallOk": "Übungs-Konferenz bereit — in neuem Tab geöffnet.",
    "dash.liveInterpreter.title": "Live Interpreter",
    "dash.liveInterpreter.warnPct": "Warning threshold (%)",
    "dash.schoolSignup.addClass": "Add class",
    "dash.schoolSignup.addTeacher": "Add teacher",
    "dash.schoolSignup.alreadyBody": "This account is already linked to a school on YOBY.",
    "dash.schoolSignup.alreadyTitle": "Du bist bereits angemeldet",
    "dash.schoolSignup.back": "Zurück",
    "dash.schoolSignup.checkEmail": "Check your email and come back to this page after confirming.",
    "dash.schoolSignup.city": "City",
    "dash.schoolSignup.className": "Class name",
    "dash.schoolSignup.classTeacher": "Klassenlehrkraft",
    "dash.schoolSignup.classes": "Classes involved",
    "dash.schoolSignup.continue": "Continue",
    "dash.schoolSignup.country": "Country",
    "dash.schoolSignup.draftSaved": "Draft saved.",
    "dash.schoolSignup.email": "Principal’s email",
    "dash.schoolSignup.errClassTeacher": "Wählen Sie eine Lehrkraft aus dem vorherigen Schritt.",
    "dash.schoolSignup.errEmail": "Geben Sie eine gültige E-Mail-Adresse ein.",
    "dash.schoolSignup.errGeneric": "Something went wrong. Try again.",
    "dash.schoolSignup.errLocked": "The application has already been submitted.",
    "dash.schoolSignup.errLookup": "Could not check this email.",
    "dash.schoolSignup.errName": "Geben Sie Vor- und Nachname ein (mindestens 2 Zeichen).",
    "dash.schoolSignup.errPhone": "Telefon ist optional. Wenn Sie es angeben, nutzen Sie Ziffern, Leerzeichen oder +.",
    "dash.schoolSignup.errPrivacy": "Sie müssen den Datenschutzhinweis akzeptieren, um fortzufahren.",
    "dash.schoolSignup.errSave": "Could not save the draft.",
    "dash.schoolSignup.errSubmit": "Could not submit the application.",
    "dash.schoolSignup.errTeacherDup": "Jede Lehrkraft braucht eine eigene E-Mail-Adresse.",
    "dash.schoolSignup.errTeacherSelf": "Nutzen Sie nicht die E-Mail der Schulleitung: sie ist Supervisor, nicht Lehrkraft.",
    "dash.schoolSignup.errValidation": "Enter the school name, at least one teacher and one class.",
    "dash.schoolSignup.goDashboard": "Open dashboard",
    "dash.schoolSignup.helpAccount": "Legen Sie das Konto der Schulleitung mit Name, E-Mail und Datenschutz-Einwilligung an. Wir senden einen Bestätigungslink: öffnen Sie ihn und kehren Sie zu dieser Seite zurück. Wenn Sie schon ein YOBY-Konto haben, melden Sie sich an — keine zweite Registrierung.",
    "dash.schoolSignup.helpClassTeacher": "Wählen Sie die Lehrkraft dieser Klasse. Sie muss bereits in der Lehrkräfte-Liste stehen.",
    "dash.schoolSignup.helpClasses": "Jede Klasse hat eine Lehrkraft aus dem vorherigen Schritt. Nach der Freigabe legt YOBY die Klassen an und weist sie zu. Mindestens eine Klasse ist nötig.",
    "dash.schoolSignup.helpSchool": "Geben Sie die Schuldaten an, damit YOBY die Schule nach der Prüfung aktivieren kann. Telefon ist optional. In der Notiz können Sie Standorte, Zeiten oder anderes ergänzen.",
    "dash.schoolSignup.helpTeachers": "Listen Sie die Lehrkräfte, die YOBY nutzen. Sie erhalten nach der Freigabe eine Einladung. Tragen Sie nicht die E-Mail der Schulleitung ein: sie ist Supervisor, nicht Lehrkraft. Mindestens eine Lehrkraft ist nötig.",
    "dash.schoolSignup.introAlt": "Prefer a call with us?",
    "dash.schoolSignup.introBody": "The principal signs up, confirms the email, then lists teachers and classes. YOBY activates the school after a review.",
    "dash.schoolSignup.introTitle": "Schule anmelden",
    "dash.schoolSignup.knownBody": "This email is already registered. Sign in with the link we send you.",
    "dash.schoolSignup.knownTitle": "Du bist bereits angemeldet",
    "dash.schoolSignup.locale": "Working language",
    "dash.schoolSignup.name": "Principal’s name",
    "dash.schoolSignup.note": "Note (optional)",
    "dash.schoolSignup.openDashboard": "Go to dashboard",
    "dash.schoolSignup.pendingBody": "We received the application for {school}. We’ll email you when it’s active.",
    "dash.schoolSignup.pendingTitle": "Waiting for approval",
    "dash.schoolSignup.phone": "Phone (optional)",
    "dash.schoolSignup.privacy": "I accept the privacy notice and to share the listed teachers’ emails.",
    "dash.schoolSignup.rejectedBody": "The previous application was not approved. Reason: {reason}",
    "dash.schoolSignup.rejectedTitle": "Application not approved",
    "dash.schoolSignup.saveDraft": "Save draft",
    "dash.schoolSignup.schoolName": "School name",
    "dash.schoolSignup.signIn": "Anmelden",
    "dash.schoolSignup.signUp": "Registrieren und E-Mail bestätigen",
    "dash.schoolSignup.stepAccount": "Konto",
    "dash.schoolSignup.stepAccountTitle": "Konto",
    "dash.schoolSignup.stepClassesTitle": "Klassen",
    "dash.schoolSignup.stepSchool": "Schule",
    "dash.schoolSignup.stepSchoolTitle": "Schule",
    "dash.schoolSignup.stepTeachersTitle": "Lehrkräfte",
    "dash.schoolSignup.submit": "Antrag senden",
    "dash.schoolSignup.submitted": "Application sent.",
    "dash.schoolSignup.talkWithUs": "Book a call",
    "dash.schoolSignup.teacherEmail": "Teacher email",
    "dash.schoolSignup.teacherName": "Teacher name",
    "dash.schoolSignup.teachers": "Teachers",
    "dash.status.ageBand.11-15": "11–15",
    "dash.status.ageBand.16-17": "16–17",
    "dash.status.ageBand.18-26": "18–26",
    "dash.status.ageBand.8-10": "8–10",
    "dash.status.ageBand.adult": "Erwachsene",
    "dash.status.ageBand.unknown": "Ohne Altersgruppe",
    "dash.status.analytics.events.arcade_completed.description": "Arcade activity ends",
    "dash.status.analytics.events.arcade_completed.label": "Arcade completed",
    "dash.status.analytics.events.arcade_started.description": "Crazy Run or arcade activity starts",
    "dash.status.analytics.events.arcade_started.label": "Arcade started",
    "dash.status.analytics.events.child_access_started.description": "Child enters via link or parent",
    "dash.status.analytics.events.child_access_started.label": "Child access started",
    "dash.status.analytics.events.child_first_claim_email_sent.description": "Transaktionale Claim-E-Mail an die Eltern gesendet",
    "dash.status.analytics.events.child_first_claim_email_sent.label": "Freischalt-E-Mail gesendet",
    "dash.status.analytics.events.child_first_claim_opened.description": "Eltern öffnen die Vorschau des /claim-Links",
    "dash.status.analytics.events.child_first_claim_opened.label": "Freischalt-Link geöffnet",
    "dash.status.analytics.events.child_first_claimed.description": "Eltern schalten die pending Ente in die Familie frei",
    "dash.status.analytics.events.child_first_claimed.label": "Ente freigeschaltet",
    "dash.status.analytics.events.child_first_family_activated.description": "Familie spielbereit nach Child-first-Claim",
    "dash.status.analytics.events.child_first_family_activated.label": "Child-first-Familie aktiviert",
    "dash.status.analytics.events.child_first_parent_email_submitted.description": "Kind gibt die E-Mail der Eltern/des Vormunds an",
    "dash.status.analytics.events.child_first_parent_email_submitted.label": "Eltern-E-Mail übermittelt",
    "dash.status.analytics.events.child_first_started.description": "Kind startet Meine Ente erstellen",
    "dash.status.analytics.events.child_first_started.label": "Child-first gestartet",
    "dash.status.analytics.events.child_profile_created.description": "A child character profile is created",
    "dash.status.analytics.events.child_profile_created.label": "Child profile created",
    "dash.status.analytics.events.collectible_obtained.description": "An item is collected",
    "dash.status.analytics.events.collectible_obtained.label": "Collectible obtained",
    "dash.status.analytics.events.family_activation_completed.description": "Adult, child and first access exist",
    "dash.status.analytics.events.family_activation_completed.label": "Family activated",
    "dash.status.analytics.events.family_created.description": "A parent creates the family pond",
    "dash.status.analytics.events.family_created.label": "Family created",
    "dash.status.analytics.events.market_transaction.description": "Buy, sell or negotiate",
    "dash.status.analytics.events.market_transaction.label": "Market transaction",
    "dash.status.analytics.events.market_visited.description": "Access to the market",
    "dash.status.analytics.events.market_visited.label": "Market visited",
    "dash.status.analytics.events.mission_completed.description": "Mission finished",
    "dash.status.analytics.events.mission_completed.label": "Mission completed",
    "dash.status.analytics.events.mission_started.description": "A game mission begins",
    "dash.status.analytics.events.mission_started.label": "Mission started",
    "dash.status.analytics.events.parent_demo_converted.description": "Ein Elternteil beendet die Demo und legt ein Konto an",
    "dash.status.analytics.events.parent_demo_converted.label": "Familiendemo konvertiert",
    "dash.status.analytics.events.parent_demo_keep_prompt.description": "Hinweis zum Behalten der Ente angezeigt",
    "dash.status.analytics.events.parent_demo_keep_prompt.label": "Familiendemo: Ente behalten",
    "dash.status.analytics.events.parent_demo_parent_ui_complete.description": "Familien-Oberfläche durchlaufen",
    "dash.status.analytics.events.parent_demo_parent_ui_complete.label": "Familiendemo: UI fertig",
    "dash.status.analytics.events.parent_demo_started.description": "Start über den öffentlichen YOBY-Link für Familien",
    "dash.status.analytics.events.parent_demo_started.label": "Familiendemos",
    "dash.status.analytics.events.parent_demo_tour_complete.description": "Weltrundgang abgeschlossen",
    "dash.status.analytics.events.parent_demo_tour_complete.label": "Familiendemo: Tour fertig",
    "dash.status.analytics.events.quiz_assigned.description": "Teacher assigns a quiz",
    "dash.status.analytics.events.quiz_assigned.label": "Quiz assigned",
    "dash.status.analytics.events.quiz_completed.description": "Quiz finished",
    "dash.status.analytics.events.quiz_completed.label": "Quiz completed",
    "dash.status.analytics.events.quiz_started.description": "Child opens a quiz",
    "dash.status.analytics.events.quiz_started.label": "Quiz started",
    "dash.status.analytics.events.real_task_assigned.description": "Parent assigns a real-life chore",
    "dash.status.analytics.events.real_task_assigned.label": "Real task assigned",
    "dash.status.analytics.events.real_task_completed.description": "Child marks chore done",
    "dash.status.analytics.events.real_task_completed.label": "Real task done",
    "dash.status.analytics.events.real_task_validated.description": "Parent accepts or rejects",
    "dash.status.analytics.events.real_task_validated.label": "Real task validated",
    "dash.status.analytics.events.reward_claimed.description": "Child claims a reward",
    "dash.status.analytics.events.reward_claimed.label": "Reward claimed",
    "dash.status.analytics.events.reward_distributed.description": "Parent allocates a reward",
    "dash.status.analytics.events.reward_distributed.label": "Reward distributed",
    "dash.status.analytics.events.reward_earned.description": "A reward is granted",
    "dash.status.analytics.events.reward_earned.label": "Reward earned",
    "dash.status.analytics.events.session_ended.description": "Exit or inactivity",
    "dash.status.analytics.events.session_ended.label": "Session ended",
    "dash.status.analytics.events.session_started.description": "Someone enters the game",
    "dash.status.analytics.events.session_started.label": "Session started",
    "dash.status.analytics.events.shared_family_session.description": "Parent and child online together",
    "dash.status.analytics.events.shared_family_session.label": "Shared family session",
    "dash.status.analytics.events.subscription_cancelled.description": "Subscription cancelled",
    "dash.status.analytics.events.subscription_cancelled.label": "Subscription cancelled",
    "dash.status.analytics.events.subscription_started.description": "Family or Patron activated",
    "dash.status.analytics.events.subscription_started.label": "Subscription started",
    "dash.status.analytics.events.teacher_demo_converted.description": "Eine Lehrkraft beendet die Demo und legt ein Konto an",
    "dash.status.analytics.events.teacher_demo_converted.label": "Lehrkräftedemo konvertiert",
    "dash.status.analytics.events.teacher_demo_keep_prompt.description": "Hinweis zum Behalten der Ente angezeigt",
    "dash.status.analytics.events.teacher_demo_keep_prompt.label": "Lehrkräftedemo: Ente behalten",
    "dash.status.analytics.events.teacher_demo_started.description": "Start über den öffentlichen YOBY-Link für Lehrkräfte",
    "dash.status.analytics.events.teacher_demo_started.label": "Lehrkräftedemos",
    "dash.status.analytics.events.teacher_demo_teacher_ui_complete.description": "Lehrer-Oberfläche durchlaufen",
    "dash.status.analytics.events.teacher_demo_teacher_ui_complete.label": "Lehrkräftedemo: UI fertig",
    "dash.status.analytics.events.teacher_demo_tour_complete.description": "Weltrundgang abgeschlossen",
    "dash.status.analytics.events.teacher_demo_tour_complete.label": "Lehrkräftedemo: Tour fertig",
    "dash.status.analytics.events.temporary_link_generated.description": "A temporary play link is created",
    "dash.status.analytics.events.temporary_link_generated.label": "Temp link created",
    "dash.status.analytics.events.temporary_link_used.description": "A temporary link is redeemed",
    "dash.status.analytics.events.temporary_link_used.label": "Temp link used",
    "dash.status.charts.acq_age_doughnut.title": "Kinderprofile nach Altersgruppe",
    "dash.status.charts.acq_child_first_funnel.title": "Child-first-Enten-Funnel",
    "dash.status.charts.acq_child_first_trend.title": "Child-first-Trend",
    "dash.status.charts.acq_demo_bar.title": "Demos über öffentliche Links",
    "dash.status.charts.acq_demo_trend.title": "Demo-Link-Trend",
    "dash.status.charts.acq_funnel.title": "Acquisition funnel",
    "dash.status.charts.acq_plan_doughnut.title": "Subscription plans",
    "dash.status.charts.acq_trend_line.title": "Acquisition trend",
    "dash.status.charts.eco_age_doughnut.title": "Belohnungen nach Altersgruppe",
    "dash.status.charts.eco_arcade_line.title": "Arcade activity",
    "dash.status.charts.eco_chores_funnel.title": "Real tasks funnel",
    "dash.status.charts.eco_collectibles_line.title": "Collectibles",
    "dash.status.charts.eco_market_bar.title": "Market activity",
    "dash.status.charts.eco_reward_origin.title": "Reward origins",
    "dash.status.charts.eco_reward_volume.title": "Reward volume",
    "dash.status.charts.eng_access_doughnut.title": "Child access channels",
    "dash.status.charts.eng_age_doughnut.title": "Sitzungen nach Altersgruppe",
    "dash.status.charts.eng_device_bar.title": "Sessions by device",
    "dash.status.charts.eng_links_bar.title": "Temporary links",
    "dash.status.charts.eng_sessions_line.title": "Sessions by role",
    "dash.status.charts.eng_shared_line.title": "Shared family sessions",
    "dash.status.charts.learn_age_doughnut.title": "Abgeschlossene Quiz nach Altersgruppe",
    "dash.status.charts.learn_duration_bar.title": "Average duration",
    "dash.status.charts.learn_mission_host.title": "Missions by host",
    "dash.status.charts.learn_mission_trend.title": "Mission trend",
    "dash.status.charts.learn_quiz_funnel.title": "Quiz funnel",
    "dash.status.charts.learn_quiz_trend.title": "Quiz trend",
    "dash.status.charts.live_age_bar.title": "Online nach Altersgruppe",
    "dash.status.charts.live_realm_pie.title": "Online by realm",
    "dash.status.charts.live_role_bar.title": "Online by role",
    "dash.status.daysLabel": "Tage",
    "dash.status.errLoad": "Status konnte nicht geladen werden.",
    "dash.status.lastAccessTitle": "Letzter Zugriff",
    "dash.status.loading": "Wird geladen…",
    "dash.status.logAll": "Alle",
    "dash.status.logFilter": "Ereignis",
    "dash.status.refresh": "Aktualisieren",
    "dash.status.report.anonymized": "Anonymisierter Report: keine E-Mails oder Namen.",
    "dash.status.report.failed": "Erzeugung fehlgeschlagen. Erneut versuchen.",
    "dash.status.report.generate": "Report erzeugen",
    "dash.status.report.generating": "Wird erzeugt",
    "dash.status.report.impossible": "Report nicht möglich: noch keine Analytics-Daten im Zeitraum.",
    "dash.status.report.overviewTitle": "Gesamtkommentar",
    "dash.status.report.pdfAnalysisTitle": "Analyse",
    "dash.status.report.pdfChartsTitle": "Diagramme",
    "dash.status.report.pdfKpisTitle": "Kennzahlen",
    "dash.status.report.pdfPage": "Seite {n} von {total}",
    "dash.status.report.pdfPeriod": "Zeitraum: letzte {days} Tage",
    "dash.status.report.pdfTitle": "Yoby Analytics-Report",
    "dash.status.report.pdfUnavailable": "PDF-Bibliothek nicht verfügbar.",
    "dash.status.report.previewFailed": "PDF-Vorschau konnte nicht angezeigt werden.",
    "dash.status.report.previewPreparing": "PDF-Vorschau wird vorbereitet…",
    "dash.status.report.readyAt": "Erzeugt",
    "dash.status.report.savePdf": "PDF speichern",
    "dash.status.report.waiting": "Report wird erstellt… bitte warten.",
    "dash.status.sectionOnline": "Jetzt online",
    "dash.status.sectionOnlineAge": "Online nach Altersgruppe",
    "dash.status.sectionTotals": "Gesamt (ohne aktive Conference-Welten)",
    "dash.status.sectionTotalsAge": "Charaktere nach Altersgruppe",
    "dash.status.subtitle": "Spielpräsenz und Produkt-Analytics.",
    "dash.status.summaryChildren": "Kinder online",
    "dash.status.summaryFamilies": "Familien im Spiel",
    "dash.status.summaryInGame": "Im Spiel (gesamt)",
    "dash.status.summaryParents": "Eltern online",
    "dash.status.summaryPlayers": "Spieler im Spiel",
    "dash.status.summaryQueueDepth": "Analytics-Warteschlange",
    "dash.status.summaryRows": "Zeilen letzter Zugriff",
    "dash.status.summarySurface": "An der Oberfläche",
    "dash.status.summaryUnderground": "Untergrund",
    "dash.status.summaryWorldsActive": "Welten mit Spielern online",
    "dash.status.summaryWorldsOpened": "Geöffnete Welten",
    "dash.status.tabs.acquisition": "Akquise",
    "dash.status.tabs.economy": "Wirtschaft",
    "dash.status.tabs.engagement": "Engagement",
    "dash.status.tabs.learning": "Lernen",
    "dash.status.tabs.live": "Live",
    "dash.status.tabs.logs": "Logs",
    "dash.status.tabs.report": "Report",
    "dash.status.thAgeBand": "Altersgruppe",
    "dash.status.thEmailName": "E-Mail / Name",
    "dash.status.thEvent": "Ereignis",
    "dash.status.thFamily": "Familie",
    "dash.status.thLastAccess": "Letzter Zugriff",
    "dash.status.thRole": "Rolle",
    "dash.status.thSummary": "Zusammenfassung",
    "dash.status.thTime": "Zeit",
    "dash.status.thWorld": "Welt",
    "dash.status.thWorldFamilies": "Familien",
    "dash.status.thWorldPlayers": "Spieler",
    "dash.status.thWorldSurface": "Oberfläche",
    "dash.status.thWorldUnderground": "Untergrund",
    "dash.status.title": "Status",
    "dash.status.totalChildren": "Kinder (gesamt)",
    "dash.status.totalFamilies": "Familien (gesamt)",
    "dash.status.totalParents": "Eltern (gesamt)",
    "dash.status.totalPlayers": "Charaktere (gesamt)",
    "dash.status.updated": "Aktualisiert",
    "dash.status.worldsTitle": "Aufschlüsselung nach Welt",
    "dash.supervisor.csvDownloaded": "CSV heruntergeladen",
    "dash.supervisor.errAudit": "Audit-Protokoll konnte nicht geladen werden.",
    "dash.supervisor.errDenied": "Zugriff verweigert. Als Supervisor oder YOBY-Admin anmelden.",
    "dash.supervisor.errExport": "CSV konnte nicht exportiert werden.",
    "dash.supervisor.exportCsvSchool": "Schul-CSV exportieren",
    "dash.supervisor.hintAudit": "Letzte für die Schule protokollierte Aktionen.",
    "dash.supervisor.hintQuizzes": "Quiz-Nutzung nach Slug (abgeschlossene Versuche in der Schule).",
    "dash.supervisor.metaSlug": "Slug",
    "dash.supervisor.metaStatus": "Status",
    "dash.supervisor.metricSchoolAvg": "Schuldurchschnitt",
    "dash.supervisor.noAudit": "Keine Audit-Einträge.",
    "dash.supervisor.noClasses": "Keine Klassen.",
    "dash.supervisor.noQuizzes": "Keine Quiz-Daten.",
    "dash.supervisor.noSchools": "Keine zugewiesenen Schulen.",
    "dash.supervisor.noTeachers": "Keine Lehrkräfte.",
    "dash.supervisor.refresh": "Aktualisieren",
    "dash.supervisor.selectSchoolHint": "Wählen Sie eine Schule, um Klassen, Lehrkräfte und Quiz-Statistiken zu sehen.",
    "dash.supervisor.subtitle": "Überblick über Schulen, Klassen, Lehrkräfte, Quiz und Audit.",
    "dash.supervisor.tabAudit": "Audit",
    "dash.supervisor.tabClasses": "Klassen",
    "dash.supervisor.tabQuizzes": "Quiz",
    "dash.supervisor.tabTeachers": "Lehrkräfte",
    "dash.supervisor.thAssignments": "Aufgaben",
    "dash.supervisor.thSchool": "Schule",
    "dash.supervisor.thTeacher": "Lehrkraft",
    "dash.supervisor.title": "Supervisor-Dashboard",
    "dash.supervisor.yourSchools": "Ihre Schulen",
    "dash.teacher.catalogTitle": "Quiz-Katalog",
    "dash.teacher.confirmArchiveClass": "Diese Klasse archivieren? Der Code ist danach nicht mehr nutzbar.",
    "dash.teacher.copied": "Kopiert!",
    "dash.teacher.copyCode": "Code kopieren",
    "dash.teacher.createClass": "Klasse erstellen",
    "dash.teacher.demoLink": "Demo-Link",
    "dash.teacher.demoLinkCopied": "Link in die Zwischenablage kopiert.",
    "dash.teacher.demoLinkReady": "Permanenter Link erstellt",
    "dash.teacher.errArchive": "Klasse konnte nicht archiviert werden.",
    "dash.teacher.errAssign": "Quiz konnte nicht zugewiesen werden.",
    "dash.teacher.errCreateClass": "Klasse konnte nicht erstellt werden.",
    "dash.teacher.errDemoDenied": "Nur Admins können Demo-Links erstellen.",
    "dash.teacher.errDemoLink": "Demo-Link konnte nicht erstellt werden.",
    "dash.teacher.errDemoNoQuiz": "Kein freies Quiz mehr für diese Klasse.",
    "dash.teacher.errDenied": "Zugriff verweigert. Als Lehrkraft anmelden.",
    "dash.teacher.errExport": "CSV konnte nicht exportiert werden.",
    "dash.teacher.errExportCatalog": "Quiz-Katalog konnte nicht exportiert werden.",
    "dash.teacher.errLoadClasses": "Klassen konnten nicht geladen werden.",
    "dash.teacher.errNoTeacher": "Lehrkraft-Profil nicht gefunden.",
    "dash.teacher.errRegen": "Code konnte nicht neu erzeugt werden.",
    "dash.teacher.errSelectSchool": "Zuerst eine Schule auswählen.",
    "dash.teacher.exportCatalogCsv": "Katalog-CSV herunterladen (alle Sprachen)",
    "dash.teacher.exportCsv": "CSV exportieren",
    "dash.teacher.hintAssign": "Kategorie, Quiz und Aufgabeneinstellungen wählen.",
    "dash.teacher.hintWrong": "Fragen mit den meisten Fehlern in den letzten Aufgaben.",
    "dash.teacher.metaAge": "Alter",
    "dash.teacher.metaCode": "Code",
    "dash.teacher.metaLang": "Sprache",
    "dash.teacher.metaYear": "Jahrgang",
    "dash.teacher.metricAssignments": "Aufgaben",
    "dash.teacher.metricAttempts": "Versuche",
    "dash.teacher.metricClassAvg": "Klassendurchschnitt",
    "dash.teacher.metricEnrolled": "Eingeschrieben",
    "dash.teacher.newCode": "Neuer Code",
    "dash.teacher.noAssignments": "Noch keine Aufgaben.",
    "dash.teacher.noCatalog": "Keine Quiz im Katalog.",
    "dash.teacher.noClasses": "Noch keine Klassen.",
    "dash.teacher.noStudents": "Keine eingeschriebenen Schüler.",
    "dash.teacher.noWrong": "Keine schwierigen Fragen.",
    "dash.teacher.open": "Öffnen",
    "dash.teacher.playLink": "Spiel-Link",
    "dash.teacher.playLinkCopied": "Link in die Zwischenablage kopiert.",
    "dash.teacher.playLinkFailed": "Spiel-Link konnte nicht erstellt werden",
    "dash.teacher.playLinkHint": "Schüler öffnen den Link und tippen auf ihren Namen. Bitte die Auswahl beaufsichtigen.",
    "dash.teacher.playLinkHours": "Stunden",
    "dash.teacher.playLinkReady": "Spiel-Link erstellt",
    "dash.teacher.quizColChoices": "Antworten",
    "dash.teacher.quizColOrder": "#",
    "dash.teacher.quizColQuestion": "Frage",
    "dash.teacher.quizLoadError": "Quiz konnte nicht geladen werden.",
    "dash.teacher.quizLoading": "Quiz wird geladen…",
    "dash.teacher.quizPreviewTitle": "Quiz-Vorschau",
    "dash.teacher.selectClassHint": "Wählen Sie eine Klasse, um Details zu sehen.",
    "dash.teacher.statusAssigned": "Quiz zugewiesen.",
    "dash.teacher.statusAssigning": "Quiz wird zugewiesen…",
    "dash.teacher.statusClassCreated": "Klasse erstellt.",
    "dash.teacher.statusCreating": "Klasse wird erstellt…",
    "dash.teacher.subtitle": "Klassen, Anmeldecodes, Quiz-Aufgaben, Ergebnisse und Exporte.",
    "dash.teacher.surveyFeedbackFinal": "Am Ende des Quiz",
    "dash.teacher.surveyFeedbackImmediate": "Sofort nach jeder Frage",
    "dash.teacher.tabAssign": "Quiz zuweisen",
    "dash.teacher.tabAssignments": "Aufgaben",
    "dash.teacher.tabStudents": "Schüler",
    "dash.teacher.tabWrong": "Schwierige Fragen",
    "dash.teacher.thAge": "Alter",
    "dash.teacher.thAvg": "Durchschnitt",
    "dash.teacher.thClass": "Klasse",
    "dash.teacher.thCode": "Code",
    "dash.teacher.thCompleted": "Abgeschlossen",
    "dash.teacher.thDifficulty": "Schwierigkeit",
    "dash.teacher.thDone": "Erledigt",
    "dash.teacher.thDue": "Fällig am",
    "dash.teacher.thErrorPct": "Fehler %",
    "dash.teacher.thErrors": "Fehler",
    "dash.teacher.thFirstName": "Vorname",
    "dash.teacher.thJoined": "Beigetreten",
    "dash.teacher.thLastName": "Nachname",
    "dash.teacher.thLastSeen": "Zuletzt gesehen",
    "dash.teacher.thMaxAttempts": "Max. Versuche",
    "dash.teacher.thNickname": "Spitzname",
    "dash.teacher.thPublish": "Veröffentlichen",
    "dash.teacher.thQuestion": "Frage",
    "dash.teacher.thTheme": "Thema",
    "dash.teacher.thTitle": "Titel",
    "dash.teacher.thTotalAnswers": "Antworten gesamt",
    "dash.teacher.thYear": "Jahrgang",
    "dash.teacher.title": "Lehrkräfte-Dashboard",
    "dash.teacher.yourClasses": "Ihre Klassen",
    "dash.teacher.yourClassesHint": "Wählen Sie eine Klasse, um Schüler, Aufgaben und Statistiken zu sehen.",
    "dash.topic.bisogni_desideri": "Bedürfnisse und Wünsche",
    "dash.topic.budget": "Budget",
    "dash.topic.consumo": "Bewusster Konsum",
    "dash.topic.imprenditorialita": "Unternehmertum",
    "dash.topic.lavoro": "Arbeitswelt",
    "dash.topic.risparmio": "Sparen",
    "footer.aria.site": "Fußzeile",
    "footer.aria.social": "Social-Media-Links",
    "footer.brand.tagline": "Der Familienteich, in dem Kinder und Erwachsene gemeinsam den Umgang mit Geld lernen.",
    "footer.col.about": "Über YOBY",
    "footer.col.aiAudits": "Neueste KI-Sicherheitsaudits",
    "footer.col.banksAndPartners": "Banken & Partner",
    "footer.col.contact": "Kontakt",
    "footer.col.cookiePolicy": "Cookie-Richtlinie",
    "footer.col.dataAndGdpr": "Daten & DSGVO",
    "footer.col.investors": "Investoren",
    "footer.col.parentalControls": "Elternkontrolle",
    "footer.col.partners.title": "Partner",
    "footer.col.press": "Presse",
    "footer.col.privacyPolicy": "Datenschutz",
    "footer.col.product.title": "Produkt",
    "footer.col.roadmap": "Roadmap",
    "footer.col.safety": "Sicherheit",
    "footer.col.schools": "Schulen",
    "footer.col.termsOfService": "Nutzungsbedingungen",
    "footer.col.trust.title": "Vertrauen & Sicherheit",
    "footer.col.yoby.title": "YOBY",
    "footer.copyright.line1": "© 2026 YOBY. Alle Rechte vorbehalten.",
    "footer.copyright.line2": "In Europa gemacht für Familien, Enten und bessere Geldgewohnheiten.",
    "home.about.feature1.body": "Ein privater Raum, in dem die ganze Familie erkundet, Quests erfüllt und zusammen wächst. Jedes Mitglied hat seine eigene Ente.",
    "home.about.feature1.title": "🦆 Ein Familienspiel zum Lernen über Geld",
    "home.about.feature2.body": "Der Frosch, die Elster, der Maulwurf und andere führen euch mit kurzen Quests und Entscheidungsfragen. Lernen durch Tun, nicht durch Pauken.",
    "home.about.feature2.title": "🐸 Mentoren, die Geldkenntnisse spielerisch vermitteln",
    "home.about.feature3.body": "Drei symbolische Währungen für Ziele, Sparen und gute Gewohnheiten. Eine Spielökonomie, die lehrt, ohne sich wie Unterricht anzufühlen.",
    "home.about.feature3.title": "🐚 Sparen, Ziele und Gewohnheiten in einer spielerischen Wirtschaft",
    "home.about.feature4.body": "Kein Kind kann unangemessene Inhalte erhalten. Kein Videochat ohne anwesenden Elternteil. Für Minderjährige gebaut — nicht nur angepasst.",
    "home.about.feature4.title": "🔒 Sicher von Grund auf",
    "home.about.title": "Das erwartet euch in der YOBY-Welt",
    "home.cta.choosePlan": "Plan wählen",
    "home.cta.joinDescription": "Erstellt euer Familienkonto und beginnt zu erkunden.",
    "home.cta.joinTitle": "Taucht ein. Es ist kostenlos.",
    "home.cta.playNow": "Jetzt spielen",
    "home.cta.premiumActive": "Du hast einen Premium-Plan — genieße das volle Erlebnis!",
    "home.cta.premiumHint": "Premium-Pläne bieten bessere Spielbedingungen: mehr Muscheln, exklusive Bereiche und Prioritätsfunktionen.",
    "home.cta.ready": "Bereit, wieder in den Teich zu tauchen?",
    "home.cta.signIn": "Anmelden",
    "home.cta.signUpFree": "Kostenlos starten",
    "home.cta.tryAsParent": "Sind Sie Elternteil? YOBY ausprobieren",
    "home.cta.tryAsStudent": "Sind Sie Lehrkraft? YOBY ausprobieren",
    "home.cta.welcomeBack": "Willkommen zurück",
    "home.cta.welcomeBackName": "Willkommen zurück, {name}",
    "home.hero.childBody": "Erstelle sie jetzt. Ein Elternteil schaltet den Teich frei, wenn ihr bereit seid.",
    "home.hero.childCta": "Meine Ente erstellen",
    "home.hero.childTitle": "Suchst du deine Ente? 🦆",
    "home.hero.ctaPrimary": "Kostenlos starten",
    "home.hero.ctaSecondary": "So funktioniert es",
    "home.hero.description": "YOBY ist ein Finanzbildungsspiel, in dem Kinder und Eltern gemeinsam Sparen, Geldentscheidungen und Ziele lernen.",
    "home.hero.tagline": "Geld spricht — endlich mit Spaß.",
    "home.hero.title": "Finanzbildung für Kinder und Familien — spielerisch gemacht.",
    "home.hero.visualAlt": "Die YOBY-Welt mit spielerischen Enten am Familienteich",
    "home.learn.choices.body": "Alltägliche Abwägungen — jetzt ausgeben, sparen oder teilen — in sicheren, storybasierten Quests.",
    "home.learn.choices.title": "Entscheidungen",
    "home.learn.goals.body": "Benennen, was zählt, planen und Fortschritte unterwegs feiern.",
    "home.learn.goals.title": "Ziele",
    "home.learn.saving.body": "Muscheln für später beiseitelegen und kleine Schritte zu größeren Zielen wachsen sehen.",
    "home.learn.saving.title": "Sparen",
    "home.learn.title": "Was Kinder lernen",
    "home.learn.value.body": "Aufwand, Zeit und Ressourcen verbinden, damit Kinder verstehen, wofür Geld steht.",
    "home.learn.value.title": "Wert des Geldes",
    "home.links.families": "Finanzbildung für Familien",
    "home.links.kids": "YOBY für Kinder",
    "home.links.schools": "Finanzbildung für Schulen",
    "home.links.title": "YOBY entdecken",
    "home.seo.description": "YOBY ist eine spielerische Finanzbildungswelt, in der Kinder und Eltern gemeinsam Sparen, Geldentscheidungen und gesunde Gewohnheiten lernen.",
    "home.seo.title": "Finanzbildung für Kinder & Familien | YOBY",
    "home.seoSection.body": "YOBY macht Finanzbildung für Kinder zu einem gemeinsamen Abenteuer. In einer spielerischen Teichwelt üben Kinder und Eltern Sparen, setzen gemeinsam Ziele und sprechen über alltägliche Geldentscheidungen. Mentoren und kurze Quests führen durch spielerisches Lernen über Geld — nicht durch Arbeitsblätter oder Vorträge. Wenn Sie Finanzbildung für Familien zu Hause suchen, trifft YOBY Kinder dort, wo sie sind: neugierig, kreativ und bereit zu entdecken. Jedes Familienmitglied hat seine eigene Ente in einem Teich, den Sie nur mit Vertrauenspersonen teilen. Muscheln, Samen und Sterne stehen für echte Gewohnheiten — Geduld, Planung und Verständnis für den Wert des Verdienten. Unterwegs lernen Kinder, dass kleine Entscheidungen zählen, Warten sich lohnen kann und Geld ein Werkzeug für Ziele ist — nicht nur zum Ausgeben. Eltern bleiben eingebunden mit klarer Übersicht und Kontrollen in einem Raum, der von Grund auf für Minderjährige gebaut ist.",
    "home.seoSection.title": "Finanzbildung für Kinder — durch Spiel",
    "home.showcase.aria": "Spiel-Screenshots",
    "home.showcase.card1.alt": "YOBY Familien-Finanzbildungsspiel mit Eltern und Kindern in einem virtuellen Teich",
    "home.showcase.card1.title": "Familienteich — gemeinsam erkunden",
    "home.showcase.card2.alt": "YOBY-Mentoren, die Kindern Geld durch spielerische Quests beibringen",
    "home.showcase.card2.title": "Mentoren treffen — spielend lernen",
    "home.showcase.card3.alt": "YOBY Finanzbildungs-Quiz und Dorfläden mit lokalisierten Mentor-Dialogen",
    "home.showcase.card3.title": "Quiz, Läden und Dorfleben",
    "home.showcase.card4.alt": "YOBY Untergrund-Mentoren lehren Geld durch cinematische Quests",
    "home.showcase.card4.title": "Untergrund-Mentoren und Quests",
    "home.showcase.card5.alt": "YOBY Tasso-Markt, wo Kinder Geldentscheidungen üben",
    "home.showcase.card5.title": "Märkte und Geldentscheidungen",
    "home.showcase.card6.alt": "YOBY Verrückter Lauf: Kinder rennen auf der Wiese und sammeln saisonale Gegenstände gegen die Zeit",
    "home.showcase.card6.title": "Verrückter Lauf — ein Wettrennen gegen die Zeit auf der Wiese",
    "home.showcase.hint": "Tippen zum Vergrößern",
    "home.showcase.title": "Entdeckt die Welt",
    "lang.switch": "Sprache",
    "nav.account": "Konto",
    "nav.actions.signIn": "Einloggen",
    "nav.actions.startFree": "Kostenlos starten",
    "nav.actions.talkWithUs": "Sprich mit uns",
    "nav.aria.main": "Hauptnavigation",
    "nav.aria.staff": "Schul- und Admin-Bereich",
    "nav.footer.schoolSignup": "Schule anmelden",
    "nav.main.blog": "Blog",
    "nav.main.forFamilies": "Für Familien",
    "nav.main.forKids": "Für Kinder",
    "nav.main.home": "Startseite",
    "nav.main.howItWorks": "So funktioniert es",
    "nav.main.pricing": "Preise",
    "nav.main.talkWithUs": "Sprich mit uns",
    "nav.menu": "Menü",
    "nav.searchPosts": "Beiträge, Tags und Autoren suchen",
    "nav.signIn": "Anmelden",
    "nav.staff.admin": "Schul-Admin",
    "nav.staff.adminSafety": "Neueste KI-Sicherheitsaudits",
    "nav.staff.conference": "Conference Call",
    "nav.staff.massmail": "Schulen-Massmail",
    "nav.staff.redteam": "AI Red Team",
    "nav.staff.schoolSignups": "Schulanmeldungen",
    "nav.staff.status": "Spielstatus",
    "nav.staff.supervisor": "Supervisor-Dashboard",
    "nav.staff.teacher": "Lehrer-Dashboard",
    "nav.subscribe": "Abonnieren",
    "safetyLab.areasTitle": "Themen, die wir prüfen",
    "safetyLab.audience": "Für Familien und Schulen",
    "safetyLab.cat.abuse": "Abuse",
    "safetyLab.cat.dangerous_behavior": "Dangerous behaviour",
    "safetyLab.cat.distress_support": "Emotional support (allowed)",
    "safetyLab.cat.drugs": "Drugs",
    "safetyLab.cat.hate": "Hate",
    "safetyLab.cat.inappropriate_instructions": "Inappropriate instructions",
    "safetyLab.cat.jailbreak": "Prompt injection",
    "safetyLab.cat.off_topic": "Off-topic",
    "safetyLab.cat.other": "Other safety checks",
    "safetyLab.cat.personal_data": "Personal information",
    "safetyLab.cat.self_harm": "Self-harm",
    "safetyLab.cat.sexual": "Inappropriate sexual content",
    "safetyLab.cat.violence": "Violence",
    "safetyLab.chartEmpty": "Sobald mehr Audits vorliegen, siehst du den Trend hier.",
    "safetyLab.chartOutcomes": "Ergebnis des letzten Audits",
    "safetyLab.chartTrend": "Trend der letzten Audits",
    "safetyLab.historyEmpty": "Noch keine abgeschlossenen Audits.",
    "safetyLab.historyTitle": "Aktuelle Historie",
    "safetyLab.languages": "Testsprachen",
    "safetyLab.lastTested": "Letztes Audit",
    "safetyLab.legendCritical": "Kritisch: hohes Risiko; höchste Priorität.",
    "safetyLab.legendFail": "Fehlgeschlagen: etwas hat nicht wie vorgesehen reagiert — wir beheben es.",
    "safetyLab.legendPass": "Bestanden: der Filter hat wie erwartet reagiert.",
    "safetyLab.legendTitle": "Was die Ergebnisse bedeuten",
    "safetyLab.legendWarning": "Hinweis: oft ein Fehlalarm (zu streng bei einer harmlosen Nachricht), kein Risiko für Kinder.",
    "safetyLab.loadFailed": "Sicherheitsaudits konnten nicht geladen werden.",
    "safetyLab.loading": "Neueste Audits werden geladen…",
    "safetyLab.method1": "Kern der Prüfung ist das Safety Gate — derselbe Filter, der Nachrichten im Spiel abfängt (Eingabe und teils Ausgabe). Jedes Szenario sendet eine Nachricht (oder eine kurze Sequenz) und prüft, ob der Filter wie erwartet erlaubt, umleitet oder blockiert.",
    "safetyLab.method2": "In der vollständigen Suite prüfen wir alle KI-Figuren, mit denen ein Kind sprechen kann: Oberflächen-Teich, Untergrund und Tutoren. Es gibt auch schnellere „Quick“-Läufe mit nur einer Figur und einer Altersgruppe pro Szenario: Die gelisteten Hosts spiegeln immer nur wider, was dieser Lauf wirklich ausgeführt hat.",
    "safetyLab.method3": "Szenarien decken sensible Themen und Umgehungsversuche ab: unangemessene sexuelle Inhalte, Gewalt, Selbstverletzung, Missbrauch, Drogen, Hass, personenbezogene Daten, gefährliche Anweisungen, Prompt-Manipulation (Jailbreak), Themenabweichung sowie harmlose oder unterstützende Fälle, die erlaubt bleiben müssen. Viele Szenarien laufen in mehreren Sprachen und Altersgruppen.",
    "safetyLab.method4": "Jeder Fall erhält ein Ergebnis: bestanden, Hinweis, fehlgeschlagen oder kritisch. Ein Hinweis ist oft ein Fehlalarm (zu streng bei einer harmlosen Nachricht), kein Risiko für Kinder. Fehlschlag oder kritisch bedeutet, dass etwas nicht wie vorgesehen reagiert hat und behoben werden muss. Wir zeigen immer den neuesten abgeschlossenen Lauf — auch wenn er nicht grün ist — und ersetzen nie ein schlechtes Ergebnis durch ein älteres gutes.",
    "safetyLab.method5": "Damit niemand die Schutzmaßnahmen umgehen kann, veröffentlichen wir keine Angriffstexte, Jailbreak-Rezepte oder vollständigen Transkripte. Öffentlich siehst du Aggregate, Kategorien und Daten; technische Details bleiben intern.",
    "safetyLab.method6": "Die Szenario-Bibliothek wächst: Finden wir eine Schwäche, fügen wir einen Regressionstest hinzu und behalten ihn. Gibt es noch kein abgeschlossenes Audit, sagen wir das klar.",
    "safetyLab.methodIntro": "YOBY führt automatische Sicherheitsaudits der kindgerichteten KI durch. Wir erfinden die Zahlen nicht: Jede Angabe auf dieser Seite stammt aus einem echten, gespeicherten Lauf. Unten erklären wir, was wir tun, was wir messen und was wir absichtlich nicht zeigen.",
    "safetyLab.methodTitle": "So werden die Tests durchgeführt",
    "safetyLab.metricCritical": "Kritisch",
    "safetyLab.metricExecuted": "Geprüfte Fälle",
    "safetyLab.metricFail": "Fehlgeschlagen",
    "safetyLab.metricPass": "Bestanden",
    "safetyLab.metricPassRate": "Erfolgsquote",
    "safetyLab.metricWarning": "Hinweise",
    "safetyLab.never": "Noch nicht ausgeführt",
    "safetyLab.noteParents": "Diese Seite ist für Eltern und Lehrkräfte. Du kannst sie jederzeit prüfen: Es ist ein öffentlicher Bericht der neuesten Audits, keine Marketingseite mit erfundenen Zahlen.",
    "safetyLab.npcs": "Abgedeckte KI-Figuren",
    "safetyLab.plainLead": "YOBY testet seine KI-Figuren laufend, wie bei einem Sicherheitsaudit. Hier siehst du das neueste Ergebnis — ohne technische Angriffsdetails.",
    "safetyLab.statusCritical": "Schwere Probleme gefunden",
    "safetyLab.statusError": "Letztes Audit nicht abgeschlossen",
    "safetyLab.statusIssues": "Es gibt Verbesserungsbedarf",
    "safetyLab.statusNever": "Noch kein Audit verfügbar",
    "safetyLab.statusPass": "Alles in Ordnung",
    "safetyLab.subtitle": "Echte Ergebnisse automatischer Prüfungen der KI, die mit Kindern spricht — für Eltern und Lehrkräfte.",
    "safetyLab.thCases": "Fälle",
    "safetyLab.thDate": "Datum",
    "safetyLab.thStatus": "Ergebnis",
    "safetyLab.title": "Neueste KI-Sicherheitsaudits",
    "footer.col.genderEquality": "Geschlechtergleichstellung",
    "dash.booking.gcalRefreshHint": "Nach einer Buchung „Kalender aktualisieren“ nutzen, falls der Termin in Google fehlt.",
    "dash.conference.delivery.title": "E-Mail-Zustellung",
    "dash.conference.delivery.untracked": "Ergebnis nicht verfügbar",
    "dash.conference.delivery.invite": "Einladung",
    "dash.conference.delivery.reschedule": "Terminänderung",
    "dash.conference.delivery.reminder": "Erinnerung",
    "dash.conference.delivery.pending": "Wird vorbereitet",
    "dash.conference.delivery.accepted": "Von Mailgun angenommen",
    "dash.conference.delivery.delivered": "An den Empfängerserver zugestellt",
    "dash.conference.delivery.deferred": "Vorübergehend verzögert",
    "dash.conference.delivery.failed": "Versand oder Zustellung fehlgeschlagen",
    "dash.conference.delivery.dry_run": "Simuliert, nicht gesendet",
    "dash.conference.delivery.confirmation": "Deine Teilnahme ist bestätigt",
    "footer.col.accessibility": "Barrierefreiheit",
    "accessibility.title": "Barrierefreiheit bei YOBY",
    "accessibility.intro": "Wir möchten die Informationen von YOBY leichter lesbar und nutzbar machen. Diese Seite erklärt die Werkzeuge der Website und die derzeitigen Einschränkungen des Spiels.",
    "accessibility.site.title": "Die Informationswebsite",
    "accessibility.site.body": "Die Seiten bieten Texte, Navigationslinks und ein Fenster zur Anpassung der Anzeige. Du kannst das Lesen an deine Bedürfnisse anpassen und über einen Tastaturlink zum Hauptinhalt gelangen.",
    "accessibility.site.status": "Diese Funktionen unterstützen die Nutzung, garantieren aber keine vollständige Barrierefreiheit. Das Widget allein belegt keine umfassende Konformität mit Standards zur Barrierefreiheit; eine vollständige Prüfung aller Seiten, Formulare und eingebundenen Dienste haben wir nicht abgeschlossen.",
    "accessibility.preferences.title": "Anzeige anpassen",
    "accessibility.preferences.body": "Öffne das Fenster über das Symbol für Barrierefreiheit in der Navigation oder mit Alt+Shift+A unter Windows/Linux und ⌥ Option+Shift+A auf dem Mac. Änderungen gelten sofort für die Webseiten.",
    "accessibility.preferences.contrast": "Hoher Kontrast: erhöht den visuellen Kontrast der Seite.",
    "accessibility.preferences.invert": "Farben umkehren: kehrt Hintergrund- und Inhaltsfarben einschließlich Bildern um.",
    "accessibility.preferences.size": "Größerer Text: wechselt zwischen normalem, großem und sehr großem Text.",
    "accessibility.preferences.spacing": "Textabstand: vergrößert den Leseabstand in unterstützten Inhalten.",
    "accessibility.preferences.focus": "Fokus hervorheben: macht das mit der Tastatur ausgewählte Bedienelement deutlicher sichtbar.",
    "accessibility.preferences.links": "Links unterstreichen: fügt Links eine Unterstreichung hinzu.",
    "accessibility.preferences.motion": "Bewegung reduzieren: reduziert Animationen und Übergänge der Seite.",
    "accessibility.preferences.font": "Lesbare Schrift: verwendet eine serifenlose Systemschrift.",
    "accessibility.preferences.storage": "Die Einstellungen werden im lokalen Speicher dieses Browsers gespeichert und vom Widget nicht an YOBY gesendet. „Standardeinstellungen wiederherstellen“ setzt sie zurück. Sie werden nicht zwischen Geräten synchronisiert; blockiert der Browser den lokalen Speicher, ist das Speichern möglicherweise nicht verfügbar.",
    "accessibility.keyboard.title": "Tastatur verwenden",
    "accessibility.keyboard.body": "Der erste Tab zeigt den Link „Zum Inhalt springen“. Mit Tab und Umschalt+Tab wechselst du zwischen Bedienelementen; Eingabe oder Leertaste aktiviert Schaltflächen. Der Fokus bleibt im geöffneten Fenster; Esc schließt es und bringt den Fokus zum Ausgangspunkt zurück.",
    "accessibility.game.title": "Das Spiel: derzeitige Einschränkungen",
    "accessibility.game.body": "Das Spiel ist ein visuelles, interaktives Erlebnis, getrennt von der Informationswebsite. Wir stellen es derzeit nicht als vollständig barrierefrei dar und können die vollständige Nutzung mit Screenreadern oder ausschließlich per Tastatur nicht garantieren.",
    "accessibility.game.limits": "Die Website-Einstellungen machen die Spielwelt nicht barrierefrei und gelten nicht automatisch für die 3D-Szene, Interaktionen oder sämtliche Spielsteuerungen. Eingebundene Dienste wie Anmelde- und Registrierungsfenster können ebenfalls eigene Verhaltensweisen und Grenzen haben. Wenn du auf eine Barriere stößt, kontaktiere uns: Wir können das Problem aufnehmen und prüfen, wie wir helfen können, ohne zu versprechen, dass bereits für jede Aktivität eine gleichwertige Alternative verfügbar ist.",
    "accessibility.feedback.title": "Eine Schwierigkeit melden",
    "accessibility.feedback.body": "Nenne bitte die betroffene Seite oder Funktion, was du tun wolltest, dein Gerät und deinen Browser sowie gegebenenfalls die verwendete assistive Technologie. Eine Diagnose oder andere Gesundheitsdaten sind nicht erforderlich.",
    "accessibility.feedback.contact": "Kontakt zur Barrierefreiheit",
    "auth.a11y.email": "E-Mail-Adresse",
    "auth.a11y.subscribe": "Registrieren",
    "auth.a11y.sent": "E-Mail gesendet. Prüfe deinen Posteingang, um fortzufahren.",
    "auth.a11y.termsRequired": "Bitte akzeptiere die Bedingungen, um fortzufahren.",
    "auth.a11y.close": "Fenster schließen",
    "auth.a11y.account": "YOBY-Konto",
    "auth.a11y.sending": "Wird gesendet…"
  },
  "nl": {
    "blog.title": "Blog",
    "dash.admin.approveSignup": "Approve",
    "dash.admin.errArchive": "Kon school niet archiveren.",
    "dash.admin.errAssign": "Kon personeel niet toewijzen.",
    "dash.admin.errCreateSchool": "Kon school niet aanmaken.",
    "dash.admin.errDenied": "Toegang geweigerd. Log in als YOBY-beheerder.",
    "dash.admin.errRoleNotAllowed": "Rol niet toegestaan.",
    "dash.admin.errSaveSchool": "School kon niet worden opgeslagen.",
    "dash.admin.errSignupApprove": "Could not approve the application.",
    "dash.admin.errSignupLoad": "Could not load school applications.",
    "dash.admin.errSignupReject": "Could not reject the application.",
    "dash.admin.errUserNotFound": "Gebruiker niet gevonden.",
    "dash.admin.linkAdminSafety": "Laatste AI-veiligheidsaudits",
    "dash.admin.linkMassmail": "Scholen-massmail",
    "dash.admin.linkPlay": "Familiegame",
    "dash.admin.linkRedteam": "AI Red Team",
    "dash.admin.linkStatus": "Spelstatus",
    "dash.admin.linkSupervisor": "Supervisordashboard",
    "dash.admin.linkTeacher": "Leraarsdashboard",
    "dash.admin.noSignups": "No school applications.",
    "dash.admin.noStaff": "Nog geen personeelsleden.",
    "dash.admin.panelSchoolsForm": "Scholen toevoegen / bewerken",
    "dash.admin.panelSchoolsList": "Schoollijst",
    "dash.admin.panelSignups": "Schoolaanmeldingen",
    "dash.admin.panelStaffForm": "Personeel toevoegen / bewerken",
    "dash.admin.panelStaffList": "Personeelslijst",
    "dash.admin.quickLinks": "Snelle links",
    "dash.admin.rejectReason": "Rejection reason",
    "dash.admin.rejectSignup": "Reject",
    "dash.admin.schoolListHint": "Klik een rij om te bewerken. Archiveren vraagt om bevestiging.",
    "dash.admin.selectSchool": "Selecteer een school",
    "dash.admin.signupClasses": "Classes",
    "dash.admin.signupTeachers": "Teachers",
    "dash.admin.staffListHint": "Klik een rij om toewijzing en rol bij te werken.",
    "dash.admin.statusAssigned": "Personeel toegewezen.",
    "dash.admin.statusAssigning": "Personeel toewijzen…",
    "dash.admin.statusCreatingSchool": "School aanmaken…",
    "dash.admin.statusEditingSchool": "School bewerken — wijzig velden en sla op.",
    "dash.admin.statusEditingStaff": "Staff bewerken — bijwerken en toewijzen.",
    "dash.admin.statusSavingSchool": "School opslaan…",
    "dash.admin.statusSchoolCreated": "School aangemaakt.",
    "dash.admin.statusSchoolSaved": "School opgeslagen.",
    "dash.admin.subtitle": "Scholen aanmaken en leraren en supervisors toewijzen. Vereist YOBY-beheerderslogin (e-mail in ADMIN_EMAILS).",
    "dash.admin.surveyAssignStaff": "Personeel toewijzen",
    "dash.admin.surveyCreateSchool": "School aanmaken",
    "dash.admin.surveySaveSchool": "School opslaan",
    "dash.admin.surveySchoolDesc": "Registreer een school in de YOBY-module.",
    "dash.admin.surveySchoolName": "Schoolnaam",
    "dash.admin.surveySchoolSlug": "Slug (optioneel)",
    "dash.admin.surveySchoolTitle": "Nieuwe school",
    "dash.admin.surveyStaffDesc": "Koppel leraren en supervisors aan een school.",
    "dash.admin.surveyStaffEmail": "E-mail personeel",
    "dash.admin.surveyStaffForce": "Toewijzing forceren",
    "dash.admin.surveyStaffForceDesc": "Opnieuw toewijzen, ook als de gebruiker al bij een andere school hoort.",
    "dash.admin.surveyStaffRoleSupervisor": "Supervisor",
    "dash.admin.surveyStaffRoleTeacher": "Leraar",
    "dash.admin.surveyStaffSchool": "School",
    "dash.admin.surveyStaffTitle": "Personeel toewijzen",
    "dash.admin.surveyUpdateStaff": "Staff bijwerken",
    "dash.admin.tabSchoolsForm": "Scholen toevoegen / bewerken",
    "dash.admin.tabSchoolsList": "Schoollijst",
    "dash.admin.tabSignups": "Schoolaanmeldingen",
    "dash.admin.tabStaffForm": "Personeel toevoegen / bewerken",
    "dash.admin.tabStaffList": "Personeelslijst",
    "dash.admin.tabsAria": "Schoolbeheer",
    "dash.admin.title": "YOBY Schoolbeheer",
    "dash.booking.active": "Openbare boekingen actief",
    "dash.booking.addEmail": "E-mail toevoegen",
    "dash.booking.addHour": "Tijdvak toevoegen",
    "dash.booking.attribution": "Hoe ze ons vonden",
    "dash.booking.availabilityHint": "Openbare boekingen op /talk-with-us/ inschakelen. Uren binnen ma–vr 09:00–19:00. Specifieke dagen hieronder blokkeren.",
    "dash.booking.availabilityTitle": "Openbare beschikbaarheid",
    "dash.booking.availableSlots": "Beschikbare tijden",
    "dash.booking.blockDate": "Blokkeer",
    "dash.booking.blockReason": "Reden",
    "dash.booking.blockReasonPlaceholder": "Reden (optioneel)",
    "dash.booking.blockedDatesHint": "Geen slots op deze dagen.",
    "dash.booking.blockedDatesTitle": "Geblokkeerde dagen",
    "dash.booking.blockedEmpty": "Geen geblokkeerde dagen.",
    "dash.booking.blockedOn": "Datum",
    "dash.booking.blockedSaved": "Dag geblokkeerd.",
    "dash.booking.booking": "Boeken…",
    "dash.booking.bufferMinutes": "Buffer tussen slots (minuten)",
    "dash.booking.calFreeDays": "Dagen met vrije slots",
    "dash.booking.cancel": "Annuleren",
    "dash.booking.cancelConfirm": "Deze boeking annuleren?",
    "dash.booking.cancelled": "geannuleerd",
    "dash.booking.cancelledOk": "Boeking geannuleerd.",
    "dash.booking.confirm": "Boeken",
    "dash.booking.confirmTitle": "Boeking bevestigen",
    "dash.booking.copyLink": "Link kopiëren",
    "dash.booking.detailTitle": "Boekingsdetail",
    "dash.booking.doneBody": "We hebben je de link gemaild. Gebruik die op de dag van de call.",
    "dash.booking.doneLinkHint": "Als de mail niet aankomt, is dit je persoonlijke link:",
    "dash.booking.doneStatus": "Check ook je inbox.",
    "dash.booking.doneTitle": "Boeking bevestigd",
    "dash.booking.emailsHint": "Voeg tot 3 e-mails toe — elk krijgt een persoonlijke link.",
    "dash.booking.empty": "Geen boekingen of geplande calls.",
    "dash.booking.errBlockDate": "Ongeldige datum.",
    "dash.booking.errBlockExists": "Dag al geblokkeerd.",
    "dash.booking.errBook": "Boeking mislukt.",
    "dash.booking.errCancel": "Annuleren mislukt.",
    "dash.booking.errEmails": "Vul minstens één geldig e-mailadres in.",
    "dash.booking.errLoad": "Boekingen laden mislukt.",
    "dash.booking.errLoadSlots": "Slots laden mislukt.",
    "dash.booking.errPickSlot": "Kies eerst hierboven een tijdstip.",
    "dash.booking.errReschedule": "Verzetten niet mogelijk.",
    "dash.booking.errSave": "Opslaan mislukt.",
    "dash.booking.errSlotTaken": "Dit slot is niet meer beschikbaar.",
    "dash.booking.errTooManyEmails": "Maximaal 3 e-mails per boeking.",
    "dash.booking.errUnblock": "Deblokkeren mislukt.",
    "dash.booking.errUrl": "Die link lijkt geen geldig webadres.",
    "dash.booking.formOptionalHint": "Alle velden hieronder zijn optioneel. Je kunt ons iets over jezelf vertellen, of gewoon langskomen en hallo zeggen. De rest zoeken we samen uit.",
    "dash.booking.gcalCalendar": "Doelkalender",
    "dash.booking.gcalConnect": "Google Calendar verbinden",
    "dash.booking.gcalConnectFailed": "Google Calendar verbinden mislukt.",
    "dash.booking.gcalConnected": "Google Calendar verbonden.",
    "dash.booking.gcalDisconnect": "Verbreken",
    "dash.booking.gcalDisconnectConfirm": "Google Calendar verbreken?",
    "dash.booking.gcalDisconnected": "Google Calendar verbroken.",
    "dash.booking.gcalMissing": "Klaar — klik Verbinden om Google te autoriseren (OAuth).",
    "dash.booking.gcalOk": "Google Calendar verbonden.",
    "dash.booking.gcalRedirectHint": "Deze redirect-URI autoriseren:",
    "dash.booking.gcalRefresh": "Kalender vernieuwen",
    "dash.booking.gcalRefreshConfirm": "Alle toekomstige afspraken opnieuw synchroniseren naar Google Calendar (juiste tijden op de YOBY-kalender)?",
    "dash.booking.gcalRefreshEmpty": "Geen lopende of toekomstige afspraken om te synchroniseren.",
    "dash.booking.gcalRefreshFailed": "Kalender vernieuwen mislukt.",
    "dash.booking.gcalRefreshNeedReconnect": "Google Calendar niet bereikbaar: verbreek, verbind opnieuw en probeer refresh.",
    "dash.booking.gcalRefreshOk": "Kalender vernieuwd: {synced}/{total} events · {failed} mislukt · {calendar}",
    "dash.booking.gcalServerMissing": "OAuth-app ontbreekt op de server: maak een Google Cloud-client «Web application», zet GOOGLE_CALENDAR_CLIENT_ID/SECRET in .env, herstart de API.",
    "dash.booking.gcalTitle": "Google Calendar",
    "dash.booking.inactive": "Openbare boekingen zijn nu niet actief.",
    "dash.booking.introBody": "Als je ons liever ontmoet dan een formulier invult, kun je rechtstreeks een gesprek boeken met het YOBY-team. We laten je graag het project zien, beantwoorden je vragen en kijken samen hoe YOBY bij jouw gezin, school, organisatie of partnerschapsidee zou kunnen passen.",
    "dash.booking.introImageAlt": "Videogesprek met het YOBY-team — eendjes die Engels, Frans en Italiaans spreken",
    "dash.booking.introInterpreter": "Spreek je een andere taal? Geen probleem: ons conference-callplatform vertaalt de jouwe naar de onze en omgekeerd.",
    "dash.booking.introLanguages": "Je kunt met ons praten in het Engels, Italiaans of Frans: Ricardo en Stefano spreken Italiaans en Engels, terwijl Antonella, onze CRO, Frans, Italiaans en Engels spreekt.",
    "dash.booking.introTitle": "Liever praten?",
    "dash.booking.landingUrl": "Landingspagina",
    "dash.booking.linkLabel": "Een link die we voor het gesprek moeten zien",
    "dash.booking.linkPlaceholder": "https://…",
    "dash.booking.listHint": "Klik een rij om gasten en links te beheren. Ook calls van de admin staan hier.",
    "dash.booking.listTitle": "Boekingen en geplande calls",
    "dash.booking.noLinkedCall": "Deze boeking heeft geen gekoppelde conference.",
    "dash.booking.noSlots": "Geen vrije slots op deze dag.",
    "dash.booking.note": "Is er iets dat je ons wilt laten weten?",
    "dash.booking.notifyInvitees": "Genodigden e-mailen (zelfde link, nieuwe tijd)",
    "dash.booking.openCall": "Conference openen",
    "dash.booking.orgLabel": "Organisatie / project",
    "dash.booking.orgPlaceholder": "School, bedrijf, publicatie, stichting...",
    "dash.booking.pickDay": "Kies een dag",
    "dash.booking.prefLang.none": "Geen voorkeur",
    "dash.booking.prefLangLabel": "Voorkeurstaal",
    "dash.booking.publicSubtitle": "Kies een vrij slot. Je krijgt een persoonlijke conference-link.",
    "dash.booking.publicTitle": "Boek een YOBY-call",
    "dash.booking.referrer": "Referrer",
    "dash.booking.rescheduleHint": "Wijzig de datum en tijd. Persoonlijke links blijven hetzelfde.",
    "dash.booking.rescheduleTitle": "Verzetten",
    "dash.booking.rescheduled": "Boeking verzet. De links zijn ongewijzigd.",
    "dash.booking.rulesHint": "Vaste regels: minstens 48 u van tevoren, ma–vr 09:00–19:00 (Europe/Rome).",
    "dash.booking.save": "Beschikbaarheid opslaan",
    "dash.booking.saveCall": "Nieuwe tijd opslaan",
    "dash.booking.saved": "Beschikbaarheid opgeslagen.",
    "dash.booking.saving": "Opslaan…",
    "dash.booking.slotMinutes": "Slotduur (minuten)",
    "dash.booking.sourceAdmin": "Geplande call",
    "dash.booking.status": "Status",
    "dash.booking.statusCancelled": "geannuleerd",
    "dash.booking.statusDone": "afgerond",
    "dash.booking.statusExpired": "verlopen",
    "dash.booking.statusLive": "bezig",
    "dash.booking.statusUpcoming": "gepland",
    "dash.booking.timezone": "Jouw tijdzone",
    "dash.booking.timezoneHint": "Beschikbare tijden worden getoond in de gekozen tijdzone. YOBY-beschikbaarheid is ma–vr 09:00–19:00 (Europe/Rome).",
    "dash.booking.topic.banking_fintech": "Banking & fintech",
    "dash.booking.topic.families": "YOBY voor gezinnen",
    "dash.booking.topic.financial_education": "Financiële educatie",
    "dash.booking.topic.investment": "Investering",
    "dash.booking.topic.other": "Iets anders",
    "dash.booking.topic.partnership": "Samenwerking",
    "dash.booking.topic.press": "Pers & interviews",
    "dash.booking.topic.research": "Onderzoek",
    "dash.booking.topic.school_pilot": "Schoolpilot",
    "dash.booking.topicsLabel": "Waar wil je over praten?",
    "dash.booking.unblockDate": "Deblokkeer",
    "dash.booking.unblocked": "Dag gedeblokkeerd.",
    "dash.booking.utm": "Campagne (UTM)",
    "dash.booking.weekday0": "Zondag",
    "dash.booking.weekday1": "Maandag",
    "dash.booking.weekday2": "Dinsdag",
    "dash.booking.weekday3": "Woensdag",
    "dash.booking.weekday4": "Donderdag",
    "dash.booking.weekday5": "Vrijdag",
    "dash.booking.weekday6": "Zaterdag",
    "dash.booking.weeklyHours": "Weekuren",
    "dash.booking.who.bank": "Bank of financiële instelling",
    "dash.booking.who.curious": "Gewoon nieuwsgierig",
    "dash.booking.who.educator": "Onderwijs of school",
    "dash.booking.who.empty": "Kies als je wilt…",
    "dash.booking.who.foundation": "Stichting of ngo",
    "dash.booking.who.investor": "Investeerder",
    "dash.booking.who.journalist": "Journalist",
    "dash.booking.who.other": "Anders",
    "dash.booking.who.parent": "Ouder",
    "dash.booking.who.public": "Overheidsinstelling",
    "dash.booking.who.startup": "Startup of bedrijf",
    "dash.booking.whoLabel": "Wie ben je?",
    "dash.booking.yourEmail": "Jouw e-mail",
    "dash.booking.yourEmails": "E-mails van gasten",
    "dash.booking.yourName": "Jouw naam",
    "dash.common.actions": "Acties",
    "dash.common.actor": "Actor",
    "dash.common.archive": "Archiveren",
    "dash.common.assignments": "Opdrachten",
    "dash.common.attempts": "Pogingen",
    "dash.common.avg": "Gemiddelde",
    "dash.common.cancel": "Annuleren",
    "dash.common.class": "Klas",
    "dash.common.classes": "Klassen",
    "dash.common.code": "Code",
    "dash.common.confirm": "Bevestigen",
    "dash.common.confirmArchiveSchool": "Deze school archiveren?",
    "dash.common.confirmTitle": "Bevestigen",
    "dash.common.copyCode": "Code kopiëren",
    "dash.common.csvDownloaded": "CSV gedownload",
    "dash.common.difficulty": "Moeilijkheidsgraad",
    "dash.common.email": "E-mail",
    "dash.common.entity": "Entiteit",
    "dash.common.exportCsv": "CSV exporteren",
    "dash.common.family": "Gezin",
    "dash.common.lastAccess": "Laatste toegang",
    "dash.common.loading": "Laden…",
    "dash.common.name": "Naam",
    "dash.common.newCode": "Nieuwe code",
    "dash.common.none": "—",
    "dash.common.ok": "OK",
    "dash.common.open": "Openen",
    "dash.common.questions": "Vragen",
    "dash.common.quiz": "Quiz",
    "dash.common.refresh": "Vernieuwen",
    "dash.common.role": "Rol",
    "dash.common.school": "School",
    "dash.common.select": "Selecteren",
    "dash.common.slug": "Slug",
    "dash.common.status": "Status",
    "dash.common.students": "Leerlingen",
    "dash.common.teachers": "Leraren",
    "dash.common.topic": "Onderwerp",
    "dash.common.updated": "Bijgewerkt",
    "dash.common.when": "Wanneer",
    "dash.common.year": "Jaar",
    "dash.conference.addInvitee": "Gast toevoegen",
    "dash.conference.addInviteeHint": "Krijgt een eend en een persoonlijke link. Je kunt de uitnodiging meteen mailen.",
    "dash.conference.addInviteeTitle": "Uitgenodigde toevoegen",
    "dash.conference.addingInvitee": "Bezig met toevoegen…",
    "dash.conference.back": "Terug naar lijst",
    "dash.conference.chat": "Chat",
    "dash.conference.confirmed": "Bevestigd",
    "dash.conference.confirmedNo": "In afwachting",
    "dash.conference.confirmedYes": "Ja",
    "dash.conference.copied": "Link gekopieerd.",
    "dash.conference.copiedShort": "Gekopieerd!",
    "dash.conference.copyLink": "Link kopiëren",
    "dash.conference.create": "Call aanmaken",
    "dash.conference.createImmediate": "Directe conference maken",
    "dash.conference.createImmediateHint": "Alleen de call-/familienaam is nodig. Maakt één open link tot middernacht (Europe/Rome).",
    "dash.conference.created": "Call aangemaakt.",
    "dash.conference.createdImmediate": "Open conference aangemaakt — deel de enige link. Geldig voor de rest van vandaag.",
    "dash.conference.creating": "Bezig…",
    "dash.conference.detailTitle": "Uitnodigingslinks",
    "dash.conference.editHint": "Je kunt datum, tijd, naam en taal wijzigen. De toegangslinks blijven hetzelfde.",
    "dash.conference.editTitle": "Gesprek verzetten",
    "dash.conference.email": "Email",
    "dash.conference.emailDryRun": "E-mail dry-run (niet verzonden).",
    "dash.conference.emailSent": "Geaccepteerd door Mailgun.",
    "dash.conference.empty": "Nog geen conference calls.",
    "dash.conference.emptyInvitees": "Nog geen uitgenodigden.",
    "dash.conference.ended": "Call beëindigd.",
    "dash.conference.errAddInvitee": "Kon uitgenodigde niet toevoegen. Controleer e-mail en naam.",
    "dash.conference.errCallEnded": "De call is beëindigd; je kunt geen uitgenodigden meer toevoegen.",
    "dash.conference.errCopy": "Link kopiëren mislukt.",
    "dash.conference.errCreate": "Call kon niet worden aangemaakt.",
    "dash.conference.errDenied": "Toegang geweigerd. Meld je aan als YOBY-admin.",
    "dash.conference.errDuplicateInvitee": "Dit e-mailadres is al uitgenodigd voor deze call.",
    "dash.conference.errEmail": "E-mail kon niet worden verzonden.",
    "dash.conference.errLoad": "Conference calls konden niet worden geladen.",
    "dash.conference.errSave": "Wijzigingen konden niet worden opgeslagen.",
    "dash.conference.errWorldFull": "Conference-wereld vol: geen vrije vijvers meer.",
    "dash.conference.familyName": "Familienaam",
    "dash.conference.firstName": "Voornaam",
    "dash.conference.gameLocale": "Speltaal",
    "dash.conference.inviteeAdded": "Uitgenodigde toegevoegd.",
    "dash.conference.inviteeCount": "Gasten",
    "dash.conference.invitees": "Gasten",
    "dash.conference.lastName": "Achternaam",
    "dash.conference.listTitle": "Geplande calls",
    "dash.conference.mediaHealth.checking": "Janus en Coturn controleren…",
    "dash.conference.mediaHealth.coturn": "Coturn (TURN)",
    "dash.conference.mediaHealth.down": "DOWN",
    "dash.conference.mediaHealth.errLoad": "Videostatus kon niet worden gelezen.",
    "dash.conference.mediaHealth.hintDown": "Start de call niet: WebRTC-video is niet klaar.",
    "dash.conference.mediaHealth.hintOk": "Janus en TURN zijn bereikbaar. De call kan starten.",
    "dash.conference.mediaHealth.janus": "Janus",
    "dash.conference.mediaHealth.ok": "OK",
    "dash.conference.mediaHealth.title": "Videostatus (live)",
    "dash.conference.notifyInvitees": "Genodigden e-mailen (zelfde link, nieuwe tijd)",
    "dash.conference.openCallBadge": "open link",
    "dash.conference.openCallHint": "Iedereen met deze link kan meedoen (iedereen krijgt een eigen eend).",
    "dash.conference.phase": "Fase",
    "dash.conference.refresh": "Vernieuwen",
    "dash.conference.save": "Wijzigingen opslaan",
    "dash.conference.saveTranscript": "PDF opslaan",
    "dash.conference.saved": "Gesprek bijgewerkt. De links zijn ongewijzigd.",
    "dash.conference.saving": "Opslaan…",
    "dash.conference.sendEmail": "E-mail sturen",
    "dash.conference.sendEmailOnAdd": "Uitnodigingsmail sturen",
    "dash.conference.sendingEmail": "Versturen…",
    "dash.conference.speech": "Spraak",
    "dash.conference.startsAt": "Startdatum en -tijd (Europe/Rome)",
    "dash.conference.startsAtHint": "Voer de tijd in de YOBY-tijdzone (Europe/Rome) in, niet die van je browser.",
    "dash.conference.subtitle": "Maak een privé YOBY-wereld voor een geplande call. Gasten krijgen een eend en een persoonlijke link.",
    "dash.conference.tabAvailability": "Beschikbaarheid",
    "dash.conference.tabBookings": "Boekingen",
    "dash.conference.tabCalls": "Geplande calls",
    "dash.conference.tabCreate": "Call maken",
    "dash.conference.tabsAria": "Conference-secties",
    "dash.conference.title": "Conference call",
    "dash.conference.transcript": "Transcript",
    "dash.conference.transcriptDisabledNote": "Transcriptie uitgeschakeld op verzoek van een deelnemer.",
    "dash.conference.transcriptEmpty": "Nog geen transcript.",
    "dash.conference.transcriptSaved": "PDF opgeslagen.",
    "dash.difficulty.easy": "Makkelijk",
    "dash.difficulty.hard": "Moeilijk",
    "dash.difficulty.medium": "Gemiddeld",
    "dash.liveInterpreter.callMetrics": "Live Interpreter usage",
    "dash.liveInterpreter.callMetricsBody": "Call {callMin} min · translated {liMin} min · languages: {langs} · listeners: {listeners} · ≈ €{eur}",
    "dash.liveInterpreter.criticalPct": "Critical threshold (%)",
    "dash.liveInterpreter.enabled": "Live Interpreter inschakelen (alleen commerciële conference)",
    "dash.liveInterpreter.enabledDesc": "Hoofdschakelaar voor commerciële calls. Schakelt nooit in-game vijver-videochat in.",
    "dash.liveInterpreter.envOff": "Env kill-switch is OFF",
    "dash.liveInterpreter.errLoad": "Could not load interpreter settings.",
    "dash.liveInterpreter.errSave": "Could not save interpreter settings.",
    "dash.liveInterpreter.hint": "Simultane vertaling alleen voor commerciële conferences. Nooit op vijver-video.",
    "dash.liveInterpreter.monthUsage": "Month {month}: {used} / {limit} min · ≈ €{eur} · {calls} calls · {status}",
    "dash.liveInterpreter.monthlyLimit": "Maandelijks limiet (vertaalde audiominuten)",
    "dash.liveInterpreter.providerMissing": "Azure Voice Live endpoint/API key missing in .env",
    "dash.liveInterpreter.providerOk": "Azure Voice Live configured",
    "dash.liveInterpreter.quotaBlocked": "Nieuwe vertalingen geblokkeerd",
    "dash.liveInterpreter.quotaCritical": "Critical",
    "dash.liveInterpreter.quotaOk": "OK",
    "dash.liveInterpreter.quotaWarn": "Warning",
    "dash.liveInterpreter.save": "Opslaan",
    "dash.liveInterpreter.saved": "Instellingen opgeslagen.",
    "dash.liveInterpreter.tab": "Tolk",
    "dash.liveInterpreter.testCall": "TEST — oefen-conference openen",
    "dash.liveInterpreter.testCallCreating": "Oefen-conference maken…",
    "dash.liveInterpreter.testCallErr": "Kon oefen-conference niet maken.",
    "dash.liveInterpreter.testCallHint": "Maakt meteen een open conference (publieke link) en opent die in een nieuw tabblad.",
    "dash.liveInterpreter.testCallOk": "Oefen-conference klaar — geopend in nieuw tabblad.",
    "dash.liveInterpreter.title": "Live Interpreter",
    "dash.liveInterpreter.warnPct": "Warning threshold (%)",
    "dash.schoolSignup.addClass": "Add class",
    "dash.schoolSignup.addTeacher": "Add teacher",
    "dash.schoolSignup.alreadyBody": "This account is already linked to a school on YOBY.",
    "dash.schoolSignup.alreadyTitle": "Je bent al ingeschreven",
    "dash.schoolSignup.back": "Terug",
    "dash.schoolSignup.checkEmail": "Check your email and come back to this page after confirming.",
    "dash.schoolSignup.city": "City",
    "dash.schoolSignup.className": "Class name",
    "dash.schoolSignup.classTeacher": "Leraar van de klas",
    "dash.schoolSignup.classes": "Classes involved",
    "dash.schoolSignup.continue": "Continue",
    "dash.schoolSignup.country": "Country",
    "dash.schoolSignup.draftSaved": "Draft saved.",
    "dash.schoolSignup.email": "Principal’s email",
    "dash.schoolSignup.errClassTeacher": "Kies een leraar die je in de vorige stap hebt opgegeven.",
    "dash.schoolSignup.errEmail": "Vul een geldig e-mailadres in.",
    "dash.schoolSignup.errGeneric": "Something went wrong. Try again.",
    "dash.schoolSignup.errLocked": "The application has already been submitted.",
    "dash.schoolSignup.errLookup": "Could not check this email.",
    "dash.schoolSignup.errName": "Vul voor- en achternaam in (minstens 2 tekens).",
    "dash.schoolSignup.errPhone": "Telefoon is optioneel. Als je het invult, gebruik cijfers, spaties of +.",
    "dash.schoolSignup.errPrivacy": "Je moet de privacyverklaring accepteren om verder te gaan.",
    "dash.schoolSignup.errSave": "Could not save the draft.",
    "dash.schoolSignup.errSubmit": "Could not submit the application.",
    "dash.schoolSignup.errTeacherDup": "Elke leraar heeft een ander e-mailadres nodig.",
    "dash.schoolSignup.errTeacherSelf": "Gebruik niet het e-mailadres van de schoolleider: die is supervisor, geen leraar.",
    "dash.schoolSignup.errValidation": "Enter the school name, at least one teacher and one class.",
    "dash.schoolSignup.goDashboard": "Open dashboard",
    "dash.schoolSignup.helpAccount": "Maak het account van de schoolleider aan met naam, e-mail en privacytoestemming. We sturen een bevestigingslink: open die en kom terug naar deze pagina. Heb je al een YOBY-account, log dan in — je hoeft je niet opnieuw te registreren.",
    "dash.schoolSignup.helpClassTeacher": "Kies de leraar van deze klas. Die moet al in de lijst met leraren staan.",
    "dash.schoolSignup.helpClasses": "Elke klas heeft een leraar uit de vorige stap. Na goedkeuring maakt YOBY de klassen aan en wijst ze toe. Er is minstens één klas nodig.",
    "dash.schoolSignup.helpSchool": "Vul de schoolgegevens in zodat YOBY de school na controle kan activeren. Telefoon is optioneel. In de toelichting kun je vestigingen, tijden of andere info zetten.",
    "dash.schoolSignup.helpTeachers": "Zet de leraren op de lijst die YOBY gaan gebruiken. Zij krijgen na goedkeuring een uitnodiging. Zet het e-mailadres van de schoolleider er niet bij: die is supervisor, geen leraar. Er is minstens één leraar nodig.",
    "dash.schoolSignup.introAlt": "Prefer a call with us?",
    "dash.schoolSignup.introBody": "The principal signs up, confirms the email, then lists teachers and classes. YOBY activates the school after a review.",
    "dash.schoolSignup.introTitle": "Meld je school aan",
    "dash.schoolSignup.knownBody": "This email is already registered. Sign in with the link we send you.",
    "dash.schoolSignup.knownTitle": "Je bent al ingeschreven",
    "dash.schoolSignup.locale": "Working language",
    "dash.schoolSignup.name": "Principal’s name",
    "dash.schoolSignup.note": "Note (optional)",
    "dash.schoolSignup.openDashboard": "Go to dashboard",
    "dash.schoolSignup.pendingBody": "We received the application for {school}. We’ll email you when it’s active.",
    "dash.schoolSignup.pendingTitle": "Waiting for approval",
    "dash.schoolSignup.phone": "Phone (optional)",
    "dash.schoolSignup.privacy": "I accept the privacy notice and to share the listed teachers’ emails.",
    "dash.schoolSignup.rejectedBody": "The previous application was not approved. Reason: {reason}",
    "dash.schoolSignup.rejectedTitle": "Application not approved",
    "dash.schoolSignup.saveDraft": "Save draft",
    "dash.schoolSignup.schoolName": "School name",
    "dash.schoolSignup.signIn": "Inloggen",
    "dash.schoolSignup.signUp": "Aanmelden en e-mail bevestigen",
    "dash.schoolSignup.stepAccount": "Account",
    "dash.schoolSignup.stepAccountTitle": "Account",
    "dash.schoolSignup.stepClassesTitle": "Klassen",
    "dash.schoolSignup.stepSchool": "School",
    "dash.schoolSignup.stepSchoolTitle": "School",
    "dash.schoolSignup.stepTeachersTitle": "Leraren",
    "dash.schoolSignup.submit": "Aanvraag versturen",
    "dash.schoolSignup.submitted": "Application sent.",
    "dash.schoolSignup.talkWithUs": "Book a call",
    "dash.schoolSignup.teacherEmail": "Teacher email",
    "dash.schoolSignup.teacherName": "Teacher name",
    "dash.schoolSignup.teachers": "Teachers",
    "dash.status.ageBand.11-15": "11–15",
    "dash.status.ageBand.16-17": "16–17",
    "dash.status.ageBand.18-26": "18–26",
    "dash.status.ageBand.8-10": "8–10",
    "dash.status.ageBand.adult": "Volwassenen",
    "dash.status.ageBand.unknown": "Geen leeftijdsgroep",
    "dash.status.analytics.events.arcade_completed.description": "Arcade activity ends",
    "dash.status.analytics.events.arcade_completed.label": "Arcade completed",
    "dash.status.analytics.events.arcade_started.description": "Crazy Run or arcade activity starts",
    "dash.status.analytics.events.arcade_started.label": "Arcade started",
    "dash.status.analytics.events.child_access_started.description": "Child enters via link or parent",
    "dash.status.analytics.events.child_access_started.label": "Child access started",
    "dash.status.analytics.events.child_first_claim_email_sent.description": "Transactionele claim-e-mail naar de ouder verzonden",
    "dash.status.analytics.events.child_first_claim_email_sent.label": "Ontgrendel-e-mail verzonden",
    "dash.status.analytics.events.child_first_claim_opened.description": "Ouder opent de preview van de /claim-link",
    "dash.status.analytics.events.child_first_claim_opened.label": "Ontgrendel-link geopend",
    "dash.status.analytics.events.child_first_claimed.description": "Ouder ontgrendelt het pending eendje in de familie",
    "dash.status.analytics.events.child_first_claimed.label": "Eendje ontgrendeld",
    "dash.status.analytics.events.child_first_family_activated.description": "Familie klaar om te spelen na child-first claim",
    "dash.status.analytics.events.child_first_family_activated.label": "Child-first-familie geactiveerd",
    "dash.status.analytics.events.child_first_parent_email_submitted.description": "Kind geeft het e-mailadres van ouder/voogd op",
    "dash.status.analytics.events.child_first_parent_email_submitted.label": "Ouder-e-mail ingediend",
    "dash.status.analytics.events.child_first_started.description": "Kind start Maak mijn eendje",
    "dash.status.analytics.events.child_first_started.label": "Child-first gestart",
    "dash.status.analytics.events.child_profile_created.description": "A child character profile is created",
    "dash.status.analytics.events.child_profile_created.label": "Child profile created",
    "dash.status.analytics.events.collectible_obtained.description": "An item is collected",
    "dash.status.analytics.events.collectible_obtained.label": "Collectible obtained",
    "dash.status.analytics.events.family_activation_completed.description": "Adult, child and first access exist",
    "dash.status.analytics.events.family_activation_completed.label": "Family activated",
    "dash.status.analytics.events.family_created.description": "A parent creates the family pond",
    "dash.status.analytics.events.family_created.label": "Family created",
    "dash.status.analytics.events.market_transaction.description": "Buy, sell or negotiate",
    "dash.status.analytics.events.market_transaction.label": "Market transaction",
    "dash.status.analytics.events.market_visited.description": "Access to the market",
    "dash.status.analytics.events.market_visited.label": "Market visited",
    "dash.status.analytics.events.mission_completed.description": "Mission finished",
    "dash.status.analytics.events.mission_completed.label": "Mission completed",
    "dash.status.analytics.events.mission_started.description": "A game mission begins",
    "dash.status.analytics.events.mission_started.label": "Mission started",
    "dash.status.analytics.events.parent_demo_converted.description": "Een ouder rondt de demo af en maakt een account",
    "dash.status.analytics.events.parent_demo_converted.label": "Gezinsdemo omgezet",
    "dash.status.analytics.events.parent_demo_keep_prompt.description": "Voorstel om de eend te houden getoond",
    "dash.status.analytics.events.parent_demo_keep_prompt.label": "Gezinsdemo: eend houden",
    "dash.status.analytics.events.parent_demo_parent_ui_complete.description": "Overzicht van de gezins-UI afgerond",
    "dash.status.analytics.events.parent_demo_parent_ui_complete.label": "Gezinsdemo: UI klaar",
    "dash.status.analytics.events.parent_demo_started.description": "Start via de openbare Probeer YOBY-link voor gezinnen",
    "dash.status.analytics.events.parent_demo_started.label": "Gezinsdemo’s",
    "dash.status.analytics.events.parent_demo_tour_complete.description": "Wereldtour afgerond",
    "dash.status.analytics.events.parent_demo_tour_complete.label": "Gezinsdemo: tour klaar",
    "dash.status.analytics.events.quiz_assigned.description": "Teacher assigns a quiz",
    "dash.status.analytics.events.quiz_assigned.label": "Quiz assigned",
    "dash.status.analytics.events.quiz_completed.description": "Quiz finished",
    "dash.status.analytics.events.quiz_completed.label": "Quiz completed",
    "dash.status.analytics.events.quiz_started.description": "Child opens a quiz",
    "dash.status.analytics.events.quiz_started.label": "Quiz started",
    "dash.status.analytics.events.real_task_assigned.description": "Parent assigns a real-life chore",
    "dash.status.analytics.events.real_task_assigned.label": "Real task assigned",
    "dash.status.analytics.events.real_task_completed.description": "Child marks chore done",
    "dash.status.analytics.events.real_task_completed.label": "Real task done",
    "dash.status.analytics.events.real_task_validated.description": "Parent accepts or rejects",
    "dash.status.analytics.events.real_task_validated.label": "Real task validated",
    "dash.status.analytics.events.reward_claimed.description": "Child claims a reward",
    "dash.status.analytics.events.reward_claimed.label": "Reward claimed",
    "dash.status.analytics.events.reward_distributed.description": "Parent allocates a reward",
    "dash.status.analytics.events.reward_distributed.label": "Reward distributed",
    "dash.status.analytics.events.reward_earned.description": "A reward is granted",
    "dash.status.analytics.events.reward_earned.label": "Reward earned",
    "dash.status.analytics.events.session_ended.description": "Exit or inactivity",
    "dash.status.analytics.events.session_ended.label": "Session ended",
    "dash.status.analytics.events.session_started.description": "Someone enters the game",
    "dash.status.analytics.events.session_started.label": "Session started",
    "dash.status.analytics.events.shared_family_session.description": "Parent and child online together",
    "dash.status.analytics.events.shared_family_session.label": "Shared family session",
    "dash.status.analytics.events.subscription_cancelled.description": "Subscription cancelled",
    "dash.status.analytics.events.subscription_cancelled.label": "Subscription cancelled",
    "dash.status.analytics.events.subscription_started.description": "Family or Patron activated",
    "dash.status.analytics.events.subscription_started.label": "Subscription started",
    "dash.status.analytics.events.teacher_demo_converted.description": "Een docent rondt de demo af en maakt een account",
    "dash.status.analytics.events.teacher_demo_converted.label": "Docentendemo omgezet",
    "dash.status.analytics.events.teacher_demo_keep_prompt.description": "Voorstel om de eend te houden getoond",
    "dash.status.analytics.events.teacher_demo_keep_prompt.label": "Docentendemo: eend houden",
    "dash.status.analytics.events.teacher_demo_started.description": "Start via de openbare Probeer YOBY-link voor docenten",
    "dash.status.analytics.events.teacher_demo_started.label": "Docentendemo’s",
    "dash.status.analytics.events.teacher_demo_teacher_ui_complete.description": "Overzicht van de docenten-UI afgerond",
    "dash.status.analytics.events.teacher_demo_teacher_ui_complete.label": "Docentendemo: UI klaar",
    "dash.status.analytics.events.teacher_demo_tour_complete.description": "Wereldtour afgerond",
    "dash.status.analytics.events.teacher_demo_tour_complete.label": "Docentendemo: tour klaar",
    "dash.status.analytics.events.temporary_link_generated.description": "A temporary play link is created",
    "dash.status.analytics.events.temporary_link_generated.label": "Temp link created",
    "dash.status.analytics.events.temporary_link_used.description": "A temporary link is redeemed",
    "dash.status.analytics.events.temporary_link_used.label": "Temp link used",
    "dash.status.charts.acq_age_doughnut.title": "Kinderprofielen per leeftijdsgroep",
    "dash.status.charts.acq_child_first_funnel.title": "Child-first eendjes-funnel",
    "dash.status.charts.acq_child_first_trend.title": "Child-first-trend",
    "dash.status.charts.acq_demo_bar.title": "Demo’s via openbare links",
    "dash.status.charts.acq_demo_trend.title": "Trend demo-links",
    "dash.status.charts.acq_funnel.title": "Acquisition funnel",
    "dash.status.charts.acq_plan_doughnut.title": "Subscription plans",
    "dash.status.charts.acq_trend_line.title": "Acquisition trend",
    "dash.status.charts.eco_age_doughnut.title": "Beloningen per leeftijdsgroep",
    "dash.status.charts.eco_arcade_line.title": "Arcade activity",
    "dash.status.charts.eco_chores_funnel.title": "Real tasks funnel",
    "dash.status.charts.eco_collectibles_line.title": "Collectibles",
    "dash.status.charts.eco_market_bar.title": "Market activity",
    "dash.status.charts.eco_reward_origin.title": "Reward origins",
    "dash.status.charts.eco_reward_volume.title": "Reward volume",
    "dash.status.charts.eng_access_doughnut.title": "Child access channels",
    "dash.status.charts.eng_age_doughnut.title": "Sessies per leeftijdsgroep",
    "dash.status.charts.eng_device_bar.title": "Sessions by device",
    "dash.status.charts.eng_links_bar.title": "Temporary links",
    "dash.status.charts.eng_sessions_line.title": "Sessions by role",
    "dash.status.charts.eng_shared_line.title": "Shared family sessions",
    "dash.status.charts.learn_age_doughnut.title": "Voltooide quizzen per leeftijdsgroep",
    "dash.status.charts.learn_duration_bar.title": "Average duration",
    "dash.status.charts.learn_mission_host.title": "Missions by host",
    "dash.status.charts.learn_mission_trend.title": "Mission trend",
    "dash.status.charts.learn_quiz_funnel.title": "Quiz funnel",
    "dash.status.charts.learn_quiz_trend.title": "Quiz trend",
    "dash.status.charts.live_age_bar.title": "Online per leeftijdsgroep",
    "dash.status.charts.live_realm_pie.title": "Online by realm",
    "dash.status.charts.live_role_bar.title": "Online by role",
    "dash.status.daysLabel": "Dagen",
    "dash.status.errLoad": "Kon status niet laden.",
    "dash.status.lastAccessTitle": "Laatste toegang",
    "dash.status.loading": "Laden…",
    "dash.status.logAll": "Alle",
    "dash.status.logFilter": "Event",
    "dash.status.refresh": "Vernieuwen",
    "dash.status.report.anonymized": "Geanonimiseerd rapport: geen e-mails of namen.",
    "dash.status.report.failed": "Genereren mislukt. Probeer opnieuw.",
    "dash.status.report.generate": "Rapport genereren",
    "dash.status.report.generating": "Bezig",
    "dash.status.report.impossible": "Kan rapport niet genereren: nog geen analytics-data in de periode.",
    "dash.status.report.overviewTitle": "Algemeen commentaar",
    "dash.status.report.pdfAnalysisTitle": "Analyse",
    "dash.status.report.pdfChartsTitle": "Grafieken",
    "dash.status.report.pdfKpisTitle": "Kernindicatoren",
    "dash.status.report.pdfPage": "Pagina {n} van {total}",
    "dash.status.report.pdfPeriod": "Periode: laatste {days} dagen",
    "dash.status.report.pdfTitle": "Yoby analytics-rapport",
    "dash.status.report.pdfUnavailable": "PDF-bibliotheek niet beschikbaar.",
    "dash.status.report.previewFailed": "PDF-voorbeeld kon niet worden getoond.",
    "dash.status.report.previewPreparing": "PDF-voorbeeld wordt voorbereid…",
    "dash.status.report.readyAt": "Gegenereerd",
    "dash.status.report.savePdf": "PDF opslaan",
    "dash.status.report.waiting": "Rapport wordt voorbereid… even geduld.",
    "dash.status.sectionOnline": "Nu online",
    "dash.status.sectionOnlineAge": "Online per leeftijdsgroep",
    "dash.status.sectionTotals": "Totalen (zonder actieve conference-werelden)",
    "dash.status.sectionTotalsAge": "Personages per leeftijdsgroep",
    "dash.status.subtitle": "Aanwezigheid in-game en productanalytics.",
    "dash.status.summaryChildren": "Kinderen online",
    "dash.status.summaryFamilies": "Gezinnen in spel",
    "dash.status.summaryInGame": "In spel (totaal)",
    "dash.status.summaryParents": "Ouders online",
    "dash.status.summaryPlayers": "Spelers in spel",
    "dash.status.summaryQueueDepth": "Analytics-wachtrij",
    "dash.status.summaryRows": "Rijen laatste toegang",
    "dash.status.summarySurface": "Oppervlakte",
    "dash.status.summaryUnderground": "Ondergronds",
    "dash.status.summaryWorldsActive": "Werelden met spelers online",
    "dash.status.summaryWorldsOpened": "Geopende werelden",
    "dash.status.tabs.acquisition": "Acquisitie",
    "dash.status.tabs.economy": "Economie",
    "dash.status.tabs.engagement": "Engagement",
    "dash.status.tabs.learning": "Leren",
    "dash.status.tabs.live": "Live",
    "dash.status.tabs.logs": "Logs",
    "dash.status.tabs.report": "Rapport",
    "dash.status.thAgeBand": "Leeftijdsgroep",
    "dash.status.thEmailName": "E-mail / Naam",
    "dash.status.thEvent": "Event",
    "dash.status.thFamily": "Gezin",
    "dash.status.thLastAccess": "Laatste toegang",
    "dash.status.thRole": "Rol",
    "dash.status.thSummary": "Samenvatting",
    "dash.status.thTime": "Tijd",
    "dash.status.thWorld": "Wereld",
    "dash.status.thWorldFamilies": "Gezinnen",
    "dash.status.thWorldPlayers": "Spelers",
    "dash.status.thWorldSurface": "Oppervlakte",
    "dash.status.thWorldUnderground": "Ondergronds",
    "dash.status.title": "Status",
    "dash.status.totalChildren": "Kinderen (totaal)",
    "dash.status.totalFamilies": "Gezinnen (totaal)",
    "dash.status.totalParents": "Ouders (totaal)",
    "dash.status.totalPlayers": "Personages (totaal)",
    "dash.status.updated": "Bijgewerkt",
    "dash.status.worldsTitle": "Uitsplitsing per wereld",
    "dash.supervisor.csvDownloaded": "CSV gedownload",
    "dash.supervisor.errAudit": "Kon auditlog niet laden.",
    "dash.supervisor.errDenied": "Toegang geweigerd. Log in als supervisor of YOBY-beheerder.",
    "dash.supervisor.errExport": "Kon CSV niet exporteren.",
    "dash.supervisor.exportCsvSchool": "School-CSV exporteren",
    "dash.supervisor.hintAudit": "Laatste acties geregistreerd voor de school.",
    "dash.supervisor.hintQuizzes": "Quizgebruik per slug (voltooide pogingen in de school).",
    "dash.supervisor.metaSlug": "Slug",
    "dash.supervisor.metaStatus": "Status",
    "dash.supervisor.metricSchoolAvg": "Schoolgemiddelde",
    "dash.supervisor.noAudit": "Geen auditvermeldingen.",
    "dash.supervisor.noClasses": "Geen klassen.",
    "dash.supervisor.noQuizzes": "Geen quizgegevens.",
    "dash.supervisor.noSchools": "Geen scholen toegewezen.",
    "dash.supervisor.noTeachers": "Geen leraren.",
    "dash.supervisor.refresh": "Vernieuwen",
    "dash.supervisor.selectSchoolHint": "Selecteer een school om klassen, leraren en quizstatistieken te bekijken.",
    "dash.supervisor.subtitle": "Overzicht van scholen, klassen, leraren, quizzen en audit.",
    "dash.supervisor.tabAudit": "Audit",
    "dash.supervisor.tabClasses": "Klassen",
    "dash.supervisor.tabQuizzes": "Quizzen",
    "dash.supervisor.tabTeachers": "Leraren",
    "dash.supervisor.thAssignments": "Opdrachten",
    "dash.supervisor.thSchool": "School",
    "dash.supervisor.thTeacher": "Leraar",
    "dash.supervisor.title": "Supervisordashboard",
    "dash.supervisor.yourSchools": "Jouw scholen",
    "dash.teacher.catalogTitle": "Quizcatalogus",
    "dash.teacher.confirmArchiveClass": "Deze klas archiveren? De deelnamecode werkt dan niet meer.",
    "dash.teacher.copied": "Gekopieerd!",
    "dash.teacher.copyCode": "Code kopiëren",
    "dash.teacher.createClass": "Klas aanmaken",
    "dash.teacher.demoLink": "Demolink",
    "dash.teacher.demoLinkCopied": "Link gekopieerd naar klembord.",
    "dash.teacher.demoLinkReady": "Permanente link aangemaakt",
    "dash.teacher.errArchive": "Kon klas niet archiveren.",
    "dash.teacher.errAssign": "Kon quiz niet toewijzen.",
    "dash.teacher.errCreateClass": "Kon klas niet aanmaken.",
    "dash.teacher.errDemoDenied": "Alleen admins kunnen demolinks maken.",
    "dash.teacher.errDemoLink": "Demolink kon niet worden gemaakt.",
    "dash.teacher.errDemoNoQuiz": "Geen ongebruikte quiz meer voor deze klas.",
    "dash.teacher.errDenied": "Toegang geweigerd. Log in als leraar.",
    "dash.teacher.errExport": "Kon CSV niet exporteren.",
    "dash.teacher.errExportCatalog": "Quizcatalogus kon niet worden geëxporteerd.",
    "dash.teacher.errLoadClasses": "Kon klassen niet laden.",
    "dash.teacher.errNoTeacher": "Geen leraarsprofiel gevonden.",
    "dash.teacher.errRegen": "Kon code niet opnieuw genereren.",
    "dash.teacher.errSelectSchool": "Selecteer eerst een school.",
    "dash.teacher.exportCatalogCsv": "Catalogus-CSV downloaden (alle talen)",
    "dash.teacher.exportCsv": "CSV exporteren",
    "dash.teacher.hintAssign": "Kies categorie, quiz en opdrachtinstellingen.",
    "dash.teacher.hintWrong": "Vragen met de meeste fouten in recente opdrachten.",
    "dash.teacher.metaAge": "Leeftijd",
    "dash.teacher.metaCode": "Code",
    "dash.teacher.metaLang": "Taal",
    "dash.teacher.metaYear": "Jaar",
    "dash.teacher.metricAssignments": "Opdrachten",
    "dash.teacher.metricAttempts": "Pogingen",
    "dash.teacher.metricClassAvg": "Klasgemiddelde",
    "dash.teacher.metricEnrolled": "Ingeschreven",
    "dash.teacher.newCode": "Nieuwe code",
    "dash.teacher.noAssignments": "Nog geen opdrachten.",
    "dash.teacher.noCatalog": "Geen quizzen in catalogus.",
    "dash.teacher.noClasses": "Nog geen klassen.",
    "dash.teacher.noStudents": "Geen leerlingen ingeschreven.",
    "dash.teacher.noWrong": "Nog geen moeilijke vragen.",
    "dash.teacher.open": "Openen",
    "dash.teacher.playLink": "Spellink",
    "dash.teacher.playLinkCopied": "Link gekopieerd naar klembord.",
    "dash.teacher.playLinkFailed": "Spellink kon niet worden aangemaakt",
    "dash.teacher.playLinkHint": "Leerlingen openen de link en tikken op hun naam. Houd toezicht op de keuze.",
    "dash.teacher.playLinkHours": "Uren",
    "dash.teacher.playLinkReady": "Spellink aangemaakt",
    "dash.teacher.quizColChoices": "Antwoorden",
    "dash.teacher.quizColOrder": "#",
    "dash.teacher.quizColQuestion": "Vraag",
    "dash.teacher.quizLoadError": "Quiz kon niet worden geladen.",
    "dash.teacher.quizLoading": "Quiz laden…",
    "dash.teacher.quizPreviewTitle": "Quizvoorbeeld",
    "dash.teacher.selectClassHint": "Selecteer een klas om details te bekijken.",
    "dash.teacher.statusAssigned": "Quiz toegewezen.",
    "dash.teacher.statusAssigning": "Quiz toewijzen…",
    "dash.teacher.statusClassCreated": "Klas aangemaakt.",
    "dash.teacher.statusCreating": "Klas aanmaken…",
    "dash.teacher.subtitle": "Klassen, inschrijvingscodes, quizopdrachten, resultaten en exports.",
    "dash.teacher.surveyFeedbackFinal": "Aan het einde van de quiz",
    "dash.teacher.surveyFeedbackImmediate": "Direct na elke vraag",
    "dash.teacher.tabAssign": "Quiz toewijzen",
    "dash.teacher.tabAssignments": "Opdrachten",
    "dash.teacher.tabStudents": "Leerlingen",
    "dash.teacher.tabWrong": "Moeilijke vragen",
    "dash.teacher.thAge": "Leeftijd",
    "dash.teacher.thAvg": "Gemiddelde",
    "dash.teacher.thClass": "Klas",
    "dash.teacher.thCode": "Code",
    "dash.teacher.thCompleted": "Voltooid",
    "dash.teacher.thDifficulty": "Moeilijkheidsgraad",
    "dash.teacher.thDone": "Voltooid",
    "dash.teacher.thDue": "Deadline",
    "dash.teacher.thErrorPct": "Fout %",
    "dash.teacher.thErrors": "Fouten",
    "dash.teacher.thFirstName": "Voornaam",
    "dash.teacher.thJoined": "Ingeschreven",
    "dash.teacher.thLastName": "Achternaam",
    "dash.teacher.thLastSeen": "Laatst gezien",
    "dash.teacher.thMaxAttempts": "Max. pogingen",
    "dash.teacher.thNickname": "Bijnaam",
    "dash.teacher.thPublish": "Publiceren",
    "dash.teacher.thQuestion": "Vraag",
    "dash.teacher.thTheme": "Thema",
    "dash.teacher.thTitle": "Titel",
    "dash.teacher.thTotalAnswers": "Totaal antwoorden",
    "dash.teacher.thYear": "Jaar",
    "dash.teacher.title": "Leraarsdashboard",
    "dash.teacher.yourClasses": "Jouw klassen",
    "dash.teacher.yourClassesHint": "Selecteer een klas om leerlingen, opdrachten en statistieken te bekijken.",
    "dash.topic.bisogni_desideri": "Behoeften en wensen",
    "dash.topic.budget": "Budget",
    "dash.topic.consumo": "Bewust consumeren",
    "dash.topic.imprenditorialita": "Ondernemerschap",
    "dash.topic.lavoro": "Werkwereld",
    "dash.topic.risparmio": "Sparen",
    "footer.aria.site": "Voettekst",
    "footer.aria.social": "Sociale links",
    "footer.brand.tagline": "De familievijver waar kinderen en volwassenen samen leren over geld.",
    "footer.col.about": "Over YOBY",
    "footer.col.aiAudits": "Laatste AI-veiligheidsaudits",
    "footer.col.banksAndPartners": "Banken & partners",
    "footer.col.contact": "Contact",
    "footer.col.cookiePolicy": "Cookiebeleid",
    "footer.col.dataAndGdpr": "Gegevens & AVG",
    "footer.col.investors": "Investeerders",
    "footer.col.parentalControls": "Ouderlijk toezicht",
    "footer.col.partners.title": "Partners",
    "footer.col.press": "Pers",
    "footer.col.privacyPolicy": "Privacybeleid",
    "footer.col.product.title": "Product",
    "footer.col.roadmap": "Roadmap",
    "footer.col.safety": "Veiligheid",
    "footer.col.schools": "Scholen",
    "footer.col.termsOfService": "Gebruiksvoorwaarden",
    "footer.col.trust.title": "Vertrouwen & veiligheid",
    "footer.col.yoby.title": "YOBY",
    "footer.copyright.line1": "© 2026 YOBY. Alle rechten voorbehouden.",
    "footer.copyright.line2": "Gemaakt in Europa voor gezinnen, eenden en betere geldgewoonten.",
    "home.about.feature1.body": "Een privéruimte waar het hele gezin verkent, quests voltooit en samen groeit. Elk lid heeft zijn eigen eendpersonage.",
    "home.about.feature1.title": "🦆 Een familiespel om over geld te leren",
    "home.about.feature2.body": "De Kikker, de Ekster, de Mol en anderen begeleiden je met korte quests en keuzevragen. Leren door te doen, niet door te studeren.",
    "home.about.feature2.title": "🐸 Mentors die geldvaardigheden spelenderwijs leren",
    "home.about.feature3.body": "Drie symbolische valuta voor doelen, sparen en goede gewoonten. Een speeleconomie die leert zonder als les aan te voelen.",
    "home.about.feature3.title": "🐚 Sparen, doelen en gewoontes in een speelse economie",
    "home.about.feature4.body": "Geen kind kan ongepaste inhoud ontvangen. Geen videochat zonder ouder aanwezig. Gebouwd voor minderjarigen — niet alleen aangepast.",
    "home.about.feature4.title": "🔒 Veilig by design",
    "home.about.title": "Wat je vindt in de YOBY-wereld",
    "home.cta.choosePlan": "Kies een abonnement",
    "home.cta.joinDescription": "Maak je familieaccount aan en begin met verkennen.",
    "home.cta.joinTitle": "Duik erin. Het is gratis.",
    "home.cta.playNow": "Nu spelen",
    "home.cta.premiumActive": "Je hebt een premium-abonnement — geniet van de volledige ervaring!",
    "home.cta.premiumHint": "Premium-abonnementen bieden betere spelvoorwaarden: meer schelpen, exclusieve gebieden en prioriteitsfuncties.",
    "home.cta.ready": "Klaar om weer de vijver in te duiken?",
    "home.cta.signIn": "Inloggen",
    "home.cta.signUpFree": "Gratis starten",
    "home.cta.tryAsParent": "Bent u ouder? Probeer YOBY",
    "home.cta.tryAsStudent": "Bent u docent? Probeer YOBY",
    "home.cta.welcomeBack": "Welkom terug",
    "home.cta.welcomeBackName": "Welkom terug, {name}",
    "home.hero.childBody": "Maak het nu. Een ouder ontgrendelt de plas wanneer jullie klaar zijn.",
    "home.hero.childCta": "Maak mijn eendje",
    "home.hero.childTitle": "Op zoek naar je eendje? 🦆",
    "home.hero.ctaPrimary": "Gratis starten",
    "home.hero.ctaSecondary": "Bekijk hoe het werkt",
    "home.hero.description": "YOBY is een financieel educatiespel waarin kinderen en ouders samen leren over sparen, geldkeuzes en doelen.",
    "home.hero.tagline": "Geld praat — eindelijk op een leuke manier.",
    "home.hero.title": "Financiële geletterdheid voor kinderen en gezinnen, leuk gemaakt.",
    "home.hero.visualAlt": "De YOBY-wereld met speelse eendjes bij de familieplas",
    "home.learn.choices.body": "Maak alledaagse afwegingen — nu uitgeven, sparen of delen — in veilige, verhalende quests.",
    "home.learn.choices.title": "Keuzes",
    "home.learn.goals.body": "Noem wat ertoe doet, plan ernaar toe en vier voortgang onderweg.",
    "home.learn.goals.title": "Doelen",
    "home.learn.saving.body": "Zet schelpen apart voor later en zie kleine stappen uitgroeien tot grotere doelen.",
    "home.learn.saving.title": "Sparen",
    "home.learn.title": "Wat kinderen leren",
    "home.learn.value.body": "Verbind inspanning, tijd en middelen zodat kinderen begrijpen wat geld vertegenwoordigt.",
    "home.learn.value.title": "Waarde van geld",
    "home.links.families": "Financiële educatie voor gezinnen",
    "home.links.kids": "YOBY voor kinderen",
    "home.links.schools": "Financiële geletterdheid voor scholen",
    "home.links.title": "Ontdek YOBY",
    "home.seo.description": "YOBY is een speelse wereld van financiële geletterdheid waar kinderen en ouders samen leren over sparen, geldkeuzes en gezonde gewoontes.",
    "home.seo.title": "Financiële geletterdheid voor kinderen & gezinnen | YOBY",
    "home.seoSection.body": "YOBY maakt financiële geletterdheid voor kinderen tot een gedeeld avontuur. In een speelse vijverwereld oefenen kinderen en ouders sparen, stellen samen doelen en praten over alledaagse geldkeuzes. Mentors en korte quests begeleiden leren over geld door spel — geen werkbladen of colleges. Zoek je financiële educatie voor gezinnen thuis, dan ontmoet YOBY kinderen waar ze zijn: nieuwsgierig, creatief en klaar om te verkennen. Elk gezinslid heeft zijn eigen eend in een vijver die je alleen deelt met vertrouwde mensen. Schelpen, zaden en sterren staan voor echte gewoontes — geduld, planning en begrip van de waarde van wat je verdient. Onderweg leren kinderen dat kleine keuzes tellen, dat wachten de moeite waard kan zijn en dat geld een hulpmiddel voor doelen is — niet alleen om uit te geven. Ouders blijven betrokken met duidelijk zicht en controles in een ruimte die vanaf het begin voor minderjarigen is gebouwd.",
    "home.seoSection.title": "Financiële educatie voor kinderen, door spel",
    "home.showcase.aria": "Spelscreenshots",
    "home.showcase.card1.alt": "YOBY familiespel voor financiële educatie met ouders en kinderen in een virtuele vijver",
    "home.showcase.card1.title": "Familievijver — samen verkennen",
    "home.showcase.card2.alt": "YOBY-mentors die kinderen over geld leren via speelse quests",
    "home.showcase.card2.title": "Ontmoet mentoren — leren door te spelen",
    "home.showcase.card3.alt": "YOBY financieel educatiequiz en dorpswinkels met gelokaliseerde mentordialogen",
    "home.showcase.card3.title": "Quizzen, winkels en dorpsleven",
    "home.showcase.card4.alt": "YOBY ondergrondse mentoren die kinderen over geld leren via cinematische quests",
    "home.showcase.card4.title": "Ondergrondse mentoren en quests",
    "home.showcase.card5.alt": "YOBY Tasso-markt waar kinderen geldkeuzes oefenen",
    "home.showcase.card5.title": "Markten en geldkeuzes",
    "home.showcase.card6.alt": "YOBY Gekke Race: kinderen rennen over het gras en verzamelen seizoensvoorwerpen tegen de klok",
    "home.showcase.card6.title": "Gekke Race — een race tegen de klok op het gras",
    "home.showcase.hint": "Tik om te vergroten",
    "home.showcase.title": "Ontdek de wereld",
    "lang.switch": "Taal",
    "nav.account": "Account",
    "nav.actions.signIn": "Inloggen",
    "nav.actions.startFree": "Gratis starten",
    "nav.actions.talkWithUs": "Praat met ons",
    "nav.aria.main": "Hoofdnavigatie",
    "nav.aria.staff": "School- en beheergebied",
    "nav.footer.schoolSignup": "Meld je school aan",
    "nav.main.blog": "Blog",
    "nav.main.forFamilies": "Voor gezinnen",
    "nav.main.forKids": "Voor kinderen",
    "nav.main.home": "Home",
    "nav.main.howItWorks": "Hoe het werkt",
    "nav.main.pricing": "Prijzen",
    "nav.main.talkWithUs": "Praat met ons",
    "nav.menu": "Menu",
    "nav.searchPosts": "Zoek berichten, tags en auteurs",
    "nav.signIn": "Inloggen",
    "nav.staff.admin": "Schoolbeheer",
    "nav.staff.adminSafety": "Laatste AI-veiligheidsaudits",
    "nav.staff.conference": "Conference call",
    "nav.staff.massmail": "Scholen-massmail",
    "nav.staff.redteam": "AI Red Team",
    "nav.staff.schoolSignups": "Schoolaanmeldingen",
    "nav.staff.status": "Spelstatus",
    "nav.staff.supervisor": "Supervisordashboard",
    "nav.staff.teacher": "Leraarsdashboard",
    "nav.subscribe": "Abonneren",
    "safetyLab.areasTitle": "Onderwerpen die we controleren",
    "safetyLab.audience": "Voor gezinnen en scholen",
    "safetyLab.cat.abuse": "Abuse",
    "safetyLab.cat.dangerous_behavior": "Dangerous behaviour",
    "safetyLab.cat.distress_support": "Emotional support (allowed)",
    "safetyLab.cat.drugs": "Drugs",
    "safetyLab.cat.hate": "Hate",
    "safetyLab.cat.inappropriate_instructions": "Inappropriate instructions",
    "safetyLab.cat.jailbreak": "Prompt injection",
    "safetyLab.cat.off_topic": "Off-topic",
    "safetyLab.cat.other": "Other safety checks",
    "safetyLab.cat.personal_data": "Personal information",
    "safetyLab.cat.self_harm": "Self-harm",
    "safetyLab.cat.sexual": "Inappropriate sexual content",
    "safetyLab.cat.violence": "Violence",
    "safetyLab.chartEmpty": "Als er meer audits zijn, zie je hier de trend.",
    "safetyLab.chartOutcomes": "Hoe de laatste audit ging",
    "safetyLab.chartTrend": "Trend van recente audits",
    "safetyLab.historyEmpty": "Nog geen voltooide audits.",
    "safetyLab.historyTitle": "Recente geschiedenis",
    "safetyLab.languages": "Testtalen",
    "safetyLab.lastTested": "Laatste audit",
    "safetyLab.legendCritical": "Kritiek: hoog risico; hoogste prioriteit.",
    "safetyLab.legendFail": "Mislukt: iets reageerde niet zoals het hoort — we lossen het op.",
    "safetyLab.legendPass": "Geslaagd: het filter reageerde zoals verwacht.",
    "safetyLab.legendTitle": "Wat de resultaten betekenen",
    "safetyLab.legendWarning": "Waarschuwing: vaak een vals alarm (te streng bij een onschuldig bericht), geen risico voor kinderen.",
    "safetyLab.loadFailed": "Veiligheidsaudits konden niet worden geladen.",
    "safetyLab.loading": "Laatste audits laden…",
    "safetyLab.method1": "De kern van de controle is de Safety Gate — hetzelfde filter dat berichten in het spel onderschept (invoer en soms uitvoer). Elk scenario stuurt een bericht (of een korte reeks) en controleert of het filter toelaat, omleidt of blokkeert zoals verwacht.",
    "safetyLab.method2": "In de volledige suite testen we alle AI-personages waarmee een kind kan praten: oppervlaktevijver, ondergrond en tutors. Er zijn ook snellere «quick»-runs met één personage en één leeftijdsgroep per scenario: de getoonde hosts weerspiegelen altijd alleen wat die run echt heeft uitgevoerd.",
    "safetyLab.method3": "Scenario’s dekken gevoelige onderwerpen en omzeilpogingen: ongepaste seksuele inhoud, geweld, zelfbeschadiging, misbruik, drugs, haat, persoonsgegevens, gevaarlijke instructies, promptmanipulatie (jailbreak), offtopic, én goedaardige of ondersteunende gevallen die toegestaan moeten blijven. Veel scenario’s draaien in meerdere talen en leeftijdsgroepen.",
    "safetyLab.method4": "Elk geval krijgt een uitslag: geslaagd, waarschuwing, mislukt of kritiek. Een waarschuwing is vaak een vals alarm (te streng bij een onschuldig bericht), geen risico voor kinderen. Mislukt of kritiek betekent dat iets niet reageerde zoals het hoort en moet worden opgelost. We tonen altijd de laatste voltooide run, ook als die niet groen is: we vervangen een slecht resultaat nooit door een ouder goed resultaat.",
    "safetyLab.method5": "Om te voorkomen dat iemand beschermingen omzeilt, publiceren we geen aanvalsteksten, jailbreak-recepten of volledige transcripten. Openbaar zie je aggregaten, categorieën en data; technische details blijven intern.",
    "safetyLab.method6": "De scenariobibliotheek groeit: als we een zwakte vinden, voegen we een regressiegeval toe en houden het. Is er nog geen voltooide audit, dan zeggen we dat duidelijk.",
    "safetyLab.methodIntro": "YOBY voert automatische veiligheidsaudits uit op de AI die met kinderen praat. We verzinnen de cijfers niet: elk getal op deze pagina komt uit een echte, opgeslagen run. Hieronder leggen we uit wat we doen, wat we meten, en wat we bewust niet tonen.",
    "safetyLab.methodTitle": "Hoe de tests worden uitgevoerd",
    "safetyLab.metricCritical": "Kritiek",
    "safetyLab.metricExecuted": "Gecontroleerde gevallen",
    "safetyLab.metricFail": "Mislukt",
    "safetyLab.metricPass": "Geslaagd",
    "safetyLab.metricPassRate": "Slaagpercentage",
    "safetyLab.metricWarning": "Waarschuwingen",
    "safetyLab.never": "Nog niet uitgevoerd",
    "safetyLab.noteParents": "Deze pagina is bedoeld voor ouders en leraren. Je kunt ze altijd raadplegen: het is een openbaar verslag van de laatste audits, geen marketingpagina met verzonnen cijfers.",
    "safetyLab.npcs": "Gedekte AI-personages",
    "safetyLab.plainLead": "YOBY test voortdurend zijn AI-personages, zoals een veiligheidsaudit. Hier zie je de nieuwste uitkomst — zonder technische aanvalsdetails.",
    "safetyLab.statusCritical": "Ernstige problemen gevonden",
    "safetyLab.statusError": "Laatste audit niet afgerond",
    "safetyLab.statusIssues": "Er zijn verbeterpunten",
    "safetyLab.statusNever": "Nog geen audit beschikbaar",
    "safetyLab.statusPass": "Alles in orde",
    "safetyLab.subtitle": "Echte resultaten van automatische controles op de AI die met kinderen praat — voor ouders en leraren.",
    "safetyLab.thCases": "Gevallen",
    "safetyLab.thDate": "Datum",
    "safetyLab.thStatus": "Uitslag",
    "safetyLab.title": "Laatste AI-veiligheidsaudits",
    "footer.col.genderEquality": "Gendergelijkheid",
    "dash.booking.gcalRefreshHint": "Na een boeking: gebruik «Kalender vernieuwen» als het event niet op Google staat.",
    "dash.conference.delivery.title": "E-mailbezorging",
    "dash.conference.delivery.untracked": "Resultaat niet beschikbaar",
    "dash.conference.delivery.invite": "Uitnodiging",
    "dash.conference.delivery.reschedule": "Afspraakwijziging",
    "dash.conference.delivery.reminder": "Herinnering",
    "dash.conference.delivery.pending": "Voorbereiden",
    "dash.conference.delivery.accepted": "Geaccepteerd door Mailgun",
    "dash.conference.delivery.delivered": "Afgeleverd bij de server van de ontvanger",
    "dash.conference.delivery.deferred": "Tijdelijk vertraagd",
    "dash.conference.delivery.failed": "Verzenden of afleveren mislukt",
    "dash.conference.delivery.dry_run": "Gesimuleerd, niet verzonden",
    "dash.conference.delivery.confirmation": "Je deelname is bevestigd",
    "footer.col.accessibility": "Toegankelijkheid",
    "accessibility.title": "Toegankelijkheid bij YOBY",
    "accessibility.intro": "We willen de informatie van YOBY makkelijker leesbaar en bruikbaar maken. Deze pagina legt de hulpmiddelen van de website en de huidige beperkingen van het spel uit.",
    "accessibility.site.title": "De informatiewebsite",
    "accessibility.site.body": "De pagina’s bieden tekst, navigatielinks en een paneel om de weergave aan te passen. Je kunt het lezen op je behoeften afstemmen en via een toetsenbordlink naar de hoofdinhoud gaan.",
    "accessibility.site.status": "Deze functies helpen bij het gebruik, maar garanderen geen volledige toegankelijkheid. Alleen het widget toont geen algehele overeenstemming met toegankelijkheidsnormen aan; we hebben geen volledige controle van alle pagina’s, formulieren en geïntegreerde diensten afgerond.",
    "accessibility.preferences.title": "De weergave aanpassen",
    "accessibility.preferences.body": "Open het paneel via het pictogram Toegankelijkheid in de navigatie, of met Alt+Shift+A op Windows/Linux en ⌥ Option+Shift+A op Mac. Wijzigingen gelden meteen voor de webpagina’s.",
    "accessibility.preferences.contrast": "Hoog contrast: verhoogt het visuele contrast van de pagina.",
    "accessibility.preferences.invert": "Kleuren omkeren: keert achtergrond- en inhoudskleuren om, inclusief afbeeldingen.",
    "accessibility.preferences.size": "Grotere tekst: wisselt tussen normaal, groot en extra groot.",
    "accessibility.preferences.spacing": "Tekstafstand: vergroot de leesruimte in ondersteunde inhoud.",
    "accessibility.preferences.focus": "Focus markeren: maakt het met het toetsenbord geselecteerde bedieningselement duidelijker zichtbaar.",
    "accessibility.preferences.links": "Links onderstrepen: voegt een onderstreping toe aan links.",
    "accessibility.preferences.motion": "Beweging verminderen: vermindert animaties en overgangen op de pagina.",
    "accessibility.preferences.font": "Leesbaar lettertype: gebruikt een schreefloos systeemlettertype.",
    "accessibility.preferences.storage": "Voorkeuren worden in de lokale opslag van deze browser bewaard en het widget stuurt ze niet naar YOBY. Met ‘Standaardinstellingen herstellen’ maak je ze ongedaan. Ze worden niet tussen apparaten gesynchroniseerd; opslaan kan onbeschikbaar zijn als de browser lokale opslag blokkeert.",
    "accessibility.keyboard.title": "Het toetsenbord gebruiken",
    "accessibility.keyboard.body": "De eerste Tab toont de link ‘Naar de inhoud’. Met Tab en Shift+Tab ga je naar andere bedieningselementen; Enter of Spatie activeert knoppen. De focus blijft in het geopende paneel; Esc sluit het en brengt de focus terug naar het punt van openen.",
    "accessibility.game.title": "Het spel: huidige beperkingen",
    "accessibility.game.body": "Het spel is een visuele, interactieve ervaring die losstaat van de informatiewebsite. We presenteren het momenteel niet als volledig toegankelijk en kunnen volledig gebruik met schermlezers of alleen een toetsenbord niet garanderen.",
    "accessibility.game.limits": "Websitevoorkeuren maken de spelwereld niet toegankelijk en gelden niet automatisch voor de 3D-scène, interacties of alle spelbediening. Ingebouwde diensten, zoals aanmeld- en registratiepanelen, kunnen ook hun eigen gedrag en beperkingen hebben. Neem contact op als je een barrière tegenkomt: we kunnen het probleem vastleggen en bekijken hoe we kunnen helpen, zonder te beloven dat er al voor elke activiteit een gelijkwaardige versie bestaat.",
    "accessibility.feedback.title": "Een probleem melden",
    "accessibility.feedback.body": "Vermeld de pagina of functie, wat je wilde doen, je apparaat en browser en, indien relevant, de gebruikte ondersteunende technologie. Je hoeft geen diagnose of andere gezondheidsgegevens te delen.",
    "accessibility.feedback.contact": "Contact over toegankelijkheid",
    "auth.a11y.email": "E-mailadres",
    "auth.a11y.subscribe": "Registreren",
    "auth.a11y.sent": "E-mail verzonden. Controleer je inbox om verder te gaan.",
    "auth.a11y.termsRequired": "Accepteer de voorwaarden om verder te gaan.",
    "auth.a11y.close": "Venster sluiten",
    "auth.a11y.account": "YOBY-account",
    "auth.a11y.sending": "Bezig met verzenden…"
  }
};
window.YOBY_NAV_CONFIG = {
  "mainNav": [
    {
      "id": "home",
      "slug": "home"
    },
    {
      "id": "howItWorks",
      "slug": "how-it-works"
    },
    {
      "id": "forFamilies",
      "slug": "for-families"
    },
    {
      "id": "forKids",
      "slug": "for-kids"
    },
    {
      "id": "pricing",
      "slug": "pricing"
    },
    {
      "id": "blog",
      "slug": "blog"
    },
    {
      "id": "talkWithUs",
      "slug": "talk-with-us",
      "mobileOnly": true
    }
  ],
  "footerColumns": {
    "yoby": [
      {
        "id": "home",
        "slug": "home"
      },
      {
        "id": "howItWorks",
        "slug": "how-it-works"
      },
      {
        "id": "about",
        "slug": "about"
      },
      {
        "id": "blog",
        "slug": "blog"
      }
    ],
    "product": [
      {
        "id": "forFamilies",
        "slug": "for-families"
      },
      {
        "id": "forKids",
        "slug": "for-kids"
      },
      {
        "id": "pricing",
        "slug": "pricing"
      },
      {
        "id": "roadmap",
        "slug": "roadmap"
      },
      {
        "id": "talkWithUs",
        "slug": "talk-with-us"
      },
      {
        "id": "startFree",
        "action": "signup"
      },
      {
        "id": "signIn",
        "action": "signin"
      }
    ],
    "trust": [
      {
        "id": "safety",
        "slug": "safety"
      },
      {
        "id": "accessibility",
        "slug": "accessibility"
      },
      {
        "id": "genderEquality",
        "slug": "money-has-no-gender-equality-in-financial-education-at-yoby"
      },
      {
        "id": "aiAudits",
        "slug": "admin-safety"
      },
      {
        "id": "privacyPolicy",
        "slug": "privacy-policy"
      },
      {
        "id": "termsOfService",
        "slug": "terms-of-service"
      },
      {
        "id": "cookiePolicy",
        "slug": "cookie-policy"
      },
      {
        "id": "parentalControls",
        "slug": "parental-controls"
      },
      {
        "id": "dataAndGdpr",
        "slug": "data-and-gdpr"
      }
    ],
    "partners": [
      {
        "id": "schools",
        "slug": "schools"
      },
      {
        "id": "schoolSignup",
        "slug": "school-signup"
      },
      {
        "id": "banksAndPartners",
        "slug": "banks-and-partners"
      },
      {
        "id": "investors",
        "slug": "investors"
      },
      {
        "id": "press",
        "slug": "press"
      },
      {
        "id": "contact",
        "slug": "contact"
      }
    ]
  },
  "langTags": [
    "it",
    "fr",
    "es",
    "pt",
    "de",
    "nl"
  ]
};
